import * as ai from "react";
import Sn, { createContext as On, useContext as kn, useState as H, useCallback as gt, useEffect as ke, useRef as ut, useMemo as xt, Fragment as bu } from "react";
import De from "@mui/material/Box";
import Su from "@mui/material/Avatar";
import wu from "@mui/material/Menu";
import Jt from "@mui/material/MenuItem";
import Pr from "@mui/material/ListItemIcon";
import yi from "@mui/material/Divider";
import Oa from "@mui/material/IconButton";
import Lr from "@mui/material/Tooltip";
import yu from "@mui/icons-material/Person";
import Ru from "@mui/icons-material/Check";
import Iu from "@mui/material/AppBar";
import _u from "@mui/material/Toolbar";
import { Box as pe, CircularProgress as ar, Typography as Ze, Button as ht, Breadcrumbs as Tu, CardActionArea as Eu, Card as jr, CardContent as Mr, Stack as yn, Chip as Cu, IconButton as Ri, SvgIcon as xu, TextField as Rn, FormControlLabel as ka, Checkbox as Pa, Link as Os, Alert as In, List as Ou, ListItemButton as ku, ListItemText as Pu, Table as Au, TableHead as Uu, TableRow as ks, TableCell as Bt, TableBody as Nu, MenuItem as Du, Divider as Lu, Dialog as Ii, DialogTitle as Aa, DialogContent as _i, DialogActions as Ti, Snackbar as ju, Tooltip as Mu } from "@mui/material";
import { colors as qt, Logo as Ua } from "brand";
import { AuthProvider as Fu, useAuth as Vt } from "react-oidc-context";
import { Delete as Vu, ArrowBack as zu, Add as Bu, People as Gu, Edit as Hu } from "@mui/icons-material";
import Fr from "@mui/material/Skeleton";
import Vr from "@mui/material/Stack";
import { ThemeProvider as $u, styled as Zr, useTheme as Wu, useColorScheme as Na } from "@mui/material/styles";
import qu from "@mui/material/CssBaseline";
import ns from "@mui/material/List";
import Ju from "@mui/material/ListItem";
import Da from "@mui/material/ListItemText";
import La from "@mui/icons-material/Home";
import ja from "@mui/icons-material/Settings";
import Yu from "@mui/icons-material/ChevronLeft";
import Zu from "@mui/icons-material/ChevronRight";
import { Navigate as Ma, useLocation as Ku } from "react-router-dom";
import Mt from "@mui/material/Typography";
import * as rs from "axios";
import Fa from "axios";
import Qu from "@mui/material/Button";
import Va from "@mui/material/Dialog";
import za from "@mui/material/DialogContent";
import Ba from "@mui/material/DialogTitle";
import Ga from "@mui/material/ListItemButton";
import Xu from "@mui/material/TextField";
import Ha from "@mui/material/Select";
import Ps from "@mui/material/Switch";
import As from "@mui/material/FormControlLabel";
import el from "@mui/icons-material/Event";
import tl from "@mui/material/useMediaQuery";
import Zn from "@mui/material/Chip";
import nl from "@mui/icons-material/Business";
import Us from "@mui/icons-material/AdminPanelSettings";
import { useTranslation as $a } from "i18n-fe";
import Wa from "@mui/icons-material/Brightness4";
import qa from "@mui/icons-material/Brightness7";
import Ja from "@mui/icons-material/Logout";
import rl from "@mui/icons-material/Assessment";
import il from "@mui/icons-material/Campaign";
import sl from "@mui/icons-material/Dashboard";
import al from "@mui/icons-material/EditNote";
import ol from "@mui/material/Link";
import ul from "@mui/icons-material/Lock";
import ll from "@mui/icons-material/LockOpen";
var Ei = { exports: {} }, Mn = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Ns;
function cl() {
  if (Ns) return Mn;
  Ns = 1;
  var t = Sn, a = Symbol.for("react.element"), r = Symbol.for("react.fragment"), s = Object.prototype.hasOwnProperty, n = t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, e = { key: !0, ref: !0, __self: !0, __source: !0 };
  function i(o, u, l) {
    var c, d = {}, h = null, g = null;
    l !== void 0 && (h = "" + l), u.key !== void 0 && (h = "" + u.key), u.ref !== void 0 && (g = u.ref);
    for (c in u) s.call(u, c) && !e.hasOwnProperty(c) && (d[c] = u[c]);
    if (o && o.defaultProps) for (c in u = o.defaultProps, u) d[c] === void 0 && (d[c] = u[c]);
    return { $$typeof: a, type: o, key: h, ref: g, props: d, _owner: n.current };
  }
  return Mn.Fragment = r, Mn.jsx = i, Mn.jsxs = i, Mn;
}
var Fn = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Ds;
function dl() {
  return Ds || (Ds = 1, process.env.NODE_ENV !== "production" && function() {
    var t = Sn, a = Symbol.for("react.element"), r = Symbol.for("react.portal"), s = Symbol.for("react.fragment"), n = Symbol.for("react.strict_mode"), e = Symbol.for("react.profiler"), i = Symbol.for("react.provider"), o = Symbol.for("react.context"), u = Symbol.for("react.forward_ref"), l = Symbol.for("react.suspense"), c = Symbol.for("react.suspense_list"), d = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), g = Symbol.for("react.offscreen"), U = Symbol.iterator, P = "@@iterator";
    function D(C) {
      if (C === null || typeof C != "object")
        return null;
      var L = U && C[U] || C[P];
      return typeof L == "function" ? L : null;
    }
    var j = t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function F(C) {
      {
        for (var L = arguments.length, B = new Array(L > 1 ? L - 1 : 0), X = 1; X < L; X++)
          B[X - 1] = arguments[X];
        V("error", C, B);
      }
    }
    function V(C, L, B) {
      {
        var X = j.ReactDebugCurrentFrame, Oe = X.getStackAddendum();
        Oe !== "" && (L += "%s", B = B.concat([Oe]));
        var Ue = B.map(function(ve) {
          return String(ve);
        });
        Ue.unshift("Warning: " + L), Function.prototype.apply.call(console[C], console, Ue);
      }
    }
    var te = !1, ge = !1, he = !1, G = !1, re = !1, K;
    K = Symbol.for("react.module.reference");
    function ze(C) {
      return !!(typeof C == "string" || typeof C == "function" || C === s || C === e || re || C === n || C === l || C === c || G || C === g || te || ge || he || typeof C == "object" && C !== null && (C.$$typeof === h || C.$$typeof === d || C.$$typeof === i || C.$$typeof === o || C.$$typeof === u || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      C.$$typeof === K || C.getModuleId !== void 0));
    }
    function at(C, L, B) {
      var X = C.displayName;
      if (X)
        return X;
      var Oe = L.displayName || L.name || "";
      return Oe !== "" ? B + "(" + Oe + ")" : B;
    }
    function He(C) {
      return C.displayName || "Context";
    }
    function ce(C) {
      if (C == null)
        return null;
      if (typeof C.tag == "number" && F("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof C == "function")
        return C.displayName || C.name || null;
      if (typeof C == "string")
        return C;
      switch (C) {
        case s:
          return "Fragment";
        case r:
          return "Portal";
        case e:
          return "Profiler";
        case n:
          return "StrictMode";
        case l:
          return "Suspense";
        case c:
          return "SuspenseList";
      }
      if (typeof C == "object")
        switch (C.$$typeof) {
          case o:
            var L = C;
            return He(L) + ".Consumer";
          case i:
            var B = C;
            return He(B._context) + ".Provider";
          case u:
            return at(C, C.render, "ForwardRef");
          case d:
            var X = C.displayName || null;
            return X !== null ? X : ce(C.type) || "Memo";
          case h: {
            var Oe = C, Ue = Oe._payload, ve = Oe._init;
            try {
              return ce(ve(Ue));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var me = Object.assign, lt = 0, zt, Rt, At, It, an, pr, gr;
    function Ln() {
    }
    Ln.__reactDisabledLog = !0;
    function be() {
      {
        if (lt === 0) {
          zt = console.log, Rt = console.info, At = console.warn, It = console.error, an = console.group, pr = console.groupCollapsed, gr = console.groupEnd;
          var C = {
            configurable: !0,
            enumerable: !0,
            value: Ln,
            writable: !0
          };
          Object.defineProperties(console, {
            info: C,
            log: C,
            warn: C,
            error: C,
            group: C,
            groupCollapsed: C,
            groupEnd: C
          });
        }
        lt++;
      }
    }
    function $e() {
      {
        if (lt--, lt === 0) {
          var C = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: me({}, C, {
              value: zt
            }),
            info: me({}, C, {
              value: Rt
            }),
            warn: me({}, C, {
              value: At
            }),
            error: me({}, C, {
              value: It
            }),
            group: me({}, C, {
              value: an
            }),
            groupCollapsed: me({}, C, {
              value: pr
            }),
            groupEnd: me({}, C, {
              value: gr
            })
          });
        }
        lt < 0 && F("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var st = j.ReactCurrentDispatcher, Et;
    function Kt(C, L, B) {
      {
        if (Et === void 0)
          try {
            throw Error();
          } catch (Oe) {
            var X = Oe.stack.trim().match(/\n( *(at )?)/);
            Et = X && X[1] || "";
          }
        return `
` + Et + C;
      }
    }
    var on = !1, _t;
    {
      var qo = typeof WeakMap == "function" ? WeakMap : Map;
      _t = new qo();
    }
    function vs(C, L) {
      if (!C || on)
        return "";
      {
        var B = _t.get(C);
        if (B !== void 0)
          return B;
      }
      var X;
      on = !0;
      var Oe = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var Ue;
      Ue = st.current, st.current = null, be();
      try {
        if (L) {
          var ve = function() {
            throw Error();
          };
          if (Object.defineProperty(ve.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(ve, []);
            } catch (bt) {
              X = bt;
            }
            Reflect.construct(C, [], ve);
          } else {
            try {
              ve.call();
            } catch (bt) {
              X = bt;
            }
            C.call(ve.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (bt) {
            X = bt;
          }
          C();
        }
      } catch (bt) {
        if (bt && X && typeof bt.stack == "string") {
          for (var de = bt.stack.split(`
`), ft = X.stack.split(`
`), We = de.length - 1, Ke = ft.length - 1; We >= 1 && Ke >= 0 && de[We] !== ft[Ke]; )
            Ke--;
          for (; We >= 1 && Ke >= 0; We--, Ke--)
            if (de[We] !== ft[Ke]) {
              if (We !== 1 || Ke !== 1)
                do
                  if (We--, Ke--, Ke < 0 || de[We] !== ft[Ke]) {
                    var St = `
` + de[We].replace(" at new ", " at ");
                    return C.displayName && St.includes("<anonymous>") && (St = St.replace("<anonymous>", C.displayName)), typeof C == "function" && _t.set(C, St), St;
                  }
                while (We >= 1 && Ke >= 0);
              break;
            }
        }
      } finally {
        on = !1, st.current = Ue, $e(), Error.prepareStackTrace = Oe;
      }
      var ln = C ? C.displayName || C.name : "", Qt = ln ? Kt(ln) : "";
      return typeof C == "function" && _t.set(C, Qt), Qt;
    }
    function Jo(C, L, B) {
      return vs(C, !1);
    }
    function Yo(C) {
      var L = C.prototype;
      return !!(L && L.isReactComponent);
    }
    function mr(C, L, B) {
      if (C == null)
        return "";
      if (typeof C == "function")
        return vs(C, Yo(C));
      if (typeof C == "string")
        return Kt(C);
      switch (C) {
        case l:
          return Kt("Suspense");
        case c:
          return Kt("SuspenseList");
      }
      if (typeof C == "object")
        switch (C.$$typeof) {
          case u:
            return Jo(C.render);
          case d:
            return mr(C.type, L, B);
          case h: {
            var X = C, Oe = X._payload, Ue = X._init;
            try {
              return mr(Ue(Oe), L, B);
            } catch {
            }
          }
        }
      return "";
    }
    var jn = Object.prototype.hasOwnProperty, ps = {}, gs = j.ReactDebugCurrentFrame;
    function br(C) {
      if (C) {
        var L = C._owner, B = mr(C.type, C._source, L ? L.type : null);
        gs.setExtraStackFrame(B);
      } else
        gs.setExtraStackFrame(null);
    }
    function Zo(C, L, B, X, Oe) {
      {
        var Ue = Function.call.bind(jn);
        for (var ve in C)
          if (Ue(C, ve)) {
            var de = void 0;
            try {
              if (typeof C[ve] != "function") {
                var ft = Error((X || "React class") + ": " + B + " type `" + ve + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof C[ve] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw ft.name = "Invariant Violation", ft;
              }
              de = C[ve](L, ve, X, B, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (We) {
              de = We;
            }
            de && !(de instanceof Error) && (br(Oe), F("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", X || "React class", B, ve, typeof de), br(null)), de instanceof Error && !(de.message in ps) && (ps[de.message] = !0, br(Oe), F("Failed %s type: %s", B, de.message), br(null));
          }
      }
    }
    var Ko = Array.isArray;
    function ti(C) {
      return Ko(C);
    }
    function Qo(C) {
      {
        var L = typeof Symbol == "function" && Symbol.toStringTag, B = L && C[Symbol.toStringTag] || C.constructor.name || "Object";
        return B;
      }
    }
    function Xo(C) {
      try {
        return ms(C), !1;
      } catch {
        return !0;
      }
    }
    function ms(C) {
      return "" + C;
    }
    function bs(C) {
      if (Xo(C))
        return F("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", Qo(C)), ms(C);
    }
    var Ss = j.ReactCurrentOwner, eu = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, ws, ys;
    function tu(C) {
      if (jn.call(C, "ref")) {
        var L = Object.getOwnPropertyDescriptor(C, "ref").get;
        if (L && L.isReactWarning)
          return !1;
      }
      return C.ref !== void 0;
    }
    function nu(C) {
      if (jn.call(C, "key")) {
        var L = Object.getOwnPropertyDescriptor(C, "key").get;
        if (L && L.isReactWarning)
          return !1;
      }
      return C.key !== void 0;
    }
    function ru(C, L) {
      typeof C.ref == "string" && Ss.current;
    }
    function iu(C, L) {
      {
        var B = function() {
          ws || (ws = !0, F("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", L));
        };
        B.isReactWarning = !0, Object.defineProperty(C, "key", {
          get: B,
          configurable: !0
        });
      }
    }
    function su(C, L) {
      {
        var B = function() {
          ys || (ys = !0, F("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", L));
        };
        B.isReactWarning = !0, Object.defineProperty(C, "ref", {
          get: B,
          configurable: !0
        });
      }
    }
    var au = function(C, L, B, X, Oe, Ue, ve) {
      var de = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: a,
        // Built-in properties that belong on the element
        type: C,
        key: L,
        ref: B,
        props: ve,
        // Record the component responsible for creating this element.
        _owner: Ue
      };
      return de._store = {}, Object.defineProperty(de._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(de, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: X
      }), Object.defineProperty(de, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: Oe
      }), Object.freeze && (Object.freeze(de.props), Object.freeze(de)), de;
    };
    function ou(C, L, B, X, Oe) {
      {
        var Ue, ve = {}, de = null, ft = null;
        B !== void 0 && (bs(B), de = "" + B), nu(L) && (bs(L.key), de = "" + L.key), tu(L) && (ft = L.ref, ru(L, Oe));
        for (Ue in L)
          jn.call(L, Ue) && !eu.hasOwnProperty(Ue) && (ve[Ue] = L[Ue]);
        if (C && C.defaultProps) {
          var We = C.defaultProps;
          for (Ue in We)
            ve[Ue] === void 0 && (ve[Ue] = We[Ue]);
        }
        if (de || ft) {
          var Ke = typeof C == "function" ? C.displayName || C.name || "Unknown" : C;
          de && iu(ve, Ke), ft && su(ve, Ke);
        }
        return au(C, de, ft, Oe, X, Ss.current, ve);
      }
    }
    var ni = j.ReactCurrentOwner, Rs = j.ReactDebugCurrentFrame;
    function un(C) {
      if (C) {
        var L = C._owner, B = mr(C.type, C._source, L ? L.type : null);
        Rs.setExtraStackFrame(B);
      } else
        Rs.setExtraStackFrame(null);
    }
    var ri;
    ri = !1;
    function ii(C) {
      return typeof C == "object" && C !== null && C.$$typeof === a;
    }
    function Is() {
      {
        if (ni.current) {
          var C = ce(ni.current.type);
          if (C)
            return `

Check the render method of \`` + C + "`.";
        }
        return "";
      }
    }
    function uu(C) {
      return "";
    }
    var _s = {};
    function lu(C) {
      {
        var L = Is();
        if (!L) {
          var B = typeof C == "string" ? C : C.displayName || C.name;
          B && (L = `

Check the top-level render call using <` + B + ">.");
        }
        return L;
      }
    }
    function Ts(C, L) {
      {
        if (!C._store || C._store.validated || C.key != null)
          return;
        C._store.validated = !0;
        var B = lu(L);
        if (_s[B])
          return;
        _s[B] = !0;
        var X = "";
        C && C._owner && C._owner !== ni.current && (X = " It was passed a child from " + ce(C._owner.type) + "."), un(C), F('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', B, X), un(null);
      }
    }
    function Es(C, L) {
      {
        if (typeof C != "object")
          return;
        if (ti(C))
          for (var B = 0; B < C.length; B++) {
            var X = C[B];
            ii(X) && Ts(X, L);
          }
        else if (ii(C))
          C._store && (C._store.validated = !0);
        else if (C) {
          var Oe = D(C);
          if (typeof Oe == "function" && Oe !== C.entries)
            for (var Ue = Oe.call(C), ve; !(ve = Ue.next()).done; )
              ii(ve.value) && Ts(ve.value, L);
        }
      }
    }
    function cu(C) {
      {
        var L = C.type;
        if (L == null || typeof L == "string")
          return;
        var B;
        if (typeof L == "function")
          B = L.propTypes;
        else if (typeof L == "object" && (L.$$typeof === u || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        L.$$typeof === d))
          B = L.propTypes;
        else
          return;
        if (B) {
          var X = ce(L);
          Zo(B, C.props, "prop", X, C);
        } else if (L.PropTypes !== void 0 && !ri) {
          ri = !0;
          var Oe = ce(L);
          F("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", Oe || "Unknown");
        }
        typeof L.getDefaultProps == "function" && !L.getDefaultProps.isReactClassApproved && F("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function du(C) {
      {
        for (var L = Object.keys(C.props), B = 0; B < L.length; B++) {
          var X = L[B];
          if (X !== "children" && X !== "key") {
            un(C), F("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", X), un(null);
            break;
          }
        }
        C.ref !== null && (un(C), F("Invalid attribute `ref` supplied to `React.Fragment`."), un(null));
      }
    }
    var Cs = {};
    function xs(C, L, B, X, Oe, Ue) {
      {
        var ve = ze(C);
        if (!ve) {
          var de = "";
          (C === void 0 || typeof C == "object" && C !== null && Object.keys(C).length === 0) && (de += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var ft = uu();
          ft ? de += ft : de += Is();
          var We;
          C === null ? We = "null" : ti(C) ? We = "array" : C !== void 0 && C.$$typeof === a ? (We = "<" + (ce(C.type) || "Unknown") + " />", de = " Did you accidentally export a JSX literal instead of a component?") : We = typeof C, F("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", We, de);
        }
        var Ke = ou(C, L, B, Oe, Ue);
        if (Ke == null)
          return Ke;
        if (ve) {
          var St = L.children;
          if (St !== void 0)
            if (X)
              if (ti(St)) {
                for (var ln = 0; ln < St.length; ln++)
                  Es(St[ln], C);
                Object.freeze && Object.freeze(St);
              } else
                F("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Es(St, C);
        }
        if (jn.call(L, "key")) {
          var Qt = ce(C), bt = Object.keys(L).filter(function(mu) {
            return mu !== "key";
          }), si = bt.length > 0 ? "{key: someKey, " + bt.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Cs[Qt + si]) {
            var gu = bt.length > 0 ? "{" + bt.join(": ..., ") + ": ...}" : "{}";
            F(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, si, Qt, gu, Qt), Cs[Qt + si] = !0;
          }
        }
        return C === s ? du(Ke) : cu(Ke), Ke;
      }
    }
    function hu(C, L, B) {
      return xs(C, L, B, !0);
    }
    function fu(C, L, B) {
      return xs(C, L, B, !1);
    }
    var vu = fu, pu = hu;
    Fn.Fragment = s, Fn.jsx = vu, Fn.jsxs = pu;
  }()), Fn;
}
process.env.NODE_ENV === "production" ? Ei.exports = cl() : Ei.exports = dl();
var m = Ei.exports;
function hl({ menuItems: t }) {
  const [a, r] = ai.useState(null), s = !!a, n = (i) => {
    r(i.currentTarget);
  }, e = () => {
    r(null);
  };
  return /* @__PURE__ */ m.jsxs(ai.Fragment, { children: [
    /* @__PURE__ */ m.jsx(De, { sx: { display: "flex", alignItems: "center", textAlign: "center" }, children: /* @__PURE__ */ m.jsx(Lr, { title: "Account settings", children: /* @__PURE__ */ m.jsx(
      Oa,
      {
        onClick: n,
        size: "small",
        sx: { ml: 2 },
        "aria-controls": s ? "account-menu" : void 0,
        "aria-haspopup": "true",
        "aria-expanded": s ? "true" : void 0,
        children: /* @__PURE__ */ m.jsx(Su, { sx: { width: 32, height: 32 }, children: /* @__PURE__ */ m.jsx(yu, {}) })
      }
    ) }) }),
    /* @__PURE__ */ m.jsx(
      wu,
      {
        anchorEl: a,
        id: "account-menu",
        open: s,
        onClose: e,
        onClick: e,
        disableScrollLock: !0,
        slotProps: {
          paper: {
            elevation: 0,
            sx: {
              overflow: "visible",
              filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
              mt: 1.5,
              "& .MuiAvatar-root": {
                width: 32,
                height: 32,
                ml: -0.5,
                mr: 1
              },
              "&::before": {
                content: '""',
                display: "block",
                position: "absolute",
                top: 0,
                right: 14,
                width: 10,
                height: 10,
                bgcolor: "background.paper",
                transform: "translateY(-50%) rotate(45deg)",
                zIndex: 0
              }
            }
          }
        },
        transformOrigin: { horizontal: "right", vertical: "top" },
        anchorOrigin: { horizontal: "right", vertical: "bottom" },
        children: t.map((i, o) => /* @__PURE__ */ m.jsxs(ai.Fragment, { children: [
          i.divider && /* @__PURE__ */ m.jsx(yi, {}),
          i.checked ? /* @__PURE__ */ m.jsxs(Jt, { selected: !0, "aria-current": "true", onClick: e, children: [
            i.icon && /* @__PURE__ */ m.jsx(Pr, { children: i.icon }),
            i.text,
            /* @__PURE__ */ m.jsx(Ru, { fontSize: "small", sx: { ml: 2 }, "data-testid": "app-switcher-check" })
          ] }) : i.href ? /* @__PURE__ */ m.jsxs(Jt, { component: "a", href: i.href, onClick: e, children: [
            i.icon && /* @__PURE__ */ m.jsx(Pr, { children: i.icon }),
            i.text
          ] }) : /* @__PURE__ */ m.jsxs(
            Jt,
            {
              onClick: () => {
                var u;
                (u = i.onClick) == null || u.call(i), e();
              },
              children: [
                i.icon && /* @__PURE__ */ m.jsx(Pr, { children: i.icon }),
                i.text
              ]
            }
          ),
          i.dividerAfter && /* @__PURE__ */ m.jsx(yi, {})
        ] }, o))
      }
    )
  ] });
}
const fl = 64, vl = ({ rightContent: t = null, brandLogo: a = null, sx: r = {} }) => /* @__PURE__ */ m.jsx(Iu, { sx: { ...r }, position: "fixed", elevation: 1, children: /* @__PURE__ */ m.jsxs(
  _u,
  {
    sx: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      pl: 0,
      minHeight: `${fl}px !important`
    },
    children: [
      a,
      /* @__PURE__ */ m.jsx(De, { sx: { display: "flex", alignItems: "center", gap: 2 }, children: t })
    ]
  }
) }), wv = ({ children: t, sx: a = {} }) => /* @__PURE__ */ m.jsx(
  De,
  {
    component: "footer",
    sx: {
      position: "fixed",
      left: 0,
      bottom: 0,
      width: "100%",
      height: "56px",
      borderTop: 1,
      borderColor: "divider",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      zIndex: (r) => r.zIndex.appBar,
      ...a
    },
    children: t
  }
), pl = 64, gl = ({ children: t }) => /* @__PURE__ */ m.jsx(
  De,
  {
    component: "main",
    sx: {
      p: "20px",
      pb: 0,
      flexGrow: 1,
      mb: "56px",
      // space for footer
      minHeight: `calc(100vh - ${pl}px - 56px)`,
      overflow: "auto"
    },
    children: t || /* @__PURE__ */ m.jsx("div", { children: "MainContent (stub)" })
  }
), Ya = "common-fe.navRailExpanded", Za = 72, ml = 200, bl = () => {
  try {
    return window.localStorage.getItem(Ya) === "true";
  } catch {
    return !1;
  }
}, Sl = (t) => {
  try {
    window.localStorage.setItem(Ya, String(t));
  } catch {
  }
}, Ka = On({
  expanded: !1,
  width: Za,
  toggleExpanded: () => {
  }
}), wl = ({ children: t }) => {
  const [a, r] = H(bl), s = gt(() => {
    r((e) => {
      const i = !e;
      return Sl(i), i;
    });
  }, []), n = a ? ml : Za;
  return /* @__PURE__ */ m.jsx(Ka.Provider, { value: { expanded: a, width: n, toggleExpanded: s }, children: t });
}, Qa = () => kn(Ka), oi = 64, yl = { xs: 2, sm: 4, md: 8 }, Rl = ({ appFooterEnabled: t, children: a, appFooter: r, appBar: s, navRail: n }) => {
  const { width: e } = Qa();
  return /* @__PURE__ */ m.jsxs(De, { sx: { minHeight: "100vh", width: "100%" }, children: [
    /* @__PURE__ */ m.jsx(
      De,
      {
        sx: {
          position: "fixed",
          top: 0,
          left: 0,
          width: "100vw",
          zIndex: 1300
        },
        children: s
      }
    ),
    /* @__PURE__ */ m.jsxs(
      De,
      {
        sx: {
          display: "flex",
          flexDirection: "row",
          pt: `${oi}px`
        },
        children: [
          n && /* @__PURE__ */ m.jsx(
            De,
            {
              sx: {
                width: e,
                flexShrink: 0,
                position: "fixed",
                height: `calc(100vh - ${oi}px)`,
                top: oi,
                left: 0,
                zIndex: 1200,
                transition: "width 0.15s ease"
              },
              children: n
            }
          ),
          /* @__PURE__ */ m.jsx(
            De,
            {
              sx: {
                flexGrow: 1,
                minWidth: 0,
                ml: n ? `${e}px` : 0,
                px: yl,
                transition: "margin-left 0.15s ease"
              },
              children: /* @__PURE__ */ m.jsx(gl, { children: a })
            }
          )
        ]
      }
    ),
    t && r
  ] });
}, yv = ({
  appFooterEnabled: t = !0,
  children: a,
  appFooter: r = null,
  appBar: s = null,
  navRail: n = null
}) => /* @__PURE__ */ m.jsx(wl, { children: /* @__PURE__ */ m.jsx(
  Rl,
  {
    appFooterEnabled: t,
    appFooter: r,
    appBar: s,
    navRail: n,
    children: a
  }
) });
function Ci({ message: t }) {
  return /* @__PURE__ */ m.jsxs(
    pe,
    {
      sx: {
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        bgcolor: "background.default",
        zIndex: 13e3
        // higher than MUI modal
      },
      children: [
        /* @__PURE__ */ m.jsx(ar, { sx: { color: qt.foxOrange } }),
        t && /* @__PURE__ */ m.jsx(Ze, { variant: "h6", sx: { mt: 2 }, children: t })
      ]
    }
  );
}
function Xa(t = "") {
  return ["/", `${t}/callback`, `${t}/logout`, `${t}/logged-out`];
}
function Il(t, a = "") {
  return typeof t == "string" && t.startsWith("/") && !Xa(a).includes(t);
}
function _l(t = "") {
  return [`${t}/logout`, `${t}/logged-out`];
}
function Tl(t, a = "") {
  return _l(a).includes(t);
}
function Rv(t) {
  if (typeof t != "string" || t === "") return "";
  let a;
  try {
    a = new URL(t).pathname;
  } catch {
    return "";
  }
  const r = "/callback";
  return a.endsWith(r) ? a.slice(0, -r.length) : "";
}
function Iv({ navigateFunction: t, location: a, basename: r = "" }) {
  return ke(() => {
    const s = setTimeout(() => {
      const n = localStorage.getItem("redirect_url");
      localStorage.removeItem("redirect_url");
      const e = Il(n, r) ? n : r || "/";
      t(e, { replace: !0 });
    }, 500);
    return () => clearTimeout(s);
  }, [t, a, r]), /* @__PURE__ */ m.jsx(Ci, { message: "Signing you in..." });
}
let eo = !1;
function _v() {
  eo = !0;
}
function Sr() {
  return eo;
}
function El() {
  return typeof window < "u" && !!window.Cypress;
}
async function Cl({ navigate: t = () => window.location.replace("/") } = {}) {
  js(Ls(() => window.localStorage)), js(Ls(() => window.sessionStorage)), await Ol(), await kl(), t();
}
function Ls(t) {
  try {
    return t();
  } catch {
    return null;
  }
}
const xl = "oidc.";
function js(t) {
  if (t)
    try {
      const a = [];
      for (let r = 0; r < t.length; r++) {
        const s = t.key(r);
        s && s.startsWith(xl) && a.push(s);
      }
      a.forEach((r) => t.removeItem(r));
    } catch {
    }
}
async function Ol() {
  var t, a;
  try {
    const r = await ((a = (t = navigator.serviceWorker) == null ? void 0 : t.getRegistrations) == null ? void 0 : a.call(t));
    if (!r) return;
    await Promise.all(r.map((s) => s.unregister()));
  } catch {
  }
}
async function kl() {
  var t, a;
  try {
    const r = await ((a = (t = window.caches) == null ? void 0 : t.keys) == null ? void 0 : a.call(t));
    if (!r) return;
    await Promise.all(r.map((s) => window.caches.delete(s)));
  } catch {
  }
}
function to(t) {
  return t ?? (typeof __BUILD_ID__ < "u" ? __BUILD_ID__ : "dev");
}
const no = On(null);
function Pl() {
  return kn(no);
}
function Al(t) {
  const a = () => typeof navigator > "u" ? !0 : navigator.onLine !== !1, [r, s] = H(a);
  return ke(() => {
    if (!t || typeof window > "u") return;
    const n = () => s(!0), e = () => s(!1);
    return s(a()), window.addEventListener("online", n), window.addEventListener("offline", e), () => {
      window.removeEventListener("online", n), window.removeEventListener("offline", e);
    };
  }, [t]), t ? r : !0;
}
function Ul(t) {
  var r;
  if (!t) return !1;
  const a = String(t.message ?? ((r = t.innerError) == null ? void 0 : r.message) ?? "");
  return /failed to fetch|network ?error|load failed/i.test(a);
}
function Nl({ error: t }) {
  const a = to();
  return /* @__PURE__ */ m.jsxs(
    pe,
    {
      sx: {
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        textAlign: "center",
        px: 3,
        bgcolor: "background.default",
        zIndex: 13e3
        // higher than MUI modal, matches FullScreenLoader
      },
      children: [
        /* @__PURE__ */ m.jsx(Ze, { variant: "h6", sx: { mb: 1 }, children: "Encountering error..." }),
        /* @__PURE__ */ m.jsx(
          Ze,
          {
            "data-testid": "auth-error-message",
            variant: "body2",
            sx: { mb: 3, maxWidth: 480, fontFamily: "monospace", color: "text.secondary" },
            children: t == null ? void 0 : t.message
          }
        ),
        /* @__PURE__ */ m.jsx(
          ht,
          {
            "data-testid": "auth-error-start-over",
            variant: "contained",
            onClick: () => Cl(),
            sx: { bgcolor: qt.foxOrange, "&:hover": { bgcolor: qt.foxOrange } },
            children: "Start over"
          }
        ),
        /* @__PURE__ */ m.jsxs(
          Ze,
          {
            "data-testid": "auth-error-build-id",
            variant: "caption",
            sx: { mt: 3, color: "text.secondary", fontFamily: "monospace" },
            children: [
              "Build ",
              a
            ]
          }
        )
      ]
    }
  );
}
function Dl({ children: t, basename: a = "", getOfflineIdentity: r }) {
  var D;
  const s = Vt(), n = typeof r == "function", e = Al(n), [i, o] = H(!1), u = Tl(window.location.pathname, a), l = ut(!1), c = ((D = s.error) == null ? void 0 : D.source) === "signinSilent" && !s.isAuthenticated, d = n && !s.isAuthenticated ? r() : null, h = !!d && !s.isLoading && !s.isAuthenticated && !Sr() && !u && !new URLSearchParams(window.location.search).has("code") && (!e || Ul(s.error)), g = !!d && !s.isAuthenticated && !Sr() && !u && (h || i);
  ke(() => {
    n && (s.isAuthenticated ? o(!1) : h && o(!0));
  }, [n, s.isAuthenticated, h]);
  const U = ut(!1);
  ke(() => {
    var j;
    e || (U.current = !1), !(!g || !e) && (U.current || !((j = s.user) != null && j.refresh_token) || (U.current = !0, s.signinSilent()));
  }, [g, e, s]);
  const P = xt(
    () => g ? { identity: d, online: e } : null,
    // identity is re-read from storage each render; key on its sub, not its identity.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [g, d == null ? void 0 : d.sub, e]
  );
  return ke(() => {
    const j = window.location.pathname;
    Xa(a).includes(j) || localStorage.setItem("redirect_url", j);
  }, [a]), ke(() => {
    var j;
    if (!s.isLoading && !s.isAuthenticated && (!s.error || c) && !Sr() && !u && !g) {
      if (!s.error && ((j = s.user) != null && j.refresh_token) && !l.current) {
        l.current = !0, s.signinSilent();
        return;
      }
      s.signinRedirect();
    }
  }, [
    s.isLoading,
    s.isAuthenticated,
    s.error,
    s,
    u,
    c,
    g
  ]), s.isLoading && !s.isAuthenticated && !g ? /* @__PURE__ */ m.jsx(Ci, { message: "Loading..." }) : s.error && !s.isAuthenticated && !Sr() && !c && !g ? /* @__PURE__ */ m.jsx(Nl, { error: s.error }) : !s.isAuthenticated && !u && !g ? /* @__PURE__ */ m.jsx(Ci, { message: "Redirecting to login..." }) : n ? /* @__PURE__ */ m.jsx(no.Provider, { value: P, children: t }) : t;
}
function Tv({
  cognitoAuthConfig: t,
  basename: a = "",
  getOfflineIdentity: r,
  children: s
}) {
  const n = El() ? { ...t, automaticSilentRenew: !1, monitorSession: !1 } : t;
  return /* @__PURE__ */ m.jsx(Fu, { ...n, children: /* @__PURE__ */ m.jsx(Dl, { basename: a, getOfflineIdentity: r, children: s }) });
}
const Ev = ({
  onConfirm: t,
  onCancel: a,
  confirmText: r = "Confirm",
  cancelText: s = "Cancel",
  buttonText: n = "Delete",
  buttonIcon: e = /* @__PURE__ */ m.jsx(Vu, {}),
  variant: i = "outlined",
  color: o = "error",
  size: u = "small",
  disabled: l = !1,
  "data-testid": c,
  confirmButtonTestId: d,
  cancelButtonTestId: h
}) => {
  const [g, U] = H(!1), P = () => {
    U(!0);
  }, D = () => {
    U(!1), t();
  }, j = () => {
    U(!1), a && a();
  };
  return g ? /* @__PURE__ */ m.jsxs(pe, { sx: { display: "flex", gap: 1 }, children: [
    /* @__PURE__ */ m.jsx(
      ht,
      {
        variant: "contained",
        color: o,
        size: u,
        onClick: D,
        "data-testid": d,
        children: r
      }
    ),
    /* @__PURE__ */ m.jsx(
      ht,
      {
        variant: "outlined",
        size: u,
        onClick: j,
        "data-testid": h,
        children: s
      }
    )
  ] }) : /* @__PURE__ */ m.jsx(
    ht,
    {
      variant: i,
      color: o,
      size: u,
      startIcon: e,
      onClick: P,
      disabled: l,
      "data-testid": c,
      children: n
    }
  );
};
function Cv({
  rows: t = 5,
  columns: a = 1,
  showHeader: r = !0,
  dense: s = !1,
  sx: n,
  ...e
}) {
  const i = s ? 28 : 40, o = s ? 0.75 : 1.25, u = Math.max(1, a), l = (c, d) => /* @__PURE__ */ m.jsx(Vr, { direction: "row", spacing: o, sx: { width: "100%" }, children: Array.from({ length: u }).map((h, g) => /* @__PURE__ */ m.jsx(
    Fr,
    {
      variant: "rounded",
      height: d,
      sx: { flex: 1, borderRadius: 1 }
    },
    g
  )) }, c);
  return /* @__PURE__ */ m.jsx(
    De,
    {
      role: "progressbar",
      "aria-busy": "true",
      "aria-label": "Loading",
      "data-testid": "table-skeleton",
      sx: { width: "100%", ...n },
      ...e,
      children: /* @__PURE__ */ m.jsxs(Vr, { spacing: o, children: [
        r && l("header", i * 0.7),
        Array.from({ length: Math.max(1, t) }).map(
          (c, d) => l(`row-${d}`, i)
        )
      ] })
    }
  );
}
function xv() {
  const t = Vt();
  return /* @__PURE__ */ m.jsxs(
    pe,
    {
      "data-testid": "logged-out-page",
      component: "main",
      sx: {
        minHeight: "75vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        textAlign: "center",
        px: 3,
        bgcolor: "background.default"
      },
      children: [
        /* @__PURE__ */ m.jsx(pe, { sx: { color: qt.darkGrey, mb: 4, lineHeight: 0 }, children: /* @__PURE__ */ m.jsx(
          Ua,
          {
            "data-testid": "logged-out-logo",
            role: "img",
            "aria-label": "Fox Village",
            style: { width: 280, maxWidth: "100%", height: "auto" }
          }
        ) }),
        /* @__PURE__ */ m.jsx(Ze, { variant: "h5", gutterBottom: !0, children: "You have been signed out" }),
        /* @__PURE__ */ m.jsx(
          Ze,
          {
            variant: "body1",
            sx: { mb: 4, maxWidth: 480, color: "text.secondary" },
            children: "Your session has ended. Sign in again to continue."
          }
        ),
        /* @__PURE__ */ m.jsx(
          ht,
          {
            "data-testid": "logged-out-sign-in",
            variant: "contained",
            size: "large",
            onClick: () => t.signinRedirect(),
            sx: {
              bgcolor: qt.foxOrange,
              color: qt.darkRed,
              fontWeight: 700,
              textTransform: "none",
              px: 4,
              py: 1.25,
              "&:hover": {
                bgcolor: qt.foxOrange,
                filter: "brightness(0.92)"
              }
            },
            children: "Sign in again"
          }
        )
      ]
    }
  );
}
function Ov({ navigateFunction: t }) {
  const a = Vt();
  return ke(() => {
    let r = !0;
    async function s() {
      await a.removeUser(), r && t("/logged-out", { replace: !0 });
    }
    return s(), () => {
      r = !1;
    };
  }, [a, t]), /* @__PURE__ */ m.jsx("div", { children: "You have been logged out." });
}
function kv({ theme: t, children: a }) {
  return !t || typeof t != "object" ? (console.error("Invalid theme object provided to MuiThemeProvider"), a) : /* @__PURE__ */ m.jsxs($u, { theme: t, children: [
    /* @__PURE__ */ m.jsx(qu, {}),
    a
  ] });
}
const Ll = Zr(De)(({ theme: t, backgroundColor: a, color: r, width: s }) => ({
  width: s,
  height: "100%",
  backgroundColor: a || t.palette.background.paper,
  color: r || t.palette.text.primary,
  borderRight: `1px solid ${t.palette.divider}`,
  display: "flex",
  flexDirection: "column",
  paddingTop: t.spacing(1),
  overflow: "hidden",
  transition: "width 0.15s ease"
})), jl = Zr(Oa)(({ theme: t, backgroundColor: a, color: r }) => ({
  position: "absolute",
  top: t.spacing(1.5),
  right: 0,
  transform: "translateX(50%)",
  width: 20,
  height: 20,
  padding: 0,
  borderRadius: 4,
  backgroundColor: a || t.palette.background.paper,
  color: r || t.palette.text.primary,
  border: `1px solid ${t.palette.divider}`,
  zIndex: 1,
  "&:hover": {
    backgroundColor: a || t.palette.background.paper,
    opacity: 0.8
  }
})), Pv = ({
  navItems: t,
  backgroundColor: a = "#1a1a1a",
  color: r = "inherit"
}) => {
  const { expanded: s, width: n, toggleExpanded: e } = Qa(), i = [
    {
      icon: /* @__PURE__ */ m.jsx(La, {}),
      text: "Home",
      onClick: () => {
      }
    },
    {
      icon: /* @__PURE__ */ m.jsx(ja, {}),
      text: "Settings",
      onClick: () => {
      }
    }
  ], o = t && t.length > 0 ? t : i;
  return /* @__PURE__ */ m.jsxs(De, { sx: { position: "relative", width: "100%", height: "100%" }, children: [
    /* @__PURE__ */ m.jsx(Ll, { backgroundColor: a, color: r, width: n, children: /* @__PURE__ */ m.jsx(ns, { sx: { width: "100%", p: 0 }, children: o.map((u, l) => {
      const c = /* @__PURE__ */ m.jsxs(
        Ju,
        {
          onClick: u.onClick,
          sx: {
            flexDirection: s ? "row" : "column",
            justifyContent: s ? "flex-start" : "center",
            py: 1,
            px: s ? 2 : 0,
            gap: s ? 1.5 : 0,
            color: "inherit",
            // #582 — nav items are clickable; show the pointer (hand) cursor
            // on hover (ListItem alone doesn't imply a button cursor).
            cursor: "pointer",
            "&:hover": {
              backgroundColor: "transparent",
              opacity: 0.8
            }
          },
          children: [
            /* @__PURE__ */ m.jsx(
              Pr,
              {
                sx: {
                  minWidth: "auto",
                  color: "inherit"
                },
                children: u.icon
              }
            ),
            s && /* @__PURE__ */ m.jsx(
              Da,
              {
                primary: u.text,
                primaryTypographyProps: {
                  variant: "caption",
                  align: "left",
                  sx: {
                    fontSize: "0.75rem",
                    color: "inherit",
                    whiteSpace: "nowrap"
                  }
                }
              }
            )
          ]
        },
        l
      );
      return s ? c : /* @__PURE__ */ m.jsx(Lr, { title: u.text, placement: "right", children: c }, l);
    }) }) }),
    /* @__PURE__ */ m.jsx(Lr, { title: s ? "Collapse navigation" : "Expand navigation", children: /* @__PURE__ */ m.jsx(
      jl,
      {
        onClick: e,
        "aria-label": s ? "Collapse navigation" : "Expand navigation",
        backgroundColor: a,
        color: r,
        children: s ? /* @__PURE__ */ m.jsx(Yu, { sx: { fontSize: 14 } }) : /* @__PURE__ */ m.jsx(Zu, { sx: { fontSize: 14 } })
      }
    ) })
  ] });
};
function Av({ children: t }) {
  const a = Vt(), r = Pl();
  return !a.isAuthenticated && !r ? /* @__PURE__ */ m.jsx(Ma, { to: "/callback", replace: !0 }) : t;
}
const Uv = ({
  children: t,
  maxWidth: a = 600,
  minWidth: r = 320,
  backTo: s,
  backLabel: n,
  breadcrumbs: e,
  onBack: i
}) => {
  const o = () => {
    i && i();
  };
  return /* @__PURE__ */ m.jsxs(
    pe,
    {
      maxWidth: a,
      minWidth: r,
      mt: 4,
      pb: 8,
      sx: {
        overflowX: "auto"
      },
      children: [
        /* @__PURE__ */ m.jsx(
          pe,
          {
            sx: {
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
              gap: 2,
              mb: 3
            },
            children: /* @__PURE__ */ m.jsxs(pe, { sx: { display: "flex", alignItems: "center", gap: 2, flex: 1 }, children: [
              s && /* @__PURE__ */ m.jsx(
                ht,
                {
                  startIcon: /* @__PURE__ */ m.jsx(zu, {}),
                  onClick: o,
                  variant: "outlined",
                  size: "small",
                  children: n || "Back"
                }
              ),
              e && /* @__PURE__ */ m.jsx(Tu, { separator: "", children: Sn.Children.map(e, (u, l) => {
                const c = Sn.Children.count(e);
                let d = "middle";
                return c === 1 ? d = "single" : l === 0 ? d = "first" : l === c - 1 && (d = "last"), Sn.cloneElement(u, { position: d });
              }) })
            ] })
          }
        ),
        t
      ]
    }
  );
}, Tt = "12px", Ml = Zr(De, {
  shouldForwardProp: (t) => t !== "position"
})(({ theme: t, position: a }) => {
  const r = () => {
    switch (a) {
      case "first":
        return `polygon(0 0, 100% 0, calc(100% - ${Tt}) 100%, 0 100%)`;
      case "middle":
        return `polygon(${Tt} 0, 100% 0, calc(100% - ${Tt}) 100%, 0 100%)`;
      case "last":
        return `polygon(${Tt} 0, calc(100% - ${Tt}) 0, 100% 50%, calc(100% - ${Tt}) 100%, 0 100%)`;
      case "single":
      default:
        return `polygon(0 0, calc(100% - ${Tt}) 0, 100% 50%, calc(100% - ${Tt}) 100%, 0 100%)`;
    }
  };
  return {
    position: "relative",
    display: "flex",
    alignItems: "center",
    height: "24px",
    backgroundColor: t.palette.mode === "dark" ? t.palette.grey[800] : t.palette.grey[200],
    color: t.palette.getContrastText(
      t.palette.mode === "dark" ? t.palette.grey[800] : t.palette.grey[200]
    ),
    cursor: "pointer",
    textDecoration: "none",
    clipPath: r(),
    // Nudge the items together to overlap
    marginLeft: a === "middle" || a === "last" ? `-${Tt}` : 0,
    // Adjust padding to make space for the clipped areas
    paddingLeft: a === "middle" || a === "last" ? `calc(${Tt} + ${t.spacing(1)})` : t.spacing(2),
    paddingRight: `calc(${Tt} + ${t.spacing(1)})`,
    "&:hover, &:focus-within": {
      backgroundColor: t.palette.mode === "dark" ? t.palette.grey[700] : t.palette.grey[300]
    }
  };
}), Fl = Zr(Mt)({
  whiteSpace: "nowrap",
  fontSize: "0.8125rem",
  fontWeight: 400,
  color: "inherit"
}), Nv = ({ label: t, component: a = "a", ...r }) => /* @__PURE__ */ m.jsx(Ml, { component: a, ...r, children: /* @__PURE__ */ m.jsx(Fl, { children: t }) }), Dv = ({ onClick: t, label: a, "data-testid": r }) => /* @__PURE__ */ m.jsx(
  Eu,
  {
    onClick: t,
    sx: {
      height: "100%",
      minHeight: 140,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      backgroundColor: (s) => s.palette.mode === "dark" ? s.palette.grey[800] : s.palette.grey[200],
      borderRadius: (s) => s.shape.borderRadius,
      padding: 2,
      "&:hover": {
        backgroundColor: (s) => s.palette.mode === "dark" ? s.palette.grey[700] : s.palette.grey[300]
      }
    },
    "data-testid": r || "new-item-card-button",
    children: /* @__PURE__ */ m.jsxs(
      pe,
      {
        sx: {
          width: "100%",
          height: "100%",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          border: "3px dashed",
          borderColor: "grey.500",
          borderRadius: "10px",
          padding: "20px",
          color: "grey.500"
        },
        children: [
          /* @__PURE__ */ m.jsx(
            pe,
            {
              sx: {
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: 48,
                height: 48,
                borderRadius: "50%",
                border: "3px solid",
                borderColor: "inherit",
                mb: 1
              },
              children: /* @__PURE__ */ m.jsx(Bu, { sx: { fontSize: 32 } })
            }
          ),
          /* @__PURE__ */ m.jsx(Ze, { variant: "button", component: "span", children: a })
        ]
      }
    )
  }
), Lv = ({ title: t, icon: a, tags: r = [], onEdit: s, showEdit: n, onMembers: e, showMembers: i, "data-testid": o, editButtonTestId: u, membersButtonTestId: l }) => /* @__PURE__ */ m.jsxs(
  jr,
  {
    sx: {
      position: "relative",
      minHeight: 120,
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-between",
      borderRadius: 0,
      backgroundColor: (c) => c.palette.mode === "dark" ? c.palette.grey[900] : c.palette.background.paper
    },
    "data-testid": o,
    elevation: 1,
    children: [
      /* @__PURE__ */ m.jsx(Mr, { sx: { pb: 1 }, children: /* @__PURE__ */ m.jsxs(pe, { sx: { display: "flex", alignItems: "center", mb: 2 }, children: [
        a && Sn.cloneElement(a, { sx: { mr: 1.5, color: "text.secondary" } }),
        /* @__PURE__ */ m.jsx(Ze, { variant: "h6", component: "div", noWrap: !0, children: t })
      ] }) }),
      /* @__PURE__ */ m.jsx(Mr, { sx: { pt: 0, flexGrow: 1 }, children: /* @__PURE__ */ m.jsx(yn, { direction: "row", spacing: 1, children: r.map((c, d) => /* @__PURE__ */ m.jsx(
        Cu,
        {
          label: c.label,
          color: c.color || "default",
          size: c.size || "small",
          variant: "outlined"
        },
        d
      )) }) }),
      /* @__PURE__ */ m.jsxs(pe, { sx: { position: "absolute", top: 8, right: 8, display: "flex", gap: 0.5 }, children: [
        i && /* @__PURE__ */ m.jsx(
          Ri,
          {
            "aria-label": `manage members for ${t}`,
            onClick: e,
            sx: {
              color: "text.secondary"
            },
            "data-testid": l,
            children: /* @__PURE__ */ m.jsx(Gu, {})
          }
        ),
        n && /* @__PURE__ */ m.jsx(
          Ri,
          {
            "aria-label": `edit ${t}`,
            onClick: s,
            sx: {
              color: "text.secondary"
            },
            "data-testid": u,
            children: /* @__PURE__ */ m.jsx(Hu, {})
          }
        )
      ] })
    ]
  }
);
class Wn extends Error {
}
Wn.prototype.name = "InvalidTokenError";
function Vl(t) {
  return decodeURIComponent(atob(t).replace(/(.)/g, (a, r) => {
    let s = r.charCodeAt(0).toString(16).toUpperCase();
    return s.length < 2 && (s = "0" + s), "%" + s;
  }));
}
function zl(t) {
  let a = t.replace(/-/g, "+").replace(/_/g, "/");
  switch (a.length % 4) {
    case 0:
      break;
    case 2:
      a += "==";
      break;
    case 3:
      a += "=";
      break;
    default:
      throw new Error("base64 string is not of the correct length");
  }
  try {
    return Vl(a);
  } catch {
    return atob(a);
  }
}
function or(t, a) {
  if (typeof t != "string")
    throw new Wn("Invalid token specified: must be a string");
  a || (a = {});
  const r = a.header === !0 ? 0 : 1, s = t.split(".")[r];
  if (typeof s != "string")
    throw new Wn(`Invalid token specified: missing part #${r + 1}`);
  let n;
  try {
    n = zl(s);
  } catch (e) {
    throw new Wn(`Invalid token specified: invalid base64 for part #${r + 1} (${e.message})`);
  }
  try {
    return JSON.parse(n);
  } catch (e) {
    throw new Wn(`Invalid token specified: invalid json for part #${r + 1} (${e.message})`);
  }
}
var xi = { d: (t, a) => {
  for (var r in a) xi.o(a, r) && !xi.o(t, r) && Object.defineProperty(t, r, { enumerable: !0, get: a[r] });
}, o: (t, a) => Object.prototype.hasOwnProperty.call(t, a) };
const Je = (Ms = { default: () => rs.default }, ui = {}, xi.d(ui, Ms), ui);
var Ms, ui;
function ro(t, a) {
  if (!(t instanceof a)) throw new TypeError("Cannot call a class as a function");
}
function Oi(t, a, r) {
  return Oi = is() ? Reflect.construct : function(s, n, e) {
    var i = [null];
    i.push.apply(i, n);
    var o = new (Function.bind.apply(s, i))();
    return e && Qn(o, e.prototype), o;
  }, Oi.apply(null, arguments);
}
function Ar(t, a, r) {
  return a in t ? Object.defineProperty(t, a, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : t[a] = r, t;
}
function Kn(t) {
  return Kn = Object.setPrototypeOf ? Object.getPrototypeOf : function(a) {
    return a.__proto__ || Object.getPrototypeOf(a);
  }, Kn(t);
}
function Qn(t, a) {
  return Qn = Object.setPrototypeOf || function(r, s) {
    return r.__proto__ = s, r;
  }, Qn(t, a);
}
function ki(t) {
  var a = typeof Map == "function" ? /* @__PURE__ */ new Map() : void 0;
  return ki = function(r) {
    if (r === null || (s = r, Function.toString.call(s).indexOf("[native code]") === -1)) return r;
    var s;
    if (typeof r != "function") throw new TypeError("Super expression must either be null or a function");
    if (a !== void 0) {
      if (a.has(r)) return a.get(r);
      a.set(r, n);
    }
    function n() {
      return Oi(r, arguments, Kn(this).constructor);
    }
    return n.prototype = Object.create(r.prototype, { constructor: { value: n, enumerable: !1, writable: !0, configurable: !0 } }), Qn(n, r);
  }, ki(t);
}
function is() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (is = function() {
    return !!t;
  })();
}
var Ye = "http://localhost".replace(/\/+$/, ""), Pn = function t(a) {
  var r, s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Ye, n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : Je.default;
  ro(this, t), Ar(this, "basePath", void 0), Ar(this, "axios", void 0), Ar(this, "configuration", void 0), this.basePath = s, this.axios = n, a && (this.configuration = a, this.basePath = (r = a.basePath) !== null && r !== void 0 ? r : s);
}, Bl = function() {
  function t(a, r) {
    var s;
    return ro(this, t), Ar(s = function(n, e, i) {
      return e = Kn(e), o = n, !(u = is() ? Reflect.construct(e, i || [], Kn(n).constructor) : e.apply(n, i)) || ((l = u) && typeof Symbol < "u" && l.constructor === Symbol ? "symbol" : typeof l) != "object" && typeof u != "function" ? function(c) {
        if (c === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return c;
      }(o) : u;
      var o, u, l;
    }(this, t, [r]), "field", void 0), s.field = a, s.name = "RequiredError", s;
  }
  return function(a, r) {
    if (typeof r != "function" && r !== null) throw new TypeError("Super expression must either be null or a function");
    a.prototype = Object.create(r && r.prototype, { constructor: { value: a, writable: !0, configurable: !0 } }), r && Qn(a, r);
  }(t, ki(Error)), t;
}(), Xe = {};
function Fs(t, a, r, s, n, e, i) {
  try {
    var o = t[e](i), u = o.value;
  } catch (l) {
    return void r(l);
  }
  o.done ? a(u) : Promise.resolve(u).then(s, n);
}
function Gl(t, a, r) {
  return a in t ? Object.defineProperty(t, a, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : t[a] = r, t;
}
var et = "https://example.com", qe = function(t, a, r) {
  if (r == null) throw new Bl(a, "Required parameter ".concat(a, " was null or undefined when calling ").concat(t, "."));
}, tt = function(t, a) {
  return (r = function() {
    var s, n;
    return function(e, i) {
      var o, u, l, c = { label: 0, sent: function() {
        if (1 & l[0]) throw l[1];
        return l[1];
      }, trys: [], ops: [] }, d = Object.create((typeof Iterator == "function" ? Iterator : Object).prototype);
      return d.next = h(0), d.throw = h(1), d.return = h(2), typeof Symbol == "function" && (d[Symbol.iterator] = function() {
        return this;
      }), d;
      function h(g) {
        return function(U) {
          return function(P) {
            if (o) throw new TypeError("Generator is already executing.");
            for (; d && (d = 0, P[0] && (c = 0)), c; ) try {
              if (o = 1, u && (l = 2 & P[0] ? u.return : P[0] ? u.throw || ((l = u.return) && l.call(u), 0) : u.next) && !(l = l.call(u, P[1])).done) return l;
              switch (u = 0, l && (P = [2 & P[0], l.value]), P[0]) {
                case 0:
                case 1:
                  l = P;
                  break;
                case 4:
                  return c.label++, { value: P[1], done: !1 };
                case 5:
                  c.label++, u = P[1], P = [0];
                  continue;
                case 7:
                  P = c.ops.pop(), c.trys.pop();
                  continue;
                default:
                  if (!((l = (l = c.trys).length > 0 && l[l.length - 1]) || P[0] !== 6 && P[0] !== 2)) {
                    c = 0;
                    continue;
                  }
                  if (P[0] === 3 && (!l || P[1] > l[0] && P[1] < l[3])) {
                    c.label = P[1];
                    break;
                  }
                  if (P[0] === 6 && c.label < l[1]) {
                    c.label = l[1], l = P;
                    break;
                  }
                  if (l && c.label < l[2]) {
                    c.label = l[2], c.ops.push(P);
                    break;
                  }
                  l[2] && c.ops.pop(), c.trys.pop();
                  continue;
              }
              P = i.call(e, c);
            } catch (D) {
              P = [6, D], u = 0;
            } finally {
              o = l = 0;
            }
            if (5 & P[0]) throw P[1];
            return { value: P[0] ? P[1] : void 0, done: !0 };
          }([g, U]);
        };
      }
    }(this, function(e) {
      switch (e.label) {
        case 0:
          return a && a.accessToken ? typeof a.accessToken != "function" ? [3, 2] : [4, a.accessToken()] : [3, 5];
        case 1:
          return n = e.sent(), [3, 4];
        case 2:
          return [4, a.accessToken];
        case 3:
          n = e.sent(), e.label = 4;
        case 4:
          s = n, t.Authorization = "Bearer " + s, e.label = 5;
        case 5:
          return [2];
      }
    });
  }, function() {
    var s = this, n = arguments;
    return new Promise(function(e, i) {
      var o = r.apply(s, n);
      function u(c) {
        Fs(o, e, i, u, l, "next", c);
      }
      function l(c) {
        Fs(o, e, i, u, l, "throw", c);
      }
      u(void 0);
    });
  })();
  var r;
};
function Pi(t, a) {
  var r, s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "";
  a != null && ((a === void 0 ? "undefined" : (r = a) && typeof Symbol < "u" && r.constructor === Symbol ? "symbol" : typeof r) == "object" ? Array.isArray(a) ? a.forEach(function(n) {
    return Pi(t, n, s);
  }) : Object.keys(a).forEach(function(n) {
    return Pi(t, a[n], "".concat(s).concat(s !== "" ? "." : "").concat(n));
  }) : t.has(s) ? t.append(s, a) : t.set(s, a));
}
var nt = function(t) {
  for (var a = arguments.length, r = new Array(a > 1 ? a - 1 : 0), s = 1; s < a; s++) r[s - 1] = arguments[s];
  var n = new URLSearchParams(t.search);
  Pi(n, r), t.search = n.toString();
}, Ot = function(t, a, r) {
  var s = typeof t != "string";
  return (s && r && r.isJsonMime ? r.isJsonMime(a.headers["Content-Type"]) : s) ? JSON.stringify(t !== void 0 ? t : {}) : t || "";
}, rt = function(t) {
  return t.pathname + t.search + t.hash;
}, it = function(t, a, r, s) {
  return function() {
    var n, e, i, o = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : a, u = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : r, l = (e = function(c) {
      for (var d = 1; d < arguments.length; d++) {
        var h = arguments[d] != null ? arguments[d] : {}, g = Object.keys(h);
        typeof Object.getOwnPropertySymbols == "function" && (g = g.concat(Object.getOwnPropertySymbols(h).filter(function(U) {
          return Object.getOwnPropertyDescriptor(h, U).enumerable;
        }))), g.forEach(function(U) {
          Gl(c, U, h[U]);
        });
      }
      return c;
    }({}, t.options), i = (i = { url: (o.defaults.baseURL ? "" : (n = s == null ? void 0 : s.basePath) !== null && n !== void 0 ? n : u) + t.url }) != null ? i : {}, Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(i)) : function(c) {
      var d = Object.keys(c);
      if (Object.getOwnPropertySymbols) {
        var h = Object.getOwnPropertySymbols(c);
        d.push.apply(d, h);
      }
      return d;
    }(Object(i)).forEach(function(c) {
      Object.defineProperty(e, c, Object.getOwnPropertyDescriptor(i, c));
    }), e);
    return o.request(l);
  };
};
function Vs(t, a, r, s, n, e, i) {
  try {
    var o = t[e](i), u = o.value;
  } catch (l) {
    return void r(l);
  }
  o.done ? a(u) : Promise.resolve(u).then(s, n);
}
function se(t) {
  return function() {
    var a = this, r = arguments;
    return new Promise(function(s, n) {
      var e = t.apply(a, r);
      function i(u) {
        Vs(e, s, n, i, o, "next", u);
      }
      function o(u) {
        Vs(e, s, n, i, o, "throw", u);
      }
      i(void 0);
    });
  };
}
function An(t, a, r) {
  return a = zr(a), s = t, !(n = io() ? Reflect.construct(a, r || [], zr(t).constructor) : a.apply(t, r)) || ((e = n) && typeof Symbol < "u" && e.constructor === Symbol ? "symbol" : typeof e) != "object" && typeof n != "function" ? function(i) {
    if (i === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return i;
  }(s) : n;
  var s, n, e;
}
function Un(t, a) {
  if (!(t instanceof a)) throw new TypeError("Cannot call a class as a function");
}
function Hl(t, a) {
  for (var r = 0; r < a.length; r++) {
    var s = a[r];
    s.enumerable = s.enumerable || !1, s.configurable = !0, "value" in s && (s.writable = !0), Object.defineProperty(t, s.key, s);
  }
}
function Nn(t, a, r) {
  return a && Hl(t.prototype, a), t;
}
function $l(t, a, r) {
  return a in t ? Object.defineProperty(t, a, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : t[a] = r, t;
}
function zr(t) {
  return zr = Object.setPrototypeOf ? Object.getPrototypeOf : function(a) {
    return a.__proto__ || Object.getPrototypeOf(a);
  }, zr(t);
}
function Dn(t, a) {
  if (typeof a != "function" && a !== null) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(a && a.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), a && Ai(t, a);
}
function ie(t) {
  for (var a = 1; a < arguments.length; a++) {
    var r = arguments[a] != null ? arguments[a] : {}, s = Object.keys(r);
    typeof Object.getOwnPropertySymbols == "function" && (s = s.concat(Object.getOwnPropertySymbols(r).filter(function(n) {
      return Object.getOwnPropertyDescriptor(r, n).enumerable;
    }))), s.forEach(function(n) {
      $l(t, n, r[n]);
    });
  }
  return t;
}
function Ai(t, a) {
  return Ai = Object.setPrototypeOf || function(r, s) {
    return r.__proto__ = s, r;
  }, Ai(t, a);
}
function io() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (io = function() {
    return !!t;
  })();
}
function ae(t, a) {
  var r, s, n, e = { label: 0, sent: function() {
    if (1 & n[0]) throw n[1];
    return n[1];
  }, trys: [], ops: [] }, i = Object.create((typeof Iterator == "function" ? Iterator : Object).prototype);
  return i.next = o(0), i.throw = o(1), i.return = o(2), typeof Symbol == "function" && (i[Symbol.iterator] = function() {
    return this;
  }), i;
  function o(u) {
    return function(l) {
      return function(c) {
        if (r) throw new TypeError("Generator is already executing.");
        for (; i && (i = 0, c[0] && (e = 0)), e; ) try {
          if (r = 1, s && (n = 2 & c[0] ? s.return : c[0] ? s.throw || ((n = s.return) && n.call(s), 0) : s.next) && !(n = n.call(s, c[1])).done) return n;
          switch (s = 0, n && (c = [2 & c[0], n.value]), c[0]) {
            case 0:
            case 1:
              n = c;
              break;
            case 4:
              return e.label++, { value: c[1], done: !1 };
            case 5:
              e.label++, s = c[1], c = [0];
              continue;
            case 7:
              c = e.ops.pop(), e.trys.pop();
              continue;
            default:
              if (!((n = (n = e.trys).length > 0 && n[n.length - 1]) || c[0] !== 6 && c[0] !== 2)) {
                e = 0;
                continue;
              }
              if (c[0] === 3 && (!n || c[1] > n[0] && c[1] < n[3])) {
                e.label = c[1];
                break;
              }
              if (c[0] === 6 && e.label < n[1]) {
                e.label = n[1], n = c;
                break;
              }
              if (n && e.label < n[2]) {
                e.label = n[2], e.ops.push(c);
                break;
              }
              n[2] && e.ops.pop(), e.trys.pop();
              continue;
          }
          c = a.call(t, e);
        } catch (d) {
          c = [6, d], s = 0;
        } finally {
          r = n = 0;
        }
        if (5 & c[0]) throw c[1];
        return { value: c[0] ? c[1] : void 0, done: !0 };
      }([u, l]);
    };
  }
}
var Wl = function(t) {
  return { getAccountInfo: function() {
    var a = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return se(function() {
      var r, s, n, e, i, o;
      return ae(this, function(u) {
        switch (u.label) {
          case 0:
            return r = new URL("/account", et), t && (s = t.baseOptions), n = ie({ method: "GET" }, s, a), i = {}, [4, tt(e = {}, t)];
          case 1:
            return u.sent(), nt(r, i), o = s && s.headers ? s.headers : {}, n.headers = ie({}, e, o, a.headers), [2, { url: rt(r), options: n }];
        }
      });
    })();
  }, getAccountPicks: function() {
    var a = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return se(function() {
      var r, s, n, e, i, o;
      return ae(this, function(u) {
        switch (u.label) {
          case 0:
            return r = new URL("/account/picks", et), t && (s = t.baseOptions), n = ie({ method: "GET" }, s, a), i = {}, [4, tt(e = {}, t)];
          case 1:
            return u.sent(), nt(r, i), o = s && s.headers ? s.headers : {}, n.headers = ie({}, e, o, a.headers), [2, { url: rt(r), options: n }];
        }
      });
    })();
  }, updateAccount: function(a) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return se(function() {
      var s, n, e, i, o, u;
      return ae(this, function(l) {
        switch (l.label) {
          case 0:
            return s = new URL("/account", et), t && (n = t.baseOptions), e = ie({ method: "POST" }, n, r), o = {}, [4, tt(i = {}, t)];
          case 1:
            return l.sent(), i["Content-Type"] = "application/json", nt(s, o), u = n && n.headers ? n.headers : {}, e.headers = ie({}, i, u, r.headers), e.data = Ot(a, e, t), [2, { url: rt(s), options: e }];
        }
      });
    })();
  }, updateAccountPicks: function(a) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return se(function() {
      var s, n, e, i, o, u;
      return ae(this, function(l) {
        switch (l.label) {
          case 0:
            return s = new URL("/account/picks", et), t && (n = t.baseOptions), e = ie({ method: "PUT" }, n, r), o = {}, [4, tt(i = {}, t)];
          case 1:
            return l.sent(), i["Content-Type"] = "application/json", nt(s, o), u = n && n.headers ? n.headers : {}, e.headers = ie({}, i, u, r.headers), e.data = Ot(a, e, t), [2, { url: rt(s), options: e }];
        }
      });
    })();
  } };
}, wr = function(t) {
  var a = Wl(t);
  return { getAccountInfo: function(r) {
    return se(function() {
      var s, n, e, i, o, u;
      return ae(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, a.getAccountInfo(r)];
          case 1:
            return e = l.sent(), o = (i = t == null ? void 0 : t.serverIndex) !== null && i !== void 0 ? i : 0, u = (n = Xe["AccountApi.getAccountInfo"]) === null || n === void 0 || (s = n[o]) === null || s === void 0 ? void 0 : s.url, [2, function(c, d) {
              return it(e, Je.default, Ye, t)(c, u || d);
            }];
        }
      });
    })();
  }, getAccountPicks: function(r) {
    return se(function() {
      var s, n, e, i, o, u;
      return ae(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, a.getAccountPicks(r)];
          case 1:
            return e = l.sent(), o = (i = t == null ? void 0 : t.serverIndex) !== null && i !== void 0 ? i : 0, u = (n = Xe["AccountApi.getAccountPicks"]) === null || n === void 0 || (s = n[o]) === null || s === void 0 ? void 0 : s.url, [2, function(c, d) {
              return it(e, Je.default, Ye, t)(c, u || d);
            }];
        }
      });
    })();
  }, updateAccount: function(r, s) {
    return se(function() {
      var n, e, i, o, u, l;
      return ae(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, a.updateAccount(r, s)];
          case 1:
            return i = c.sent(), u = (o = t == null ? void 0 : t.serverIndex) !== null && o !== void 0 ? o : 0, l = (e = Xe["AccountApi.updateAccount"]) === null || e === void 0 || (n = e[u]) === null || n === void 0 ? void 0 : n.url, [2, function(d, h) {
              return it(i, Je.default, Ye, t)(d, l || h);
            }];
        }
      });
    })();
  }, updateAccountPicks: function(r, s) {
    return se(function() {
      var n, e, i, o, u, l;
      return ae(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, a.updateAccountPicks(r, s)];
          case 1:
            return i = c.sent(), u = (o = t == null ? void 0 : t.serverIndex) !== null && o !== void 0 ? o : 0, l = (e = Xe["AccountApi.updateAccountPicks"]) === null || e === void 0 || (n = e[u]) === null || n === void 0 ? void 0 : n.url, [2, function(d, h) {
              return it(i, Je.default, Ye, t)(d, l || h);
            }];
        }
      });
    })();
  } };
}, ql = function(t) {
  function a() {
    return Un(this, a), An(this, a, arguments);
  }
  return Dn(a, t), Nn(a, [{ key: "getAccountInfo", value: function(r) {
    var s = this;
    return wr(this.configuration).getAccountInfo(r).then(function(n) {
      return n(s.axios, s.basePath);
    });
  } }, { key: "getAccountPicks", value: function(r) {
    var s = this;
    return wr(this.configuration).getAccountPicks(r).then(function(n) {
      return n(s.axios, s.basePath);
    });
  } }, { key: "updateAccount", value: function(r, s) {
    var n = this;
    return wr(this.configuration).updateAccount(r, s).then(function(e) {
      return e(n.axios, n.basePath);
    });
  } }, { key: "updateAccountPicks", value: function(r, s) {
    var n = this;
    return wr(this.configuration).updateAccountPicks(r, s).then(function(e) {
      return e(n.axios, n.basePath);
    });
  } }]), a;
}(Pn), Jl = function(t) {
  return { getOrgEntitlements: function(a) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return se(function() {
      var s, n, e, i, o, u, l;
      return ae(this, function(c) {
        switch (c.label) {
          case 0:
            return qe("getOrgEntitlements", "id", a), s = "/org/{id}/entitlements".replace("{id}", encodeURIComponent(String(a))), n = new URL(s, et), t && (e = t.baseOptions), i = ie({ method: "GET" }, e, r), u = {}, [4, tt(o = {}, t)];
          case 1:
            return c.sent(), nt(n, u), l = e && e.headers ? e.headers : {}, i.headers = ie({}, o, l, r.headers), [2, { url: rt(n), options: i }];
        }
      });
    })();
  }, setOrgEntitlements: function(a, r) {
    var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return se(function() {
      var n, e, i, o, u, l, c;
      return ae(this, function(d) {
        switch (d.label) {
          case 0:
            return qe("setOrgEntitlements", "id", a), qe("setOrgEntitlements", "setOrgEntitlementsRequest", r), n = "/org/{id}/entitlements".replace("{id}", encodeURIComponent(String(a))), e = new URL(n, et), t && (i = t.baseOptions), o = ie({ method: "PUT" }, i, s), l = {}, [4, tt(u = {}, t)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", nt(e, l), c = i && i.headers ? i.headers : {}, o.headers = ie({}, u, c, s.headers), o.data = Ot(r, o, t), [2, { url: rt(e), options: o }];
        }
      });
    })();
  } };
}, zs = function(t) {
  var a = Jl(t);
  return { getOrgEntitlements: function(r, s) {
    return se(function() {
      var n, e, i, o, u, l;
      return ae(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, a.getOrgEntitlements(r, s)];
          case 1:
            return i = c.sent(), u = (o = t == null ? void 0 : t.serverIndex) !== null && o !== void 0 ? o : 0, l = (e = Xe["EntitlementsApi.getOrgEntitlements"]) === null || e === void 0 || (n = e[u]) === null || n === void 0 ? void 0 : n.url, [2, function(d, h) {
              return it(i, Je.default, Ye, t)(d, l || h);
            }];
        }
      });
    })();
  }, setOrgEntitlements: function(r, s, n) {
    return se(function() {
      var e, i, o, u, l, c;
      return ae(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, a.setOrgEntitlements(r, s, n)];
          case 1:
            return o = d.sent(), l = (u = t == null ? void 0 : t.serverIndex) !== null && u !== void 0 ? u : 0, c = (i = Xe["EntitlementsApi.setOrgEntitlements"]) === null || i === void 0 || (e = i[l]) === null || e === void 0 ? void 0 : e.url, [2, function(h, g) {
              return it(o, Je.default, Ye, t)(h, c || g);
            }];
        }
      });
    })();
  } };
};
(function(t) {
  function a() {
    return Un(this, a), An(this, a, arguments);
  }
  return Dn(a, t), Nn(a, [{ key: "getOrgEntitlements", value: function(r, s) {
    var n = this;
    return zs(this.configuration).getOrgEntitlements(r, s).then(function(e) {
      return e(n.axios, n.basePath);
    });
  } }, { key: "setOrgEntitlements", value: function(r, s, n) {
    var e = this;
    return zs(this.configuration).setOrgEntitlements(r, s, n).then(function(i) {
      return i(e.axios, e.basePath);
    });
  } }]), a;
})(Pn);
var Yl = function(t) {
  return { createOrganization: function(a) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return se(function() {
      var s, n, e, i, o, u;
      return ae(this, function(l) {
        switch (l.label) {
          case 0:
            return qe("createOrganization", "createOrganizationRequest", a), s = new URL("/org", et), t && (n = t.baseOptions), e = ie({ method: "POST" }, n, r), o = {}, [4, tt(i = {}, t)];
          case 1:
            return l.sent(), i["Content-Type"] = "application/json", nt(s, o), u = n && n.headers ? n.headers : {}, e.headers = ie({}, i, u, r.headers), e.data = Ot(a, e, t), [2, { url: rt(s), options: e }];
        }
      });
    })();
  }, getOrganization: function(a) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return se(function() {
      var s, n, e, i, o, u, l;
      return ae(this, function(c) {
        switch (c.label) {
          case 0:
            return qe("getOrganization", "id", a), s = "/org/{id}".replace("{id}", encodeURIComponent(String(a))), n = new URL(s, et), t && (e = t.baseOptions), i = ie({ method: "GET" }, e, r), u = {}, [4, tt(o = {}, t)];
          case 1:
            return c.sent(), nt(n, u), l = e && e.headers ? e.headers : {}, i.headers = ie({}, o, l, r.headers), [2, { url: rt(n), options: i }];
        }
      });
    })();
  }, listAllOrganizations: function(a) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return se(function() {
      var s, n, e, i, o, u;
      return ae(this, function(l) {
        switch (l.label) {
          case 0:
            return s = new URL("/org/all", et), t && (n = t.baseOptions), e = ie({ method: "GET" }, n, r), o = {}, [4, tt(i = {}, t)];
          case 1:
            return l.sent(), a !== void 0 && (o.enabledOnly = a), nt(s, o), u = n && n.headers ? n.headers : {}, e.headers = ie({}, i, u, r.headers), [2, { url: rt(s), options: e }];
        }
      });
    })();
  }, listOrganizations: function() {
    var a = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return se(function() {
      var r, s, n, e, i, o;
      return ae(this, function(u) {
        switch (u.label) {
          case 0:
            return r = new URL("/org", et), t && (s = t.baseOptions), n = ie({ method: "GET" }, s, a), i = {}, [4, tt(e = {}, t)];
          case 1:
            return u.sent(), nt(r, i), o = s && s.headers ? s.headers : {}, n.headers = ie({}, e, o, a.headers), [2, { url: rt(r), options: n }];
        }
      });
    })();
  }, provisionOrganization: function(a) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return se(function() {
      var s, n, e, i, o, u;
      return ae(this, function(l) {
        switch (l.label) {
          case 0:
            return qe("provisionOrganization", "provisionOrganizationRequest", a), s = new URL("/org/provision", et), t && (n = t.baseOptions), e = ie({ method: "POST" }, n, r), o = {}, [4, tt(i = {}, t)];
          case 1:
            return l.sent(), i["Content-Type"] = "application/json", nt(s, o), u = n && n.headers ? n.headers : {}, e.headers = ie({}, i, u, r.headers), e.data = Ot(a, e, t), [2, { url: rt(s), options: e }];
        }
      });
    })();
  }, updateOrganization: function(a, r) {
    var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return se(function() {
      var n, e, i, o, u, l, c;
      return ae(this, function(d) {
        switch (d.label) {
          case 0:
            return qe("updateOrganization", "id", a), n = "/org/{id}".replace("{id}", encodeURIComponent(String(a))), e = new URL(n, et), t && (i = t.baseOptions), o = ie({ method: "POST" }, i, s), l = {}, [4, tt(u = {}, t)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", nt(e, l), c = i && i.headers ? i.headers : {}, o.headers = ie({}, u, c, s.headers), o.data = Ot(r, o, t), [2, { url: rt(e), options: o }];
        }
      });
    })();
  } };
}, cn = function(t) {
  var a = Yl(t);
  return { createOrganization: function(r, s) {
    return se(function() {
      var n, e, i, o, u, l;
      return ae(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, a.createOrganization(r, s)];
          case 1:
            return i = c.sent(), u = (o = t == null ? void 0 : t.serverIndex) !== null && o !== void 0 ? o : 0, l = (e = Xe["OrganizationApi.createOrganization"]) === null || e === void 0 || (n = e[u]) === null || n === void 0 ? void 0 : n.url, [2, function(d, h) {
              return it(i, Je.default, Ye, t)(d, l || h);
            }];
        }
      });
    })();
  }, getOrganization: function(r, s) {
    return se(function() {
      var n, e, i, o, u, l;
      return ae(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, a.getOrganization(r, s)];
          case 1:
            return i = c.sent(), u = (o = t == null ? void 0 : t.serverIndex) !== null && o !== void 0 ? o : 0, l = (e = Xe["OrganizationApi.getOrganization"]) === null || e === void 0 || (n = e[u]) === null || n === void 0 ? void 0 : n.url, [2, function(d, h) {
              return it(i, Je.default, Ye, t)(d, l || h);
            }];
        }
      });
    })();
  }, listAllOrganizations: function(r, s) {
    return se(function() {
      var n, e, i, o, u, l;
      return ae(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, a.listAllOrganizations(r, s)];
          case 1:
            return i = c.sent(), u = (o = t == null ? void 0 : t.serverIndex) !== null && o !== void 0 ? o : 0, l = (e = Xe["OrganizationApi.listAllOrganizations"]) === null || e === void 0 || (n = e[u]) === null || n === void 0 ? void 0 : n.url, [2, function(d, h) {
              return it(i, Je.default, Ye, t)(d, l || h);
            }];
        }
      });
    })();
  }, listOrganizations: function(r) {
    return se(function() {
      var s, n, e, i, o, u;
      return ae(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, a.listOrganizations(r)];
          case 1:
            return e = l.sent(), o = (i = t == null ? void 0 : t.serverIndex) !== null && i !== void 0 ? i : 0, u = (n = Xe["OrganizationApi.listOrganizations"]) === null || n === void 0 || (s = n[o]) === null || s === void 0 ? void 0 : s.url, [2, function(c, d) {
              return it(e, Je.default, Ye, t)(c, u || d);
            }];
        }
      });
    })();
  }, provisionOrganization: function(r, s) {
    return se(function() {
      var n, e, i, o, u, l;
      return ae(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, a.provisionOrganization(r, s)];
          case 1:
            return i = c.sent(), u = (o = t == null ? void 0 : t.serverIndex) !== null && o !== void 0 ? o : 0, l = (e = Xe["OrganizationApi.provisionOrganization"]) === null || e === void 0 || (n = e[u]) === null || n === void 0 ? void 0 : n.url, [2, function(d, h) {
              return it(i, Je.default, Ye, t)(d, l || h);
            }];
        }
      });
    })();
  }, updateOrganization: function(r, s, n) {
    return se(function() {
      var e, i, o, u, l, c;
      return ae(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, a.updateOrganization(r, s, n)];
          case 1:
            return o = d.sent(), l = (u = t == null ? void 0 : t.serverIndex) !== null && u !== void 0 ? u : 0, c = (i = Xe["OrganizationApi.updateOrganization"]) === null || i === void 0 || (e = i[l]) === null || e === void 0 ? void 0 : e.url, [2, function(h, g) {
              return it(o, Je.default, Ye, t)(h, c || g);
            }];
        }
      });
    })();
  } };
};
(function(t) {
  function a() {
    return Un(this, a), An(this, a, arguments);
  }
  return Dn(a, t), Nn(a, [{ key: "createOrganization", value: function(r, s) {
    var n = this;
    return cn(this.configuration).createOrganization(r, s).then(function(e) {
      return e(n.axios, n.basePath);
    });
  } }, { key: "getOrganization", value: function(r, s) {
    var n = this;
    return cn(this.configuration).getOrganization(r, s).then(function(e) {
      return e(n.axios, n.basePath);
    });
  } }, { key: "listAllOrganizations", value: function(r, s) {
    var n = this;
    return cn(this.configuration).listAllOrganizations(r, s).then(function(e) {
      return e(n.axios, n.basePath);
    });
  } }, { key: "listOrganizations", value: function(r) {
    var s = this;
    return cn(this.configuration).listOrganizations(r).then(function(n) {
      return n(s.axios, s.basePath);
    });
  } }, { key: "provisionOrganization", value: function(r, s) {
    var n = this;
    return cn(this.configuration).provisionOrganization(r, s).then(function(e) {
      return e(n.axios, n.basePath);
    });
  } }, { key: "updateOrganization", value: function(r, s, n) {
    var e = this;
    return cn(this.configuration).updateOrganization(r, s, n).then(function(i) {
      return i(e.axios, e.basePath);
    });
  } }]), a;
})(Pn);
var Zl = function(t) {
  return { createOrganizationMember: function(a, r) {
    var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return se(function() {
      var n, e, i, o, u, l, c;
      return ae(this, function(d) {
        switch (d.label) {
          case 0:
            return qe("createOrganizationMember", "orgId", a), n = "/org/{orgId}/member".replace("{orgId}", encodeURIComponent(String(a))), e = new URL(n, et), t && (i = t.baseOptions), o = ie({ method: "POST" }, i, s), l = {}, [4, tt(u = {}, t)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", nt(e, l), c = i && i.headers ? i.headers : {}, o.headers = ie({}, u, c, s.headers), o.data = Ot(r, o, t), [2, { url: rt(e), options: o }];
        }
      });
    })();
  }, editOrganizationMember: function(a, r, s) {
    var n = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    return se(function() {
      var e, i, o, u, l, c, d;
      return ae(this, function(h) {
        switch (h.label) {
          case 0:
            return qe("editOrganizationMember", "orgId", a), qe("editOrganizationMember", "userId", r), e = "/org/{orgId}/member/{userId}".replace("{orgId}", encodeURIComponent(String(a))).replace("{userId}", encodeURIComponent(String(r))), i = new URL(e, et), t && (o = t.baseOptions), u = ie({ method: "PATCH" }, o, n), c = {}, [4, tt(l = {}, t)];
          case 1:
            return h.sent(), l["Content-Type"] = "application/json", nt(i, c), d = o && o.headers ? o.headers : {}, u.headers = ie({}, l, d, n.headers), u.data = Ot(s, u, t), [2, { url: rt(i), options: u }];
        }
      });
    })();
  }, listOrganizationMembers: function(a, r, s) {
    var n = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    return se(function() {
      var e, i, o, u, l, c, d;
      return ae(this, function(h) {
        switch (h.label) {
          case 0:
            return qe("listOrganizationMembers", "orgId", a), e = "/org/{orgId}/member".replace("{orgId}", encodeURIComponent(String(a))), i = new URL(e, et), t && (o = t.baseOptions), u = ie({ method: "GET" }, o, n), c = {}, [4, tt(l = {}, t)];
          case 1:
            return h.sent(), r !== void 0 && (c.limit = r), s !== void 0 && (c.cursor = s), nt(i, c), d = o && o.headers ? o.headers : {}, u.headers = ie({}, l, d, n.headers), [2, { url: rt(i), options: u }];
        }
      });
    })();
  }, lookupOrganizationMember: function(a, r) {
    var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return se(function() {
      var n, e, i, o, u, l, c;
      return ae(this, function(d) {
        switch (d.label) {
          case 0:
            return qe("lookupOrganizationMember", "email", a), qe("lookupOrganizationMember", "orgId", r), n = "/org/{orgId}/member/lookup".replace("{orgId}", encodeURIComponent(String(r))), e = new URL(n, et), t && (i = t.baseOptions), o = ie({ method: "GET" }, i, s), l = {}, [4, tt(u = {}, t)];
          case 1:
            return d.sent(), a !== void 0 && (l.email = a), nt(e, l), c = i && i.headers ? i.headers : {}, o.headers = ie({}, u, c, s.headers), [2, { url: rt(e), options: o }];
        }
      });
    })();
  }, removeOrganizationMember: function(a, r) {
    var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return se(function() {
      var n, e, i, o, u, l, c;
      return ae(this, function(d) {
        switch (d.label) {
          case 0:
            return qe("removeOrganizationMember", "orgId", a), qe("removeOrganizationMember", "userId", r), n = "/org/{orgId}/member/{userId}".replace("{orgId}", encodeURIComponent(String(a))).replace("{userId}", encodeURIComponent(String(r))), e = new URL(n, et), t && (i = t.baseOptions), o = ie({ method: "DELETE" }, i, s), l = {}, [4, tt(u = {}, t)];
          case 1:
            return d.sent(), nt(e, l), c = i && i.headers ? i.headers : {}, o.headers = ie({}, u, c, s.headers), [2, { url: rt(e), options: o }];
        }
      });
    })();
  } };
}, Vn = function(t) {
  var a = Zl(t);
  return { createOrganizationMember: function(r, s, n) {
    return se(function() {
      var e, i, o, u, l, c;
      return ae(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, a.createOrganizationMember(r, s, n)];
          case 1:
            return o = d.sent(), l = (u = t == null ? void 0 : t.serverIndex) !== null && u !== void 0 ? u : 0, c = (i = Xe["OrganizationMemberApi.createOrganizationMember"]) === null || i === void 0 || (e = i[l]) === null || e === void 0 ? void 0 : e.url, [2, function(h, g) {
              return it(o, Je.default, Ye, t)(h, c || g);
            }];
        }
      });
    })();
  }, editOrganizationMember: function(r, s, n, e) {
    return se(function() {
      var i, o, u, l, c, d;
      return ae(this, function(h) {
        switch (h.label) {
          case 0:
            return [4, a.editOrganizationMember(r, s, n, e)];
          case 1:
            return u = h.sent(), c = (l = t == null ? void 0 : t.serverIndex) !== null && l !== void 0 ? l : 0, d = (o = Xe["OrganizationMemberApi.editOrganizationMember"]) === null || o === void 0 || (i = o[c]) === null || i === void 0 ? void 0 : i.url, [2, function(g, U) {
              return it(u, Je.default, Ye, t)(g, d || U);
            }];
        }
      });
    })();
  }, listOrganizationMembers: function(r, s, n, e) {
    return se(function() {
      var i, o, u, l, c, d;
      return ae(this, function(h) {
        switch (h.label) {
          case 0:
            return [4, a.listOrganizationMembers(r, s, n, e)];
          case 1:
            return u = h.sent(), c = (l = t == null ? void 0 : t.serverIndex) !== null && l !== void 0 ? l : 0, d = (o = Xe["OrganizationMemberApi.listOrganizationMembers"]) === null || o === void 0 || (i = o[c]) === null || i === void 0 ? void 0 : i.url, [2, function(g, U) {
              return it(u, Je.default, Ye, t)(g, d || U);
            }];
        }
      });
    })();
  }, lookupOrganizationMember: function(r, s, n) {
    return se(function() {
      var e, i, o, u, l, c;
      return ae(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, a.lookupOrganizationMember(r, s, n)];
          case 1:
            return o = d.sent(), l = (u = t == null ? void 0 : t.serverIndex) !== null && u !== void 0 ? u : 0, c = (i = Xe["OrganizationMemberApi.lookupOrganizationMember"]) === null || i === void 0 || (e = i[l]) === null || e === void 0 ? void 0 : e.url, [2, function(h, g) {
              return it(o, Je.default, Ye, t)(h, c || g);
            }];
        }
      });
    })();
  }, removeOrganizationMember: function(r, s, n) {
    return se(function() {
      var e, i, o, u, l, c;
      return ae(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, a.removeOrganizationMember(r, s, n)];
          case 1:
            return o = d.sent(), l = (u = t == null ? void 0 : t.serverIndex) !== null && u !== void 0 ? u : 0, c = (i = Xe["OrganizationMemberApi.removeOrganizationMember"]) === null || i === void 0 || (e = i[l]) === null || e === void 0 ? void 0 : e.url, [2, function(h, g) {
              return it(o, Je.default, Ye, t)(h, c || g);
            }];
        }
      });
    })();
  } };
};
(function(t) {
  function a() {
    return Un(this, a), An(this, a, arguments);
  }
  return Dn(a, t), Nn(a, [{ key: "createOrganizationMember", value: function(r, s, n) {
    var e = this;
    return Vn(this.configuration).createOrganizationMember(r, s, n).then(function(i) {
      return i(e.axios, e.basePath);
    });
  } }, { key: "editOrganizationMember", value: function(r, s, n, e) {
    var i = this;
    return Vn(this.configuration).editOrganizationMember(r, s, n, e).then(function(o) {
      return o(i.axios, i.basePath);
    });
  } }, { key: "listOrganizationMembers", value: function(r, s, n, e) {
    var i = this;
    return Vn(this.configuration).listOrganizationMembers(r, s, n, e).then(function(o) {
      return o(i.axios, i.basePath);
    });
  } }, { key: "lookupOrganizationMember", value: function(r, s, n) {
    var e = this;
    return Vn(this.configuration).lookupOrganizationMember(r, s, n).then(function(i) {
      return i(e.axios, e.basePath);
    });
  } }, { key: "removeOrganizationMember", value: function(r, s, n) {
    var e = this;
    return Vn(this.configuration).removeOrganizationMember(r, s, n).then(function(i) {
      return i(e.axios, e.basePath);
    });
  } }]), a;
})(Pn);
var Kl = function(t) {
  return { getPermissionsManifest: function() {
    var a = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return se(function() {
      var r, s, n, e, i, o;
      return ae(this, function(u) {
        switch (u.label) {
          case 0:
            return r = new URL("/permissions/manifest", et), t && (s = t.baseOptions), n = ie({ method: "GET" }, s, a), i = {}, [4, tt(e = {}, t)];
          case 1:
            return u.sent(), nt(r, i), o = s && s.headers ? s.headers : {}, n.headers = ie({}, e, o, a.headers), [2, { url: rt(r), options: n }];
        }
      });
    })();
  } };
}, Ql = function(t) {
  var a = Kl(t);
  return { getPermissionsManifest: function(r) {
    return se(function() {
      var s, n, e, i, o, u;
      return ae(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, a.getPermissionsManifest(r)];
          case 1:
            return e = l.sent(), o = (i = t == null ? void 0 : t.serverIndex) !== null && i !== void 0 ? i : 0, u = (n = Xe["PermissionsApi.getPermissionsManifest"]) === null || n === void 0 || (s = n[o]) === null || s === void 0 ? void 0 : s.url, [2, function(c, d) {
              return it(e, Je.default, Ye, t)(c, u || d);
            }];
        }
      });
    })();
  } };
};
(function(t) {
  function a() {
    return Un(this, a), An(this, a, arguments);
  }
  return Dn(a, t), Nn(a, [{ key: "getPermissionsManifest", value: function(r) {
    var s = this;
    return Ql(this.configuration).getPermissionsManifest(r).then(function(n) {
      return n(s.axios, s.basePath);
    });
  } }]), a;
})(Pn);
var Xl = function(t) {
  return { assignRole: function(a, r, s) {
    var n = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    return se(function() {
      var e, i, o, u, l, c, d;
      return ae(this, function(h) {
        switch (h.label) {
          case 0:
            return qe("assignRole", "orgId", a), qe("assignRole", "userId", r), qe("assignRole", "assignRoleRequest", s), e = "/org/{orgId}/member/{userId}/role".replace("{orgId}", encodeURIComponent(String(a))).replace("{userId}", encodeURIComponent(String(r))), i = new URL(e, et), t && (o = t.baseOptions), u = ie({ method: "POST" }, o, n), c = {}, [4, tt(l = {}, t)];
          case 1:
            return h.sent(), l["Content-Type"] = "application/json", nt(i, c), d = o && o.headers ? o.headers : {}, u.headers = ie({}, l, d, n.headers), u.data = Ot(s, u, t), [2, { url: rt(i), options: u }];
        }
      });
    })();
  }, revokeRole: function(a, r, s) {
    var n = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    return se(function() {
      var e, i, o, u, l, c, d;
      return ae(this, function(h) {
        switch (h.label) {
          case 0:
            return qe("revokeRole", "orgId", a), qe("revokeRole", "userId", r), qe("revokeRole", "assignRoleRequest", s), e = "/org/{orgId}/member/{userId}/role".replace("{orgId}", encodeURIComponent(String(a))).replace("{userId}", encodeURIComponent(String(r))), i = new URL(e, et), t && (o = t.baseOptions), u = ie({ method: "DELETE" }, o, n), c = {}, [4, tt(l = {}, t)];
          case 1:
            return h.sent(), l["Content-Type"] = "application/json", nt(i, c), d = o && o.headers ? o.headers : {}, u.headers = ie({}, l, d, n.headers), u.data = Ot(s, u, t), [2, { url: rt(i), options: u }];
        }
      });
    })();
  } };
}, Bs = function(t) {
  var a = Xl(t);
  return { assignRole: function(r, s, n, e) {
    return se(function() {
      var i, o, u, l, c, d;
      return ae(this, function(h) {
        switch (h.label) {
          case 0:
            return [4, a.assignRole(r, s, n, e)];
          case 1:
            return u = h.sent(), c = (l = t == null ? void 0 : t.serverIndex) !== null && l !== void 0 ? l : 0, d = (o = Xe["RolesApi.assignRole"]) === null || o === void 0 || (i = o[c]) === null || i === void 0 ? void 0 : i.url, [2, function(g, U) {
              return it(u, Je.default, Ye, t)(g, d || U);
            }];
        }
      });
    })();
  }, revokeRole: function(r, s, n, e) {
    return se(function() {
      var i, o, u, l, c, d;
      return ae(this, function(h) {
        switch (h.label) {
          case 0:
            return [4, a.revokeRole(r, s, n, e)];
          case 1:
            return u = h.sent(), c = (l = t == null ? void 0 : t.serverIndex) !== null && l !== void 0 ? l : 0, d = (o = Xe["RolesApi.revokeRole"]) === null || o === void 0 || (i = o[c]) === null || i === void 0 ? void 0 : i.url, [2, function(g, U) {
              return it(u, Je.default, Ye, t)(g, d || U);
            }];
        }
      });
    })();
  } };
};
(function(t) {
  function a() {
    return Un(this, a), An(this, a, arguments);
  }
  return Dn(a, t), Nn(a, [{ key: "assignRole", value: function(r, s, n, e) {
    var i = this;
    return Bs(this.configuration).assignRole(r, s, n, e).then(function(o) {
      return o(i.axios, i.basePath);
    });
  } }, { key: "revokeRole", value: function(r, s, n, e) {
    var i = this;
    return Bs(this.configuration).revokeRole(r, s, n, e).then(function(o) {
      return o(i.axios, i.basePath);
    });
  } }]), a;
})(Pn);
function ec(t, a) {
  for (var r = 0; r < a.length; r++) {
    var s = a[r];
    s.enumerable = s.enumerable || !1, s.configurable = !0, "value" in s && (s.writable = !0), Object.defineProperty(t, s.key, s);
  }
}
function Nt(t, a, r) {
  return a in t ? Object.defineProperty(t, a, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : t[a] = r, t;
}
function Gs(t) {
  for (var a = 1; a < arguments.length; a++) {
    var r = arguments[a] != null ? arguments[a] : {}, s = Object.keys(r);
    typeof Object.getOwnPropertySymbols == "function" && (s = s.concat(Object.getOwnPropertySymbols(r).filter(function(n) {
      return Object.getOwnPropertyDescriptor(r, n).enumerable;
    }))), s.forEach(function(n) {
      Nt(t, n, r[n]);
    });
  }
  return t;
}
var tc = function() {
  function t() {
    var s, n, e, i = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    (function(o, u) {
      if (!(o instanceof u)) throw new TypeError("Cannot call a class as a function");
    })(this, t), Nt(this, "apiKey", void 0), Nt(this, "username", void 0), Nt(this, "password", void 0), Nt(this, "accessToken", void 0), Nt(this, "basePath", void 0), Nt(this, "serverIndex", void 0), Nt(this, "baseOptions", void 0), Nt(this, "formDataCtor", void 0), this.apiKey = i.apiKey, this.username = i.username, this.password = i.password, this.accessToken = i.accessToken, this.basePath = i.basePath, this.serverIndex = i.serverIndex, this.baseOptions = (n = Gs({}, i.baseOptions), e = (e = { headers: Gs({}, (s = i.baseOptions) === null || s === void 0 ? void 0 : s.headers) }) != null ? e : {}, Object.getOwnPropertyDescriptors ? Object.defineProperties(n, Object.getOwnPropertyDescriptors(e)) : function(o) {
      var u = Object.keys(o);
      if (Object.getOwnPropertySymbols) {
        var l = Object.getOwnPropertySymbols(o);
        u.push.apply(u, l);
      }
      return u;
    }(Object(e)).forEach(function(o) {
      Object.defineProperty(n, o, Object.getOwnPropertyDescriptor(e, o));
    }), n), this.formDataCtor = i.formDataCtor;
  }
  var a, r;
  return a = t, (r = [{ key: "isJsonMime", value: function(s) {
    var n = new RegExp("^(application/json|[^;/ 	]+/[^;/ 	]+[+]json)[ 	]*(;.*)?$", "i");
    return s !== null && (n.test(s) || s.toLowerCase() === "application/json-patch+json");
  } }]) && ec(a.prototype, r), t;
}();
const nc = 4e3, Ui = "common-fe.accountPicksDirty", rc = () => {
  try {
    return window.localStorage.getItem(Ui) === "1";
  } catch {
    return !1;
  }
}, Hs = (t) => {
  try {
    t ? window.localStorage.setItem(Ui, "1") : window.localStorage.removeItem(Ui);
  } catch {
  }
}, ic = (t) => {
  const a = t == null ? void 0 : t.data;
  if (!a || a.status !== "success" || !a.data)
    throw new Error("Unexpected account picks response");
  return {
    activeOrgId: a.data.activeOrgId ?? null,
    showByOrg: a.data.showByOrg ?? {}
  };
}, Kr = Object.freeze({
  enabled: !1,
  settled: !0,
  serverPicks: null,
  dirtyAtLoad: !1,
  savePicks: () => {
  }
}), sc = Object.freeze({ ...Kr, settled: !1 });
function ac(t, a) {
  const r = !!(t && a), [s, n] = H({
    loaded: !1,
    serverPicks: null,
    dirtyAtLoad: !1
  }), e = ut(a);
  e.current = a;
  const i = ut(t);
  i.current = t;
  const o = ut(Promise.resolve()), u = ut(!1), l = gt(
    () => new ql(
      new tc({
        basePath: i.current,
        accessToken: e.current
      })
    ),
    []
  );
  ke(() => {
    if (!r) return;
    let d = !1;
    const h = new AbortController(), g = setTimeout(() => h.abort(), nc), U = rc();
    return (async () => {
      try {
        const P = await l().getAccountPicks({
          signal: h.signal
        });
        if (d) return;
        n({ loaded: !0, serverPicks: ic(P), dirtyAtLoad: U });
      } catch (P) {
        if (d) return;
        console.warn("Could not load saved org/show picks:", (P == null ? void 0 : P.message) || P), n({ loaded: !0, serverPicks: null, dirtyAtLoad: U });
      } finally {
        clearTimeout(g);
      }
    })(), () => {
      d = !0, clearTimeout(g), h.abort();
    };
  }, [r, l]);
  const c = gt(
    (d) => {
      !r || !d || (o.current = o.current.then(async () => {
        await l().updateAccountPicks(d), u.current || Hs(!1);
      }).catch((h) => {
        u.current = !0, Hs(!0), console.warn("Could not save org/show picks:", (h == null ? void 0 : h.message) || h);
      }));
    },
    [r, l]
  );
  return xt(
    () => r ? {
      enabled: r,
      settled: s.loaded,
      serverPicks: s.serverPicks,
      dirtyAtLoad: s.dirtyAtLoad,
      savePicks: c
    } : t ? sc : Kr,
    [r, t, s, c]
  );
}
const Ni = "common-fe.activeOrgId", so = "426e8750-5b55-59f4-90c7-835b46d6a990", oc = (t) => {
  const a = t.filter((r) => r.id !== so);
  return a.length ? a : t;
}, uc = (t) => {
  if (!t) return !1;
  try {
    const a = or(t), r = a["custom:super"] ?? a.super;
    return r === "true" || r === !0;
  } catch {
    return !1;
  }
}, lc = (t) => {
  if (!t) return null;
  try {
    const a = or(t), r = a.orgs ?? a["custom:orgs"];
    let s = r;
    if (typeof r == "string")
      try {
        s = JSON.parse(r);
      } catch {
        s = [r];
      }
    if (!Array.isArray(s)) return null;
    const n = s.filter((o) => typeof o == "string" && o), e = n.filter((o) => o !== so), i = e.length ? e : n;
    return i.length === 1 ? i[0] : null;
  } catch {
    return null;
  }
}, cc = (t) => {
  if (!t) return null;
  try {
    const a = or(t), r = a["custom:orgs"] ?? a.orgs;
    if (r == null) return null;
    let s = r;
    if (!Array.isArray(r))
      try {
        const n = JSON.parse(r);
        s = Array.isArray(n) ? n : [r];
      } catch {
        s = [r];
      }
    return typeof s[0] == "string" && s[0] ? s[0] : null;
  } catch {
    return null;
  }
}, ao = On({
  orgs: [],
  activeOrgId: null,
  setActiveOrgId: () => {
  },
  loading: !1,
  error: null,
  isSuper: !1,
  orgResolved: !1,
  // #3607 -- the account-saved org/show picks transport. ActiveShowProvider
  // reads it to adopt/save the per-org show pick. No-op without a provider.
  picksSync: Kr
}), dc = () => {
  try {
    return window.localStorage.getItem(Ni) || null;
  } catch {
    return null;
  }
}, hc = (t) => {
  try {
    t ? window.localStorage.setItem(Ni, t) : window.localStorage.removeItem(Ni);
  } catch {
  }
}, jv = ({
  listOrgs: t,
  seedFromToken: a = !1,
  accountApiBasePath: r,
  children: s
}) => {
  var at, He;
  const e = (at = Vt().user) == null ? void 0 : at.access_token, i = uc(e), [o, u] = H([]), [l, c] = H(!0), [d, h] = H(null), [g, U] = H(() => dc()), P = ac(r, e), [D, j] = H(() => !r), F = ut(!1), te = (P.settled && !D && !P.dirtyAtLoad && !F.current ? ((He = P.serverPicks) == null ? void 0 : He.activeOrgId) ?? null : null) ?? g, ge = a && !te && !i ? lc(e) : null, he = te ?? ge, G = gt((ce) => {
    U(ce), hc(ce);
  }, []), { savePicks: re } = P, K = gt(
    (ce) => {
      D || (F.current = !0), G(ce), ce && re({ activeOrgId: ce });
    },
    [G, re, D]
  );
  ke(() => {
    if (D || !P.settled) return;
    j(!0);
    const ce = P.serverPicks;
    ce && (P.dirtyAtLoad ? g && P.savePicks({ activeOrgId: g }) : F.current || (ce.activeOrgId ? ce.activeOrgId !== g && G(ce.activeOrgId) : g && P.savePicks({ activeOrgId: g })));
  }, [D, P, g, G]), ke(() => {
    if (!t) {
      c(!1);
      return;
    }
    let ce = !1;
    const me = new AbortController();
    return (async () => {
      try {
        c(!0), h(null);
        const lt = await t(i, me.signal);
        if (ce) return;
        u(oc(Array.isArray(lt) ? lt : []));
      } catch (lt) {
        if (ce) return;
        console.error("Failed to load orgs for switcher:", lt), h(lt), u([]);
      } finally {
        ce || c(!1);
      }
    })(), () => {
      ce = !0, me.abort();
    };
  }, [t, i]), ke(() => {
    if (!o.length) return;
    if (o.some((me) => me.id === he))
      te || G(he);
    else {
      if (!D) return;
      G(o[0].id);
    }
  }, [o, he, te, D, G]);
  const ze = he != null || !l && o.length === 0;
  return /* @__PURE__ */ m.jsx(
    ao.Provider,
    {
      value: {
        orgs: o,
        activeOrgId: he,
        setActiveOrgId: K,
        loading: l,
        error: d,
        isSuper: i,
        orgResolved: ze,
        picksSync: P
      },
      children: s
    }
  );
}, ur = () => kn(ao), lr = "America/Los_Angeles", fc = /^(?:GMT|UTC)?\s*([+-])\s*(\d{1,2})(?::?(\d{2}))?$/i, vc = -14, pc = 12, li = /* @__PURE__ */ new Map();
function gc(t) {
  if (li.has(t)) return li.get(t);
  let a = !0;
  try {
    new Intl.DateTimeFormat("en-CA", { timeZone: t });
  } catch {
    a = !1;
  }
  return li.set(t, a), a;
}
function oo(t) {
  if (typeof t != "string") return null;
  const a = t.trim();
  if (!a) return null;
  if (/^(?:GMT|UTC)$/i.test(a)) return "Etc/GMT";
  const r = fc.exec(a);
  if (r) {
    const [, s, n, e] = r;
    if (e && Number(e) !== 0) return null;
    const i = Number(n) * (s === "-" ? -1 : 1);
    return i < vc || i > pc ? null : i === 0 ? "Etc/GMT" : `Etc/GMT${i < 0 ? "+" : "-"}${Math.abs(i)}`;
  }
  return gc(a) ? a : null;
}
function Qr(t) {
  return oo(t) ?? lr;
}
function uo(t) {
  return oo(t) !== null;
}
const lo = "Venue timezone not set";
function Xr(t) {
  if (t instanceof Date) return Number.isNaN(t.getTime()) ? null : t;
  if (t == null) return null;
  let a = t;
  if (typeof t == "string") {
    const s = t.trim();
    if (!/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}/.test(s)) return null;
    a = /[Zz]|[+-]\d{2}:?\d{2}$/.test(s) ? s : `${s}Z`;
  }
  const r = new Date(a);
  return Number.isNaN(r.getTime()) ? null : r;
}
function mc(t, { timeZone: a = lr, seconds: r = !1, hour12: s = !0 } = {}) {
  const n = Xr(t);
  return n ? n.toLocaleTimeString("en-US", {
    ...s ? { hour: "numeric", hour12: !0 } : { hour: "2-digit", hourCycle: "h23" },
    minute: "2-digit",
    ...r ? { second: "2-digit" } : {},
    timeZone: Qr(a)
  }) : "";
}
function bc(t, a = /* @__PURE__ */ new Date()) {
  var n;
  const r = Qr(t);
  return ((n = new Intl.DateTimeFormat("en-US", {
    timeZone: r,
    timeZoneName: "short"
  }).formatToParts(a).find((e) => e.type === "timeZoneName")) == null ? void 0 : n.value) ?? r;
}
function co(t, a = lr) {
  const r = Xr(t);
  return r ? new Intl.DateTimeFormat("en-CA", {
    timeZone: Qr(a),
    year: "numeric",
    month: "2-digit",
    day: "2-digit"
  }).format(r) : null;
}
function Mv(t, { timeZone: a, unsetText: r = lo, ...s } = {}) {
  return Xr(t) ? uo(a) ? mc(t, { ...s, timeZone: a }) : r : "";
}
function Fv(t, {
  timeZone: a,
  unsetText: r = lo,
  options: s = { dateStyle: "medium", timeStyle: "short" }
} = {}) {
  const n = Xr(t);
  if (!n) return "";
  if (!uo(a)) return r;
  const e = n.toLocaleString("en-US", {
    ...s,
    timeZone: Qr(a)
  });
  return s.timeZoneName ? e : `${e} ${bc(a, n)}`;
}
const zn = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"], $s = (t) => {
  if (typeof t != "string") return null;
  const a = /^(\d{4})-(\d{2})-(\d{2})/.exec(t.trim());
  if (!a) return null;
  const r = Number(a[2]);
  return r < 1 || r > 12 ? null : { y: Number(a[1]), m: r, d: Number(a[3]) };
};
function Ws(t) {
  const a = $s(t == null ? void 0 : t.startDate);
  if (!a) return "";
  const r = $s(t == null ? void 0 : t.endDate), s = `${zn[a.m - 1]} ${a.d}, ${a.y}`;
  return !r || r.y === a.y && r.m === a.m && r.d === a.d ? s : r.y !== a.y ? `${s} - ${zn[r.m - 1]} ${r.d}, ${r.y}` : r.m !== a.m ? `${zn[a.m - 1]} ${a.d} - ${zn[r.m - 1]} ${r.d}, ${a.y}` : `${zn[a.m - 1]} ${a.d}-${r.d}, ${a.y}`;
}
const Br = (t) => String(t || "").toLowerCase().replace(/[^a-z0-9]+/g, " ").trim();
function ss(t, a) {
  const r = Ws(t), s = Br(t == null ? void 0 : t.name);
  if (!(!!s && (a || []).some(
    (i) => i && i.id !== t.id && Br(i.name) === s && Ws(i) === r
  ))) return r;
  const e = `#${String(t.id).slice(-6)}`;
  return r ? `${r} (${e})` : e;
}
function Sc(t, a) {
  const r = Br(t == null ? void 0 : t.name);
  return !!r && (a || []).some((s) => s && s.id !== t.id && Br(s.name) === r);
}
const wc = ({
  orgs: t,
  activeOrgId: a,
  onOrgChange: r,
  shows: s,
  allShows: n,
  filterActive: e,
  showAllShows: i,
  onShowAllShowsChange: o,
  onPick: u
}) => {
  const l = Array.isArray(t) && t.length > 1, c = e && !i && s.length === 0, d = c ? n : s, h = e ? n.length - s.length : 0, g = e && !i && !c && h > 0;
  return /* @__PURE__ */ m.jsxs(
    Va,
    {
      open: !0,
      fullWidth: !0,
      maxWidth: "sm",
      disableEscapeKeyDown: !0,
      "aria-labelledby": "show-picker-title",
      "data-testid": "show-picker-modal",
      onClose: () => {
      },
      children: [
        /* @__PURE__ */ m.jsx(Ba, { id: "show-picker-title", children: "Pick a show to continue" }),
        /* @__PURE__ */ m.jsxs(za, { children: [
          /* @__PURE__ */ m.jsx(Mt, { variant: "body2", sx: { mb: 2 }, children: "Choose the show you want to work on. Nothing loads until you do." }),
          l && /* @__PURE__ */ m.jsx(
            Xu,
            {
              select: !0,
              fullWidth: !0,
              size: "small",
              label: "Organization",
              value: a || "",
              onChange: (U) => r(U.target.value),
              sx: { mb: 2 },
              slotProps: {
                htmlInput: { "data-testid": "show-picker-org" }
              },
              children: t.map((U) => /* @__PURE__ */ m.jsx(Jt, { value: U.id, children: U.name }, U.id))
            }
          ),
          d.length === 0 ? /* @__PURE__ */ m.jsx(Mt, { variant: "body2", "data-testid": "show-picker-empty", children: "This organization has no shows." }) : /* @__PURE__ */ m.jsx(ns, { dense: !0, "data-testid": "show-picker-list", "aria-label": "Shows", children: d.map((U) => {
            var D;
            const P = ss(U, n);
            return /* @__PURE__ */ m.jsx(
              Ga,
              {
                onClick: () => u(U.id),
                "data-testid": `show-picker-option-${U.id}`,
                children: /* @__PURE__ */ m.jsx(
                  Da,
                  {
                    primary: ((D = U.friendlyName) == null ? void 0 : D.trim()) || U.name || U.id,
                    secondary: P || void 0
                  }
                )
              },
              U.id
            );
          }) }),
          g && /* @__PURE__ */ m.jsx(De, { sx: { mt: 1 }, children: /* @__PURE__ */ m.jsx(
            Qu,
            {
              size: "small",
              onClick: () => o(!0),
              "data-testid": "show-picker-show-all",
              children: "Show all past shows"
            }
          ) })
        ] })
      ]
    }
  );
}, ho = "common-fe.activeShowId", as = "common-fe.activeShowIdByOrg", qs = Symbol("active-show-never-loaded"), fo = On({
  shows: [],
  allShows: [],
  activeShowId: null,
  activeShow: null,
  setActiveShowId: () => {
  },
  patchShow: () => {
  },
  loading: !1,
  error: null,
  filterActive: !1,
  showAllShows: !1,
  setShowAllShows: () => {
  }
}), Js = 3, Di = 24 * 60 * 60 * 1e3, wn = (t) => {
  if (typeof t != "string" || !t) return null;
  const a = /* @__PURE__ */ new Date(`${t}T00:00:00.000Z`);
  return Number.isNaN(a.getTime()) ? null : a;
}, yc = (t, { todayKey: a = co(/* @__PURE__ */ new Date(), lr) } = {}) => {
  const r = wn(t == null ? void 0 : t.startDate), s = wn(t == null ? void 0 : t.endDate);
  if (!r || !s) return !0;
  const n = wn(a);
  if (!n) return !0;
  const e = r.getTime() - Js * Di, i = s.getTime() + Js * Di;
  return n.getTime() >= e && n.getTime() <= i;
}, nn = (t) => t || "", os = () => {
  try {
    const t = window.localStorage.getItem(as), a = t ? JSON.parse(t) : null;
    return a && typeof a == "object" && !Array.isArray(a) ? a : {};
  } catch {
    return {};
  }
}, Rc = (t, a) => {
  try {
    const r = os();
    a ? r[nn(t)] = a : delete r[nn(t)], window.localStorage.setItem(as, JSON.stringify(r));
  } catch {
  }
}, Ic = (t) => {
  try {
    const a = { ...os(), ...t };
    return window.localStorage.setItem(as, JSON.stringify(a)), a;
  } catch {
    return { ...t };
  }
}, _c = () => {
  try {
    return window.localStorage.getItem(ho) || null;
  } catch {
    return null;
  }
}, Tc = () => {
  try {
    window.localStorage.removeItem(ho);
  } catch {
  }
}, ci = (t, { newestFirst: a = !1 } = {}) => [...t].sort((r, s) => {
  const n = r != null && r.startDate ? new Date(r.startDate).getTime() : NaN, e = s != null && s.startDate ? new Date(s.startDate).getTime() : NaN, i = Number.isFinite(n), o = Number.isFinite(e);
  return i && o ? a ? e - n : n - e : i ? -1 : o ? 1 : 0;
}), Ec = 14, Ys = (t, {
  days: a = Ec,
  todayKey: r = co(/* @__PURE__ */ new Date(), lr)
} = {}) => {
  const s = wn(t == null ? void 0 : t.endDate) || wn(t == null ? void 0 : t.startDate), n = wn(r);
  return !s || !n ? !1 : n.getTime() - s.getTime() > a * Di;
}, Vv = ({
  listShows: t,
  orgId: a,
  filterActive: r = !1,
  requirePick: s = !0,
  children: n
}) => {
  var Ln;
  const { orgs: e, setActiveOrgId: i, picksSync: o = Kr } = ur(), [u, l] = H([]), [c, d] = H(qs), [h, g] = H(!0), [U, P] = H(null), [D, j] = H(() => os()), [F, V] = H(() => _c()), [te, ge] = H(
    () => o.settled && !o.enabled
  ), he = ut(/* @__PURE__ */ new Set()), { savePicks: G } = o, re = o.settled && !te && !o.dirtyAtLoad ? ((Ln = o.serverPicks) == null ? void 0 : Ln.showByOrg) ?? null : null, K = xt(() => {
    if (!re) return D;
    const be = { ...D, ...re };
    for (const $e of he.current)
      $e in D && (be[$e] = D[$e]);
    return be;
  }, [D, re]), ze = c === a && o.settled, at = ut(qs), He = K[nn(a)] ?? null;
  let ce = He;
  if (ze && !U) {
    const be = He ?? F ?? null;
    ce = u.some(($e) => $e.id === be) ? be : null;
  }
  const me = gt(
    (be) => {
      j(($e) => {
        const st = { ...$e };
        return be ? st[nn(a)] = be : delete st[nn(a)], st;
      }), Rc(a, be);
    },
    [a]
  ), lt = gt(
    (be) => {
      be && !te && he.current.add(nn(a)), me(be), be && a && G({ showByOrg: { [a]: be } });
    },
    [me, te, a, G]
  );
  ke(() => {
    if (te || !o.settled) return;
    ge(!0);
    const be = o.serverPicks;
    if (!be) return;
    const $e = be.showByOrg || {}, st = Object.fromEntries(
      Object.entries(D).filter(([_t]) => _t)
    );
    if (o.dirtyAtLoad) {
      Object.keys(st).length && G({ showByOrg: st });
      return;
    }
    const Et = he.current, Kt = Object.fromEntries(
      Object.entries($e).filter(([_t]) => !Et.has(_t))
    );
    Object.keys(Kt).length && j(Ic(Kt));
    const on = Object.fromEntries(
      Object.entries(st).filter(
        ([_t]) => !(_t in $e) && !Et.has(_t)
      )
    );
    Object.keys(on).length && G({ showByOrg: on });
  }, [te, o, D, G]);
  const zt = gt((be, $e) => {
    l(
      (st) => st.map((Et) => Et.id === be ? { ...Et, ...$e } : Et)
    );
  }, []);
  ke(() => {
    if (!t) {
      g(!1);
      return;
    }
    let be = !1;
    const $e = new AbortController();
    return (async () => {
      try {
        g(!0);
        const st = await t($e.signal);
        if (be) return;
        at.current = a, P(null), l(Array.isArray(st) ? ci(st) : []), d(a);
      } catch (st) {
        if (be) return;
        console.error("Failed to load shows for switcher:", st), at.current !== a && (P(st), l([]), d(a));
      } finally {
        be || g(!1);
      }
    })(), () => {
      be = !0, $e.abort();
    };
  }, [t, a]);
  const [Rt, At] = H(!1), It = xt(() => !r || Rt ? u : u.filter((be) => yc(be)), [u, r, Rt]);
  ke(() => {
    if (!ze || !u.length) return;
    const be = K[nn(a)] ?? null;
    if (be) {
      u.some(($e) => $e.id === be) || me(null);
      return;
    }
    F && u.some(($e) => $e.id === F) && (me(F), Tc(), V(null));
  }, [ze, u, K, a, F, me]);
  const an = xt(
    () => u.find((be) => be.id === ce) || null,
    [u, ce]
  ), pr = xt(
    () => ({
      shows: It,
      allShows: u,
      activeShowId: ce,
      activeShow: an,
      setActiveShowId: lt,
      patchShow: zt,
      loading: h,
      error: U,
      filterActive: r,
      showAllShows: Rt,
      setShowAllShows: At
    }),
    [
      It,
      u,
      ce,
      an,
      lt,
      zt,
      h,
      U,
      r,
      Rt
    ]
  ), gr = s && !!a && ze && !h && !U && !an && (u.length > 0 || ((e == null ? void 0 : e.length) ?? 0) > 1);
  return /* @__PURE__ */ m.jsxs(fo.Provider, { value: pr, children: [
    n,
    gr && /* @__PURE__ */ m.jsx(
      wc,
      {
        orgs: e,
        activeOrgId: a,
        onOrgChange: i,
        shows: ci(It, { newestFirst: !0 }),
        allShows: ci(u, { newestFirst: !0 }),
        filterActive: r,
        showAllShows: Rt,
        onShowAllShowsChange: At,
        onPick: lt
      }
    )
  ] });
}, vo = () => kn(fo);
function po(t, { max: a = 28, tail: r = 12 } = {}) {
  if (!t || t.length <= a) return t;
  const s = Math.max(0, a - r - 1);
  return `${t.slice(0, s)}…${t.slice(-r)}`;
}
const Cc = { max: 44, tail: 16 }, xc = { max: 28, tail: 12 }, Li = (t) => (typeof (t == null ? void 0 : t.friendlyName) == "string" ? t.friendlyName.trim() : "") || null, di = "__older-shows__", Zs = ({ show: t, allShows: a }) => {
  const r = ss(t, a), s = [Li(t) ? t.name || t.id : "", r].filter(Boolean).join(" · ");
  return s ? /* @__PURE__ */ m.jsxs(De, { sx: { display: "flex", flexDirection: "column" }, children: [
    /* @__PURE__ */ m.jsx("span", { children: Li(t) || t.name || t.id }),
    /* @__PURE__ */ m.jsx(
      De,
      {
        component: "span",
        "data-testid": "show-option-detail",
        sx: { fontSize: "0.75rem", color: "text.secondary" },
        children: s
      }
    )
  ] }) : t.name || t.id;
}, zv = ({ onShowChange: t, toggleInDropdown: a = !1 }) => {
  const {
    shows: r,
    allShows: s,
    activeShowId: n,
    activeShow: e,
    setActiveShowId: i,
    loading: o,
    filterActive: u,
    showAllShows: l,
    setShowAllShows: c
  } = vo(), d = Wu(), h = tl(d.breakpoints.up("lg"), {
    defaultMatches: !0
  }), [g, U] = H(!1);
  if (o && !s.length)
    return /* @__PURE__ */ m.jsx(
      Fr,
      {
        "data-testid": "show-switcher-loading",
        variant: "rounded",
        width: 140,
        height: 24,
        sx: { bgcolor: "rgba(255,255,255,0.18)" }
      }
    );
  if (!s || s.length === 0) return null;
  const P = r.filter((V) => !Ys(V)), D = s.filter((V) => Ys(V)), j = (V) => {
    i(V), t && t(V);
  }, F = (V) => {
    const te = V.target.value;
    if (te === di) {
      U(!0);
      return;
    }
    j(te);
  };
  return /* @__PURE__ */ m.jsxs(
    De,
    {
      "data-testid": "show-switcher",
      sx: { display: "flex", alignItems: "center", gap: 0.75, color: "inherit" },
      children: [
        /* @__PURE__ */ m.jsx(el, { fontSize: "small", sx: { color: "inherit", opacity: 0.9 } }),
        /* @__PURE__ */ m.jsxs(
          Ha,
          {
            value: n || "",
            onChange: F,
            variant: "standard",
            disableUnderline: !0,
            inputProps: { "aria-label": "Show switcher" },
            renderValue: () => {
              const V = e ? e.name || e.id : "", te = Li(e), ge = te || po(
                V,
                h ? Cc : xc
              ), he = !te && e && Sc(e, s) ? ` (${ss(e, s)})` : "";
              return /* @__PURE__ */ m.jsxs(
                "span",
                {
                  title: he ? `${V}${he}` : V,
                  style: { display: "flex", whiteSpace: "nowrap", overflow: "hidden" },
                  children: [
                    /* @__PURE__ */ m.jsx("span", { style: { overflow: "hidden", textOverflow: "ellipsis" }, children: ge }),
                    he && /* @__PURE__ */ m.jsx("span", { style: { flex: "none", whiteSpace: "pre" }, children: he })
                  ]
                }
              );
            },
            sx: {
              color: "inherit",
              fontSize: "0.9rem",
              // { xs: 240, lg: 420 } (was 240): a 33-character full name plus the caret did not fit
              // in 240 at 0.9rem, so the CSS end-ellipsis stacked a second
              // ellipsis on top of truncateMiddle's (bug #200). Sized for the
              // 44-character FULL_NAME_TRUNCATION budget above. Only from lg up: at
              // narrow widths the bar also carries OrgSwitcher + email, and a
              // wider wrapper cannot shrink below its content, so xs keeps 240
              // (paired with NARROW_NAME_TRUNCATION).
              maxWidth: { xs: 240, lg: 420 },
              "& .MuiSelect-select": { py: 0.25 },
              "& .MuiSelect-icon": { color: "inherit" }
            },
            children: [
              e && !P.some((V) => V.id === e.id) && /* @__PURE__ */ m.jsx(
                Jt,
                {
                  value: e.id,
                  style: { display: "none" },
                  children: e.name || e.id
                },
                e.id
              ),
              P.map((V) => /* @__PURE__ */ m.jsx(Jt, { value: V.id, children: /* @__PURE__ */ m.jsx(Zs, { show: V, allShows: s }) }, V.id)),
              D.length > 0 && /* @__PURE__ */ m.jsx(
                Jt,
                {
                  value: di,
                  "data-testid": "older-shows-item",
                  sx: { borderTop: 1, borderColor: "divider", fontStyle: "italic" },
                  children: "Older shows"
                },
                di
              ),
              u && a && /* @__PURE__ */ m.jsxs(De, { component: "li", children: [
                /* @__PURE__ */ m.jsx(yi, { sx: { my: 0.5 } }),
                /* @__PURE__ */ m.jsx(
                  De,
                  {
                    onClick: (V) => V.stopPropagation(),
                    onKeyDown: (V) => {
                      V.key !== "Escape" && V.stopPropagation();
                    },
                    sx: { px: 2, py: 0.5 },
                    children: /* @__PURE__ */ m.jsx(
                      As,
                      {
                        "data-testid": "show-all-shows-toggle",
                        control: /* @__PURE__ */ m.jsx(
                          Ps,
                          {
                            size: "small",
                            checked: l,
                            onChange: (V) => c(V.target.checked),
                            inputProps: { "aria-label": "Show all past shows" }
                          }
                        ),
                        label: "Show all past shows",
                        sx: { mr: 0, "& .MuiFormControlLabel-label": { fontSize: "0.8rem" } }
                      }
                    )
                  }
                )
              ] }, "show-all-shows-toggle-row")
            ]
          }
        ),
        /* @__PURE__ */ m.jsxs(
          Va,
          {
            open: g,
            onClose: () => U(!1),
            fullWidth: !0,
            maxWidth: "sm",
            scroll: "paper",
            children: [
              /* @__PURE__ */ m.jsx(Ba, { children: "Older shows" }),
              /* @__PURE__ */ m.jsx(za, { dividers: !0, sx: { p: 0 }, children: /* @__PURE__ */ m.jsx(ns, { "data-testid": "older-shows-list", disablePadding: !0, children: D.map((V) => /* @__PURE__ */ m.jsx(
                Ga,
                {
                  selected: V.id === n,
                  onClick: () => {
                    U(!1), j(V.id);
                  },
                  children: /* @__PURE__ */ m.jsx(Zs, { show: V, allShows: s })
                },
                V.id
              )) }) })
            ]
          }
        ),
        u && !a && /* @__PURE__ */ m.jsx(
          As,
          {
            "data-testid": "show-all-shows-toggle",
            control: /* @__PURE__ */ m.jsx(
              Ps,
              {
                size: "small",
                checked: l,
                onChange: (V) => c(V.target.checked),
                inputProps: { "aria-label": "Show all past shows" },
                sx: {
                  "& .MuiSwitch-switchBase": { color: "rgba(255,255,255,0.75)" },
                  "& .MuiSwitch-switchBase.Mui-checked": { color: "#fff" },
                  "& .MuiSwitch-track": {
                    backgroundColor: "rgba(255,255,255,0.5)"
                  },
                  "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
                    backgroundColor: "rgba(255,255,255,0.9)"
                  }
                }
              }
            ),
            label: "Show all past shows",
            sx: {
              color: "inherit",
              ml: 0.5,
              mr: 0,
              "& .MuiFormControlLabel-label": { fontSize: "0.75rem" }
            }
          }
        )
      ]
    }
  );
}, go = On({
  appNamespace: null,
  isSuper: !1,
  permissions: /* @__PURE__ */ new Set()
}), Oc = (t, a) => typeof a == "string" && a.includes(":") ? a : `${t}:${a}`, kc = (t) => {
  if (!t) return { isSuper: !1, permissions: /* @__PURE__ */ new Set() };
  try {
    const a = or(t), r = a["custom:super"] ?? a.super, s = r === "true" || r === !0, n = new Set(
      Array.isArray(a.permissions) ? a.permissions : []
    );
    return { isSuper: s, permissions: n };
  } catch {
    return { isSuper: !1, permissions: /* @__PURE__ */ new Set() };
  }
}, Bv = ({ appNamespace: t, children: a }) => {
  var e;
  const s = (e = Vt().user) == null ? void 0 : e.access_token, n = xt(() => {
    const { isSuper: i, permissions: o } = kc(s);
    return { appNamespace: t, isSuper: i, permissions: o };
  }, [t, s]);
  return /* @__PURE__ */ m.jsx(go.Provider, { value: n, children: a });
}, Gv = (t) => {
  const { appNamespace: a, isSuper: r, permissions: s } = kn(go);
  return r ? !0 : s.has(Oc(a, t));
}, Xn = (t) => typeof t == "string" ? t.trim() : "", mo = (t) => Xn(t == null ? void 0 : t.firstName) || Xn(t == null ? void 0 : t.given_name), Pc = (t) => Xn(t == null ? void 0 : t.lastName) || Xn(t == null ? void 0 : t.family_name), bo = (t) => Xn(t == null ? void 0 : t.email);
function Ac(t) {
  return t ? [mo(t), Pc(t)].filter(Boolean).join(" ") || bo(t) : "";
}
function Hv(t) {
  return t ? mo(t) || bo(t) : "";
}
const Uc = (t, a) => t.length > a ? `${t.slice(0, Math.max(0, a - 1))}…` : t;
function Nc({ maxEmailChars: t = 28 }) {
  var o;
  const r = ((o = Vt().user) == null ? void 0 : o.profile) || {}, s = (r.given_name || "").trim(), n = Ac(r), e = (r.email || "").trim(), i = s || (e ? Uc(e, t) : "");
  return i ? /* @__PURE__ */ m.jsx(Lr, { title: n || e, children: /* @__PURE__ */ m.jsx(
    Mt,
    {
      variant: "body2",
      noWrap: !0,
      "data-testid": "nav-user-name",
      sx: { color: "inherit", maxWidth: 220 },
      children: i
    }
  ) }) : null;
}
const Dc = ({ accountOrgsUrl: t } = {}) => {
  const { orgs: a, activeOrgId: r, setActiveOrgId: s, isSuper: n } = ur(), { t: e } = $a("common");
  return n && (!a || a.length === 0) ? /* @__PURE__ */ m.jsx(
    De,
    {
      "data-testid": "org-switcher-empty",
      sx: { display: "flex", alignItems: "center", gap: 0.75, color: "inherit" },
      children: /* @__PURE__ */ m.jsx(
        Zn,
        {
          ...t ? { component: "a", href: t, clickable: !0 } : {},
          size: "small",
          icon: /* @__PURE__ */ m.jsx(
            Us,
            {
              fontSize: "small",
              sx: { color: "inherit !important" }
            }
          ),
          label: t ? e(
            "orgSwitcher.noOrgsEnabledLink",
            "No orgs enabled for switching — manage in Account"
          ) : e("orgSwitcher.noOrgsEnabled", "No orgs enabled for switching"),
          sx: {
            color: "inherit",
            bgcolor: "rgba(255, 255, 255, 0.18)",
            fontWeight: 600,
            ...t && {
              textDecoration: "underline",
              "&:hover": { bgcolor: "rgba(255, 255, 255, 0.28)" }
            }
          }
        }
      )
    }
  ) : !a || a.length <= 1 ? null : /* @__PURE__ */ m.jsxs(
    De,
    {
      "data-testid": "org-switcher",
      sx: { display: "flex", alignItems: "center", gap: 0.75, color: "inherit" },
      children: [
        n && /* @__PURE__ */ m.jsx(
          Zn,
          {
            size: "small",
            "data-testid": "super-badge",
            icon: /* @__PURE__ */ m.jsx(
              Us,
              {
                fontSize: "small",
                sx: { color: "inherit !important" }
              }
            ),
            label: "All orgs",
            sx: {
              color: "inherit",
              bgcolor: "rgba(255, 255, 255, 0.18)",
              fontWeight: 600
            }
          }
        ),
        /* @__PURE__ */ m.jsx(nl, { fontSize: "small", sx: { color: "inherit", opacity: 0.9 } }),
        /* @__PURE__ */ m.jsx(
          Ha,
          {
            value: r || "",
            onChange: (i) => s(i.target.value),
            variant: "standard",
            disableUnderline: !0,
            inputProps: { "aria-label": "Organization switcher" },
            renderValue: (i) => {
              const o = a.find((l) => l.id === i), u = o ? o.name : "";
              return /* @__PURE__ */ m.jsx(
                "span",
                {
                  title: u,
                  style: {
                    display: "block",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap"
                  },
                  children: po(u)
                }
              );
            },
            sx: {
              color: "inherit",
              fontSize: "0.9rem",
              maxWidth: 220,
              "& .MuiSelect-select": { py: 0.25 },
              "& .MuiSelect-icon": { color: "inherit" }
            },
            children: a.map((i) => /* @__PURE__ */ m.jsx(Jt, { value: i.id, children: i.name }, i.id))
          }
        )
      ]
    }
  );
}, Lc = [
  "m1106.2 131.25h-112.5v-56.25c0-4.9727-1.9766-9.7422-5.4922-13.258-3.5156-3.5156-8.2852-5.4922-13.258-5.4922h-112.5c-4.9727 0-9.7422 1.9766-13.258 5.4922-3.5156 3.5156-5.4922 8.2852-5.4922 13.258v56.25h-168.75v-56.25c0-4.9727-1.9766-9.7422-5.4922-13.258-3.5156-3.5156-8.2852-5.4922-13.258-5.4922h-112.5c-4.9727 0-9.7422 1.9766-13.258 5.4922-3.5156 3.5156-5.4922 8.2852-5.4922 13.258v56.25h-168.75v-56.25c0-4.9727-1.9766-9.7422-5.4922-13.258-3.5156-3.5156-8.2852-5.4922-13.258-5.4922h-112.5c-4.9727 0-9.7422 1.9766-13.258 5.4922-3.5156 3.5156-5.4922 8.2852-5.4922 13.258v56.25h-112.5c-4.9727 0-9.7422 1.9766-13.258 5.4922-3.5156 3.5156-5.4922 8.2852-5.4922 13.258v787.5c0 4.9727 1.9766 9.7422 5.4922 13.258 3.5156 3.5156 8.2852 5.4922 13.258 5.4922h225v168.75c0 4.9727 1.9766 9.7422 5.4922 13.258 3.5156 3.5156 8.2852 5.4922 13.258 5.4922h112.5c4.9727 0 9.7422-1.9766 13.258-5.4922 3.5156-3.5156 5.4922-8.2852 5.4922-13.258v-168.75h243.75v168.75c0 4.9727 1.9766 9.7422 5.4922 13.258 3.5156 3.5156 8.2852 5.4922 13.258 5.4922h112.5c4.9727 0 9.7422-1.9766 13.258-5.4922 3.5156-3.5156 5.4922-8.2852 5.4922-13.258v-168.75h243.75c4.9727 0 9.7422-1.9766 13.258-5.4922 3.5156-3.5156 5.4922-8.2852 5.4922-13.258v-787.5c0-4.9727-1.9766-9.7422-5.4922-13.258-3.5156-3.5156-8.2852-5.4922-13.258-5.4922zm-225-37.5h75v75h-75zm-318.75 0h75v75h-75zm-318.75 0h75v75h-75zm187.5 1012.5h-75v-150h75zm393.75 0h-75v-150h75zm262.5-187.5h-975v-750h93.75v18.75c0 4.9727 1.9766 9.7422 5.4922 13.258 3.5156 3.5156 8.2852 5.4922 13.258 5.4922h112.5c4.9727 0 9.7422-1.9766 13.258-5.4922 3.5156-3.5156 5.4922-8.2852 5.4922-13.258v-18.75h168.75v18.75c0 4.9727 1.9766 9.7422 5.4922 13.258 3.5156 3.5156 8.2852 5.4922 13.258 5.4922h112.5c4.9727 0 9.7422-1.9766 13.258-5.4922 3.5156-3.5156 5.4922-8.2852 5.4922-13.258v-18.75h168.75v18.75c0 4.9727 1.9766 9.7422 5.4922 13.258 3.5156 3.5156 8.2852 5.4922 13.258 5.4922h112.5c4.9727 0 9.7422-1.9766 13.258-5.4922 3.5156-3.5156 5.4922-8.2852 5.4922-13.258v-18.75h93.75z",
  "m525 375h-356.25c-4.9727 0-9.7422 1.9766-13.258 5.4922-3.5156 3.5156-5.4922 8.2852-5.4922 13.258v468.75c0 4.9727 1.9766 9.7422 5.4922 13.258 3.5156 3.5156 8.2852 5.4922 13.258 5.4922h862.5c4.9727 0 9.7422-1.9766 13.258-5.4922 3.5156-3.5156 5.4922-8.2852 5.4922-13.258v-468.75c0-4.9727-1.9766-9.7422-5.4922-13.258-3.5156-3.5156-8.2852-5.4922-13.258-5.4922zm487.5 187.5h-468.75v-56.25h468.75zm0 93.75h-468.75v-56.25h468.75zm-825-56.25h56.25v56.25h-56.25zm93.75 0h225v56.25h-225zm225-37.5h-225v-56.25h225zm-262.5 0h-56.25v-56.25h56.25zm-56.25 131.25h56.25v56.25h-56.25zm93.75 0h225v56.25h-225zm262.5 0h468.75v56.25h-468.75zm468.75-225h-468.75v-56.25h468.75zm-506.25-56.25v56.25h-225v-56.25zm-318.75 0h56.25v56.25h-56.25zm0 375h56.25v56.25h-56.25zm93.75 56.25v-56.25h225v56.25zm731.25 0h-468.75v-56.25h468.75z"
];
function jc(t) {
  return /* @__PURE__ */ m.jsx(xu, { viewBox: "0 0 1200 1200", ...t, children: Lc.map((a, r) => /* @__PURE__ */ m.jsx("path", { d: a }, r)) });
}
const Ks = (t) => t.replace(/\/+$/, ""), So = Object.freeze([
  {
    key: "manager",
    envVar: "VITE_MANAGER_FE_BASE_URL",
    Icon: sl,
    title: (t) => t("home.apps.manager.title", { defaultValue: "Show Manager" }),
    description: (t) => t("home.apps.manager.description", {
      defaultValue: "Manage shows, results, scoring, and payouts."
    }),
    inSwitcher: !1
  },
  {
    key: "scoreadmin",
    envVar: "VITE_SCOREADMIN_FE_BASE_URL",
    Icon: rl,
    title: (t) => t("home.apps.scoreadmin.title", { defaultValue: "Score Admin" }),
    description: (t) => t("home.apps.scoreadmin.description", {
      defaultValue: "Set up rings, assign scribes, and manage scoring."
    }),
    inSwitcher: !0
  },
  {
    key: "scribe",
    envVar: "VITE_SCRIBE_FE_BASE_URL",
    Icon: al,
    title: (t) => t("home.apps.scribe.title", { defaultValue: "Scribe" }),
    description: (t) => t("home.apps.scribe.description", {
      defaultValue: "Enter ride scores at the ring, online or offline."
    }),
    inSwitcher: !1
  },
  {
    key: "scoreboard",
    envVar: "VITE_SCORE_FE_BASE_URL",
    Icon: jc,
    title: (t) => t("home.apps.scoreboard.title", { defaultValue: "Scoreboard" }),
    description: (t) => t("home.apps.scoreboard.description", {
      defaultValue: "Follow live scores and results from the show."
    }),
    inSwitcher: !0,
    // #3336: the Scoreboard row is the staff remote control, not the score-fe
    // root (the public competitor landing page). Routes: apps/score-fe
    // src/remote/RemoteRoutes.jsx.
    path: (t) => `${Ks(t)}/scoreboard/remote-control/`,
    // #3656: straight to the show's Live Control when a show is active.
    showPath: (t, a) => `${Ks(t)}/scoreboard/remote-control/remote/show/${encodeURIComponent(a)}`
  },
  {
    key: "announcer",
    envVar: "VITE_ANNOUNCER_FE_BASE_URL",
    Icon: il,
    title: (t) => t("home.apps.announcer.title", { defaultValue: "Announcer" }),
    description: (t) => t("home.apps.announcer.description", {
      defaultValue: "Running order and live info for the announcer booth."
    }),
    inSwitcher: !0
  }
]), wo = Object.freeze(["scoreadmin", "announcer", "scoreboard"]), $v = Object.freeze(
  wo.map((t) => So.find((a) => a.key === t).envVar)
), Mc = (t, a, r = null) => {
  const s = a == null ? void 0 : a[t.envVar];
  return s ? r && t.showPath ? t.showPath(s, r) : t.path ? t.path(s) : s : "";
}, Fc = {
  roles: {
    score_admin: {
      title: "Score Admin",
      description: "Administer scoring for the organization, including scribe assignment",
      // #1635 — score admins get board control by adding the permission
      // straight to this role rather than needing a second role (design §3.3).
      permissions: [
        "list_shows_org",
        "assign_scribes",
        "reopen_score_sheet",
        "demo_reseed",
        "edit_catalog",
        "manage_scoreboard",
        "edit_movement_override",
        "manage_judges",
        "set_ring_state",
        // #2862 — the placed-class placings lock's admin-only override.
        "override_placed_class",
        // #2816 — admin-only, see the permission's own comment above.
        "switch_authoritative_score_sheet",
        // #3009 — admin-only, see the permission's own comment above.
        "resolve_stale_write_conflict",
        // #3477 -- admin-only, see the permission's own comment above.
        "pick_sheet_version",
        // #3356 -- admin-only, see the permission's own comment above.
        "apply_quarantined_payload",
        // #3571 -- admin-only, see the permission's own comment above.
        "import_tablet_sheets",
        // #3746 -- admin-only, see the permission's own comment above.
        "use_fvd_pointer",
        // #2801 -- admin-only, see the permission's own comment above.
        "unfinalize_score_sheet"
      ]
    },
    score_scribe: {
      title: "Scribe",
      description: "Enter and update scores during a show",
      permissions: ["list_shows_org", "edit_score_sheet", "set_ring_state"]
    },
    score_judge: {
      title: "Judge",
      description: "Score and sign sheets for shows you are assigned to",
      // Flat, fully-resolved set — no runtime inheritance (§5.1).
      permissions: ["list_shows_mine", "edit_score_sheet", "sign_score_sheet"]
    },
    score_viewer: {
      title: "Viewer",
      description: "Read-only access to shows",
      permissions: ["list_shows_mine"]
    },
    score_announcer: {
      title: "Announcer",
      description: "Read-only access to the whole show, for ring announcing",
      // list_shows_org (not list_shows_mine, cf. score_viewer above) — an
      // announcer needs the entire show, not just shows they're personally
      // assigned to.
      permissions: ["list_shows_org"]
    },
    // #1635 — scoreboard-admin (design §3.3): drives the remote control
    // (views/sponsors/themes/assets) without needing the full score_admin
    // grant (scribe assignment, sheet reopen, demo reseed).
    score_scoreboard_admin: {
      title: "Scoreboard Admin",
      description: "Configure and drive the public scoreboards for a show",
      permissions: ["manage_scoreboard", "list_shows_org"]
    }
  }
}, yo = (t) => Object.entries(Fc.roles).filter(([, a]) => a.permissions.includes(t)).map(([a]) => a), Vc = Object.freeze(["score_admin"]), zc = Object.freeze(yo("list_shows_org")), Bc = Object.freeze(yo("manage_scoreboard")), Gc = (t, a) => {
  if (!t) return {};
  try {
    const r = or(t)[a], s = typeof r == "string" ? JSON.parse(r) : r || {};
    return s && typeof s == "object" ? s : {};
  } catch {
    return {};
  }
}, Ro = (t, a, r) => {
  if (!r) return [];
  const s = Gc(t, a)[r];
  return Array.isArray(s) ? s : [];
}, Hc = (t, a) => Ro(t, "entitlements", a), $c = (t, a) => Ro(t, "roles", a), hi = (t, a) => t.some((r) => a.includes(r) || a.includes(r == null ? void 0 : r.replace(/^score:/, ""))), Wc = {
  scoreadmin: ({ entitlements: t, roles: a }) => t.includes("score") && hi(a, Vc),
  announcer: ({ roles: t }) => hi(t, zc),
  scoreboard: ({ roles: t }) => hi(t, Bc),
  // Launcher-only apps (account-fe Home): the org entitlement is the whole rule.
  manager: ({ entitlements: t }) => t.includes("manager"),
  scribe: ({ entitlements: t }) => t.includes("score")
}, qc = (t, { accessToken: a, orgId: r, isSuper: s } = {}) => {
  const n = Wc[t];
  return n ? s ? !0 : !a || !r ? !1 : n({
    entitlements: Hc(a, r),
    roles: $c(a, r)
  }) : !1;
};
function Jc({
  currentApp: t = null,
  env: a,
  accessToken: r,
  orgId: s = null,
  isSuper: n = !1,
  showId: e = null,
  t: i
}) {
  const o = wo.map((l) => So.find((c) => c.key === l)).filter((l) => l && l.inSwitcher).filter((l) => qc(l.key, { accessToken: r, orgId: s, isSuper: n })).map((l) => ({ app: l, href: Mc(l, a, e) })).filter(({ app: l, href: c }) => l.key === t || c);
  if (!o.some(({ app: l }) => l.key !== t)) return [];
  const u = o.map(({ app: l, href: c }) => {
    const d = l.Icon;
    return {
      icon: /* @__PURE__ */ m.jsx(d, {}),
      text: l.title(i),
      ...l.key === t ? { checked: !0 } : { href: c }
    };
  });
  return u[u.length - 1] = { ...u[u.length - 1], dividerAfter: !0 }, u;
}
function Yc({ currentApp: t = null, env: a }) {
  var u;
  const r = Vt(), { activeOrgId: s, isSuper: n } = ur(), { activeShowId: e } = vo(), { t: i } = $a("common"), o = (u = r == null ? void 0 : r.user) == null ? void 0 : u.access_token;
  return xt(
    () => Jc({
      currentApp: t,
      env: a,
      accessToken: o,
      orgId: s,
      isSuper: n,
      showId: e,
      t: i
    }),
    [t, a, o, s, n, e, i]
  );
}
function Zc({ onLogout: t, brandLogo: a = null, accountOrgsUrl: r, env: s = {} }) {
  var d;
  const { mode: n, setMode: e } = Na(), { orgs: i, activeOrgId: o } = ur(), u = ((d = i.find((h) => h.id === o)) == null ? void 0 : d.name) || null, c = [
    ...Yc({ currentApp: null, env: s }),
    {
      icon: n === "dark" ? /* @__PURE__ */ m.jsx(qa, {}) : /* @__PURE__ */ m.jsx(Wa, {}),
      text: n === "dark" ? "Light mode" : "Dark mode",
      onClick: () => e(n === "dark" ? "light" : "dark")
    },
    {
      icon: /* @__PURE__ */ m.jsx(Ja, {}),
      text: "Sign out",
      onClick: t
    }
  ];
  return /* @__PURE__ */ m.jsx(
    vl,
    {
      sx: { backgroundColor: qt.darkGrey, color: "#fff" },
      brandLogo: a,
      rightContent: /* @__PURE__ */ m.jsxs(
        De,
        {
          "data-testid": "gate-header",
          sx: { display: "flex", alignItems: "center", gap: 1.5 },
          children: [
            /* @__PURE__ */ m.jsx(Dc, { accountOrgsUrl: r }),
            u && /* @__PURE__ */ m.jsx(
              Mt,
              {
                "data-testid": "gate-active-org-name",
                variant: "body2",
                sx: { color: "inherit", opacity: 0.9, whiteSpace: "nowrap" },
                children: u
              }
            ),
            /* @__PURE__ */ m.jsx(Nc, {}),
            /* @__PURE__ */ m.jsx(hl, { menuItems: c })
          ]
        }
      )
    }
  );
}
function Wv({
  appName: t,
  onLogout: a,
  accountFeBaseUrl: r,
  brandLogo: s = null,
  env: n
}) {
  const e = (r || "").replace(/\/+$/, "");
  return /* @__PURE__ */ m.jsxs(m.Fragment, { children: [
    /* @__PURE__ */ m.jsx(
      Zc,
      {
        onLogout: a,
        brandLogo: s,
        accountOrgsUrl: `${e}/orgs`,
        env: n
      }
    ),
    /* @__PURE__ */ m.jsx(
      De,
      {
        "data-testid": "no-access-screen",
        sx: { maxWidth: 560, mx: "auto", pt: "64px", pb: 8, px: 3, textAlign: "center" },
        children: /* @__PURE__ */ m.jsxs(De, { sx: { pt: 8 }, children: [
          /* @__PURE__ */ m.jsx(Mt, { variant: "h5", component: "h1", gutterBottom: !0, color: "text.primary", children: `You don't have access to ${t}` }),
          /* @__PURE__ */ m.jsx(Mt, { variant: "body1", color: "text.secondary", sx: { mb: 3 }, children: `Your account doesn't have access to ${t} in this organization. Ask your organization's admin to grant it, or switch to an organization that has it.` }),
          /* @__PURE__ */ m.jsx(
            ol,
            {
              "data-testid": "no-access-apps-link",
              href: `${e}/`,
              variant: "body1",
              underline: "always",
              children: "Back to your apps in Account Center"
            }
          )
        ] })
      }
    )
  ] });
}
const Io = "common-fe.mockAuth", _o = On(null), Kc = {
  email: "jaybill@foxvillage.com",
  displayName: "Jaybill"
};
function Qc() {
  try {
    const t = localStorage.getItem(Io);
    return t ? JSON.parse(t) : { signedIn: !1, user: null };
  } catch {
    return { signedIn: !1, user: null };
  }
}
function Xc(t) {
  try {
    localStorage.setItem(Io, JSON.stringify(t));
  } catch {
  }
}
function qv({ children: t, defaultUser: a = Kc }) {
  const [r, s] = H(Qc);
  ke(() => {
    Xc(r);
  }, [r]);
  const n = gt(
    (o) => {
      s({ signedIn: !0, user: o ?? a });
    },
    [a]
  ), e = gt(() => {
    s({ signedIn: !1, user: null });
  }, []), i = xt(
    () => ({
      isAuthenticated: r.signedIn,
      user: r.user,
      signIn: n,
      signOut: e
    }),
    [r, n, e]
  );
  return /* @__PURE__ */ m.jsx(_o.Provider, { value: i, children: t });
}
function To() {
  const t = kn(_o);
  if (!t)
    throw new Error("useMockAuth must be used within a MockAuthProvider");
  return t;
}
function Jv({ children: t, loginPath: a = "/login" }) {
  const { isAuthenticated: r } = To(), s = Ku();
  return r ? t : /* @__PURE__ */ m.jsx(Ma, { to: a, replace: !0, state: { from: s.pathname } });
}
const ed = "jaybill@foxvillage.com", td = "demo-password", nd = {
  heading: "Sign in",
  subheading: "Sign in to your account.",
  emailLabel: "Email address",
  passwordLabel: "Password",
  showPassword: "Show password",
  forgotPassword: "Forgot your password?",
  submit: "Sign in",
  newUserPrompt: "New user?",
  createAccount: "Create an account"
};
function Yv({
  onSignIn: t,
  brandLogo: a,
  labels: r = {}
}) {
  const { signIn: s } = To(), [n, e] = H(ed), [i, o] = H(td), [u, l] = H(!1), c = { ...nd, ...r }, d = (g) => {
    g.preventDefault();
    const U = { email: n, displayName: n.split("@")[0] };
    t ? t(U) : s(U);
  }, h = a ?? Ua;
  return /* @__PURE__ */ m.jsx(
    pe,
    {
      sx: {
        minHeight: "100vh",
        width: "100%",
        bgcolor: (g) => g.palette.mode === "dark" ? "#2a2a2a" : "grey.100",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        p: 2
      },
      children: /* @__PURE__ */ m.jsxs(
        jr,
        {
          elevation: 6,
          sx: {
            width: "100%",
            maxWidth: 480,
            p: { xs: 3, sm: 5 },
            bgcolor: (g) => g.palette.mode === "dark" ? "#000" : "background.paper",
            color: (g) => g.palette.mode === "dark" ? "#fff" : "text.primary",
            borderRadius: 3
          },
          children: [
            /* @__PURE__ */ m.jsx(
              pe,
              {
                sx: {
                  display: "flex",
                  justifyContent: "center",
                  mb: 4,
                  color: "inherit"
                },
                children: /* @__PURE__ */ m.jsx(h, { style: { width: 240, height: "auto" } })
              }
            ),
            /* @__PURE__ */ m.jsx(Ze, { variant: "h4", component: "h1", fontWeight: 700, gutterBottom: !0, children: c.heading }),
            /* @__PURE__ */ m.jsx(
              Ze,
              {
                variant: "body1",
                sx: { opacity: 0.7, mb: 4 },
                children: c.subheading
              }
            ),
            /* @__PURE__ */ m.jsx(pe, { component: "form", onSubmit: d, children: /* @__PURE__ */ m.jsxs(yn, { spacing: 3, children: [
              /* @__PURE__ */ m.jsx(
                Rn,
                {
                  label: c.emailLabel,
                  type: "email",
                  fullWidth: !0,
                  value: n,
                  onChange: (g) => e(g.target.value),
                  InputLabelProps: {
                    sx: { fontWeight: 600 }
                  }
                }
              ),
              /* @__PURE__ */ m.jsxs(pe, { children: [
                /* @__PURE__ */ m.jsx(
                  Rn,
                  {
                    label: c.passwordLabel,
                    type: u ? "text" : "password",
                    fullWidth: !0,
                    value: i,
                    onChange: (g) => o(g.target.value),
                    InputLabelProps: {
                      sx: { fontWeight: 600 }
                    }
                  }
                ),
                /* @__PURE__ */ m.jsxs(
                  yn,
                  {
                    direction: "row",
                    justifyContent: "space-between",
                    alignItems: "center",
                    sx: { mt: 1 },
                    children: [
                      /* @__PURE__ */ m.jsx(
                        ka,
                        {
                          control: /* @__PURE__ */ m.jsx(
                            Pa,
                            {
                              size: "small",
                              checked: u,
                              onChange: (g) => l(g.target.checked),
                              sx: { color: "inherit" }
                            }
                          ),
                          label: c.showPassword
                        }
                      ),
                      /* @__PURE__ */ m.jsx(
                        Os,
                        {
                          component: "button",
                          type: "button",
                          underline: "hover",
                          onClick: () => {
                          },
                          sx: { color: "primary.light" },
                          children: c.forgotPassword
                        }
                      )
                    ]
                  }
                )
              ] }),
              /* @__PURE__ */ m.jsx(
                ht,
                {
                  type: "submit",
                  variant: "contained",
                  fullWidth: !0,
                  size: "large",
                  sx: { py: 1.5, fontWeight: 600 },
                  children: c.submit
                }
              ),
              /* @__PURE__ */ m.jsxs(
                Ze,
                {
                  variant: "body2",
                  align: "center",
                  sx: { opacity: 0.8 },
                  children: [
                    c.newUserPrompt,
                    " ",
                    /* @__PURE__ */ m.jsx(
                      Os,
                      {
                        component: "button",
                        type: "button",
                        underline: "hover",
                        onClick: () => {
                        },
                        sx: { color: "primary.light" },
                        children: c.createAccount
                      }
                    )
                  ]
                }
              )
            ] }) })
          ]
        }
      )
    }
  );
}
var ji = { d: (t, a) => {
  for (var r in a) ji.o(a, r) && !ji.o(t, r) && Object.defineProperty(t, r, { enumerable: !0, get: a[r] });
}, o: (t, a) => Object.prototype.hasOwnProperty.call(t, a) };
const we = (Qs = { default: () => rs.default }, fi = {}, ji.d(fi, Qs), fi);
var Qs, fi;
function Eo(t, a) {
  if (!(t instanceof a)) throw new TypeError("Cannot call a class as a function");
}
function Mi(t, a, r) {
  return Mi = us() ? Reflect.construct : function(s, n, e) {
    var i = [null];
    i.push.apply(i, n);
    var o = new (Function.bind.apply(s, i))();
    return e && tr(o, e.prototype), o;
  }, Mi.apply(null, arguments);
}
function Ur(t, a, r) {
  return a in t ? Object.defineProperty(t, a, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : t[a] = r, t;
}
function er(t) {
  return er = Object.setPrototypeOf ? Object.getPrototypeOf : function(a) {
    return a.__proto__ || Object.getPrototypeOf(a);
  }, er(t);
}
function tr(t, a) {
  return tr = Object.setPrototypeOf || function(r, s) {
    return r.__proto__ = s, r;
  }, tr(t, a);
}
function Fi(t) {
  var a = typeof Map == "function" ? /* @__PURE__ */ new Map() : void 0;
  return Fi = function(r) {
    if (r === null || (s = r, Function.toString.call(s).indexOf("[native code]") === -1)) return r;
    var s;
    if (typeof r != "function") throw new TypeError("Super expression must either be null or a function");
    if (a !== void 0) {
      if (a.has(r)) return a.get(r);
      a.set(r, n);
    }
    function n() {
      return Mi(r, arguments, er(this).constructor);
    }
    return n.prototype = Object.create(r.prototype, { constructor: { value: n, enumerable: !1, writable: !0, configurable: !0 } }), tr(n, r);
  }, Fi(t);
}
function us() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (us = function() {
    return !!t;
  })();
}
var ye = "http://localhost".replace(/\/+$/, ""), cr = function t(a) {
  var r, s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : ye, n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : we.default;
  Eo(this, t), Ur(this, "basePath", void 0), Ur(this, "axios", void 0), Ur(this, "configuration", void 0), this.basePath = s, this.axios = n, a && (this.configuration = a, this.basePath = (r = a.basePath) !== null && r !== void 0 ? r : s);
}, rd = function() {
  function t(a, r) {
    var s;
    return Eo(this, t), Ur(s = function(n, e, i) {
      return e = er(e), o = n, !(u = us() ? Reflect.construct(e, i || [], er(n).constructor) : e.apply(n, i)) || ((l = u) && typeof Symbol < "u" && l.constructor === Symbol ? "symbol" : typeof l) != "object" && typeof u != "function" ? function(c) {
        if (c === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return c;
      }(o) : u;
      var o, u, l;
    }(this, t, [r]), "field", void 0), s.field = a, s.name = "RequiredError", s;
  }
  return function(a, r) {
    if (typeof r != "function" && r !== null) throw new TypeError("Super expression must either be null or a function");
    a.prototype = Object.create(r && r.prototype, { constructor: { value: a, writable: !0, configurable: !0 } }), r && tr(a, r);
  }(t, Fi(Error)), t;
}(), Re = {};
function Xs(t, a, r, s, n, e, i) {
  try {
    var o = t[e](i), u = o.value;
  } catch (l) {
    return void r(l);
  }
  o.done ? a(u) : Promise.resolve(u).then(s, n);
}
function id(t, a, r) {
  return a in t ? Object.defineProperty(t, a, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : t[a] = r, t;
}
var Ie = "https://example.com", le = function(t, a, r) {
  if (r == null) throw new rd(a, "Required parameter ".concat(a, " was null or undefined when calling ").concat(t, "."));
}, Ne = function(t, a) {
  return (r = function() {
    var s, n;
    return function(e, i) {
      var o, u, l, c = { label: 0, sent: function() {
        if (1 & l[0]) throw l[1];
        return l[1];
      }, trys: [], ops: [] }, d = Object.create((typeof Iterator == "function" ? Iterator : Object).prototype);
      return d.next = h(0), d.throw = h(1), d.return = h(2), typeof Symbol == "function" && (d[Symbol.iterator] = function() {
        return this;
      }), d;
      function h(g) {
        return function(U) {
          return function(P) {
            if (o) throw new TypeError("Generator is already executing.");
            for (; d && (d = 0, P[0] && (c = 0)), c; ) try {
              if (o = 1, u && (l = 2 & P[0] ? u.return : P[0] ? u.throw || ((l = u.return) && l.call(u), 0) : u.next) && !(l = l.call(u, P[1])).done) return l;
              switch (u = 0, l && (P = [2 & P[0], l.value]), P[0]) {
                case 0:
                case 1:
                  l = P;
                  break;
                case 4:
                  return c.label++, { value: P[1], done: !1 };
                case 5:
                  c.label++, u = P[1], P = [0];
                  continue;
                case 7:
                  P = c.ops.pop(), c.trys.pop();
                  continue;
                default:
                  if (!((l = (l = c.trys).length > 0 && l[l.length - 1]) || P[0] !== 6 && P[0] !== 2)) {
                    c = 0;
                    continue;
                  }
                  if (P[0] === 3 && (!l || P[1] > l[0] && P[1] < l[3])) {
                    c.label = P[1];
                    break;
                  }
                  if (P[0] === 6 && c.label < l[1]) {
                    c.label = l[1], l = P;
                    break;
                  }
                  if (l && c.label < l[2]) {
                    c.label = l[2], c.ops.push(P);
                    break;
                  }
                  l[2] && c.ops.pop(), c.trys.pop();
                  continue;
              }
              P = i.call(e, c);
            } catch (D) {
              P = [6, D], u = 0;
            } finally {
              o = l = 0;
            }
            if (5 & P[0]) throw P[1];
            return { value: P[0] ? P[1] : void 0, done: !0 };
          }([g, U]);
        };
      }
    }(this, function(e) {
      switch (e.label) {
        case 0:
          return a && a.accessToken ? typeof a.accessToken != "function" ? [3, 2] : [4, a.accessToken()] : [3, 5];
        case 1:
          return n = e.sent(), [3, 4];
        case 2:
          return [4, a.accessToken];
        case 3:
          n = e.sent(), e.label = 4;
        case 4:
          s = n, t.Authorization = "Bearer " + s, e.label = 5;
        case 5:
          return [2];
      }
    });
  }, function() {
    var s = this, n = arguments;
    return new Promise(function(e, i) {
      var o = r.apply(s, n);
      function u(c) {
        Xs(o, e, i, u, l, "next", c);
      }
      function l(c) {
        Xs(o, e, i, u, l, "throw", c);
      }
      u(void 0);
    });
  })();
  var r;
};
function Vi(t, a) {
  var r, s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "";
  a != null && ((a === void 0 ? "undefined" : (r = a) && typeof Symbol < "u" && r.constructor === Symbol ? "symbol" : typeof r) == "object" ? Array.isArray(a) ? a.forEach(function(n) {
    return Vi(t, n, s);
  }) : Object.keys(a).forEach(function(n) {
    return Vi(t, a[n], "".concat(s).concat(s !== "" ? "." : "").concat(n));
  }) : t.has(s) ? t.append(s, a) : t.set(s, a));
}
var _e = function(t) {
  for (var a = arguments.length, r = new Array(a > 1 ? a - 1 : 0), s = 1; s < a; s++) r[s - 1] = arguments[s];
  var n = new URLSearchParams(t.search);
  Vi(n, r), t.search = n.toString();
}, wt = function(t, a, r) {
  var s = typeof t != "string";
  return (s && r && r.isJsonMime ? r.isJsonMime(a.headers["Content-Type"]) : s) ? JSON.stringify(t !== void 0 ? t : {}) : t || "";
}, Te = function(t) {
  return t.pathname + t.search + t.hash;
}, Ee = function(t, a, r, s) {
  return function() {
    var n, e, i, o = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : a, u = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : r, l = (e = function(c) {
      for (var d = 1; d < arguments.length; d++) {
        var h = arguments[d] != null ? arguments[d] : {}, g = Object.keys(h);
        typeof Object.getOwnPropertySymbols == "function" && (g = g.concat(Object.getOwnPropertySymbols(h).filter(function(U) {
          return Object.getOwnPropertyDescriptor(h, U).enumerable;
        }))), g.forEach(function(U) {
          id(c, U, h[U]);
        });
      }
      return c;
    }({}, t.options), i = (i = { url: (o.defaults.baseURL ? "" : (n = s == null ? void 0 : s.basePath) !== null && n !== void 0 ? n : u) + t.url }) != null ? i : {}, Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(i)) : function(c) {
      var d = Object.keys(c);
      if (Object.getOwnPropertySymbols) {
        var h = Object.getOwnPropertySymbols(c);
        d.push.apply(d, h);
      }
      return d;
    }(Object(i)).forEach(function(c) {
      Object.defineProperty(e, c, Object.getOwnPropertyDescriptor(i, c));
    }), e);
    return o.request(l);
  };
};
function ea(t, a, r, s, n, e, i) {
  try {
    var o = t[e](i), u = o.value;
  } catch (l) {
    return void r(l);
  }
  o.done ? a(u) : Promise.resolve(u).then(s, n);
}
function W(t) {
  return function() {
    var a = this, r = arguments;
    return new Promise(function(s, n) {
      var e = t.apply(a, r);
      function i(u) {
        ea(e, s, n, i, o, "next", u);
      }
      function o(u) {
        ea(e, s, n, i, o, "throw", u);
      }
      i(void 0);
    });
  };
}
function dr(t, a, r) {
  return a = Gr(a), s = t, !(n = Co() ? Reflect.construct(a, r || [], Gr(t).constructor) : a.apply(t, r)) || ((e = n) && typeof Symbol < "u" && e.constructor === Symbol ? "symbol" : typeof e) != "object" && typeof n != "function" ? function(i) {
    if (i === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return i;
  }(s) : n;
  var s, n, e;
}
function hr(t, a) {
  if (!(t instanceof a)) throw new TypeError("Cannot call a class as a function");
}
function sd(t, a) {
  for (var r = 0; r < a.length; r++) {
    var s = a[r];
    s.enumerable = s.enumerable || !1, s.configurable = !0, "value" in s && (s.writable = !0), Object.defineProperty(t, s.key, s);
  }
}
function fr(t, a, r) {
  return a && sd(t.prototype, a), t;
}
function ad(t, a, r) {
  return a in t ? Object.defineProperty(t, a, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : t[a] = r, t;
}
function Gr(t) {
  return Gr = Object.setPrototypeOf ? Object.getPrototypeOf : function(a) {
    return a.__proto__ || Object.getPrototypeOf(a);
  }, Gr(t);
}
function vr(t, a) {
  if (typeof a != "function" && a !== null) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(a && a.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), a && zi(t, a);
}
function $(t) {
  for (var a = 1; a < arguments.length; a++) {
    var r = arguments[a] != null ? arguments[a] : {}, s = Object.keys(r);
    typeof Object.getOwnPropertySymbols == "function" && (s = s.concat(Object.getOwnPropertySymbols(r).filter(function(n) {
      return Object.getOwnPropertyDescriptor(r, n).enumerable;
    }))), s.forEach(function(n) {
      ad(t, n, r[n]);
    });
  }
  return t;
}
function zi(t, a) {
  return zi = Object.setPrototypeOf || function(r, s) {
    return r.__proto__ = s, r;
  }, zi(t, a);
}
function Co() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (Co = function() {
    return !!t;
  })();
}
function q(t, a) {
  var r, s, n, e = { label: 0, sent: function() {
    if (1 & n[0]) throw n[1];
    return n[1];
  }, trys: [], ops: [] }, i = Object.create((typeof Iterator == "function" ? Iterator : Object).prototype);
  return i.next = o(0), i.throw = o(1), i.return = o(2), typeof Symbol == "function" && (i[Symbol.iterator] = function() {
    return this;
  }), i;
  function o(u) {
    return function(l) {
      return function(c) {
        if (r) throw new TypeError("Generator is already executing.");
        for (; i && (i = 0, c[0] && (e = 0)), e; ) try {
          if (r = 1, s && (n = 2 & c[0] ? s.return : c[0] ? s.throw || ((n = s.return) && n.call(s), 0) : s.next) && !(n = n.call(s, c[1])).done) return n;
          switch (s = 0, n && (c = [2 & c[0], n.value]), c[0]) {
            case 0:
            case 1:
              n = c;
              break;
            case 4:
              return e.label++, { value: c[1], done: !1 };
            case 5:
              e.label++, s = c[1], c = [0];
              continue;
            case 7:
              c = e.ops.pop(), e.trys.pop();
              continue;
            default:
              if (!((n = (n = e.trys).length > 0 && n[n.length - 1]) || c[0] !== 6 && c[0] !== 2)) {
                e = 0;
                continue;
              }
              if (c[0] === 3 && (!n || c[1] > n[0] && c[1] < n[3])) {
                e.label = c[1];
                break;
              }
              if (c[0] === 6 && e.label < n[1]) {
                e.label = n[1], n = c;
                break;
              }
              if (n && e.label < n[2]) {
                e.label = n[2], e.ops.push(c);
                break;
              }
              n[2] && e.ops.pop(), e.trys.pop();
              continue;
          }
          c = a.call(t, e);
        } catch (d) {
          c = [6, d], s = 0;
        } finally {
          r = n = 0;
        }
        if (5 & c[0]) throw c[1];
        return { value: c[0] ? c[1] : void 0, done: !0 };
      }([u, l]);
    };
  }
}
var od = function(t) {
  return { correctUsefClass: function(a, r) {
    var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return W(function() {
      var n, e, i, o, u, l, c;
      return q(this, function(d) {
        switch (d.label) {
          case 0:
            return le("correctUsefClass", "classId", a), le("correctUsefClass", "uploadUsefClassRequest", r), n = "/federation/usef/classes/{classId}/correct".replace("{classId}", encodeURIComponent(String(a))), e = new URL(n, Ie), t && (i = t.baseOptions), o = $({ method: "POST" }, i, s), l = {}, [4, Ne(u = {}, t)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", _e(e, l), c = i && i.headers ? i.headers : {}, o.headers = $({}, u, c, s.headers), o.data = wt(r, o, t), [2, { url: Te(e), options: o }];
        }
      });
    })();
  }, deleteUsefClass: function(a, r) {
    var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return W(function() {
      var n, e, i, o, u, l, c;
      return q(this, function(d) {
        switch (d.label) {
          case 0:
            return le("deleteUsefClass", "classId", a), le("deleteUsefClass", "deleteUsefClassRequest", r), n = "/federation/usef/classes/{classId}/delete".replace("{classId}", encodeURIComponent(String(a))), e = new URL(n, Ie), t && (i = t.baseOptions), o = $({ method: "POST" }, i, s), l = {}, [4, Ne(u = {}, t)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", _e(e, l), c = i && i.headers ? i.headers : {}, o.headers = $({}, u, c, s.headers), o.data = wt(r, o, t), [2, { url: Te(e), options: o }];
        }
      });
    })();
  }, finalizeUsefClass: function(a, r) {
    var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return W(function() {
      var n, e, i, o, u, l, c;
      return q(this, function(d) {
        switch (d.label) {
          case 0:
            return le("finalizeUsefClass", "classId", a), le("finalizeUsefClass", "deleteUsefClassRequest", r), n = "/federation/usef/classes/{classId}/finalize".replace("{classId}", encodeURIComponent(String(a))), e = new URL(n, Ie), t && (i = t.baseOptions), o = $({ method: "POST" }, i, s), l = {}, [4, Ne(u = {}, t)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", _e(e, l), c = i && i.headers ? i.headers : {}, o.headers = $({}, u, c, s.headers), o.data = wt(r, o, t), [2, { url: Te(e), options: o }];
        }
      });
    })();
  }, getFederationClassAudit: function(a) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return W(function() {
      var s, n, e, i, o, u, l;
      return q(this, function(c) {
        switch (c.label) {
          case 0:
            return le("getFederationClassAudit", "classId", a), s = "/federation/classes/{classId}/audit".replace("{classId}", encodeURIComponent(String(a))), n = new URL(s, Ie), t && (e = t.baseOptions), i = $({ method: "GET" }, e, r), u = {}, [4, Ne(o = {}, t)];
          case 1:
            return c.sent(), _e(n, u), l = e && e.headers ? e.headers : {}, i.headers = $({}, o, l, r.headers), [2, { url: Te(n), options: i }];
        }
      });
    })();
  }, getFederationShowAudit: function(a) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return W(function() {
      var s, n, e, i, o, u, l;
      return q(this, function(c) {
        switch (c.label) {
          case 0:
            return le("getFederationShowAudit", "showId", a), s = "/federation/shows/{showId}/audit".replace("{showId}", encodeURIComponent(String(a))), n = new URL(s, Ie), t && (e = t.baseOptions), i = $({ method: "GET" }, e, r), u = {}, [4, Ne(o = {}, t)];
          case 1:
            return c.sent(), _e(n, u), l = e && e.headers ? e.headers : {}, i.headers = $({}, o, l, r.headers), [2, { url: Te(n), options: i }];
        }
      });
    })();
  }, getFederationShowState: function(a) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return W(function() {
      var s, n, e, i, o, u, l;
      return q(this, function(c) {
        switch (c.label) {
          case 0:
            return le("getFederationShowState", "showId", a), s = "/federation/shows/{showId}/state".replace("{showId}", encodeURIComponent(String(a))), n = new URL(s, Ie), t && (e = t.baseOptions), i = $({ method: "GET" }, e, r), u = {}, [4, Ne(o = {}, t)];
          case 1:
            return c.sent(), _e(n, u), l = e && e.headers ? e.headers : {}, i.headers = $({}, o, l, r.headers), [2, { url: Te(n), options: i }];
        }
      });
    })();
  }, getUsefDeadlineStatus: function(a, r) {
    var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return W(function() {
      var n, e, i, o, u, l;
      return q(this, function(c) {
        switch (c.label) {
          case 0:
            return le("getUsefDeadlineStatus", "competitionEndDate", a), n = new URL("/federation/usef/deadline", Ie), t && (e = t.baseOptions), i = $({ method: "GET" }, e, s), u = {}, [4, Ne(o = {}, t)];
          case 1:
            return c.sent(), a !== void 0 && (u.competitionEndDate = a), r !== void 0 && (u.showId = r), _e(n, u), l = e && e.headers ? e.headers : {}, i.headers = $({}, o, l, s.headers), [2, { url: Te(n), options: i }];
        }
      });
    })();
  }, listUsefDressageSections: function(a) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return W(function() {
      var s, n, e, i, o, u;
      return q(this, function(l) {
        switch (l.label) {
          case 0:
            return le("listUsefDressageSections", "compYear", a), s = new URL("/federation/usef/sections", Ie), t && (n = t.baseOptions), e = $({ method: "GET" }, n, r), o = {}, [4, Ne(i = {}, t)];
          case 1:
            return l.sent(), a !== void 0 && (o.compYear = a), _e(s, o), u = n && n.headers ? n.headers : {}, e.headers = $({}, i, u, r.headers), [2, { url: Te(s), options: e }];
        }
      });
    })();
  }, listUsefDressageTests: function(a) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return W(function() {
      var s, n, e, i, o, u;
      return q(this, function(l) {
        switch (l.label) {
          case 0:
            return le("listUsefDressageTests", "testYear", a), s = new URL("/federation/usef/tests", Ie), t && (n = t.baseOptions), e = $({ method: "GET" }, n, r), o = {}, [4, Ne(i = {}, t)];
          case 1:
            return l.sent(), a !== void 0 && (o.testYear = a), _e(s, o), u = n && n.headers ? n.headers : {}, e.headers = $({}, i, u, r.headers), [2, { url: Te(s), options: e }];
        }
      });
    })();
  }, markClassForRepublish: function(a, r) {
    var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return W(function() {
      var n, e, i, o, u, l, c;
      return q(this, function(d) {
        switch (d.label) {
          case 0:
            return le("markClassForRepublish", "classId", a), le("markClassForRepublish", "markClassForRepublishRequest", r), n = "/federation/usef/classes/{classId}/mark-for-republish".replace("{classId}", encodeURIComponent(String(a))), e = new URL(n, Ie), t && (i = t.baseOptions), o = $({ method: "POST" }, i, s), l = {}, [4, Ne(u = {}, t)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", _e(e, l), c = i && i.headers ? i.headers : {}, o.headers = $({}, u, c, s.headers), o.data = wt(r, o, t), [2, { url: Te(e), options: o }];
        }
      });
    })();
  }, previewClassResult: function(a) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return W(function() {
      var s, n, e, i, o, u, l;
      return q(this, function(c) {
        switch (c.label) {
          case 0:
            return le("previewClassResult", "classId", a), s = "/federation/classes/{classId}/preview".replace("{classId}", encodeURIComponent(String(a))), n = new URL(s, Ie), t && (e = t.baseOptions), i = $({ method: "GET" }, e, r), u = {}, [4, Ne(o = {}, t)];
          case 1:
            return c.sent(), _e(n, u), l = e && e.headers ? e.headers : {}, i.headers = $({}, o, l, r.headers), [2, { url: Te(n), options: i }];
        }
      });
    })();
  }, previewShowResults: function(a) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return W(function() {
      var s, n, e, i, o, u, l;
      return q(this, function(c) {
        switch (c.label) {
          case 0:
            return le("previewShowResults", "showId", a), s = "/federation/shows/{showId}/preview".replace("{showId}", encodeURIComponent(String(a))), n = new URL(s, Ie), t && (e = t.baseOptions), i = $({ method: "GET" }, e, r), u = {}, [4, Ne(o = {}, t)];
          case 1:
            return c.sent(), _e(n, u), l = e && e.headers ? e.headers : {}, i.headers = $({}, o, l, r.headers), [2, { url: Te(n), options: i }];
        }
      });
    })();
  }, publishUsdfShow: function(a, r) {
    var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return W(function() {
      var n, e, i, o, u, l, c;
      return q(this, function(d) {
        switch (d.label) {
          case 0:
            return le("publishUsdfShow", "showId", a), n = "/federation/usdf/shows/{showId}/publish".replace("{showId}", encodeURIComponent(String(a))), e = new URL(n, Ie), t && (i = t.baseOptions), o = $({ method: "POST" }, i, s), l = {}, [4, Ne(u = {}, t)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", _e(e, l), c = i && i.headers ? i.headers : {}, o.headers = $({}, u, c, s.headers), o.data = wt(r, o, t), [2, { url: Te(e), options: o }];
        }
      });
    })();
  }, publishUsefShow: function(a, r) {
    var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return W(function() {
      var n, e, i, o, u, l, c;
      return q(this, function(d) {
        switch (d.label) {
          case 0:
            return le("publishUsefShow", "showId", a), le("publishUsefShow", "publishUsefShowRequest", r), n = "/federation/usef/shows/{showId}/publish".replace("{showId}", encodeURIComponent(String(a))), e = new URL(n, Ie), t && (i = t.baseOptions), o = $({ method: "POST" }, i, s), l = {}, [4, Ne(u = {}, t)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", _e(e, l), c = i && i.headers ? i.headers : {}, o.headers = $({}, u, c, s.headers), o.data = wt(r, o, t), [2, { url: Te(e), options: o }];
        }
      });
    })();
  }, resolveUsefDeleteUncommitted: function(a, r) {
    var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return W(function() {
      var n, e, i, o, u, l, c;
      return q(this, function(d) {
        switch (d.label) {
          case 0:
            return le("resolveUsefDeleteUncommitted", "classId", a), le("resolveUsefDeleteUncommitted", "markClassForRepublishRequest", r), n = "/federation/usef/classes/{classId}/resolve-delete-uncommitted".replace("{classId}", encodeURIComponent(String(a))), e = new URL(n, Ie), t && (i = t.baseOptions), o = $({ method: "POST" }, i, s), l = {}, [4, Ne(u = {}, t)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", _e(e, l), c = i && i.headers ? i.headers : {}, o.headers = $({}, u, c, s.headers), o.data = wt(r, o, t), [2, { url: Te(e), options: o }];
        }
      });
    })();
  }, submitUsefShow: function(a, r) {
    var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return W(function() {
      var n, e, i, o, u, l, c;
      return q(this, function(d) {
        switch (d.label) {
          case 0:
            return le("submitUsefShow", "showId", a), le("submitUsefShow", "submitUsefShowRequest", r), n = "/federation/usef/shows/{showId}/submit".replace("{showId}", encodeURIComponent(String(a))), e = new URL(n, Ie), t && (i = t.baseOptions), o = $({ method: "POST" }, i, s), l = {}, [4, Ne(u = {}, t)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", _e(e, l), c = i && i.headers ? i.headers : {}, o.headers = $({}, u, c, s.headers), o.data = wt(r, o, t), [2, { url: Te(e), options: o }];
        }
      });
    })();
  }, uploadUsefClass: function(a, r) {
    var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return W(function() {
      var n, e, i, o, u, l, c;
      return q(this, function(d) {
        switch (d.label) {
          case 0:
            return le("uploadUsefClass", "classId", a), le("uploadUsefClass", "uploadUsefClassRequest", r), n = "/federation/usef/classes/{classId}/upload".replace("{classId}", encodeURIComponent(String(a))), e = new URL(n, Ie), t && (i = t.baseOptions), o = $({ method: "POST" }, i, s), l = {}, [4, Ne(u = {}, t)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", _e(e, l), c = i && i.headers ? i.headers : {}, o.headers = $({}, u, c, s.headers), o.data = wt(r, o, t), [2, { url: Te(e), options: o }];
        }
      });
    })();
  } };
}, ct = function(t) {
  var a = od(t);
  return { correctUsefClass: function(r, s, n) {
    return W(function() {
      var e, i, o, u, l, c;
      return q(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, a.correctUsefClass(r, s, n)];
          case 1:
            return o = d.sent(), l = (u = t == null ? void 0 : t.serverIndex) !== null && u !== void 0 ? u : 0, c = (i = Re["FederationApi.correctUsefClass"]) === null || i === void 0 || (e = i[l]) === null || e === void 0 ? void 0 : e.url, [2, function(h, g) {
              return Ee(o, we.default, ye, t)(h, c || g);
            }];
        }
      });
    })();
  }, deleteUsefClass: function(r, s, n) {
    return W(function() {
      var e, i, o, u, l, c;
      return q(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, a.deleteUsefClass(r, s, n)];
          case 1:
            return o = d.sent(), l = (u = t == null ? void 0 : t.serverIndex) !== null && u !== void 0 ? u : 0, c = (i = Re["FederationApi.deleteUsefClass"]) === null || i === void 0 || (e = i[l]) === null || e === void 0 ? void 0 : e.url, [2, function(h, g) {
              return Ee(o, we.default, ye, t)(h, c || g);
            }];
        }
      });
    })();
  }, finalizeUsefClass: function(r, s, n) {
    return W(function() {
      var e, i, o, u, l, c;
      return q(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, a.finalizeUsefClass(r, s, n)];
          case 1:
            return o = d.sent(), l = (u = t == null ? void 0 : t.serverIndex) !== null && u !== void 0 ? u : 0, c = (i = Re["FederationApi.finalizeUsefClass"]) === null || i === void 0 || (e = i[l]) === null || e === void 0 ? void 0 : e.url, [2, function(h, g) {
              return Ee(o, we.default, ye, t)(h, c || g);
            }];
        }
      });
    })();
  }, getFederationClassAudit: function(r, s) {
    return W(function() {
      var n, e, i, o, u, l;
      return q(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, a.getFederationClassAudit(r, s)];
          case 1:
            return i = c.sent(), u = (o = t == null ? void 0 : t.serverIndex) !== null && o !== void 0 ? o : 0, l = (e = Re["FederationApi.getFederationClassAudit"]) === null || e === void 0 || (n = e[u]) === null || n === void 0 ? void 0 : n.url, [2, function(d, h) {
              return Ee(i, we.default, ye, t)(d, l || h);
            }];
        }
      });
    })();
  }, getFederationShowAudit: function(r, s) {
    return W(function() {
      var n, e, i, o, u, l;
      return q(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, a.getFederationShowAudit(r, s)];
          case 1:
            return i = c.sent(), u = (o = t == null ? void 0 : t.serverIndex) !== null && o !== void 0 ? o : 0, l = (e = Re["FederationApi.getFederationShowAudit"]) === null || e === void 0 || (n = e[u]) === null || n === void 0 ? void 0 : n.url, [2, function(d, h) {
              return Ee(i, we.default, ye, t)(d, l || h);
            }];
        }
      });
    })();
  }, getFederationShowState: function(r, s) {
    return W(function() {
      var n, e, i, o, u, l;
      return q(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, a.getFederationShowState(r, s)];
          case 1:
            return i = c.sent(), u = (o = t == null ? void 0 : t.serverIndex) !== null && o !== void 0 ? o : 0, l = (e = Re["FederationApi.getFederationShowState"]) === null || e === void 0 || (n = e[u]) === null || n === void 0 ? void 0 : n.url, [2, function(d, h) {
              return Ee(i, we.default, ye, t)(d, l || h);
            }];
        }
      });
    })();
  }, getUsefDeadlineStatus: function(r, s, n) {
    return W(function() {
      var e, i, o, u, l, c;
      return q(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, a.getUsefDeadlineStatus(r, s, n)];
          case 1:
            return o = d.sent(), l = (u = t == null ? void 0 : t.serverIndex) !== null && u !== void 0 ? u : 0, c = (i = Re["FederationApi.getUsefDeadlineStatus"]) === null || i === void 0 || (e = i[l]) === null || e === void 0 ? void 0 : e.url, [2, function(h, g) {
              return Ee(o, we.default, ye, t)(h, c || g);
            }];
        }
      });
    })();
  }, listUsefDressageSections: function(r, s) {
    return W(function() {
      var n, e, i, o, u, l;
      return q(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, a.listUsefDressageSections(r, s)];
          case 1:
            return i = c.sent(), u = (o = t == null ? void 0 : t.serverIndex) !== null && o !== void 0 ? o : 0, l = (e = Re["FederationApi.listUsefDressageSections"]) === null || e === void 0 || (n = e[u]) === null || n === void 0 ? void 0 : n.url, [2, function(d, h) {
              return Ee(i, we.default, ye, t)(d, l || h);
            }];
        }
      });
    })();
  }, listUsefDressageTests: function(r, s) {
    return W(function() {
      var n, e, i, o, u, l;
      return q(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, a.listUsefDressageTests(r, s)];
          case 1:
            return i = c.sent(), u = (o = t == null ? void 0 : t.serverIndex) !== null && o !== void 0 ? o : 0, l = (e = Re["FederationApi.listUsefDressageTests"]) === null || e === void 0 || (n = e[u]) === null || n === void 0 ? void 0 : n.url, [2, function(d, h) {
              return Ee(i, we.default, ye, t)(d, l || h);
            }];
        }
      });
    })();
  }, markClassForRepublish: function(r, s, n) {
    return W(function() {
      var e, i, o, u, l, c;
      return q(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, a.markClassForRepublish(r, s, n)];
          case 1:
            return o = d.sent(), l = (u = t == null ? void 0 : t.serverIndex) !== null && u !== void 0 ? u : 0, c = (i = Re["FederationApi.markClassForRepublish"]) === null || i === void 0 || (e = i[l]) === null || e === void 0 ? void 0 : e.url, [2, function(h, g) {
              return Ee(o, we.default, ye, t)(h, c || g);
            }];
        }
      });
    })();
  }, previewClassResult: function(r, s) {
    return W(function() {
      var n, e, i, o, u, l;
      return q(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, a.previewClassResult(r, s)];
          case 1:
            return i = c.sent(), u = (o = t == null ? void 0 : t.serverIndex) !== null && o !== void 0 ? o : 0, l = (e = Re["FederationApi.previewClassResult"]) === null || e === void 0 || (n = e[u]) === null || n === void 0 ? void 0 : n.url, [2, function(d, h) {
              return Ee(i, we.default, ye, t)(d, l || h);
            }];
        }
      });
    })();
  }, previewShowResults: function(r, s) {
    return W(function() {
      var n, e, i, o, u, l;
      return q(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, a.previewShowResults(r, s)];
          case 1:
            return i = c.sent(), u = (o = t == null ? void 0 : t.serverIndex) !== null && o !== void 0 ? o : 0, l = (e = Re["FederationApi.previewShowResults"]) === null || e === void 0 || (n = e[u]) === null || n === void 0 ? void 0 : n.url, [2, function(d, h) {
              return Ee(i, we.default, ye, t)(d, l || h);
            }];
        }
      });
    })();
  }, publishUsdfShow: function(r, s, n) {
    return W(function() {
      var e, i, o, u, l, c;
      return q(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, a.publishUsdfShow(r, s, n)];
          case 1:
            return o = d.sent(), l = (u = t == null ? void 0 : t.serverIndex) !== null && u !== void 0 ? u : 0, c = (i = Re["FederationApi.publishUsdfShow"]) === null || i === void 0 || (e = i[l]) === null || e === void 0 ? void 0 : e.url, [2, function(h, g) {
              return Ee(o, we.default, ye, t)(h, c || g);
            }];
        }
      });
    })();
  }, publishUsefShow: function(r, s, n) {
    return W(function() {
      var e, i, o, u, l, c;
      return q(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, a.publishUsefShow(r, s, n)];
          case 1:
            return o = d.sent(), l = (u = t == null ? void 0 : t.serverIndex) !== null && u !== void 0 ? u : 0, c = (i = Re["FederationApi.publishUsefShow"]) === null || i === void 0 || (e = i[l]) === null || e === void 0 ? void 0 : e.url, [2, function(h, g) {
              return Ee(o, we.default, ye, t)(h, c || g);
            }];
        }
      });
    })();
  }, resolveUsefDeleteUncommitted: function(r, s, n) {
    return W(function() {
      var e, i, o, u, l, c;
      return q(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, a.resolveUsefDeleteUncommitted(r, s, n)];
          case 1:
            return o = d.sent(), l = (u = t == null ? void 0 : t.serverIndex) !== null && u !== void 0 ? u : 0, c = (i = Re["FederationApi.resolveUsefDeleteUncommitted"]) === null || i === void 0 || (e = i[l]) === null || e === void 0 ? void 0 : e.url, [2, function(h, g) {
              return Ee(o, we.default, ye, t)(h, c || g);
            }];
        }
      });
    })();
  }, submitUsefShow: function(r, s, n) {
    return W(function() {
      var e, i, o, u, l, c;
      return q(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, a.submitUsefShow(r, s, n)];
          case 1:
            return o = d.sent(), l = (u = t == null ? void 0 : t.serverIndex) !== null && u !== void 0 ? u : 0, c = (i = Re["FederationApi.submitUsefShow"]) === null || i === void 0 || (e = i[l]) === null || e === void 0 ? void 0 : e.url, [2, function(h, g) {
              return Ee(o, we.default, ye, t)(h, c || g);
            }];
        }
      });
    })();
  }, uploadUsefClass: function(r, s, n) {
    return W(function() {
      var e, i, o, u, l, c;
      return q(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, a.uploadUsefClass(r, s, n)];
          case 1:
            return o = d.sent(), l = (u = t == null ? void 0 : t.serverIndex) !== null && u !== void 0 ? u : 0, c = (i = Re["FederationApi.uploadUsefClass"]) === null || i === void 0 || (e = i[l]) === null || e === void 0 ? void 0 : e.url, [2, function(h, g) {
              return Ee(o, we.default, ye, t)(h, c || g);
            }];
        }
      });
    })();
  } };
};
(function(t) {
  function a() {
    return hr(this, a), dr(this, a, arguments);
  }
  return vr(a, t), fr(a, [{ key: "correctUsefClass", value: function(r, s, n) {
    var e = this;
    return ct(this.configuration).correctUsefClass(r, s, n).then(function(i) {
      return i(e.axios, e.basePath);
    });
  } }, { key: "deleteUsefClass", value: function(r, s, n) {
    var e = this;
    return ct(this.configuration).deleteUsefClass(r, s, n).then(function(i) {
      return i(e.axios, e.basePath);
    });
  } }, { key: "finalizeUsefClass", value: function(r, s, n) {
    var e = this;
    return ct(this.configuration).finalizeUsefClass(r, s, n).then(function(i) {
      return i(e.axios, e.basePath);
    });
  } }, { key: "getFederationClassAudit", value: function(r, s) {
    var n = this;
    return ct(this.configuration).getFederationClassAudit(r, s).then(function(e) {
      return e(n.axios, n.basePath);
    });
  } }, { key: "getFederationShowAudit", value: function(r, s) {
    var n = this;
    return ct(this.configuration).getFederationShowAudit(r, s).then(function(e) {
      return e(n.axios, n.basePath);
    });
  } }, { key: "getFederationShowState", value: function(r, s) {
    var n = this;
    return ct(this.configuration).getFederationShowState(r, s).then(function(e) {
      return e(n.axios, n.basePath);
    });
  } }, { key: "getUsefDeadlineStatus", value: function(r, s, n) {
    var e = this;
    return ct(this.configuration).getUsefDeadlineStatus(r, s, n).then(function(i) {
      return i(e.axios, e.basePath);
    });
  } }, { key: "listUsefDressageSections", value: function(r, s) {
    var n = this;
    return ct(this.configuration).listUsefDressageSections(r, s).then(function(e) {
      return e(n.axios, n.basePath);
    });
  } }, { key: "listUsefDressageTests", value: function(r, s) {
    var n = this;
    return ct(this.configuration).listUsefDressageTests(r, s).then(function(e) {
      return e(n.axios, n.basePath);
    });
  } }, { key: "markClassForRepublish", value: function(r, s, n) {
    var e = this;
    return ct(this.configuration).markClassForRepublish(r, s, n).then(function(i) {
      return i(e.axios, e.basePath);
    });
  } }, { key: "previewClassResult", value: function(r, s) {
    var n = this;
    return ct(this.configuration).previewClassResult(r, s).then(function(e) {
      return e(n.axios, n.basePath);
    });
  } }, { key: "previewShowResults", value: function(r, s) {
    var n = this;
    return ct(this.configuration).previewShowResults(r, s).then(function(e) {
      return e(n.axios, n.basePath);
    });
  } }, { key: "publishUsdfShow", value: function(r, s, n) {
    var e = this;
    return ct(this.configuration).publishUsdfShow(r, s, n).then(function(i) {
      return i(e.axios, e.basePath);
    });
  } }, { key: "publishUsefShow", value: function(r, s, n) {
    var e = this;
    return ct(this.configuration).publishUsefShow(r, s, n).then(function(i) {
      return i(e.axios, e.basePath);
    });
  } }, { key: "resolveUsefDeleteUncommitted", value: function(r, s, n) {
    var e = this;
    return ct(this.configuration).resolveUsefDeleteUncommitted(r, s, n).then(function(i) {
      return i(e.axios, e.basePath);
    });
  } }, { key: "submitUsefShow", value: function(r, s, n) {
    var e = this;
    return ct(this.configuration).submitUsefShow(r, s, n).then(function(i) {
      return i(e.axios, e.basePath);
    });
  } }, { key: "uploadUsefClass", value: function(r, s, n) {
    var e = this;
    return ct(this.configuration).uploadUsefClass(r, s, n).then(function(i) {
      return i(e.axios, e.basePath);
    });
  } }]), a;
})(cr);
var ud = function(t) {
  return { getHealth: function() {
    var a = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return W(function() {
      var r, s, n, e, i;
      return q(this, function(o) {
        return r = new URL("/health", Ie), t && (s = t.baseOptions), n = $({ method: "GET" }, s, a), e = {}, _e(r, {}), i = s && s.headers ? s.headers : {}, n.headers = $({}, e, i, a.headers), [2, { url: Te(r), options: n }];
      });
    })();
  } };
}, ld = function(t) {
  var a = ud(t);
  return { getHealth: function(r) {
    return W(function() {
      var s, n, e, i, o, u;
      return q(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, a.getHealth(r)];
          case 1:
            return e = l.sent(), o = (i = t == null ? void 0 : t.serverIndex) !== null && i !== void 0 ? i : 0, u = (n = Re["HealthApi.getHealth"]) === null || n === void 0 || (s = n[o]) === null || s === void 0 ? void 0 : s.url, [2, function(c, d) {
              return Ee(e, we.default, ye, t)(c, u || d);
            }];
        }
      });
    })();
  } };
};
(function(t) {
  function a() {
    return hr(this, a), dr(this, a, arguments);
  }
  return vr(a, t), fr(a, [{ key: "getHealth", value: function(r) {
    var s = this;
    return ld(this.configuration).getHealth(r).then(function(n) {
      return n(s.axios, s.basePath);
    });
  } }]), a;
})(cr);
var cd = function(t) {
  return { createReportRun: function(a, r) {
    var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return W(function() {
      var n, e, i, o, u, l, c;
      return q(this, function(d) {
        switch (d.label) {
          case 0:
            return le("createReportRun", "id", a), n = "/reports/{id}/runs".replace("{id}", encodeURIComponent(String(a))), e = new URL(n, Ie), t && (i = t.baseOptions), o = $({ method: "POST" }, i, s), l = {}, [4, Ne(u = {}, t)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", _e(e, l), c = i && i.headers ? i.headers : {}, o.headers = $({}, u, c, s.headers), o.data = wt(r, o, t), [2, { url: Te(e), options: o }];
        }
      });
    })();
  }, listReports: function(a) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return W(function() {
      var s, n, e, i, o, u;
      return q(this, function(l) {
        switch (l.label) {
          case 0:
            return s = new URL("/reports", Ie), t && (n = t.baseOptions), e = $({ method: "GET" }, n, r), o = {}, [4, Ne(i = {}, t)];
          case 1:
            return l.sent(), a !== void 0 && (o.domain = a), _e(s, o), u = n && n.headers ? n.headers : {}, e.headers = $({}, i, u, r.headers), [2, { url: Te(s), options: e }];
        }
      });
    })();
  } };
}, ta = function(t) {
  var a = cd(t);
  return { createReportRun: function(r, s, n) {
    return W(function() {
      var e, i, o, u, l, c;
      return q(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, a.createReportRun(r, s, n)];
          case 1:
            return o = d.sent(), l = (u = t == null ? void 0 : t.serverIndex) !== null && u !== void 0 ? u : 0, c = (i = Re["ReportsApi.createReportRun"]) === null || i === void 0 || (e = i[l]) === null || e === void 0 ? void 0 : e.url, [2, function(h, g) {
              return Ee(o, we.default, ye, t)(h, c || g);
            }];
        }
      });
    })();
  }, listReports: function(r, s) {
    return W(function() {
      var n, e, i, o, u, l;
      return q(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, a.listReports(r, s)];
          case 1:
            return i = c.sent(), u = (o = t == null ? void 0 : t.serverIndex) !== null && o !== void 0 ? o : 0, l = (e = Re["ReportsApi.listReports"]) === null || e === void 0 || (n = e[u]) === null || n === void 0 ? void 0 : n.url, [2, function(d, h) {
              return Ee(i, we.default, ye, t)(d, l || h);
            }];
        }
      });
    })();
  } };
}, dd = function(t) {
  function a() {
    return hr(this, a), dr(this, a, arguments);
  }
  return vr(a, t), fr(a, [{ key: "createReportRun", value: function(r, s, n) {
    var e = this;
    return ta(this.configuration).createReportRun(r, s, n).then(function(i) {
      return i(e.axios, e.basePath);
    });
  } }, { key: "listReports", value: function(r, s) {
    var n = this;
    return ta(this.configuration).listReports(r, s).then(function(e) {
      return e(n.axios, n.basePath);
    });
  } }]), a;
}(cr), hd = function(t) {
  return { getClassSheetDelivery: function(a) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return W(function() {
      var s, n, e, i, o, u, l;
      return q(this, function(c) {
        switch (c.label) {
          case 0:
            return le("getClassSheetDelivery", "classId", a), s = "/score-sheets/classes/{classId}/delivery".replace("{classId}", encodeURIComponent(String(a))), n = new URL(s, Ie), t && (e = t.baseOptions), i = $({ method: "GET" }, e, r), u = {}, [4, Ne(o = {}, t)];
          case 1:
            return c.sent(), _e(n, u), l = e && e.headers ? e.headers : {}, i.headers = $({}, o, l, r.headers), [2, { url: Te(n), options: i }];
        }
      });
    })();
  }, getPublicScoreSheetUrl: function(a, r, s) {
    var n = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    return W(function() {
      var e, i, o, u, l, c;
      return q(this, function(d) {
        return le("getPublicScoreSheetUrl", "requestId", a), le("getPublicScoreSheetUrl", "rideId", r), le("getPublicScoreSheetUrl", "variant", s), e = "/public/sheets/{requestId}/{rideId}/{variant}/url".replace("{requestId}", encodeURIComponent(String(a))).replace("{rideId}", encodeURIComponent(String(r))).replace("{variant}", encodeURIComponent(String(s))), i = new URL(e, Ie), t && (o = t.baseOptions), u = $({ method: "GET" }, o, n), l = {}, _e(i, {}), c = o && o.headers ? o.headers : {}, u.headers = $({}, l, c, n.headers), [2, { url: Te(i), options: u }];
      });
    })();
  }, getPublicScoreSheets: function(a) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return W(function() {
      var s, n, e, i, o, u;
      return q(this, function(l) {
        return le("getPublicScoreSheets", "token", a), s = "/public/score-sheets/{token}".replace("{token}", encodeURIComponent(String(a))), n = new URL(s, Ie), t && (e = t.baseOptions), i = $({ method: "GET" }, e, r), o = {}, _e(n, {}), u = e && e.headers ? e.headers : {}, i.headers = $({}, o, u, r.headers), [2, { url: Te(n), options: i }];
      });
    })();
  }, getPublicScoreSheetsConfig: function() {
    var a = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return W(function() {
      var r, s, n, e, i;
      return q(this, function(o) {
        return r = new URL("/public/score-sheets/config", Ie), t && (s = t.baseOptions), n = $({ method: "GET" }, s, a), e = {}, _e(r, {}), i = s && s.headers ? s.headers : {}, n.headers = $({}, e, i, a.headers), [2, { url: Te(r), options: n }];
      });
    })();
  }, getScorePageLink: function(a) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return W(function() {
      var s, n, e, i, o, u, l;
      return q(this, function(c) {
        switch (c.label) {
          case 0:
            return le("getScorePageLink", "rideId", a), s = "/score-sheets/rides/{rideId}/link".replace("{rideId}", encodeURIComponent(String(a))), n = new URL(s, Ie), t && (e = t.baseOptions), i = $({ method: "GET" }, e, r), u = {}, [4, Ne(o = {}, t)];
          case 1:
            return c.sent(), _e(n, u), l = e && e.headers ? e.headers : {}, i.headers = $({}, o, l, r.headers), [2, { url: Te(n), options: i }];
        }
      });
    })();
  }, getScoreSheetStatus: function(a) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return W(function() {
      var s, n, e, i, o, u, l;
      return q(this, function(c) {
        switch (c.label) {
          case 0:
            return le("getScoreSheetStatus", "rideId", a), s = "/score-sheets/rides/{rideId}/status".replace("{rideId}", encodeURIComponent(String(a))), n = new URL(s, Ie), t && (e = t.baseOptions), i = $({ method: "GET" }, e, r), u = {}, [4, Ne(o = {}, t)];
          case 1:
            return c.sent(), _e(n, u), l = e && e.headers ? e.headers : {}, i.headers = $({}, o, l, r.headers), [2, { url: Te(n), options: i }];
        }
      });
    })();
  }, requestPublicScoreSheets: function(a) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return W(function() {
      var s, n, e, i, o, u;
      return q(this, function(l) {
        return le("requestPublicScoreSheets", "requestPublicScoreSheetsRequest", a), s = new URL("/public/score-sheets/request", Ie), t && (n = t.baseOptions), e = $({ method: "POST" }, n, r), o = {}, (i = {})["Content-Type"] = "application/json", _e(s, o), u = n && n.headers ? n.headers : {}, e.headers = $({}, i, u, r.headers), e.data = wt(a, e, t), [2, { url: Te(s), options: e }];
      });
    })();
  }, resendScoreSheet: function(a, r) {
    var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return W(function() {
      var n, e, i, o, u, l, c;
      return q(this, function(d) {
        switch (d.label) {
          case 0:
            return le("resendScoreSheet", "rideId", a), n = "/score-sheets/rides/{rideId}/resend".replace("{rideId}", encodeURIComponent(String(a))), e = new URL(n, Ie), t && (i = t.baseOptions), o = $({ method: "POST" }, i, s), l = {}, [4, Ne(u = {}, t)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", _e(e, l), c = i && i.headers ? i.headers : {}, o.headers = $({}, u, c, s.headers), o.data = wt(r, o, t), [2, { url: Te(e), options: o }];
        }
      });
    })();
  } };
}, Gt = function(t) {
  var a = hd(t);
  return { getClassSheetDelivery: function(r, s) {
    return W(function() {
      var n, e, i, o, u, l;
      return q(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, a.getClassSheetDelivery(r, s)];
          case 1:
            return i = c.sent(), u = (o = t == null ? void 0 : t.serverIndex) !== null && o !== void 0 ? o : 0, l = (e = Re["RiderSheetsApi.getClassSheetDelivery"]) === null || e === void 0 || (n = e[u]) === null || n === void 0 ? void 0 : n.url, [2, function(d, h) {
              return Ee(i, we.default, ye, t)(d, l || h);
            }];
        }
      });
    })();
  }, getPublicScoreSheetUrl: function(r, s, n, e) {
    return W(function() {
      var i, o, u, l, c, d;
      return q(this, function(h) {
        switch (h.label) {
          case 0:
            return [4, a.getPublicScoreSheetUrl(r, s, n, e)];
          case 1:
            return u = h.sent(), c = (l = t == null ? void 0 : t.serverIndex) !== null && l !== void 0 ? l : 0, d = (o = Re["RiderSheetsApi.getPublicScoreSheetUrl"]) === null || o === void 0 || (i = o[c]) === null || i === void 0 ? void 0 : i.url, [2, function(g, U) {
              return Ee(u, we.default, ye, t)(g, d || U);
            }];
        }
      });
    })();
  }, getPublicScoreSheets: function(r, s) {
    return W(function() {
      var n, e, i, o, u, l;
      return q(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, a.getPublicScoreSheets(r, s)];
          case 1:
            return i = c.sent(), u = (o = t == null ? void 0 : t.serverIndex) !== null && o !== void 0 ? o : 0, l = (e = Re["RiderSheetsApi.getPublicScoreSheets"]) === null || e === void 0 || (n = e[u]) === null || n === void 0 ? void 0 : n.url, [2, function(d, h) {
              return Ee(i, we.default, ye, t)(d, l || h);
            }];
        }
      });
    })();
  }, getPublicScoreSheetsConfig: function(r) {
    return W(function() {
      var s, n, e, i, o, u;
      return q(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, a.getPublicScoreSheetsConfig(r)];
          case 1:
            return e = l.sent(), o = (i = t == null ? void 0 : t.serverIndex) !== null && i !== void 0 ? i : 0, u = (n = Re["RiderSheetsApi.getPublicScoreSheetsConfig"]) === null || n === void 0 || (s = n[o]) === null || s === void 0 ? void 0 : s.url, [2, function(c, d) {
              return Ee(e, we.default, ye, t)(c, u || d);
            }];
        }
      });
    })();
  }, getScorePageLink: function(r, s) {
    return W(function() {
      var n, e, i, o, u, l;
      return q(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, a.getScorePageLink(r, s)];
          case 1:
            return i = c.sent(), u = (o = t == null ? void 0 : t.serverIndex) !== null && o !== void 0 ? o : 0, l = (e = Re["RiderSheetsApi.getScorePageLink"]) === null || e === void 0 || (n = e[u]) === null || n === void 0 ? void 0 : n.url, [2, function(d, h) {
              return Ee(i, we.default, ye, t)(d, l || h);
            }];
        }
      });
    })();
  }, getScoreSheetStatus: function(r, s) {
    return W(function() {
      var n, e, i, o, u, l;
      return q(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, a.getScoreSheetStatus(r, s)];
          case 1:
            return i = c.sent(), u = (o = t == null ? void 0 : t.serverIndex) !== null && o !== void 0 ? o : 0, l = (e = Re["RiderSheetsApi.getScoreSheetStatus"]) === null || e === void 0 || (n = e[u]) === null || n === void 0 ? void 0 : n.url, [2, function(d, h) {
              return Ee(i, we.default, ye, t)(d, l || h);
            }];
        }
      });
    })();
  }, requestPublicScoreSheets: function(r, s) {
    return W(function() {
      var n, e, i, o, u, l;
      return q(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, a.requestPublicScoreSheets(r, s)];
          case 1:
            return i = c.sent(), u = (o = t == null ? void 0 : t.serverIndex) !== null && o !== void 0 ? o : 0, l = (e = Re["RiderSheetsApi.requestPublicScoreSheets"]) === null || e === void 0 || (n = e[u]) === null || n === void 0 ? void 0 : n.url, [2, function(d, h) {
              return Ee(i, we.default, ye, t)(d, l || h);
            }];
        }
      });
    })();
  }, resendScoreSheet: function(r, s, n) {
    return W(function() {
      var e, i, o, u, l, c;
      return q(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, a.resendScoreSheet(r, s, n)];
          case 1:
            return o = d.sent(), l = (u = t == null ? void 0 : t.serverIndex) !== null && u !== void 0 ? u : 0, c = (i = Re["RiderSheetsApi.resendScoreSheet"]) === null || i === void 0 || (e = i[l]) === null || e === void 0 ? void 0 : e.url, [2, function(h, g) {
              return Ee(o, we.default, ye, t)(h, c || g);
            }];
        }
      });
    })();
  } };
};
(function(t) {
  function a() {
    return hr(this, a), dr(this, a, arguments);
  }
  return vr(a, t), fr(a, [{ key: "getClassSheetDelivery", value: function(r, s) {
    var n = this;
    return Gt(this.configuration).getClassSheetDelivery(r, s).then(function(e) {
      return e(n.axios, n.basePath);
    });
  } }, { key: "getPublicScoreSheetUrl", value: function(r, s, n, e) {
    var i = this;
    return Gt(this.configuration).getPublicScoreSheetUrl(r, s, n, e).then(function(o) {
      return o(i.axios, i.basePath);
    });
  } }, { key: "getPublicScoreSheets", value: function(r, s) {
    var n = this;
    return Gt(this.configuration).getPublicScoreSheets(r, s).then(function(e) {
      return e(n.axios, n.basePath);
    });
  } }, { key: "getPublicScoreSheetsConfig", value: function(r) {
    var s = this;
    return Gt(this.configuration).getPublicScoreSheetsConfig(r).then(function(n) {
      return n(s.axios, s.basePath);
    });
  } }, { key: "getScorePageLink", value: function(r, s) {
    var n = this;
    return Gt(this.configuration).getScorePageLink(r, s).then(function(e) {
      return e(n.axios, n.basePath);
    });
  } }, { key: "getScoreSheetStatus", value: function(r, s) {
    var n = this;
    return Gt(this.configuration).getScoreSheetStatus(r, s).then(function(e) {
      return e(n.axios, n.basePath);
    });
  } }, { key: "requestPublicScoreSheets", value: function(r, s) {
    var n = this;
    return Gt(this.configuration).requestPublicScoreSheets(r, s).then(function(e) {
      return e(n.axios, n.basePath);
    });
  } }, { key: "resendScoreSheet", value: function(r, s, n) {
    var e = this;
    return Gt(this.configuration).resendScoreSheet(r, s, n).then(function(i) {
      return i(e.axios, e.basePath);
    });
  } }]), a;
})(cr);
var fd = function(t) {
  return { clearRuns: function(a) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return W(function() {
      var s, n, e, i, o, u;
      return q(this, function(l) {
        switch (l.label) {
          case 0:
            return s = new URL("/runs", Ie), t && (n = t.baseOptions), e = $({ method: "DELETE" }, n, r), o = {}, [4, Ne(i = {}, t)];
          case 1:
            return l.sent(), a !== void 0 && (o.reportId = a), _e(s, o), u = n && n.headers ? n.headers : {}, e.headers = $({}, i, u, r.headers), [2, { url: Te(s), options: e }];
        }
      });
    })();
  }, deleteRun: function(a) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return W(function() {
      var s, n, e, i, o, u, l;
      return q(this, function(c) {
        switch (c.label) {
          case 0:
            return le("deleteRun", "id", a), s = "/runs/{id}".replace("{id}", encodeURIComponent(String(a))), n = new URL(s, Ie), t && (e = t.baseOptions), i = $({ method: "DELETE" }, e, r), u = {}, [4, Ne(o = {}, t)];
          case 1:
            return c.sent(), _e(n, u), l = e && e.headers ? e.headers : {}, i.headers = $({}, o, l, r.headers), [2, { url: Te(n), options: i }];
        }
      });
    })();
  }, getRun: function(a) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return W(function() {
      var s, n, e, i, o, u, l;
      return q(this, function(c) {
        switch (c.label) {
          case 0:
            return le("getRun", "id", a), s = "/runs/{id}".replace("{id}", encodeURIComponent(String(a))), n = new URL(s, Ie), t && (e = t.baseOptions), i = $({ method: "GET" }, e, r), u = {}, [4, Ne(o = {}, t)];
          case 1:
            return c.sent(), _e(n, u), l = e && e.headers ? e.headers : {}, i.headers = $({}, o, l, r.headers), [2, { url: Te(n), options: i }];
        }
      });
    })();
  }, listRuns: function(a, r) {
    var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return W(function() {
      var n, e, i, o, u, l;
      return q(this, function(c) {
        switch (c.label) {
          case 0:
            return n = new URL("/runs", Ie), t && (e = t.baseOptions), i = $({ method: "GET" }, e, s), u = {}, [4, Ne(o = {}, t)];
          case 1:
            return c.sent(), a !== void 0 && (u.reportId = a), r !== void 0 && (u.showId = r), _e(n, u), l = e && e.headers ? e.headers : {}, i.headers = $({}, o, l, s.headers), [2, { url: Te(n), options: i }];
        }
      });
    })();
  } };
}, yr = function(t) {
  var a = fd(t);
  return { clearRuns: function(r, s) {
    return W(function() {
      var n, e, i, o, u, l;
      return q(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, a.clearRuns(r, s)];
          case 1:
            return i = c.sent(), u = (o = t == null ? void 0 : t.serverIndex) !== null && o !== void 0 ? o : 0, l = (e = Re["RunsApi.clearRuns"]) === null || e === void 0 || (n = e[u]) === null || n === void 0 ? void 0 : n.url, [2, function(d, h) {
              return Ee(i, we.default, ye, t)(d, l || h);
            }];
        }
      });
    })();
  }, deleteRun: function(r, s) {
    return W(function() {
      var n, e, i, o, u, l;
      return q(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, a.deleteRun(r, s)];
          case 1:
            return i = c.sent(), u = (o = t == null ? void 0 : t.serverIndex) !== null && o !== void 0 ? o : 0, l = (e = Re["RunsApi.deleteRun"]) === null || e === void 0 || (n = e[u]) === null || n === void 0 ? void 0 : n.url, [2, function(d, h) {
              return Ee(i, we.default, ye, t)(d, l || h);
            }];
        }
      });
    })();
  }, getRun: function(r, s) {
    return W(function() {
      var n, e, i, o, u, l;
      return q(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, a.getRun(r, s)];
          case 1:
            return i = c.sent(), u = (o = t == null ? void 0 : t.serverIndex) !== null && o !== void 0 ? o : 0, l = (e = Re["RunsApi.getRun"]) === null || e === void 0 || (n = e[u]) === null || n === void 0 ? void 0 : n.url, [2, function(d, h) {
              return Ee(i, we.default, ye, t)(d, l || h);
            }];
        }
      });
    })();
  }, listRuns: function(r, s, n) {
    return W(function() {
      var e, i, o, u, l, c;
      return q(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, a.listRuns(r, s, n)];
          case 1:
            return o = d.sent(), l = (u = t == null ? void 0 : t.serverIndex) !== null && u !== void 0 ? u : 0, c = (i = Re["RunsApi.listRuns"]) === null || i === void 0 || (e = i[l]) === null || e === void 0 ? void 0 : e.url, [2, function(h, g) {
              return Ee(o, we.default, ye, t)(h, c || g);
            }];
        }
      });
    })();
  } };
}, vd = function(t) {
  function a() {
    return hr(this, a), dr(this, a, arguments);
  }
  return vr(a, t), fr(a, [{ key: "clearRuns", value: function(r, s) {
    var n = this;
    return yr(this.configuration).clearRuns(r, s).then(function(e) {
      return e(n.axios, n.basePath);
    });
  } }, { key: "deleteRun", value: function(r, s) {
    var n = this;
    return yr(this.configuration).deleteRun(r, s).then(function(e) {
      return e(n.axios, n.basePath);
    });
  } }, { key: "getRun", value: function(r, s) {
    var n = this;
    return yr(this.configuration).getRun(r, s).then(function(e) {
      return e(n.axios, n.basePath);
    });
  } }, { key: "listRuns", value: function(r, s, n) {
    var e = this;
    return yr(this.configuration).listRuns(r, s, n).then(function(i) {
      return i(e.axios, e.basePath);
    });
  } }]), a;
}(cr);
function pd(t, a) {
  for (var r = 0; r < a.length; r++) {
    var s = a[r];
    s.enumerable = s.enumerable || !1, s.configurable = !0, "value" in s && (s.writable = !0), Object.defineProperty(t, s.key, s);
  }
}
function Dt(t, a, r) {
  return a in t ? Object.defineProperty(t, a, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : t[a] = r, t;
}
function na(t) {
  for (var a = 1; a < arguments.length; a++) {
    var r = arguments[a] != null ? arguments[a] : {}, s = Object.keys(r);
    typeof Object.getOwnPropertySymbols == "function" && (s = s.concat(Object.getOwnPropertySymbols(r).filter(function(n) {
      return Object.getOwnPropertyDescriptor(r, n).enumerable;
    }))), s.forEach(function(n) {
      Dt(t, n, r[n]);
    });
  }
  return t;
}
var gd = function() {
  function t() {
    var s, n, e, i = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    (function(o, u) {
      if (!(o instanceof u)) throw new TypeError("Cannot call a class as a function");
    })(this, t), Dt(this, "apiKey", void 0), Dt(this, "username", void 0), Dt(this, "password", void 0), Dt(this, "accessToken", void 0), Dt(this, "basePath", void 0), Dt(this, "serverIndex", void 0), Dt(this, "baseOptions", void 0), Dt(this, "formDataCtor", void 0), this.apiKey = i.apiKey, this.username = i.username, this.password = i.password, this.accessToken = i.accessToken, this.basePath = i.basePath, this.serverIndex = i.serverIndex, this.baseOptions = (n = na({}, i.baseOptions), e = (e = { headers: na({}, (s = i.baseOptions) === null || s === void 0 ? void 0 : s.headers) }) != null ? e : {}, Object.getOwnPropertyDescriptors ? Object.defineProperties(n, Object.getOwnPropertyDescriptors(e)) : function(o) {
      var u = Object.keys(o);
      if (Object.getOwnPropertySymbols) {
        var l = Object.getOwnPropertySymbols(o);
        u.push.apply(u, l);
      }
      return u;
    }(Object(e)).forEach(function(o) {
      Object.defineProperty(n, o, Object.getOwnPropertyDescriptor(e, o));
    }), n), this.formDataCtor = i.formDataCtor;
  }
  var a, r;
  return a = t, (r = [{ key: "isJsonMime", value: function(s) {
    var n = new RegExp("^(application/json|[^;/ 	]+/[^;/ 	]+[+]json)[ 	]*(;.*)?$", "i");
    return s !== null && (n.test(s) || s.toLowerCase() === "application/json-patch+json");
  } }]) && pd(a.prototype, r), t;
}();
const md = "Server Error";
function Zv(t) {
  const a = t == null ? void 0 : t.serverFailure;
  return a ? { code: a.code, message: a.message, data: a.data } : { code: null, message: null, data: null };
}
const xo = "fvApplyActiveOrg";
let Nr = null;
function bd(t) {
  Nr = t || null;
}
const ra = /* @__PURE__ */ new WeakSet();
function Sd(t = Fa) {
  ra.has(t) || (ra.add(t), t.interceptors.request.use((a) => (a != null && a[xo] && Nr && a.headers && ((a.headers.has ? a.headers.has("X-Org-Id") : a.headers["X-Org-Id"] != null) || (a.headers.set ? a.headers.set("X-Org-Id", Nr) : a.headers["X-Org-Id"] = Nr)), a)));
}
let ia = !1;
function Kv(t = Fa) {
  ia || (ia = !0, t.interceptors.response.use(
    (a) => a,
    (a) => {
      var n, e, i;
      const r = (n = a == null ? void 0 : a.response) == null ? void 0 : n.data, s = ((e = r == null ? void 0 : r.data) == null ? void 0 : e.message) || (r == null ? void 0 : r.message) || (r == null ? void 0 : r.error) || (r == null ? void 0 : r.code) || (a == null ? void 0 : a.message);
      return console.error("[api error]", (i = a == null ? void 0 : a.response) == null ? void 0 : i.status, s, r), a && ((r == null ? void 0 : r.status) === "fail" && r.data && typeof r.data == "object" && (a.serverFailure = {
        code: typeof r.code == "string" ? r.code : null,
        message: typeof r.data.message == "string" && r.data.message ? r.data.message : null,
        data: r.data
      }), a.serverErrorDetail = s, a.message = md), Promise.reject(a);
    }
  ));
}
function wd() {
  var o;
  const t = Vt(), { activeOrgId: a, isSuper: r } = ur(), s = (o = t.user) == null ? void 0 : o.access_token;
  bd(a), Sd();
  const [n, e] = H({
    seen: a,
    identityOrg: a,
    everSet: a != null
  });
  if (n.seen !== a) {
    const u = n.seen == null && !n.everSet && !r && a != null && a === cc(s);
    e({
      seen: a,
      identityOrg: u ? n.identityOrg : a,
      everSet: n.everSet || a != null
    });
  }
  const { identityOrg: i } = n;
  return gt(
    (u) => ({
      basePath: u,
      accessToken: s,
      baseOptions: { [xo]: !0 }
    }),
    // identityOrg is deliberately a dep only to rebuild on a REAL selection
    // change; the header value itself is stamped at send time.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [s, i]
  );
}
function Oo(t) {
  const a = wd();
  return xt(() => {
    const r = new gd(a(t));
    return {
      reports: new dd(r),
      runs: new vd(r)
    };
  }, [a, t]);
}
function rn(t) {
  var r;
  const a = t == null ? void 0 : t.data;
  if (!a || a.status !== "success") {
    const s = ((r = a == null ? void 0 : a.data) == null ? void 0 : r.message) || (a == null ? void 0 : a.code) || "Request failed";
    throw new Error(s);
  }
  return a.data;
}
const yd = {
  empty: "No reports available.",
  error: "Failed to load reports"
}, Rd = (t) => (t == null ? void 0 : t.name) ?? "";
function Id({
  api: t,
  domain: a,
  onSelect: r,
  selectedId: s,
  // #579 — when set, auto-select this def once (deep-link from another page).
  autoSelectId: n,
  labels: e = {},
  resolveReportName: i = Rd
}) {
  const o = { ...yd, ...e }, [u, l] = H([]), [c, d] = H(!0), [h, g] = H(null), U = ut(!1);
  return ke(() => {
    if (U.current || !n || u.length === 0) return;
    const P = u.find((D) => D.id === n);
    P && (U.current = !0, r == null || r(P));
  }, [u, n, r]), ke(() => {
    let P = !1;
    return d(!0), g(null), t.reports.listReports(a).then((D) => {
      P || l(rn(D) || []);
    }).catch((D) => {
      P || g(D.message || o.error);
    }).finally(() => {
      P || d(!1);
    }), () => {
      P = !0;
    };
  }, [t, a, o.error]), c ? /* @__PURE__ */ m.jsx(pe, { sx: { display: "flex", justifyContent: "center", p: 3 }, children: /* @__PURE__ */ m.jsx(ar, { "data-testid": "report-list-loading" }) }) : h ? /* @__PURE__ */ m.jsx(In, { severity: "error", children: h }) : u.length === 0 ? /* @__PURE__ */ m.jsx(Ze, { color: "text.secondary", sx: { p: 2 }, children: o.empty }) : /* @__PURE__ */ m.jsx(Ou, { "data-testid": "report-list", children: u.map((P) => /* @__PURE__ */ m.jsx(
    ku,
    {
      selected: P.id === s,
      onClick: () => r == null ? void 0 : r(P),
      children: /* @__PURE__ */ m.jsx(
        Pu,
        {
          primary: i(P),
          primaryTypographyProps: { color: "text.primary" }
        }
      )
    },
    P.id
  )) });
}
const _d = {
  title: "Past reports",
  empty: "No reports have been run for this show yet.",
  loadError: "Failed to load past reports",
  openError: "Could not open this report",
  colReport: "Report",
  colRun: "Run",
  colStatus: "Status",
  open: "Open",
  statusRunning: "Running",
  statusFailed: "Failed",
  statusComplete: "Ready"
}, Td = (t) => (t == null ? void 0 : t.name) ?? (t == null ? void 0 : t.id) ?? "", Ed = () => null, Cd = () => null, xd = (t, a) => String(a.createdAt || "").localeCompare(String(t.createdAt || ""));
function Od(t, a, r) {
  const s = a({ id: t.reportId, name: t.reportId }), n = r(t);
  return n ? `${s} · ${n}` : s;
}
function kd(t) {
  const a = document.createElement("a");
  a.href = t, a.target = "_blank", a.rel = "noopener", document.body.appendChild(a), a.click(), a.remove();
}
function Pd({
  api: t,
  showId: a,
  // Bumped by the parent when a run starts or finishes, so the list refetches.
  refreshKey: r = 0,
  labels: s = {},
  resolveReportName: n = Td,
  resolveRunSubject: e = Ed,
  resolveRunFailure: i = Cd
}) {
  const o = { ..._d, ...s }, [u, l] = H(null), [c, d] = H(null), [h, g] = H(null);
  ke(() => {
    if (!a) return;
    let j = !1;
    return d(null), t.runs.listRuns(void 0, a).then((F) => {
      j || l([...rn(F) || []].sort(xd));
    }).catch((F) => {
      j || d(F.message || o.loadError);
    }), () => {
      j = !0;
    };
  }, [t, a, r, o.loadError]);
  const U = async (j) => {
    var F, V;
    g(null);
    try {
      const te = rn(await t.runs.getRun(j.id)), ge = ((F = te.artifactUrls) == null ? void 0 : F.pdf) || ((V = te.artifactUrls) == null ? void 0 : V.html);
      if (!ge) throw new Error(o.openError);
      kd(ge);
    } catch (te) {
      g(te.message || o.openError);
    }
  };
  if (!a) return null;
  const P = new Map(
    (u || []).filter((j) => j.status === "FAILED").map((j) => [j.id, i(j)])
  ), D = (j) => j === "COMPLETE" ? o.statusComplete : j === "FAILED" ? o.statusFailed : o.statusRunning;
  return /* @__PURE__ */ m.jsxs(pe, { "data-testid": "report-run-list", sx: { mt: 3 }, children: [
    /* @__PURE__ */ m.jsx(Ze, { variant: "subtitle1", sx: { color: "text.primary", mb: 1 }, children: o.title }),
    c && /* @__PURE__ */ m.jsx(In, { severity: "error", children: c }),
    h && /* @__PURE__ */ m.jsx(In, { severity: "error", sx: { mb: 1 }, onClose: () => g(null), children: h }),
    !c && u === null && /* @__PURE__ */ m.jsx(ar, { size: 22, color: "inherit", "data-testid": "report-run-list-loading" }),
    !c && u !== null && u.length === 0 && /* @__PURE__ */ m.jsx(Ze, { color: "text.secondary", children: o.empty }),
    !c && u !== null && u.length > 0 && /* @__PURE__ */ m.jsxs(Au, { size: "small", children: [
      /* @__PURE__ */ m.jsx(Uu, { children: /* @__PURE__ */ m.jsxs(ks, { children: [
        /* @__PURE__ */ m.jsx(Bt, { children: o.colReport }),
        /* @__PURE__ */ m.jsx(Bt, { children: o.colRun }),
        /* @__PURE__ */ m.jsx(Bt, { children: o.colStatus }),
        /* @__PURE__ */ m.jsx(Bt, {})
      ] }) }),
      /* @__PURE__ */ m.jsx(Nu, { children: u.map((j) => {
        var F;
        return /* @__PURE__ */ m.jsxs(ks, { "data-testid": "report-run-row", children: [
          /* @__PURE__ */ m.jsx(Bt, { sx: { color: "text.primary" }, children: Od(j, n, e) }),
          /* @__PURE__ */ m.jsx(Bt, { sx: { color: "text.primary" }, children: j.createdAt ? new Date(j.createdAt).toLocaleString() : "" }),
          /* @__PURE__ */ m.jsxs(Bt, { sx: { color: "text.primary" }, children: [
            D(j.status),
            P.get(j.id) && /* @__PURE__ */ m.jsx(
              Ze,
              {
                variant: "caption",
                component: "div",
                sx: { color: "text.secondary" },
                "data-testid": "report-run-failure-reason",
                children: P.get(j.id).reason
              }
            )
          ] }),
          /* @__PURE__ */ m.jsxs(Bt, { align: "right", children: [
            j.status === "COMPLETE" && /* @__PURE__ */ m.jsx(ht, { size: "small", variant: "outlined", color: "inherit", onClick: () => U(j), children: o.open }),
            ((F = P.get(j.id)) == null ? void 0 : F.action) && /* @__PURE__ */ m.jsx(
              ht,
              {
                size: "small",
                variant: "outlined",
                color: "inherit",
                onClick: P.get(j.id).action.onClick,
                "data-testid": "report-run-failure-action",
                children: P.get(j.id).action.label
              }
            )
          ] })
        ] }, j.id);
      }) })
    ] })
  ] });
}
function Ad(t) {
  return t.default !== void 0 ? t.default : t.type === "boolean" ? !1 : "";
}
const Bn = (t) => t !== "" && t !== void 0 && t !== null, Ud = {
  submit: "Run report",
  required: "Required"
}, Nd = (t, a, r) => (r == null ? void 0 : r.title) || a;
function Dd({
  def: t,
  onSubmit: a,
  submitting: r = !1,
  labels: s = {},
  // #551 — `context` supplies values for fields the surface knows (e.g. showId
  // from the active show); those fields are auto-filled + hidden, not typed.
  // `fieldRenderers` overrides how a specific field renders (e.g. day/ring as
  // dropdowns, classId/rideId as a lookup) — keyed by the param name; each gets
  // { value, onChange, label, required, error, disabled }.
  context: n = {},
  fieldRenderers: e = {},
  resolveParamLabel: i = Nd,
  // #1995 — when true AND every required param is already supplied by
  // `context` (a full deep-link, e.g. RideEditor's "Score Sheet Report"
  // button), submit automatically the first time that becomes true instead
  // of making the admin click "Run report" on a form with nothing left to
  // fill in. Guarded to fire at most once per mounted `def`.
  autoSubmit: o = !1
}) {
  var ge, he;
  const u = { ...Ud, ...s }, l = ((ge = t == null ? void 0 : t.paramsSchema) == null ? void 0 : ge.properties) || {}, c = ((he = t == null ? void 0 : t.paramsSchema) == null ? void 0 : he.required) || [], d = Object.entries(l).filter(([G]) => !Bn(n[G])), [h, g] = H(() => {
    const G = {};
    for (const [re, K] of Object.entries(l))
      Bn(n[re]) || (G[re] = Ad(K));
    return G;
  }), [U, P] = H(!1), D = (G, re) => g((K) => ({ ...K, [G]: re })), j = c.filter((G) => Bn(n[G]) ? !1 : !Bn(h[G])), F = () => {
    const G = {};
    for (const [re, K] of Object.entries(l)) {
      if (Bn(n[re])) {
        G[re] = n[re];
        continue;
      }
      const ze = h[re];
      ze === "" && !c.includes(re) || (G[re] = K.type === "number" || K.type === "integer" ? Number(ze) : ze);
    }
    return G;
  }, V = (G) => {
    G.preventDefault(), P(!0), !(j.length > 0) && a(F());
  }, te = ut(!1);
  return ke(() => {
    te.current = !1;
  }, [t == null ? void 0 : t.id]), ke(() => {
    !o || te.current || j.length > 0 || (te.current = !0, a(F()));
  }, [o, j.length]), /* @__PURE__ */ m.jsx(pe, { component: "form", onSubmit: V, noValidate: !0, children: /* @__PURE__ */ m.jsxs(yn, { spacing: 2, children: [
    d.map(([G, re]) => {
      const K = i(t, G, re), ze = c.includes(G), at = U && ze && j.includes(G), He = e[G];
      if (He)
        return /* @__PURE__ */ m.jsx(bu, { children: He({
          value: h[G],
          onChange: (me) => D(G, me),
          label: K,
          required: ze,
          error: at,
          disabled: r
        }) }, G);
      if (re.type === "boolean")
        return /* @__PURE__ */ m.jsx(
          ka,
          {
            control: /* @__PURE__ */ m.jsx(
              Pa,
              {
                color: "default",
                checked: !!h[G],
                onChange: (me) => D(G, me.target.checked)
              }
            ),
            label: K
          },
          G
        );
      if (Array.isArray(re.enum))
        return /* @__PURE__ */ m.jsx(
          Rn,
          {
            select: !0,
            label: K,
            required: ze,
            error: at,
            helperText: at ? u.required : re.description,
            value: h[G] ?? "",
            onChange: (me) => D(G, me.target.value),
            fullWidth: !0,
            children: re.enum.map((me) => /* @__PURE__ */ m.jsx(Du, { value: me, children: String(me) }, String(me)))
          },
          G
        );
      const ce = re.type === "number" || re.type === "integer";
      return /* @__PURE__ */ m.jsx(
        Rn,
        {
          label: K,
          type: ce ? "number" : "text",
          required: ze,
          error: at,
          helperText: at ? u.required : re.description,
          value: h[G] ?? "",
          onChange: (me) => D(G, me.target.value),
          fullWidth: !0
        },
        G
      );
    }),
    /* @__PURE__ */ m.jsx(pe, { children: /* @__PURE__ */ m.jsx(ht, { type: "submit", variant: "contained", loading: r, children: u.submit }) })
  ] }) });
}
function ko(t) {
  const a = document.createElement("a");
  a.href = t, a.target = "_blank", a.rel = "noopener", a.download = "", document.body.appendChild(a), a.click(), a.remove();
}
function Po(t, a) {
  const [r, s] = H(null), n = ut(!1);
  return ke(() => {
    if (!a) return;
    n.current = !1;
    let e = !1, i;
    const o = async () => {
      var u, l;
      try {
        const c = rn(await t.runs.getRun(a));
        if (e) return;
        if (s(c), c.status === "COMPLETE") {
          const d = ((u = c.artifactUrls) == null ? void 0 : u.pdf) || ((l = c.artifactUrls) == null ? void 0 : l.html);
          d && !n.current && (n.current = !0, ko(d));
          return;
        }
        if (c.status === "FAILED")
          return;
        i = setTimeout(o, 3e3);
      } catch {
        e || s((c) => ({ ...c || {}, status: "FAILED" }));
      }
    };
    return i = setTimeout(o, 1200), () => {
      e = !0, clearTimeout(i);
    };
  }, [a, t]), { runResult: r, setRunResult: s };
}
function Qv(t) {
  const a = Oo(t), [r, s] = H(null), [n, e] = H(!1), [i, o] = H(null), { runResult: u, setRunResult: l } = Po(a, r), c = gt(
    async (U, P) => {
      var D, j, F;
      o(null), l(null), e(!0);
      try {
        const V = rn(await a.reports.createReportRun(U, { params: P }));
        l(V), s(V.id);
      } catch (V) {
        s(null), o(((F = (j = (D = V == null ? void 0 : V.response) == null ? void 0 : D.data) == null ? void 0 : j.data) == null ? void 0 : F.message) || (V == null ? void 0 : V.message) || "Failed to start report");
      } finally {
        e(!1);
      }
    },
    [a, l]
  ), d = gt(() => {
    s(null), l(null), o(null);
  }, [l]);
  let h = "idle";
  if (i) h = "failed";
  else if (n) h = "running";
  else if (r) {
    const U = u == null ? void 0 : u.status;
    h = U === "COMPLETE" ? "complete" : U === "FAILED" ? "failed" : "running";
  }
  const g = h === "failed" && (u != null && u.failureCode) ? { code: u.failureCode, ids: u.failureIds || {} } : null;
  return { start: c, reset: d, status: h, error: i, failure: g };
}
const Ld = {
  title: "Reports",
  availableReports: "Available reports",
  reportStarted: "Report started.",
  failedToStart: "Failed to start report",
  // #609 — run-progress modal
  runningTitle: "Running report…",
  runningMessage: "Your report is being generated. It will download automatically when it's ready.",
  runningDoneTitle: "Report ready",
  runningDoneMessage: "Your report has downloaded.",
  runningFailedTitle: "Report failed",
  download: "Download",
  close: "Close",
  // ReportList
  noReports: "No reports available.",
  failedToLoadReports: "Failed to load reports",
  // ReportParamsForm
  runReport: "Run report",
  required: "Required",
  // Run-progress modal failure text
  runFailed: "This run failed to render."
}, jd = (t) => (t == null ? void 0 : t.name) ?? (t == null ? void 0 : t.id) ?? "", Md = (t, a, r) => (r == null ? void 0 : r.title) || a;
function Xv({
  basePath: t,
  domain: a,
  // Back-compat: an explicit `title` still wins; otherwise labels.title is used.
  title: r,
  // #602 — translated chrome strings from the mounting app (see DEFAULT_LABELS).
  labels: s = {},
  // #551 — a surface can supply context values (e.g. showId from the active
  // show) and custom field renderers (day/ring dropdowns, class/ride lookups)
  // forwarded to the params form. `paramsFieldRenderers` may be a plain map or
  // a function of the selected def (so renderers can depend on the def).
  paramsContext: n = {},
  paramsFieldRenderers: e = {},
  // #579 — a surface can deep-link to a specific report (e.g. from a ride page);
  // the matching def is auto-selected once the list loads.
  initialSelectedId: i,
  // #1995 — when true, a deep-linked def whose required params are already
  // fully supplied by `paramsContext` runs immediately (skipping the manual
  // "Run report" click) instead of just being pre-filled. See
  // ReportParamsForm's `autoSubmit` for the fire-once guard.
  autoRun: o = !1,
  // #649 — see defaultResolveReportName/defaultResolveParamLabel above.
  resolveReportName: u = jd,
  resolveParamLabel: l = Md,
  // #3704 -- the read-only "Past reports" list for paramsContext.showId. The
  // mounting app supplies `resolveRunSubject(run)` (the "CL 12" / "CNO 42" part
  // of a run's title) and translated `runListLabels`; see ReportRunList.
  resolveRunSubject: c,
  resolveRunFailure: d,
  runListLabels: h
}) {
  var zt, Rt;
  const g = { ...Ld, ...s }, U = Oo(t), [P, D] = H(null), [j, F] = H(!1), [V, te] = H(null), [ge, he] = H(""), [G, re] = H(null), { runResult: K, setRunResult: ze } = Po(U, G), [at, He] = H(0), ce = K == null ? void 0 : K.status;
  ke(() => {
    G && He((At) => At + 1);
  }, [G, ce]);
  const me = ut(!1), lt = async (At) => {
    if (P) {
      me.current = !0, F(!0), te(null);
      try {
        const It = rn(await U.reports.createReportRun(P.id, { params: At }));
        D(null), ze(It), re(It.id);
      } catch (It) {
        te(It.message || g.failedToStart);
      } finally {
        F(!1);
      }
    }
  };
  return /* @__PURE__ */ m.jsxs(pe, { children: [
    /* @__PURE__ */ m.jsx(Ze, { variant: "h5", sx: { mb: 2, color: "text.primary" }, children: r ?? g.title }),
    /* @__PURE__ */ m.jsxs(pe, { sx: { display: "flex", flexDirection: { xs: "column", md: "row" }, gap: 2, alignItems: "flex-start" }, children: [
      /* @__PURE__ */ m.jsx(pe, { sx: { width: { xs: "100%", md: 340 }, flexShrink: 0 }, children: /* @__PURE__ */ m.jsx(jr, { variant: "outlined", children: /* @__PURE__ */ m.jsxs(Mr, { children: [
        /* @__PURE__ */ m.jsx(Ze, { variant: "subtitle1", sx: { color: "text.primary" }, children: g.availableReports }),
        /* @__PURE__ */ m.jsx(
          Id,
          {
            api: U,
            domain: a,
            selectedId: P == null ? void 0 : P.id,
            autoSelectId: i,
            onSelect: D,
            labels: { empty: g.noReports, error: g.failedToLoadReports },
            resolveReportName: u
          }
        )
      ] }) }) }),
      /* @__PURE__ */ m.jsx(pe, { sx: { flex: 1, minWidth: 0, width: "100%" }, children: P && /* @__PURE__ */ m.jsx(jr, { variant: "outlined", sx: { mb: 2 }, children: /* @__PURE__ */ m.jsxs(Mr, { children: [
        /* @__PURE__ */ m.jsx(Ze, { variant: "subtitle1", sx: { color: "text.primary" }, children: u(P) }),
        /* @__PURE__ */ m.jsx(Lu, { sx: { my: 1 } }),
        V && /* @__PURE__ */ m.jsx(In, { severity: "error", sx: { mb: 2 }, children: V }),
        /* @__PURE__ */ m.jsx(
          Dd,
          {
            def: P,
            onSubmit: lt,
            submitting: j,
            autoSubmit: o && !me.current && (P == null ? void 0 : P.id) === i,
            labels: { submit: g.runReport, required: g.required },
            context: n,
            fieldRenderers: typeof e == "function" ? e(P) : e,
            resolveParamLabel: l
          }
        )
      ] }) }) })
    ] }),
    /* @__PURE__ */ m.jsx(
      Pd,
      {
        api: U,
        showId: n == null ? void 0 : n.showId,
        refreshKey: at,
        labels: h,
        resolveReportName: u,
        resolveRunSubject: c,
        resolveRunFailure: d
      }
    ),
    /* @__PURE__ */ m.jsxs(Ii, { open: !!G, onClose: () => re(null), maxWidth: "xs", fullWidth: !0, children: [
      /* @__PURE__ */ m.jsx(Aa, { children: (K == null ? void 0 : K.status) === "COMPLETE" ? g.runningDoneTitle : (K == null ? void 0 : K.status) === "FAILED" ? g.runningFailedTitle : g.runningTitle }),
      /* @__PURE__ */ m.jsx(_i, { children: (K == null ? void 0 : K.status) === "FAILED" ? /* @__PURE__ */ m.jsx(In, { severity: "error", children: g.runFailed }) : (K == null ? void 0 : K.status) === "COMPLETE" ? /* @__PURE__ */ m.jsx(Ze, { sx: { color: "text.primary" }, children: g.runningDoneMessage }) : /* @__PURE__ */ m.jsxs(pe, { sx: { display: "flex", alignItems: "center", gap: 2, py: 1 }, children: [
        /* @__PURE__ */ m.jsx(ar, { size: 26, color: "inherit" }),
        /* @__PURE__ */ m.jsx(Ze, { sx: { color: "text.primary" }, children: g.runningMessage })
      ] }) }),
      /* @__PURE__ */ m.jsxs(Ti, { children: [
        (K == null ? void 0 : K.status) === "COMPLETE" && (((zt = K.artifactUrls) == null ? void 0 : zt.pdf) || ((Rt = K.artifactUrls) == null ? void 0 : Rt.html)) && // #609 — brand primary is darkGrey (invisible as a text button on
        // dark); a contained button + inherit-colored Close stay legible
        // in both light and dark.
        /* @__PURE__ */ m.jsx(
          ht,
          {
            variant: "contained",
            onClick: () => ko(K.artifactUrls.pdf || K.artifactUrls.html),
            children: g.download
          }
        ),
        /* @__PURE__ */ m.jsx(ht, { color: "inherit", onClick: () => re(null), children: g.close })
      ] })
    ] }),
    /* @__PURE__ */ m.jsx(
      ju,
      {
        open: !!ge,
        autoHideDuration: 5e3,
        onClose: () => he(""),
        message: ge
      }
    )
  ] });
}
const Fd = {
  failed: "This run failed to render.",
  notReady: "Report is not ready yet.",
  error: "Failed to load report",
  openPdf: "Open PDF",
  openHtml: "Open HTML in new tab",
  preview: "Report preview"
};
function ep({ api: t, runId: a, height: r = 600, labels: s = {} }) {
  const n = { ...Fd, ...s }, [e, i] = H(null), [o, u] = H(!0), [l, c] = H(null);
  return ke(() => {
    if (!a) return;
    let d = !1;
    return u(!0), c(null), t.runs.getRun(a).then((h) => {
      if (d) return;
      const g = rn(h);
      if (g.status !== "COMPLETE" || !g.artifactUrls) {
        c(g.status === "FAILED" ? n.failed : n.notReady);
        return;
      }
      i(g.artifactUrls);
    }).catch((h) => {
      d || c(h.message || n.error);
    }).finally(() => {
      d || u(!1);
    }), () => {
      d = !0;
    };
  }, [t, a, n.error, n.failed, n.notReady]), a ? o ? /* @__PURE__ */ m.jsx(pe, { sx: { display: "flex", justifyContent: "center", p: 3 }, children: /* @__PURE__ */ m.jsx(ar, { "data-testid": "report-viewer-loading" }) }) : l ? /* @__PURE__ */ m.jsx(In, { severity: "error", children: l }) : e ? /* @__PURE__ */ m.jsxs(yn, { spacing: 1, "data-testid": "report-viewer", children: [
    /* @__PURE__ */ m.jsxs(yn, { direction: "row", spacing: 1, children: [
      e.pdf && /* @__PURE__ */ m.jsx(ht, { variant: "outlined", href: e.pdf, target: "_blank", rel: "noopener", children: n.openPdf }),
      e.html && /* @__PURE__ */ m.jsx(ht, { variant: "text", href: e.html, target: "_blank", rel: "noopener", children: n.openHtml })
    ] }),
    e.html && /* @__PURE__ */ m.jsx(
      pe,
      {
        component: "iframe",
        "data-testid": "report-viewer-frame",
        title: n.preview,
        src: e.html,
        sx: { width: "100%", height: r, border: 1, borderColor: "divider", borderRadius: 1, bgcolor: "#fff" }
      }
    )
  ] }) : null : null;
}
var qn = {};
function Ht(t, a, r) {
  return a in t ? Object.defineProperty(t, a, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : t[a] = r, t;
}
qn.d = (t, a) => {
  for (var r in a) qn.o(a, r) && !qn.o(t, r) && Object.defineProperty(t, r, { enumerable: !0, get: a[r] });
}, qn.o = (t, a) => Object.prototype.hasOwnProperty.call(t, a);
var Ao = ["E", "H", "C", "M", "B"], Gn = { PENDING: "PENDING", ENTERING_RING: "ENTERING_RING", IN_PROGRESS: "IN_PROGRESS", COMPLETED: "COMPLETED", SCRATCHED: "SCRATCHED" }, gn = { SCRATCHED: "Scratched", EXCUSED: "Excused", ELIMINATED: "Eliminated", NO_SHOW: "No Show", WITHDRAWN: "Withdrawn" }, ls = { BLOOD: "BLOOD", LAMENESS: "LAMENESS", MEETING_REQUESTED: "MEETING_REQUESTED" }, Jn = { POINTS: "POINTS", PERCENT_SENIOR: "PERCENT_SENIOR", PERCENT_YOUTH: "PERCENT_YOUTH" }, Vd = 0, _n = 10, ei = 0.5, dn = { RIDE_INTRO_DETAILED: "ride-intro-detailed", POST_RIDE_SCORE: "post-ride-score", END_OF_CLASS_RESULT: "end-of-class-result", MID_RIDE_SIMPLE: "mid-ride-simple", CLASS_SUMMARY: "class-summary", MID_CLASS_RESULT: "mid-class-result" }, sa = { DETAILED: "detailed", SIMPLE: "simple" }, vi, Xt;
Ht(Xt = {}, dn.RIDE_INTRO_DETAILED, ["classNumberName", "testName", "entryIdentity", "riderLocation", "horseBio", "ownerInfo", "judgesPositions"]), Ht(Xt, dn.POST_RIDE_SCORE, ["classNumberName", "testName", "judgesPositions", "entryIdentity", "scoreHero", "termReason", "currentRank", "divisionRank", "perJudgeBreakout", "qr"]), Ht(Xt, dn.END_OF_CLASS_RESULT, ["classNumberName", "judgesPositions", "rankedList", "resultLayout", "resultDwellSeconds", "sponsor", "qr"]), Ht(Xt, dn.MID_CLASS_RESULT, ["classNumberName", "judgesPositions", "rankedList", "resultLayout", "resultDwellSeconds", "sponsor", "qr"]), Ht(Xt, dn.MID_RIDE_SIMPLE, ["classNumberName", "testName", "entryIdentity", "qr"]), Ht(Xt, dn.CLASS_SUMMARY, (Ht(vi = {}, sa.DETAILED, ["judgesPositions", "classNumberName", "startList", "resultLayout", "resultDwellSeconds", "sponsor", "qr"]), Ht(vi, sa.SIMPLE, ["classNumberName", "testName", "judgesPositions", "classStart", "estimatedFinish", "totalRides", "ring", "sponsor", "qr"]), vi));
var zd = "Withdrawn / retired", Rr = { RULE: "rule", MANUAL: "manual", OTHER_DEDUCTION: "otherDeduction" }, Uo = ["technical", "artistic", "final"], pi = { SCRIBE_LIVE: "scribe-live", ADMIN_PAPER: "admin-paper", RECONSTRUCTED: "reconstructed" }, Bd = { CLASS_RIDE_MISMATCH: "CLASS_RIDE_MISMATCH" }, O = Object.freeze({ ALREADY_AUTHORITATIVE: "already_authoritative", ALREADY_EXCUSED: "already_excused", ALREADY_MAPPED: "already_mapped", ASSET_IN_USE_BY_SLIDESHOW: "asset_in_use_by_slideshow", ALREADY_NO_SCORE_RECORDED: "already_no_score_recorded", ALREADY_NO_SHOW: "already_no_show", ALREADY_RESOLVED: "already_resolved", ALREADY_WITHDRAWN: "already_withdrawn", APPLY_FAILED: "quarantine_apply_failed", ARCHIVE_ENTRY_NOT_APPLICABLE: "archive_entry_not_applicable", ARCHIVE_ENTRY_NOT_FOUND: "archive_entry_not_found", AMBIGUOUS_USEF_COMP_ID: "ambiguous_usef_comp_id", BATCH_TOO_LARGE: "batch_too_large", CLASS_NOT_FOUND: "class_not_found", COMPOSITE_JUDGE_COUNT_INVALID: "composite_judge_count_invalid", COMPOSITE_JUDGE_NOT_FOUND: "composite_judge_not_found", CONCURRENT_MODIFICATION: "concurrent_modification", CREATE_KEY_CONFLICT: "ride_create_key_conflict", DEF_CHANGED_SINCE_CONFIRM: "def_changed_since_confirm", DEFAULT_VIEW_REQUIRED: "default_view_required", DEFAULT_VIEW_UNDELETABLE: "default_view_undeletable", DUPLICATE_JUDGE: "duplicate_judge", DUPLICATE_SCORE_SHEET: "duplicate_score_sheet", DUPLICATE_SLUG: "duplicate_slug", ELIMINATION_CHANGE_NEEDS_SHEET_EDIT: "elimination_change_needs_sheet_edit", ENV_NOT_ALLOWED: "env_not_allowed", FORBIDDEN: "forbidden", HELD_SCORE_NOT_FOUND: "held_score_not_found", INSUFFICIENT_CONTRAST: "insufficient_contrast", INVALID_ACTION: "invalid_action", INVALID_ASPECT_RATIO: "invalid_aspect_ratio", INVALID_BODY: "invalid_body", INVALID_DEFAULT_MODE: "invalid_default_mode", INVALID_EVENT_MODE_MAP: "invalid_event_mode_map", INVALID_FIELD_SET: "invalid_field_set", INVALID_IMAGE_TYPE: "invalid_image_type", INVALID_JUDGE: "invalid_judge", INVALID_MANUAL_HOLD: "invalid_manual_hold", INVALID_MIRROR_TARGET: "invalid_mirror_target", INVALID_MODE_GROUP: "invalid_mode_group", INVALID_SCHEDULE_ENTRIES: "invalid_schedule_entries", INVALID_MODE_TYPE: "invalid_mode_type", INVALID_RIDE_PICK: "invalid_ride_pick", INVALID_SLIDESHOW: "invalid_slideshow", INVALID_USEF_ID: "invalid_usef_id", USEF_ID_HELD_BY_OTHER_JUDGE: "usef_id_held_by_other_judge", INVALID_MOVEMENT_NUMBER: "invalid_movement_number", INVALID_MOVEMENT_OVERRIDE: "invalid_movement_override", INVALID_PATH: "invalid_path", INVALID_PIN: "invalid_pin", INVALID_RIDE: "invalid_ride", INVALID_SHAPE: "invalid_shape", INVALID_SIGNATURE: "invalid_signature", INVALID_SLUG: "invalid_slug", INVALID_SPONSOR: "invalid_sponsor", INVALID_STATUS: "invalid_status", INVALID_STATUS_ENTRY: "invalid_status_entry", INVALID_TERM_REASON: "invalid_term_reason", INVALID_TIMEZONE: "invalid_timezone", INVALID_SHOW_LIVE_QR: "invalid_show_live_qr", INVALID_TRANSITION: "invalid_transition", INVALID_TYPE: "invalid_type", INVALID_VISIBLE_ON_REMOTE: "invalid_visible_on_remote", INVALID_WATERMARK_MODE: "invalid_watermark_mode", JUDGE_NOT_FOUND: "judge_not_found", JUDGE_NOT_ON_PANEL: "judge_not_on_panel", LIVE_GUARD: "live_guard", LOGO_TOO_LARGE: "logo_too_large", LOGO_TOO_SMALL: "logo_too_small", MARKS_CONFIRMED_FROZEN: "marks_confirmed_frozen", MARKS_NOT_CONFIRMED: "marks_not_confirmed", MIRROR_CYCLE: "mirror_cycle", MISSING_ACTION: "missing_action", MISSING_BASE_VERSION: "missing_base_version", MISSING_PARAMS: "missing_params", MISSING_QUERY_PARAM: "missing_query_param", MISSING_SHOW_ID: "missing_show_id", MISSING_SIGNATURE: "missing_signature", MISSING_TARGET: "missing_target", NO_CONFLICT: "no_conflict", NO_CONTENDER: "no_contender", NO_TABLET_MARKS: "no_tablet_marks", NO_TABLET_MARKS_DIFFERENCE: "no_tablet_marks_difference", NO_DRAFT: "no_draft", NO_SCRIBE_IDENTITY: "no_scribe_identity", NOT_ASSIGNED: "not_assigned", NOT_CHAMPIONSHIP_CLASS: "not_championship_class", NOT_ENTITLED: "not_entitled", NOT_EXCUSED: "not_excused", NOT_WITHDRAWN: "not_withdrawn", NOT_FINAL: "not_final", NOT_FOUND: "not_found", NOT_MANUAL: "not_manual", NOT_NO_SCORE_RECORDED: "not_no_score_recorded", NOT_NO_SHOW: "not_no_show", NOT_PANEL_SHEET: "not_panel_sheet", NOT_PRESIDING_JUDGE: "not_presiding_judge", NOT_RELEASABLE: "not_releasable", NOT_UNFILLED_SLOT: "not_unfilled_slot", PANEL_NOT_FULLY_SIGNED: "panel_not_fully_signed", PICK_TEST_UNAVAILABLE: "pick_test_unavailable", PLACED_CLASS_LOCKED: "placed_class_locked", PLACE_BY_RULES_CHANGED: "place_by_rules_changed", PLACE_BY_RULES_UNAVAILABLE: "place_by_rules_unavailable", UNBREAKABLE_TIE_BROKEN: "unbreakable_tie_broken", OTHER_JUDGE_NOT_FOUND: "other_judge_not_found", PRIMARY_JUDGE_NOT_FOUND: "primary_judge_not_found", PROD_REFUSED: "prod_refused", REASON_REQUIRED: "reason_required", SCHEDULE_NEEDS_VENUE_TIMEZONE: "schedule_needs_venue_timezone", SCHEDULE_ON_MIRROR: "schedule_on_mirror", MIRROR_VIEW_HAS_SCHEDULE: "mirror_view_has_schedule", SCHEDULE_SCREEN_IN_USE: "schedule_screen_in_use", REVIEW_ITEM_CHANGED: "review_item_changed", RIDE_ENDED: "ride_ended", RIDE_FORCE_FINALIZED: "ride_force_finalized", RIDE_HAS_MARKS: "ride_has_marks", RIDE_HAS_SHEETS: "ride_has_sheets", RIDE_HORS_DE_CONCOURS: "ride_hors_de_concours", RIDE_NO_SCORE_RECORDED: "ride_no_score_recorded", RIDE_SCRATCHED: "ride_scratched", RIDE_TERMINATED: "ride_terminated", ROUTE_NOT_FOUND: "route_not_found", RUNNING_REQUIRES_CLASS: "running_requires_class", SAME_CLASS: "same_class", SAME_RIDE: "same_ride", SELF_MAPPING: "self_mapping", SECTION_CLASS_LOCKED: "section_class_locked", SECTION_NOT_ALLOWED: "section_not_allowed", SHEET_CHANGED_SINCE_DIFF: "sheet_changed_since_diff", SHEET_COMPLETED: "sheet_completed", SHEET_EDITING: "sheet_editing", SHEET_INCOMPLETE: "sheet_incomplete", SHEET_NOT_EDITING: "sheet_not_editing", SHEET_NOT_FROZEN: "sheet_not_frozen", SHEET_NOT_ORPHAN: "sheet_not_orphan", SHOW_NOT_FOUND: "show_not_found", SHOW_SETUP_ITEM_DONE: "show_setup_item_done", SHOW_SETUP_ITEM_UNKNOWN: "show_setup_item_unknown", SLIDESHOW_IN_USE: "slideshow_in_use", SIBLING_SHEET_FROZEN_UNDER_TERMINATION: "sibling_sheet_frozen_under_termination", SNAPSHOT_CHANGED_SINCE_DIFF: "snapshot_changed_since_diff", SOURCE_IS_PLACEHOLDER: "source_is_placeholder", SOURCE_NOT_FOUND: "source_not_found", SOURCE_NOT_PLACED: "source_not_placed", STALE_WRITE: "stale_write", TARGET_ALREADY_SCORED: "target_already_scored", TARGET_IS_MANUAL: "target_is_manual", TARGET_NOT_FOUND: "target_not_found", TARGET_WRONG_SHOW: "target_wrong_show", TERM_REASON_CONFLICT: "term_reason_conflict", TEST_ALREADY_MATCHED: "test_already_matched", TEST_MISMATCH: "test_mismatch", TEXT_REQUIRED: "text_required", UNDO_ALREADY_DONE: "undo_already_done", UNDO_CHANGED_SINCE: "undo_changed_since", UNDO_LOCKED: "undo_locked", MISTAKE_REASON_REQUIRED: "mistake_reason_required", MISTAKE_SENT_TO_FVD: "mistake_sent_to_fvd", MISTAKE_SEAT_TAKEN: "mistake_seat_taken", MISTAKE_RIDE_ATTACHED: "mistake_ride_attached", RIDE_HAS_COUNTING_SHEETS: "ride_has_counting_sheets", RIDE_CREATED_BY_MISTAKE: "ride_created_by_mistake", RIDE_NOT_CREATED_BY_MISTAKE: "ride_not_created_by_mistake", ENTRY_REMOVED_NOT_ORPHANED: "entry_removed_not_orphaned", ENTRY_REMOVED_ALREADY: "entry_removed_already", ENTRY_REMOVED_NOT_MARKED: "entry_removed_not_marked", FVD_CHANGE_NOT_PENDING: "fvd_change_not_pending", FVD_POINTER_CHANGED: "fvd_pointer_changed", FVD_TARGET_MISSING: "fvd_target_missing", FVD_PUSH_NOT_DISMISSIBLE: "fvd_push_not_dismissible", FVD_PUSH_NOT_DISMISSED: "fvd_push_not_dismissed", SHEET_CREATED_BY_MISTAKE: "sheet_created_by_mistake", SHEET_NOT_CREATED_BY_MISTAKE: "sheet_not_created_by_mistake", TABLET_FILE_DRAFT_NO_BASE: "tablet_file_draft_no_base", TABLET_FILE_INVALID: "tablet_file_invalid", TABLET_FILE_NO_ORG: "tablet_file_no_org", TABLET_FILE_SHEET_UNRESOLVED: "tablet_file_sheet_unresolved", TABLET_FILE_UNKNOWN_KIND: "tablet_file_unknown_kind", TABLET_FILE_UNKNOWN_VERSION: "tablet_file_unknown_version", TABLET_FILE_WRONG_ORG: "tablet_file_wrong_org", TABLET_RIDE_NOT_APPLIED: "tablet_ride_not_applied", UNDO_NOT_SUPPORTED: "undo_not_supported", UNDO_UNCHECKED: "undo_unchecked", UNSUPPORTED_OP_TYPE: "unsupported_op_type", UNEXPECTED_ERROR: "unexpected_error", UNKNOWN_MODE: "unknown_mode", UNSUPPORTED_SUBJECT_TYPE: "unsupported_subject_type", VALIDATION_ERROR: "validation_error", VALIDATION_FAILED: "validation_failed", VENUE_HAS_SCREENS: "venue_has_screens", VENUE_HAS_SHOWS: "venue_has_shows", VIEW_NOT_FOUND: "view_not_found", WRONG_ORG: "wrong_org", YEAR_MISMATCH: "year_mismatch" });
new Set(Object.values(O));
function k(t, a, r) {
  return a in t ? Object.defineProperty(t, a, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : t[a] = r, t;
}
function hn(t) {
  return t == null || t === "" ? "another status" : String(t).toLowerCase().split(/[_\s]+/).filter(Boolean).map(function(a) {
    return a.charAt(0).toUpperCase() + a.slice(1);
  }).join(" ");
}
function Ir(t) {
  var a, r = [], s = !0, n = !1, e = void 0;
  try {
    for (var i, o = (Array.isArray(t) ? t : [])[Symbol.iterator](); !(s = (i = o.next()).done); s = !0) {
      var u = i.value, l = String(u).replace(/^\//, "").split(/[/.[\]]/)[0].replace(/([a-z0-9])([A-Z])/g, "$1 $2").replace(/[_-]+/g, " ").toLowerCase().replace(/\s+ids?$/, "").trim();
      l && !r.includes(l) && r.push(l);
    }
  } catch (c) {
    n = !0, e = c;
  } finally {
    try {
      s || o.return == null || o.return();
    } finally {
      if (n) throw e;
    }
  }
  return r.length <= 1 ? (a = r[0]) !== null && a !== void 0 ? a : "" : "".concat(r.slice(0, -1).join(", "), " and ").concat(r[r.length - 1]);
}
var x, fn = "Reload the page and try again.";
Object.freeze((k(x = {}, O.ALREADY_AUTHORITATIVE, { default: "This sheet is already the authoritative one for this seat. There is nothing to switch." }), k(x, O.ALREADY_EXCUSED, { default: "This ride is already marked Excused. There is nothing more to do here." }), k(x, O.ALREADY_MAPPED, { default: "This combined judge already has its two judges set. Edit the existing pairing instead of adding a new one." }), k(x, O.ALREADY_WITHDRAWN, { default: "This ride is already marked Withdrawn. There is nothing more to do here." }), k(x, O.ALREADY_NO_SCORE_RECORDED, { default: "This ride is already marked No score recorded. There is nothing more to do here." }), k(x, O.ALREADY_RESOLVED, { default: "This held item was already handled. Reload the review queue to see where it stands." }), k(x, O.APPLY_FAILED, { default: "The held entry was not applied because the score system still refuses it. It stays in the review queue. Read the reason shown with it, fix what it names, then try again." }), k(x, O.ARCHIVE_ENTRY_NOT_APPLICABLE, { default: "That archived copy holds no marks to apply (it records a finished decision or a sign or confirm request). Nothing was changed." }), k(x, O.ARCHIVE_ENTRY_NOT_FOUND, { default: "That archived copy is no longer on this sheet. Reload the review queue and try again." }), k(x, O.TABLET_FILE_INVALID, { default: "That is not a saved sheets file from a scribe tablet, or part of it is missing. Nothing was imported. Pick the file the tablet saved when Reset tablet asked for one." }), k(x, O.TABLET_FILE_NO_ORG, { default: "That saved sheets file does not say which organization the tablet was working in, so nothing was imported. Ask for the file again from an up to date tablet." }), k(x, O.TABLET_FILE_DRAFT_NO_BASE, { default: "This sheet was changed on the tablet but the file does not say which cloud version it started from, so importing it could overwrite newer scores. It is held here: compare it with the cloud sheet and choose." }), k(x, O.TABLET_FILE_SHEET_UNRESOLVED, { default: "This change belongs to a sheet the import could not place in the cloud, so it is held here instead of being applied to the wrong sheet. Resolve the held sheet first." }), k(x, O.TABLET_RIDE_NOT_APPLIED, { default: "This sheet belongs to a ride that was added by hand on the tablet and is still waiting in the Review Queue. Apply that ride first, then apply this sheet." }), k(x, O.TABLET_FILE_UNKNOWN_KIND, { default: "That file is not a saved sheets file from a scribe tablet. Nothing was imported. Pick the file the tablet saved when Reset tablet asked for one." }), k(x, O.TABLET_FILE_UNKNOWN_VERSION, { default: "That saved sheets file was made by a newer or older scribe app than this screen can read. Nothing was imported. Ask for the file again from an up to date tablet, or ask the office to update this screen." }), k(x, O.TABLET_FILE_WRONG_ORG, { default: "That saved sheets file belongs to a different organization than the one you are signed in to, so nothing was imported. Switch to the organization the tablet was working in, then import it again." }), k(x, O.UNSUPPORTED_OP_TYPE, { default: "This kind of held entry cannot be applied from here. Mark it reviewed, or discard it, and re-enter it by hand." }), k(x, O.MISSING_BASE_VERSION, { default: "This held edit has no record of which version of the sheet it was based on, so applying it could overwrite newer scores. Mark it reviewed, or discard it, and re-enter the change by hand on the current sheet." }), k(x, O.ALREADY_NO_SHOW, { default: "This ride is already marked No Show. There is nothing more to do here." }), k(x, O.AMBIGUOUS_USEF_COMP_ID, { default: "More than one show uses this USEF competition number. Add the show year to the scoreboard link to pick the right one." }), k(x, O.BATCH_TOO_LARGE, { default: function() {
  var t = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}).max;
  return "That is more than ".concat(t, " placings to save at once. Save them in smaller groups.");
} }), k(x, O.CLASS_NOT_FOUND, { default: "That class could not be found for this show. Check the link, or choose the class again from the class list." }), k(x, O.COMPOSITE_JUDGE_COUNT_INVALID, { default: "A combined judge needs a primary judge and 1 to 4 other judges, 2 to 5 judges in all. Add or remove judges, then save." }), k(x, O.COMPOSITE_JUDGE_NOT_FOUND, { default: "The combined judge you picked is not on this show's judge list. Reload the judge list and pick again." }), k(x, O.CONCURRENT_MODIFICATION, { default: "Someone else changed this scoresheet after you opened it. Reload the sheet to see their changes, then make yours again.", commit: "Someone else changed this scoresheet after you opened it. Reload the sheet to see their changes, then save your edit again.", restore: "Someone else changed this scoresheet after you opened it. Reload the audit trail to see their changes, then try the restore again.", stationReconcile: "This station was reconciled again after you last looked. Reload the review and try again." }), k(x, O.CREATE_KEY_CONFLICT, { default: "Another device already used this ride's internal key for a different rider. Nothing was overwritten; this device will retry with a fresh key." }), k(x, O.DEF_CHANGED_SINCE_CONFIRM, { default: "This test's scoring was corrected after this sheet was confirmed, so the errors and eliminations can't be changed here without moving the score the judge confirmed. Ask the show office to unlock and correct the sheet.", resolveStaleWrite: "This test's scoring was corrected after this sheet was confirmed, so applying the attempted value would move the score the judge confirmed. Choose Keep current value to clear this item. If the attempted value is the right one, ask the show office to unlock and correct the sheet." }), k(x, O.DEFAULT_VIEW_REQUIRED, { default: "Every show needs a default scoreboard view, and this is the only one. Make another view the default first, then change this one." }), k(x, O.DEFAULT_VIEW_UNDELETABLE, { default: "This is the show's default scoreboard view, so it cannot be deleted while other views exist. Make another view the default first, then delete this one." }), k(x, O.DUPLICATE_JUDGE, { default: "Each judge in a combined judge can only be added once. Remove the repeated judge." }), k(x, O.DUPLICATE_SCORE_SHEET, { default: "This judge already has a scoresheet for this ride. Open that sheet instead of starting a new one." }), k(x, O.DUPLICATE_SLUG, { default: function() {
  var t = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}).slug;
  return 'Another scoreboard view on this show already uses the web address "'.concat(t, '". Choose a different one.');
} }), k(x, O.ELIMINATION_CHANGE_NEEDS_SHEET_EDIT, { default: "Applying this value would add or remove an elimination on the sheet, which can't be done from the review queue. Keep the current value here, then make the change on the sheet itself." }), k(x, O.ENV_NOT_ALLOWED, { default: function() {
  var t = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}).allowed;
  return "Resetting the demo data only works on these servers: ".concat(t, ". This server is not one of them.");
} }), k(x, O.FORBIDDEN, { default: "You do not have permission to do that. Ask the show office if you need it.", clearMachine: "Only the show office can clear this tablet. Ask the show office to sign in on it, or to start the clear from Station Monitor.", superAdmin: "Only a Fox Village administrator can change this. Ask Fox Village support if it needs changing.", instance: "Your account cannot change this scoring station's setup. Ask Fox Village support if it needs changing.", showOfficeOnly: "Only the show office can make that status change. Ask the show office to make it for you.", otherOrg: "This show belongs to a different organization. Switch to that organization, or check that you picked the right show." }), k(x, O.HELD_SCORE_NOT_FOUND, { default: "The score was not moved: there is no score on this ride that this item can move. Nothing was changed. Open the ride from this row to check its scores.", noneRecorded: "The score was not moved: no score sheet is recorded as saved on this ride by a tablet that still had the old ride, so there is nothing this item can move. Nothing was changed. Open the ride from this row to check its scores, then choose Leave it where it is if none of them belongs on the other ride.", movedOff: "The score was not moved: the score sheet a tablet saved here for the old ride is no longer on this ride, so there is nothing left to move. Nothing was changed. Open the ride from this row to see what is on it now, then choose Leave it where it is.", alreadyAnswered: "The score was not moved: this item was already answered, by a Move score or a Leave it where it is, so there is no held score left for it to move. Nothing was changed. The list has been refreshed, so you can see where things stand now." }), k(x, O.INSUFFICIENT_CONTRAST, { default: function() {
  var t = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}).parts;
  return "The text color is too hard to read against the ".concat(t, ". Pick a darker or lighter text color, or change that color.");
} }), k(x, O.INVALID_ACTION, { default: "That choice is not available for this review item. Reload the review list and pick one of the options shown." }), k(x, O.INVALID_ASPECT_RATIO, { default: function() {
  var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, a = t.width, r = t.height;
  return "That picture is ".concat(a, " by ").concat(r, " pixels, which is the wrong shape. Crop it to the shape you picked and upload it again.");
}, square: function() {
  var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, a = t.width, r = t.height;
  return "That picture is ".concat(a, " by ").concat(r, " pixels, but a square image has to be as wide as it is tall. Crop it to a square and upload it again.");
}, wide: function() {
  var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, a = t.width, r = t.height;
  return "That picture is ".concat(a, " by ").concat(r, " pixels, but a wide image has to be about five times as wide as it is tall. Crop it to that shape and upload it again.");
} }), k(x, O.INVALID_BODY, { default: "Some of what was sent was missing or in the wrong form. ".concat(fn), listMissing: "The list of rides or classes to work on was missing or empty. ".concat(fn), tooMany: function() {
  var t = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}).max;
  return "That is more than ".concat(t, " items to load at once. Load fewer at a time.");
}, placingsMissing: "There were no placings to save. Set at least one placing, then save again.", otherDeduction: "A penalty recorded on this sheet is not one this test prints, or its amount does not match, or it was recorded more times than the sheet allows. Reload the sheet and record it again." }), k(x, O.INVALID_DEFAULT_MODE, { default: "A screen's default can only be a message, an image, a blank screen, or a group made only of those, all from that same view, because the default shows when nothing is selected and must never read ride or ring data. Pick one of those, or clear the default." }), k(x, O.INVALID_EVENT_MODE_MAP, { default: "The automatic switching list can only use ride start, ride scored or class complete, and each one must point at a screen from this same view. Fix the list and save again." }), k(x, O.INVALID_FIELD_SET, { default: function() {
  var t = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}).fieldSet;
  return '"'.concat(t, '" is not a class summary layout we know. Pick Detailed or Simple.');
} }), k(x, O.INVALID_MANUAL_HOLD, { default: "The Manual hold has to be a whole number of seconds from 1 to 86400, or left on 'until staff send it back to automatic'. Fix the number and save again." }), k(x, O.INVALID_MODE_GROUP, { default: "A group needs a list of screens from this same view, each with a whole-number dwell time from 3 to 120 seconds. A group cannot contain itself or another group. Fix the group's list and save again." }), k(x, O.INVALID_SCHEDULE_ENTRIES, { default: "A schedule entry needs a start date and time, a length from 1 minute to 24 hours, a screen from this same view to show (a message, an image, a blank screen, a group of those, or an Image Loop), and either nothing or another screen from this view to show afterwards. A view can hold up to 50 entries. Fix the entry and save again." }), k(x, O.SCHEDULE_NEEDS_VENUE_TIMEZONE, { default: "This show has no venue time zone, so a schedule has no way to know when its start time is. Set the venue time zone on the Venues page, then save the schedule again." }), k(x, O.SCHEDULE_ON_MIRROR, { default: function() {
  var t = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}).sourceName;
  return "This view mirrors ".concat(t ? '"'.concat(t, '"') : "another view", ", so it shows whatever that view shows and cannot have a schedule of its own. Put the schedule on ").concat(t ? '"'.concat(t, '"') : "the view it mirrors", ", or stop mirroring first, then save again.");
} }), k(x, O.MIRROR_VIEW_HAS_SCHEDULE, { default: function() {
  var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, a = t.sourceName, r = t.entryCount;
  return "This view has ".concat(r === 1 ? "a scheduled screen" : "".concat(r ?? "some", " scheduled screens"), ", and a view that mirrors ").concat(a ? '"'.concat(a, '"') : "another view", " shows only what that view shows, so they would never fire. Delete this view's schedule entries in the Schedule card on this page first, then set it to mirror again. Or put the schedule on ").concat(a ? '"'.concat(a, '"') : "the view it mirrors", ".");
} }), k(x, O.SCHEDULE_SCREEN_IN_USE, { default: function() {
  var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, a = t.screenName, r = t.startLocal;
  return "".concat(a ? '"'.concat(a, '"') : "A screen", " is on this view's schedule").concat(r ? " (the entry starting ".concat(r.replace("T", " "), ")") : "", ", so it cannot be removed or changed to a live screen. Edit or delete that schedule entry first, then save the screens again.");
} }), k(x, O.INVALID_SLIDESHOW, { default: "An Image Loop needs a name and a list of pictures, each with a whole-number display time from 3 to 120 seconds, and every picture must be one from your picture library. Fix the Image Loop and save again.", mode: "This screen points at an Image Loop that could not be found. Pick an Image Loop from your list and save again." }), k(x, O.SLIDESHOW_IN_USE, { default: "This Image Loop is still used by one or more scoreboards. Switch those scoreboards to something else first, then delete the Image Loop." }), k(x, O.ASSET_IN_USE_BY_SLIDESHOW, { default: "This picture is still used by one or more Image Loops. Remove it from those Image Loops first, then delete the picture." }), k(x, O.INVALID_IMAGE_TYPE, { default: "That file is not a picture we can use. Upload a PNG, GIF, or JPEG image.", pngOrJpegOnly: "This picture has to be a PNG or JPEG. Save it in one of those formats and upload it again.", damaged: function() {
  var t = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}).kind;
  return "That ".concat(t, " picture looks damaged and could not be read. Save it again and upload the new copy.");
} }), k(x, O.INVALID_USEF_ID, { default: function() {
  var t = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}).usefId;
  return '"'.concat(t ?? "", `" is not a USEF number. A USEF number is digits only, for example 90393. Check the number on the judge's USEF record and enter it again, or leave it empty to clear it.`);
} }), k(x, O.USEF_ID_HELD_BY_OTHER_JUDGE, { default: function() {
  var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, a = t.usefId, r = t.holderName;
  return "USEF number ".concat(a ?? "", " already belongs to ").concat(r || "another judge", `, and that name is not this judge's name. If it is the same person, choose "Yes, same person" to link them. If not, check the number on the judge's USEF record and enter it again.`);
} }), k(x, O.INVALID_JUDGE, { default: "One of the judges you picked is not on this show's judge list. Reload the page and pick the judges again." }), k(x, O.INVALID_MIRROR_TARGET, { default: function() {
  var t = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}).view;
  return 'The view to copy from ("'.concat(t, `") is not one of this show's scoreboard views. Pick a view from this show's list.`);
} }), k(x, O.INVALID_MODE_TYPE, { default: function() {
  var t = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}).modeType;
  return '"'.concat(t, '" is not a kind of scoreboard screen we know. Pick a screen type from the list.');
} }), k(x, O.INVALID_RIDE_PICK, { default: "That ride could not be picked because its class was missing. Reload the page and pick the ride again.", ride: "That ride could not be picked because it is not in that class any more. Reload the page and pick the ride again.", mirror: "This view mirrors another view, so a ride cannot be picked on it. Pick the ride on the view it mirrors." }), k(x, O.INVALID_MOVEMENT_NUMBER, { default: "The movement number has to be a whole number. Enter it again without letters or decimals." }), k(x, O.INVALID_MOVEMENT_OVERRIDE, { default: "That movement change would leave the test sheet in a form that cannot be scored, for example two movements with the same number. Check the section and movement number, then save again." }), k(x, O.INVALID_PATH, { default: function() {
  var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, a = t.fileLabel, r = t.path;
  return "The ".concat(a, ' path "').concat(r, '" is not valid. Fix the path and save again.');
}, wrongEnding: function() {
  var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, a = t.fileLabel, r = t.path, s = t.ending;
  return "The ".concat(a, ' path "').concat(r, '" has to end in "').concat(s, '". Fix the path and save again.');
}, parentFolder: function() {
  var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, a = t.fileLabel, r = t.path;
  return "The ".concat(a, ' path "').concat(r, '" cannot step up a folder with "..". Enter the full path to the file and save again.');
}, hiddenCharacter: function() {
  var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, a = t.fileLabel, r = t.path;
  return "The ".concat(a, ' path "').concat(r, '" contains a hidden character that is not allowed. Retype the path and save again.');
} }), k(x, O.INVALID_PIN, { default: "The scribe unlock PIN has to be 4 to 8 digits, numbers only. Enter a new PIN, or clear it to turn the PIN off." }), k(x, O.INVALID_RIDE, { default: "One of the rides in these placings is not in this class. Reload the class and set the placings again." }), k(x, O.INVALID_SHAPE, { default: "The logo shape has to be square or wide. Pick one and upload again." }), k(x, O.INVALID_SIGNATURE, { default: "The signature did not come through as a picture. Clear the signature box, have the judge sign again, and save." }), k(x, O.INVALID_SLUG, { default: "The web address for this view can only use lowercase letters, numbers, and hyphens. Change it and save again." }), k(x, O.INVALID_SPONSOR, { default: "The sponsor you picked is not in this show's sponsor list. Reload the page and pick the sponsor again." }), k(x, O.INVALID_STATUS, { default: "That is not a ride status the scoring system knows. ".concat(fn) }), k(x, O.INVALID_STATUS_ENTRY, { default: "Every ride in this update needs a ride and a known status. Reload the page and set the statuses again." }), k(x, O.INVALID_TERM_REASON, { default: "That is not a reason the scoring system knows for ending a ride. Reload the page and pick the reason again from the list." }), k(x, O.INVALID_TIMEZONE, { default: "The venue time zone was not recognized. Enter a whole-hour offset such as GMT-4, a zone name such as America/Chicago, or clear it." }), k(x, O.INVALID_TRANSITION, { default: "That screen change is not one we know. Pick Cut, Fade or Crossfade, with a time from 0.1 to 3 seconds, and save again." }), k(x, O.INVALID_TYPE, { default: "That is not a kind of alert the scoring system knows. Reload the page and pick the alert again." }), k(x, O.INVALID_SHOW_LIVE_QR, { default: "That is not a yes or no. Choose whether this screen shows the code for the Live page." }), k(x, O.INVALID_VISIBLE_ON_REMOTE, { default: function() {
  var t = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}).visibleOnRemote;
  return '"'.concat(t, '" is not a yes or no. Choose whether this mode shows a button on the remote.');
} }), k(x, O.INVALID_WATERMARK_MODE, { default: function() {
  var t = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}).watermarkMode;
  return '"'.concat(t, `" is not a watermark setting we know. Pick Inherit, Show or Hide for the screen's watermark.`);
} }), k(x, O.JUDGE_NOT_FOUND, { default: "That judge is not on this show's judge list any more. Reload the judge list and try again." }), k(x, O.JUDGE_NOT_ON_PANEL, { default: "That judge is not on this class's panel. Pick a judge from this class's panel." }), k(x, O.LIVE_GUARD, { default: "Resetting the demo data is switched off on a live scoring server. Use the demo server instead." }), k(x, O.LOGO_TOO_LARGE, { default: function() {
  var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, a = t.sizeMb, r = t.maxMb;
  return "That picture is ".concat(a, " MB, and the limit is ").concat(r, " MB. Make it smaller and upload it again.");
} }), k(x, O.LOGO_TOO_SMALL, { default: function() {
  var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, a = t.width, r = t.height, s = t.minPx;
  return "That picture is only ".concat(a, " by ").concat(r, " pixels, and its longest side needs to be at least ").concat(s, " pixels. Upload a bigger version.");
} }), k(x, O.MARKS_CONFIRMED_FROZEN, { default: "The marks on this sheet are confirmed and locked, so only the remarks can still be changed. To change a mark, ask the show office to unlock the sheet." }), k(x, O.MARKS_NOT_CONFIRMED, { default: "The class's marks have not been confirmed yet. Confirm the marks first, then the panel can sign." }), k(x, O.MIRROR_CYCLE, { default: "A scoreboard view cannot copy itself. Pick a different view to copy from.", loop: function() {
  var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, a = t.view, r = t.maxDepth;
  return 'Copying "'.concat(a, '" would make views copy each other in a loop, or chain more than ').concat(r, " views together. Pick a view that shows its own content.");
} }), k(x, O.MISSING_ACTION, { default: "No choice was picked for this review item. Pick an option and try again." }), k(x, O.MISSING_PARAMS, { default: "The page did not say which show to use. Reload the page, or pick the show again.", showAndRing: "The page did not say which show and ring to use. Pick the show and ring again." }), k(x, O.MISSING_QUERY_PARAM, { default: "The page did not say which show to use. Reload the page, or pick the show again.", showAndRing: "The page did not say which show and ring to use. Pick the show and ring again.", rideFilter: "Looking up rides needs a class, show, rider, horse, or review filter. Pick one and search again.", rideOrJudge: "Looking up scoresheets needs a ride or a judge. Pick one and try again." }), k(x, O.MISSING_SHOW_ID, { default: "The page did not say which show to use. Reload the page, or pick the show again." }), k(x, O.MISSING_SIGNATURE, { default: "The judge needs to sign this sheet before it can be completed. Have the judge sign, then complete the sheet again.", notOnFile: "That judge has no signature on file for this show. Ask the show office to add the judge's signature, then try again.", namedJudgeNotOnFile: function() {
  var t = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}).judgeName;
  return "".concat(t, " has no signature on file for this show. Ask the show office to add it, then try again.");
}, combinedJudgeUnresolved: "One of the two judges behind this combined judge could not be found. Ask the show office to check the combined judge setup, then try again." }), k(x, O.MISSING_TARGET, { default: "No ride was picked to move this sheet to. Pick the ride, then try again." }), k(x, O.NO_CONFLICT, { default: "This sheet has no stale-write conflict waiting to be resolved. Reload the review queue and try again." }), k(x, O.NO_CONTENDER, { default: "This seat has no other sheet to compare against. Reload the ride and try again." }), k(x, O.NO_TABLET_MARKS, { default: "That tablet's latest saved copy has no marks for this sheet. Pick another tablet, or ask the scribe to reopen the sheet so it uploads again." }), k(x, O.NO_TABLET_MARKS_DIFFERENCE, { default: "The tablet's marks match the server's, so there is nothing to apply. Pick another tablet, or close this window." }), k(x, O.NO_DRAFT, { default: "There are no unsaved edits on this sheet to work with. Reload the sheet to see what was saved." }), k(x, O.NO_SCRIBE_IDENTITY, { default: "This tablet is not signed in as a scribe. Sign in again, then try again." }), k(x, O.NOT_ASSIGNED, { default: "You aren't assigned to scribe this class. Ask the show office to assign you to this judge, then try again.", ride: "You aren't assigned to scribe this ride. Ask the show office to assign you, then try again." }), k(x, O.NOT_CHAMPIONSHIP_CLASS, { default: "This class is not a championship class, so its spots cannot be filled from other classes. Pick a championship class.", target: "The class you are filling is not a championship class. Pick a ride in a championship class." }), k(x, O.NOT_EXCUSED, { default: "This ride is not marked Excused, so there is nothing to undo. Reload the ride to see its current status." }), k(x, O.NOT_WITHDRAWN, { default: "This ride is not marked Withdrawn, so there is nothing to undo. Reload the ride to see its current status." }), k(x, O.NOT_FINAL, { default: function() {
  var t = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}).status;
  return "This ride cannot be placed yet because it is still ".concat(hn(t).toLowerCase(), ". Every judge's sheet for the ride has to be signed first.");
} }), k(x, O.NOT_FOUND, { default: "That record could not be found. ".concat(fn), ride: "This ride could not be found. It may have been removed, so reload the class list and open it again.", scoreSheet: "This scoresheet is no longer on the server. Go back to the class list and open the ride again.", class: "This class could not be found. It may have been removed, so reload the class list and pick it again.", station: "This tablet has not been named yet. Name it to carry on.", classNoRides: "This class has no rides yet, so there is nothing to place. Check the class's rides, then try again.", test: "The dressage test for this ride could not be found. Ask the show office to check which test the class uses.", catalogTest: "That test is not in the test catalog. Check the test name, or ask Fox Village support to add it.", riderInShow: "This rider has no rides in this show, so their scoresheet recipients cannot be set here. Reload the Riders list and try again.", person: "This person could not be found. They may have been removed, so reload the list and try again.", horse: "This horse could not be found. It may have been removed, so reload the list and try again.", show: "This show could not be found. Check that you are in the right organization, then pick the show again.", view: "This scoreboard view could not be found. It may have been deleted, so reload the list of views.", sponsor: "This sponsor could not be found. It may have been deleted, so reload the list of sponsors.", theme: "This theme could not be found. It may have been deleted, so reload the list of themes.", screen: "This screen could not be found. It may have been deleted, so reload the list of screens.", slideshow: "This Image Loop could not be found. It may have been deleted, so reload the list of Image Loops.", venue: "This venue could not be found. It may have been deleted, so reload the list of venues.", asset: "This picture could not be found. It may have been deleted, so reload the page and upload it again.", alert: "This alert could not be found. It may already have been cleared, so reload the ride to check.", reviewItem: "This review item could not be found. It may already have been handled, so reload the review list.", version: "That version is no longer in this sheet's audit trail. Reload the audit trail and pick a version from the current list.", judgePairing: "This combined judge pairing could not be found. It may have been removed, so reload the judge list.", movement: function() {
  var t = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}).movementNumber;
  return "Movement ".concat(t, " is not on this ride's test sheet. Reload the sheet and pick a movement that is listed.");
} }), k(x, O.NOT_MANUAL, { default: "Only a ride that was added by hand can be matched to a real ride this way. Pick a ride that was added by hand.", createdByMistake: "Only a ride that was added by hand can be marked as created by mistake. For a ride that came from FVD, open it and mark its sheet as created by mistake instead." }), k(x, O.NOT_NO_SCORE_RECORDED, { default: "This ride is not marked No score recorded, so there is nothing to undo. Reload the ride to see its current status." }), k(x, O.NOT_NO_SHOW, { default: "This ride is not marked No Show, so there is nothing to undo. Reload the ride to see its current status." }), k(x, O.NOT_PANEL_SHEET, { default: "This sheet is not scored by a judging panel, so it does not use panel signing. Use Complete & Sign instead." }), k(x, O.NOT_PRESIDING_JUDGE, { default: "Only the judge at C can do that. Ask the judge at C to do it.", markNoShow: "Only the judge at C can mark this ride No Show. Ask the judge at C to do it.", undoNoShow: "Only the judge at C can undo this ride's No Show. Ask the judge at C to do it.", eliminate: "Only the judge at C can eliminate a rider or record a withdrawal. Ask the judge at C to enter it, and it will end the ride for every judge.", markExcused: "Only the judge at C can mark this ride Excused. Ask the judge at C to do it.", undoExcused: "Only the judge at C can undo this ride's Excused mark. Ask the judge at C to do it.", markWithdrawn: "Only the judge at C can mark this ride Withdrawn. Ask the judge at C to do it.", undoWithdrawn: "Only the judge at C can undo this ride's Withdrawn mark. Ask the judge at C to do it." }), k(x, O.NOT_RELEASABLE, { default: function() {
  var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, a = t.blocking, r = t.total;
  return "".concat(a, " of ").concat(r, " rides in this class are not finished, because not every judge's sheet is signed yet. Finish judging those rides, then save the placings.");
} }), k(x, O.NOT_UNFILLED_SLOT, { default: "That ride is not an empty championship spot. Pick an empty spot to fill." }), k(x, O.PANEL_NOT_FULLY_SIGNED, { default: "Not every judge on the panel has signed yet. Have the remaining judges sign, then complete the sheet." }), k(x, O.PICK_TEST_UNAVAILABLE, { default: "This sheet's test could not be found, so the totals cannot be worked out for the version you picked. Nothing was changed. Check the ride's test, then pick again." }), k(x, O.MISTAKE_REASON_REQUIRED, { default: "Say why this was created by mistake (for example, the rider rode a different test). The reason is kept with the sheet. Type a short reason, then try again." }), k(x, O.MISTAKE_SENT_TO_FVD, { default: "This ride's score was already sent to FVD, so it can't be detached here. Nothing was changed. Fix it in FVD first, then use the Ride Editor." }), k(x, O.MISTAKE_SEAT_TAKEN, { default: "A newer sheet now counts for this judge on this ride, so this one can't be put back without replacing it. Nothing was changed. Mark the newer sheet as created by mistake first if it is the wrong one." }), k(x, O.MISTAKE_RIDE_ATTACHED, { default: "This ride was already matched to a real ride, so it can't be marked as created by mistake. Nothing was changed. Undo the match from the Done tab of the Review Queue if it was wrong." }), k(x, O.RIDE_HAS_COUNTING_SHEETS, { default: "This ride still has sheets that count. Nothing was changed. Mark each of its sheets as created by mistake first, or confirm that they should go with the ride.", entryRemoved: "This ride still has a sheet that counts, so it cannot be taken out of the class yet. Nothing was changed. If the sheet should never have existed, mark it as created by mistake in the Ride Editor first, then take the ride out." }), k(x, O.RIDE_CREATED_BY_MISTAKE, { default: "This ride is already marked as created by mistake. Reload the page to see where it stands." }), k(x, O.RIDE_NOT_CREATED_BY_MISTAKE, { default: "This ride is not marked as created by mistake, so there is nothing to put back. Reload the page to see where it stands." }), k(x, O.ENTRY_REMOVED_NOT_ORPHANED, { default: "FVD still has this entry, so it cannot be taken out of the class as removed in FVD. Nothing was changed. If this ride was added by hand by mistake, use Created by mistake instead." }), k(x, O.ENTRY_REMOVED_ALREADY, { default: "This ride is already taken out of the class as removed in FVD. Reload the page to see where it stands." }), k(x, O.ENTRY_REMOVED_NOT_MARKED, { default: "This ride is not marked Entry removed in FVD, so there is nothing to put back. Reload the page to see where it stands." }), k(x, O.FVD_PUSH_NOT_DISMISSIBLE, { default: "This ride's score is not waiting on an FVD entry that does not exist, so there is nothing to stop sending. Nothing was changed. Reload the page to see where it stands." }), k(x, O.FVD_CHANGE_NOT_PENDING, { default: "FVD is not asking for a different rider or horse on this ride any more. The sync already moved it, or FVD changed it back. Nothing was changed. Re-run the sync to see where it stands.", rider: "FVD is not asking for a different rider on this ride any more. The sync already moved it, or FVD changed it back. Nothing was changed. Re-run the sync to see where it stands.", horse: "FVD is not asking for a different horse on this ride any more. The sync already moved it, or FVD changed it back. Nothing was changed. Re-run the sync to see where it stands." }), k(x, O.FVD_POINTER_CHANGED, { default: "Someone changed this ride's rider or horse after the sync alert was made, so it was left as it is. Re-run the sync, then use FVD's choice again if it still shows.", rider: "Someone changed this ride's rider after the sync alert was made, so it was left as it is. Re-run the sync, then use FVD's rider again if it still shows.", horse: "Someone changed this ride's horse after the sync alert was made, so it was left as it is. Re-run the sync, then use FVD's horse again if it still shows." }), k(x, O.FVD_TARGET_MISSING, { default: "The rider or horse FVD names for this ride has not reached Fox Village yet, so nothing was changed. Re-run the sync, then try again.", rider: "The rider FVD names for this ride has not reached Fox Village yet, so nothing was changed. Re-run the sync, then try again.", horse: "The horse FVD names for this ride has not reached Fox Village yet, so nothing was changed. Re-run the sync, then try again." }), k(x, O.FVD_PUSH_NOT_DISMISSED, { default: "This ride's score is not marked as not sent to FVD on purpose, so there is nothing to put back. Reload the page to see where it stands." }), k(x, O.SHEET_CREATED_BY_MISTAKE, { default: "This sheet is already marked as created by mistake. Reload the page to see where it stands.", switch: "This sheet was marked as created by mistake, so it can't be made the counting sheet. Nothing was changed. Put it back from the ride's Created by mistake list first if you do need it." }), k(x, O.SHEET_NOT_CREATED_BY_MISTAKE, { default: "This sheet is not marked as created by mistake, so there is nothing to put back. Reload the page to see where it stands." }), k(x, O.UNDO_LOCKED, { default: "This can no longer be undone here, because the class is final or the score has already been sent out. To change it now, use the Ride Editor." }), k(x, O.UNDO_NOT_SUPPORTED, { default: "This one can't be undone from the Review Queue. To change it, use the Ride Editor." }), k(x, O.UNDO_UNCHECKED, { default: "Could not check whether this can still be undone, so it is not offered right now. Nothing was changed. Try again in a moment." }), k(x, O.UNDO_ALREADY_DONE, { default: "This has already been undone. Refresh the Done tab to see where it stands." }), k(x, O.UNDO_CHANGED_SINCE, { default: "This score was changed again after that choice was made, so undoing it here could lose the newer change. Nothing was changed. Use the Ride Editor to fix it." }), k(x, O.PLACED_CLASS_LOCKED, { default: "This class's placings are already set and locked. Ask someone with permission to override placed classes to change them." }), k(x, O.PLACE_BY_RULES_CHANGED, { default: "The scores changed after you looked at these placings, so nothing was placed. Look at the new placings and confirm again." }), k(x, O.PLACE_BY_RULES_UNAVAILABLE, { default: "This class cannot be placed by the rules right now, so nothing was placed. Open Placings for the class to see why." }), k(x, O.UNBREAKABLE_TIE_BROKEN, { default: "Some of these places split a tie that the rules say must stay tied (DR123.3). Nothing was placed. Place the tied rides as tied, or keep your places and say why." }), k(x, O.OTHER_JUDGE_NOT_FOUND, { default: "One of the other judges you picked is not on this show's judge list. Reload the judge list and pick again." }), k(x, O.PRIMARY_JUDGE_NOT_FOUND, { default: "The first judge you picked is not on this show's judge list. Reload the judge list and pick again." }), k(x, O.PROD_REFUSED, { default: "Resetting the demo data is never allowed on the live production server. Use the demo server instead." }), k(x, O.REASON_REQUIRED, { default: "Enter a reason before saving. The reason is kept in the sheet's history.", unlock: "Enter a reason for unlocking this sheet. The reason is kept in the sheet's history.", commit: "Enter a reason for this edit before saving it. The reason is kept in the sheet's history.", restore: "Enter a reason for restoring this version. The reason is kept in the sheet's history.", unfinalize: "Enter a reason for reopening this ride. The reason is kept in each sheet's history.", keepTies: "Say why you are keeping places that split a tie. The reason is kept with the class's placings.", noScore: "Enter a reason this ride has no score (for example, the sheet was keyed against the wrong ride). The reason is kept in the ride's history." }), k(x, O.REVIEW_ITEM_CHANGED, { default: "This item changed while you were looking at it, so nothing was applied. Reload the review list and look at it again." }), k(x, O.RIDE_HAS_MARKS, { default: "This ride already has marks on its sheet, so it can't be marked No score recorded. Score or correct the sheet instead, or mark the sheet created by mistake if it should never have existed.", noShow: "This ride already has marks, so it can't be marked No Show. No Show is only for a rider who never started. The judge at C can end the ride as Withdrawn or Excused instead." }), k(x, O.RIDE_HAS_SHEETS, { default: "This ride already has a score sheet, which was built for its current test, so its test can't be changed here. Ask the show office to move the sheet to the right ride first." }), k(x, O.RIDE_HORS_DE_CONCOURS, { default: "This ride is hors de concours, so it cannot take a placing. Leave it out of the placings.", batch: function() {
  var t = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}).count;
  return "".concat(t, " of the rides in these placings are hors de concours and cannot take a placing. Leave them out and save again.");
} }), k(x, O.RIDE_NO_SCORE_RECORDED, { default: "This ride has no score recorded, so it cannot be placed. Leave it out of the placings.", batch: function() {
  var t = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}).count;
  return "".concat(t, " of the rides in these placings have no score recorded and cannot be placed. Leave them out and save again.");
} }), k(x, O.RIDE_SCRATCHED, { default: "This ride has been scratched, so it can't be scored. Pick another ride from the class list." }), k(x, O.RIDE_ENDED, { default: function() {
  var t = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}).termReason;
  return t === "ELIMINATED" ? "This ride was marked Eliminated in FVD, so it can't be scored. If that was a mistake, clear the elimination in FVD, then score the ride." : "This ride was marked ".concat(t ? hn(t) : "No Show, Withdrawn or Excused", ", so it can't be scored. If that was a mistake, undo it first, then score the ride.");
} }), k(x, O.RIDE_TERMINATED, { default: function() {
  var t = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}).termReason;
  return "This ride ended as ".concat(hn(t), ", so it cannot be placed. Leave it out of the placings.");
}, batch: function() {
  var t = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}).count;
  return "".concat(t, " of the rides in these placings ended early and cannot be placed. Leave them out and save again.");
} }), k(x, O.ROUTE_NOT_FOUND, { default: "This app asked the scoring server for something it doesn't have. Reload the app, and if it keeps happening tell the show office." }), k(x, O.RUNNING_REQUIRES_CLASS, { default: "To mark the ring as running, pick the class that is in the ring. Choose a class, then try again." }), k(x, O.SAME_CLASS, { default: "The ride to fill from has to come from a different class that qualifies for this championship. Pick a ride from a qualifying class." }), k(x, O.SAME_RIDE, { default: "The ride you picked is the same ride this sheet is already on. Pick a different ride." }), k(x, O.SELF_MAPPING, { default: "A combined judge cannot include itself. Pick the real judges instead." }), k(x, O.SHEET_CHANGED_SINCE_DIFF, { default: "This sheet was changed after you opened the comparison. Close it and open it again to see the current marks." }), k(x, O.SNAPSHOT_CHANGED_SINCE_DIFF, { default: "That tablet uploaded a newer copy after you opened the comparison. Close it and open it again to see the newest marks." }), k(x, O.SHEET_COMPLETED, { default: "This sheet has already been signed and is locked, so changes can't be saved to it. Ask the show office to unlock it if something needs fixing." }), k(x, O.SHEET_EDITING, { default: "This sheet has an edit in progress. Commit or discard that edit first, then restore the version.", unfinalize: "A sheet on this ride has an edit in progress. Commit or discard that edit first, then reopen the ride." }), k(x, O.SHEET_INCOMPLETE, { default: "This sheet still has a blank movement or collective mark. Fill in every mark, then try again.", confirm: "This sheet cannot be confirmed yet because a movement or collective mark is blank. Fill in every mark, then confirm again.", complete: "This sheet cannot be completed yet because a movement or collective mark is blank. Fill in every mark, then complete it again.", commit: "This edit cannot be saved because a movement or collective mark is blank. Fill in every mark, then save again." }), k(x, O.RIDE_FORCE_FINALIZED, { default: "This ride was finished by the show office, not by its sheets, so it cannot be reopened. Ask the show office to correct it.", unfinalize: "This ride was finished by the show office, not by its sheets, so it cannot be reopened from here. Ask the show office to correct it." }), k(x, O.SHEET_NOT_EDITING, { default: "This sheet is not unlocked for editing. Unlock it first, then make the change.", commit: "This edit was already committed or discarded, most likely by someone else on staff or in another window, so there is nothing left to commit. Reload the sheet to see how it stands now.", discard: "This edit was already committed or discarded, most likely by someone else on staff or in another window, so there is nothing left to discard. Reload the sheet to see how it stands now." }), k(x, O.SHEET_NOT_FROZEN, { default: "This sheet is not locked, so there is nothing to unlock. Make your changes directly.", unfinalize: "Nothing on this ride is final or locked, so there is nothing to reopen. Refresh the ride to see its current state." }), k(x, O.SHEET_NOT_ORPHAN, { default: "This sheet is no longer waiting on a missing ride, so it cannot be attached from here. Refresh the Review Queue to see its current state." }), k(x, O.SHOW_NOT_FOUND, { default: "This show could not be found. Check the show link, or pick the show again from the list." }), k(x, O.SHOW_SETUP_ITEM_DONE, { default: "Nothing is wrong with this setup item, so there is nothing to confirm by hand. Reload the setup checklist to see its current state." }), k(x, O.SHOW_SETUP_ITEM_UNKNOWN, { default: "That is not a setup checklist item. Reload the setup checklist and pick the item again." }), k(x, O.SECTION_CLASS_LOCKED, { default: "This class has already been confirmed and signed, so riders can no longer be moved between sections or reordered. Ask the show office to reopen the class first." }), k(x, O.SECTION_NOT_ALLOWED, { default: "Sections can only be used in Dressage Seat Equitation and Dressage Seat Medal classes. This ride is in a different kind of class." }), k(x, O.SIBLING_SHEET_FROZEN_UNDER_TERMINATION, { default: "Another judge already confirmed or signed their sheet after this elimination ended the ride, so removing the elimination would leave that sheet scored as eliminated. Ask the show office to reopen that judge's sheet first (Reopen on the ride), then remove the elimination." }), k(x, O.SOURCE_IS_PLACEHOLDER, { default: "The ride you are filling from is itself an empty championship spot. Pick a real ride from a qualifying class." }), k(x, O.SOURCE_NOT_FOUND, { default: "The ride you are filling from could not be found. Reload the class and pick it again." }), k(x, O.SOURCE_NOT_PLACED, { default: "The ride you are filling from has not been placed in its class yet. Place that class first, then fill the championship." }), k(x, O.STALE_WRITE, { default: "Someone else saved a change to this scoresheet after you loaded it. Reload the sheet to see their change, then make yours again." }), k(x, O.TARGET_ALREADY_SCORED, { default: "The ride you picked already has a sheet from the same judge. Pick a different ride, or ask the show office to sort out the extra sheet." }), k(x, O.TARGET_IS_MANUAL, { default: "The ride you picked was also added by hand. Pick a ride that came from the show's entries." }), k(x, O.TARGET_NOT_FOUND, { default: "The ride you picked could not be found. Reload the class and pick it again." }), k(x, O.TARGET_WRONG_SHOW, { default: "The ride you picked is in a different show than this sheet. Pick a ride in the same show." }), k(x, O.TERM_REASON_CONFLICT, { default: function() {
  var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, a = t.existing, r = t.incoming;
  return r ? "This ride is already marked ".concat(hn(a), ", so it can't also be marked ").concat(hn(r), ". Ask the show office to clear the earlier status first.") : "This ride is already marked ".concat(hn(a), ". Ask the show office to clear that status first.");
} }), k(x, O.TEST_ALREADY_MATCHED, { default: "This already uses a real test from the catalog, so there is nothing to assign. Only a class or ride whose test FVD could not match can be given a test by hand." }), k(x, O.TEST_MISMATCH, { default: "This sheet was scored on a different test than the ride you picked. Pick a ride in a class that uses the same test.", attach: "This sheet was scored on a different test than the ride you picked, so it cannot be attached. Pick a ride in a class that uses the same test.", move: "This sheet was scored on a different test than the ride you picked, so it cannot be moved there. Pick a ride in a class that uses the same test." }), k(x, O.TEXT_REQUIRED, { default: "The note is empty. Type the note, then save." }), k(x, O.UNEXPECTED_ERROR, { default: "The scoring server couldn't accept that request. Try again, and if it keeps happening tell the show office.", server: "The scoring server hit a problem. Try again in a moment, and if it keeps happening tell the show office." }), k(x, O.UNKNOWN_MODE, { default: function() {
  var t = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}).mode;
  return 'That screen ("'.concat(t, `") is not one of this view's screens. Reload the view and pick one of its screens.`);
} }), k(x, O.UNSUPPORTED_SUBJECT_TYPE, { default: "This kind of review item is not handled from the review list. Open the ride itself and resolve it there." }), k(x, O.VALIDATION_ERROR, { default: "Some of what was entered is missing or not in the right form. Check what you entered and try again.", fields: function() {
  var t = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}).fields;
  return Ir(t) ? "Some of what was sent wasn't in a form the server accepts. Check the ".concat(Ir(t), " and try again.") : "Some of what was sent wasn't in a form the server accepts. ".concat(fn);
}, sheetFields: function() {
  var t = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}).fields;
  return Ir(t) ? "Some of what was entered on this sheet wasn't in a form the server accepts. Check the ".concat(Ir(t), " and try again.") : "Some of what was entered on this sheet wasn't in a form the server accepts. ".concat(fn);
}, recipientEmail: "One of those is not an email address. Fix it or remove it from the list, then save again.", recipientCount: "That is too many recipients for one rider. Remove some addresses from the list, then save again.", stationName: "Give this tablet a name before carrying on. Type one in the box and press Save.", clearMachine: "This clear cannot go ahead. A tablet that still holds scores that have not been sent can only be cleared after a copy of them has been saved. Reload the tablet and try again.", catalogTest: "The updated test does not fit the rules every test sheet has to follow. Check the listed problems, then save again.", judgePairing: "A combined judge needs the combined judge, a primary judge and at least one other judge. Pick them, then save.", seat: "The page did not say which show and scribe seat to use. Reload the page and try again.", held: "The failed change was missing details it needs to be held for review. Reload the page and try again.", placing: "A placing has to be a whole number of 0 or more, or left blank. Fix the placing and save again.", ringStatus: "The ring update was missing the show, the ring, or the ring status. Pick all three and try again.", viewFields: "A scoreboard view needs a show, a name, and a web address. Fill them in, then save.", sponsorFields: "A sponsor needs a name, a display name, or a logo. Add at least one, then save.", themeName: "A theme needs a name. Enter one, then save.", venueName: "A venue needs a name. Enter one, then save.", screenLabel: "A screen needs a label. Enter one, then save.", screenAspectRatio: "The screen shape has to be 2 to 1, 16 to 9, or 4 to 3. Pick one of those, then save.", screenTokenLocked: "A screen's public link cannot be changed. To get a new link, delete the screen and add a new one.", showVenueId: "That venue could not be found. Pick a venue from the list, then save.", viewScreenNoVenue: "This show has no venue yet, so it has no screens to put a view on. Set the show's venue first, then pick a screen.", viewScreen: "That screen is not at this show's venue. Pick a screen from the list for this venue, then save.", image: "No picture was attached. Choose a picture, then upload again." }), k(x, O.VALIDATION_FAILED, { default: "Pick at least one scribe account to assign in the demo data. Then run the reset again." }), k(x, O.VENUE_HAS_SCREENS, { default: "This venue still has screens. Delete its screens first, then delete the venue." }), k(x, O.VENUE_HAS_SHOWS, { default: "This venue is still linked to one or more shows. Unlink those shows from it first, then delete the venue." }), k(x, O.VIEW_NOT_FOUND, { default: "This scoreboard view could not be found. Check the scoreboard link, or ask the show office for the right one." }), k(x, O.WRONG_ORG, { default: "Resetting the demo data only works while you are in the demo organization. Switch to it, then try again." }), k(x, O.YEAR_MISMATCH, { default: "That show is not from the year given in the scoreboard link. Check the year in the link." }), k(x, O.NOT_ENTITLED, { default: "Your organization does not have the scoring app turned on. Ask Fox Village support to turn it on." }), x));
function gi(t, a, r) {
  return a in t ? Object.defineProperty(t, a, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : t[a] = r, t;
}
function No(t) {
  var a = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : ei;
  if (typeof t != "number" || !Number.isFinite(t)) return null;
  var r = Math.round(t / a) * a, s = Math.round(1e3 * r) / 1e3;
  return s < 0 ? 0 : s > _n ? _n : s;
}
function Do(t) {
  var a = (arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}).suppressShorthand, r = a !== void 0 && a;
  if (t == null) return null;
  var s = String(t).trim();
  if (s === "") return null;
  var n = Number(s);
  return Number.isFinite(n) ? /\./.test(s) || n >= 0 && n <= _n ? n : !r && n > _n && n <= 100 ? n / 10 : n : null;
}
function Gd(t) {
  var a = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : ei, r = Do(t);
  return r === null ? null : No(r, a);
}
var _r;
gi(_r = {}, Jn.POINTS, [{ points: 2 }, { points: 4 }, { eliminate: !0 }]), gi(_r, Jn.PERCENT_SENIOR, [{ percent: 2 }, { eliminate: !0 }]), gi(_r, Jn.PERCENT_YOUTH, [{ percent: 0.5 }, { percent: 1 }, { eliminate: !0 }]);
function vt(t, a, r) {
  return a in t ? Object.defineProperty(t, a, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : t[a] = r, t;
}
var dt, pt = { PERCENTAGE: "PERCENTAGE", COLLECTIVE_MARKS: "COLLECTIVE_MARKS", YOUNG_HORSE_AVERAGE: "YOUNG_HORSE_AVERAGE", YOUNG_HORSE_SUBMISSION: "YOUNG_HORSE_SUBMISSION", FEI_CHILDREN_TECHNICAL: "FEI_CHILDREN_TECHNICAL", FEI_CHILDREN_MEDIAN: "FEI_CHILDREN_MEDIAN", FREESTYLE_ARTISTIC: "FREESTYLE_ARTISTIC", FREESTYLE_HARMONY: "FREESTYLE_HARMONY", FREESTYLE_CHOREOGRAPHY: "FREESTYLE_CHOREOGRAPHY", MOVEMENT_TOTALS: "MOVEMENT_TOTALS", UNRESOLVED: "UNRESOLVED", JUDGE_ENTERED: "JUDGE_ENTERED", RIDE_OFF_REQUIRED: "RIDE_OFF_REQUIRED", DSHB_JUDGE_ENTERED: "DSHB_JUDGE_ENTERED", DSHB_UNRESOLVED: "DSHB_UNRESOLVED" };
vt(dt = {}, pt.PERCENTAGE, "DR123.3"), vt(dt, pt.COLLECTIVE_MARKS, "DR123.3"), vt(dt, pt.YOUNG_HORSE_AVERAGE, "DR123.3 (Young Horse exception)"), vt(dt, pt.YOUNG_HORSE_SUBMISSION, "DR123.3 (Young Horse exception)"), vt(dt, pt.FEI_CHILDREN_TECHNICAL, "DR123.3 (FEI Children exception)"), vt(dt, pt.FEI_CHILDREN_MEDIAN, "DR123.3 (FEI Children exception)"), vt(dt, pt.FREESTYLE_ARTISTIC, "DR129.5"), vt(dt, pt.FREESTYLE_HARMONY, "DR129.5"), vt(dt, pt.FREESTYLE_CHOREOGRAPHY, "DR129.5"), vt(dt, pt.MOVEMENT_TOTALS, "DR211.4"), vt(dt, pt.UNRESOLVED, "DR123.3"), vt(dt, pt.JUDGE_ENTERED, "DR133.1.k / DR133.2.g.4"), vt(dt, pt.RIDE_OFF_REQUIRED, "DR133.2.g.5"), vt(dt, pt.DSHB_JUDGE_ENTERED, "DR210.5 / DR204.2.c"), vt(dt, pt.DSHB_UNRESOLVED, "DR211.4");
var Ut = { PENDING: Gn.PENDING, ENTERING_RING: Gn.ENTERING_RING, IN_PROGRESS: Gn.IN_PROGRESS, CONFIRMED: "CONFIRMED", COMPLETED: Gn.COMPLETED, FINAL: "FINAL", SCRATCHED: Gn.SCRATCHED, IN_REVIEW: "IN_REVIEW", NEEDS_SIGNING: "NEEDS_SIGNING" }, Hd = [zd, "Withdrawal", "Withdrawn", "Withdraw", "Withdrew", "Rider Withdrew", "Retired", "Rider Retired"];
new Set(Hd.map($d));
function $d(t) {
  return typeof t == "string" ? t.trim().toLowerCase().replace(/[^a-z0-9]/g, "") : "";
}
var xe, aa;
(function(t) {
  t.assertEqual = (a) => {
  }, t.assertIs = function(a) {
  }, t.assertNever = function(a) {
    throw new Error();
  }, t.arrayToEnum = (a) => {
    const r = {};
    for (const s of a) r[s] = s;
    return r;
  }, t.getValidEnumValues = (a) => {
    const r = t.objectKeys(a).filter((n) => typeof a[a[n]] != "number"), s = {};
    for (const n of r) s[n] = a[n];
    return t.objectValues(s);
  }, t.objectValues = (a) => t.objectKeys(a).map(function(r) {
    return a[r];
  }), t.objectKeys = typeof Object.keys == "function" ? (a) => Object.keys(a) : (a) => {
    const r = [];
    for (const s in a) Object.prototype.hasOwnProperty.call(a, s) && r.push(s);
    return r;
  }, t.find = (a, r) => {
    for (const s of a) if (r(s)) return s;
  }, t.isInteger = typeof Number.isInteger == "function" ? (a) => Number.isInteger(a) : (a) => typeof a == "number" && Number.isFinite(a) && Math.floor(a) === a, t.joinValues = function(a, r = " | ") {
    return a.map((s) => typeof s == "string" ? `'${s}'` : s).join(r);
  }, t.jsonStringifyReplacer = (a, r) => typeof r == "bigint" ? r.toString() : r;
})(xe || (xe = {})), function(t) {
  t.mergeShapes = (a, r) => ({ ...a, ...r });
}(aa || (aa = {}));
const J = xe.arrayToEnum(["string", "nan", "number", "integer", "float", "boolean", "date", "bigint", "symbol", "function", "undefined", "null", "array", "object", "unknown", "promise", "void", "never", "map", "set"]), Wt = (t) => {
  switch (typeof t) {
    case "undefined":
      return J.undefined;
    case "string":
      return J.string;
    case "number":
      return Number.isNaN(t) ? J.nan : J.number;
    case "boolean":
      return J.boolean;
    case "function":
      return J.function;
    case "bigint":
      return J.bigint;
    case "symbol":
      return J.symbol;
    case "object":
      return Array.isArray(t) ? J.array : t === null ? J.null : t.then && typeof t.then == "function" && t.catch && typeof t.catch == "function" ? J.promise : typeof Map < "u" && t instanceof Map ? J.map : typeof Set < "u" && t instanceof Set ? J.set : typeof Date < "u" && t instanceof Date ? J.date : J.object;
    default:
      return J.unknown;
  }
}, M = xe.arrayToEnum(["invalid_type", "invalid_literal", "custom", "invalid_union", "invalid_union_discriminator", "invalid_enum_value", "unrecognized_keys", "invalid_arguments", "invalid_return_type", "invalid_date", "invalid_string", "too_small", "too_big", "invalid_intersection_types", "not_multiple_of", "not_finite"]);
class Ft extends Error {
  get errors() {
    return this.issues;
  }
  constructor(a) {
    super(), this.issues = [], this.addIssue = (s) => {
      this.issues = [...this.issues, s];
    }, this.addIssues = (s = []) => {
      this.issues = [...this.issues, ...s];
    };
    const r = new.target.prototype;
    Object.setPrototypeOf ? Object.setPrototypeOf(this, r) : this.__proto__ = r, this.name = "ZodError", this.issues = a;
  }
  format(a) {
    const r = a || function(e) {
      return e.message;
    }, s = { _errors: [] }, n = (e) => {
      for (const i of e.issues) if (i.code === "invalid_union") i.unionErrors.map(n);
      else if (i.code === "invalid_return_type") n(i.returnTypeError);
      else if (i.code === "invalid_arguments") n(i.argumentsError);
      else if (i.path.length === 0) s._errors.push(r(i));
      else {
        let o = s, u = 0;
        for (; u < i.path.length; ) {
          const l = i.path[u];
          u === i.path.length - 1 ? (o[l] = o[l] || { _errors: [] }, o[l]._errors.push(r(i))) : o[l] = o[l] || { _errors: [] }, o = o[l], u++;
        }
      }
    };
    return n(this), s;
  }
  static assert(a) {
    if (!(a instanceof Ft)) throw new Error(`Not a ZodError: ${a}`);
  }
  toString() {
    return this.message;
  }
  get message() {
    return JSON.stringify(this.issues, xe.jsonStringifyReplacer, 2);
  }
  get isEmpty() {
    return this.issues.length === 0;
  }
  flatten(a = (r) => r.message) {
    const r = {}, s = [];
    for (const n of this.issues) if (n.path.length > 0) {
      const e = n.path[0];
      r[e] = r[e] || [], r[e].push(a(n));
    } else s.push(a(n));
    return { formErrors: s, fieldErrors: r };
  }
  get formErrors() {
    return this.flatten();
  }
}
Ft.create = (t) => new Ft(t);
const Bi = (t, a) => {
  let r;
  switch (t.code) {
    case M.invalid_type:
      r = t.received === J.undefined ? "Required" : `Expected ${t.expected}, received ${t.received}`;
      break;
    case M.invalid_literal:
      r = `Invalid literal value, expected ${JSON.stringify(t.expected, xe.jsonStringifyReplacer)}`;
      break;
    case M.unrecognized_keys:
      r = `Unrecognized key(s) in object: ${xe.joinValues(t.keys, ", ")}`;
      break;
    case M.invalid_union:
      r = "Invalid input";
      break;
    case M.invalid_union_discriminator:
      r = `Invalid discriminator value. Expected ${xe.joinValues(t.options)}`;
      break;
    case M.invalid_enum_value:
      r = `Invalid enum value. Expected ${xe.joinValues(t.options)}, received '${t.received}'`;
      break;
    case M.invalid_arguments:
      r = "Invalid function arguments";
      break;
    case M.invalid_return_type:
      r = "Invalid function return type";
      break;
    case M.invalid_date:
      r = "Invalid date";
      break;
    case M.invalid_string:
      typeof t.validation == "object" ? "includes" in t.validation ? (r = `Invalid input: must include "${t.validation.includes}"`, typeof t.validation.position == "number" && (r = `${r} at one or more positions greater than or equal to ${t.validation.position}`)) : "startsWith" in t.validation ? r = `Invalid input: must start with "${t.validation.startsWith}"` : "endsWith" in t.validation ? r = `Invalid input: must end with "${t.validation.endsWith}"` : xe.assertNever(t.validation) : r = t.validation !== "regex" ? `Invalid ${t.validation}` : "Invalid";
      break;
    case M.too_small:
      r = t.type === "array" ? `Array must contain ${t.exact ? "exactly" : t.inclusive ? "at least" : "more than"} ${t.minimum} element(s)` : t.type === "string" ? `String must contain ${t.exact ? "exactly" : t.inclusive ? "at least" : "over"} ${t.minimum} character(s)` : t.type === "number" || t.type === "bigint" ? `Number must be ${t.exact ? "exactly equal to " : t.inclusive ? "greater than or equal to " : "greater than "}${t.minimum}` : t.type === "date" ? `Date must be ${t.exact ? "exactly equal to " : t.inclusive ? "greater than or equal to " : "greater than "}${new Date(Number(t.minimum))}` : "Invalid input";
      break;
    case M.too_big:
      r = t.type === "array" ? `Array must contain ${t.exact ? "exactly" : t.inclusive ? "at most" : "less than"} ${t.maximum} element(s)` : t.type === "string" ? `String must contain ${t.exact ? "exactly" : t.inclusive ? "at most" : "under"} ${t.maximum} character(s)` : t.type === "number" ? `Number must be ${t.exact ? "exactly" : t.inclusive ? "less than or equal to" : "less than"} ${t.maximum}` : t.type === "bigint" ? `BigInt must be ${t.exact ? "exactly" : t.inclusive ? "less than or equal to" : "less than"} ${t.maximum}` : t.type === "date" ? `Date must be ${t.exact ? "exactly" : t.inclusive ? "smaller than or equal to" : "smaller than"} ${new Date(Number(t.maximum))}` : "Invalid input";
      break;
    case M.custom:
      r = "Invalid input";
      break;
    case M.invalid_intersection_types:
      r = "Intersection results could not be merged";
      break;
    case M.not_multiple_of:
      r = `Number must be a multiple of ${t.multipleOf}`;
      break;
    case M.not_finite:
      r = "Number must be finite";
      break;
    default:
      r = a.defaultError, xe.assertNever(t);
  }
  return { message: r };
};
let Wd = Bi;
var Y;
(function(t) {
  t.errToObj = (a) => typeof a == "string" ? { message: a } : a || {}, t.toString = (a) => typeof a == "string" ? a : a == null ? void 0 : a.message;
})(Y || (Y = {}));
function z(t, a) {
  const r = Wd, s = ((n) => {
    const { data: e, path: i, errorMaps: o, issueData: u } = n, l = [...i, ...u.path || []], c = { ...u, path: l };
    if (u.message !== void 0) return { ...u, path: l, message: u.message };
    let d = "";
    const h = o.filter((g) => !!g).slice().reverse();
    for (const g of h) d = g(c, { data: e, defaultError: d }).message;
    return { ...u, path: l, message: d };
  })({ issueData: a, data: t.data, path: t.path, errorMaps: [t.common.contextualErrorMap, t.schemaErrorMap, r, r === Bi ? void 0 : Bi].filter((n) => !!n) });
  t.common.issues.push(s);
}
class mt {
  constructor() {
    this.value = "valid";
  }
  dirty() {
    this.value === "valid" && (this.value = "dirty");
  }
  abort() {
    this.value !== "aborted" && (this.value = "aborted");
  }
  static mergeArray(a, r) {
    const s = [];
    for (const n of r) {
      if (n.status === "aborted") return ne;
      n.status === "dirty" && a.dirty(), s.push(n.value);
    }
    return { status: a.value, value: s };
  }
  static async mergeObjectAsync(a, r) {
    const s = [];
    for (const n of r) {
      const e = await n.key, i = await n.value;
      s.push({ key: e, value: i });
    }
    return mt.mergeObjectSync(a, s);
  }
  static mergeObjectSync(a, r) {
    const s = {};
    for (const n of r) {
      const { key: e, value: i } = n;
      if (e.status === "aborted" || i.status === "aborted") return ne;
      e.status === "dirty" && a.dirty(), i.status === "dirty" && a.dirty(), e.value === "__proto__" || i.value === void 0 && !n.alwaysSet || (s[e.value] = i.value);
    }
    return { status: a.value, value: s };
  }
}
const ne = Object.freeze({ status: "aborted" }), Gi = (t) => ({ status: "dirty", value: t }), yt = (t) => ({ status: "valid", value: t }), oa = (t) => t.status === "aborted", ua = (t) => t.status === "dirty", Tn = (t) => t.status === "valid", Hr = (t) => typeof Promise < "u" && t instanceof Promise;
class Pt {
  constructor(a, r, s, n) {
    this._cachedPath = [], this.parent = a, this.data = r, this._path = s, this._key = n;
  }
  get path() {
    return this._cachedPath.length || (Array.isArray(this._key) ? this._cachedPath.push(...this._path, ...this._key) : this._cachedPath.push(...this._path, this._key)), this._cachedPath;
  }
}
const la = (t, a) => {
  if (Tn(a)) return { success: !0, data: a.value };
  if (!t.common.issues.length) throw new Error("Validation failed but no issues detected.");
  return { success: !1, get error() {
    if (this._error) return this._error;
    const r = new Ft(t.common.issues);
    return this._error = r, this._error;
  } };
};
function oe(t) {
  if (!t) return {};
  const { errorMap: a, invalid_type_error: r, required_error: s, description: n } = t;
  if (a && (r || s)) throw new Error(`Can't use "invalid_type_error" or "required_error" in conjunction with custom error map.`);
  return a ? { errorMap: a, description: n } : { errorMap: (e, i) => {
    const { message: o } = t;
    return e.code === "invalid_enum_value" ? { message: o ?? i.defaultError } : i.data === void 0 ? { message: o ?? s ?? i.defaultError } : e.code !== "invalid_type" ? { message: i.defaultError } : { message: o ?? r ?? i.defaultError };
  }, description: n };
}
class fe {
  get description() {
    return this._def.description;
  }
  _getType(a) {
    return Wt(a.data);
  }
  _getOrReturnCtx(a, r) {
    return r || { common: a.parent.common, data: a.data, parsedType: Wt(a.data), schemaErrorMap: this._def.errorMap, path: a.path, parent: a.parent };
  }
  _processInputParams(a) {
    return { status: new mt(), ctx: { common: a.parent.common, data: a.data, parsedType: Wt(a.data), schemaErrorMap: this._def.errorMap, path: a.path, parent: a.parent } };
  }
  _parseSync(a) {
    const r = this._parse(a);
    if (Hr(r)) throw new Error("Synchronous parse encountered promise.");
    return r;
  }
  _parseAsync(a) {
    const r = this._parse(a);
    return Promise.resolve(r);
  }
  parse(a, r) {
    const s = this.safeParse(a, r);
    if (s.success) return s.data;
    throw s.error;
  }
  safeParse(a, r) {
    const s = { common: { issues: [], async: (r == null ? void 0 : r.async) ?? !1, contextualErrorMap: r == null ? void 0 : r.errorMap }, path: (r == null ? void 0 : r.path) || [], schemaErrorMap: this._def.errorMap, parent: null, data: a, parsedType: Wt(a) }, n = this._parseSync({ data: a, path: s.path, parent: s });
    return la(s, n);
  }
  "~validate"(a) {
    var s, n;
    const r = { common: { issues: [], async: !!this["~standard"].async }, path: [], schemaErrorMap: this._def.errorMap, parent: null, data: a, parsedType: Wt(a) };
    if (!this["~standard"].async) try {
      const e = this._parseSync({ data: a, path: [], parent: r });
      return Tn(e) ? { value: e.value } : { issues: r.common.issues };
    } catch (e) {
      (n = (s = e == null ? void 0 : e.message) == null ? void 0 : s.toLowerCase()) != null && n.includes("encountered") && (this["~standard"].async = !0), r.common = { issues: [], async: !0 };
    }
    return this._parseAsync({ data: a, path: [], parent: r }).then((e) => Tn(e) ? { value: e.value } : { issues: r.common.issues });
  }
  async parseAsync(a, r) {
    const s = await this.safeParseAsync(a, r);
    if (s.success) return s.data;
    throw s.error;
  }
  async safeParseAsync(a, r) {
    const s = { common: { issues: [], contextualErrorMap: r == null ? void 0 : r.errorMap, async: !0 }, path: (r == null ? void 0 : r.path) || [], schemaErrorMap: this._def.errorMap, parent: null, data: a, parsedType: Wt(a) }, n = this._parse({ data: a, path: s.path, parent: s }), e = await (Hr(n) ? n : Promise.resolve(n));
    return la(s, e);
  }
  refine(a, r) {
    const s = (n) => typeof r == "string" || r === void 0 ? { message: r } : typeof r == "function" ? r(n) : r;
    return this._refinement((n, e) => {
      const i = a(n), o = () => e.addIssue({ code: M.custom, ...s(n) });
      return typeof Promise < "u" && i instanceof Promise ? i.then((u) => !!u || (o(), !1)) : !!i || (o(), !1);
    });
  }
  refinement(a, r) {
    return this._refinement((s, n) => !!a(s) || (n.addIssue(typeof r == "function" ? r(s, n) : r), !1));
  }
  _refinement(a) {
    return new bn({ schema: this, typeName: ee.ZodEffects, effect: { type: "refinement", refinement: a } });
  }
  superRefine(a) {
    return this._refinement(a);
  }
  constructor(a) {
    this.spa = this.safeParseAsync, this._def = a, this.parse = this.parse.bind(this), this.safeParse = this.safeParse.bind(this), this.parseAsync = this.parseAsync.bind(this), this.safeParseAsync = this.safeParseAsync.bind(this), this.spa = this.spa.bind(this), this.refine = this.refine.bind(this), this.refinement = this.refinement.bind(this), this.superRefine = this.superRefine.bind(this), this.optional = this.optional.bind(this), this.nullable = this.nullable.bind(this), this.nullish = this.nullish.bind(this), this.array = this.array.bind(this), this.promise = this.promise.bind(this), this.or = this.or.bind(this), this.and = this.and.bind(this), this.transform = this.transform.bind(this), this.brand = this.brand.bind(this), this.default = this.default.bind(this), this.catch = this.catch.bind(this), this.describe = this.describe.bind(this), this.pipe = this.pipe.bind(this), this.readonly = this.readonly.bind(this), this.isNullable = this.isNullable.bind(this), this.isOptional = this.isOptional.bind(this), this["~standard"] = { version: 1, vendor: "zod", validate: (r) => this["~validate"](r) };
  }
  optional() {
    return Zt.create(this, this._def);
  }
  nullable() {
    return xn.create(this, this._def);
  }
  nullish() {
    return this.nullable().optional();
  }
  array() {
    return kt.create(this);
  }
  promise() {
    return Jr.create(this, this._def);
  }
  or(a) {
    return Wr.create([this, a], this._def);
  }
  and(a) {
    return qr.create(this, a, this._def);
  }
  transform(a) {
    return new bn({ ...oe(this._def), schema: this, typeName: ee.ZodEffects, effect: { type: "transform", transform: a } });
  }
  default(a) {
    const r = typeof a == "function" ? a : () => a;
    return new qi({ ...oe(this._def), innerType: this, defaultValue: r, typeName: ee.ZodDefault });
  }
  brand() {
    return new hh({ typeName: ee.ZodBranded, type: this, ...oe(this._def) });
  }
  catch(a) {
    const r = typeof a == "function" ? a : () => a;
    return new Ji({ ...oe(this._def), innerType: this, catchValue: r, typeName: ee.ZodCatch });
  }
  describe(a) {
    return new this.constructor({ ...this._def, description: a });
  }
  pipe(a) {
    return ds.create(this, a);
  }
  readonly() {
    return Yi.create(this);
  }
  isOptional() {
    return this.safeParse(void 0).success;
  }
  isNullable() {
    return this.safeParse(null).success;
  }
}
const qd = /^c[^\s-]{8,}$/i, Jd = /^[0-9a-z]+$/, Yd = /^[0-9A-HJKMNP-TV-Z]{26}$/i, Zd = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/i, Kd = /^[a-z0-9_-]{21}$/i, Qd = /^[A-Za-z0-9-_]+\.[A-Za-z0-9-_]+\.[A-Za-z0-9-_]*$/, Xd = /^[-+]?P(?!$)(?:(?:[-+]?\d+Y)|(?:[-+]?\d+[.,]\d+Y$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:(?:[-+]?\d+W)|(?:[-+]?\d+[.,]\d+W$))?(?:(?:[-+]?\d+D)|(?:[-+]?\d+[.,]\d+D$))?(?:T(?=[\d+-])(?:(?:[-+]?\d+H)|(?:[-+]?\d+[.,]\d+H$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:[-+]?\d+(?:[.,]\d+)?S)?)??$/, eh = /^(?!\.)(?!.*\.\.)([A-Z0-9_'+\-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$/i;
let mi;
const th = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/, nh = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\/(3[0-2]|[12]?[0-9])$/, rh = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))$/, ih = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))\/(12[0-8]|1[01][0-9]|[1-9]?[0-9])$/, sh = /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/, ah = /^([0-9a-zA-Z-_]{4})*(([0-9a-zA-Z-_]{2}(==)?)|([0-9a-zA-Z-_]{3}(=)?))?$/, Lo = "((\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-((0[13578]|1[02])-(0[1-9]|[12]\\d|3[01])|(0[469]|11)-(0[1-9]|[12]\\d|30)|(02)-(0[1-9]|1\\d|2[0-8])))", oh = new RegExp(`^${Lo}$`);
function jo(t) {
  let a = "[0-5]\\d";
  return t.precision ? a = `${a}\\.\\d{${t.precision}}` : t.precision == null && (a = `${a}(\\.\\d+)?`), `([01]\\d|2[0-3]):[0-5]\\d(:${a})${t.precision ? "+" : "?"}`;
}
function uh(t) {
  let a = `${Lo}T${jo(t)}`;
  const r = [];
  return r.push(t.local ? "Z?" : "Z"), t.offset && r.push("([+-]\\d{2}:?\\d{2})"), a = `${a}(${r.join("|")})`, new RegExp(`^${a}$`);
}
function lh(t, a) {
  if (!Qd.test(t)) return !1;
  try {
    const [r] = t.split(".");
    if (!r) return !1;
    const s = r.replace(/-/g, "+").replace(/_/g, "/").padEnd(r.length + (4 - r.length % 4) % 4, "="), n = JSON.parse(atob(s));
    return !(typeof n != "object" || n === null || "typ" in n && (n == null ? void 0 : n.typ) !== "JWT" || !n.alg || a && n.alg !== a);
  } catch {
    return !1;
  }
}
function ch(t, a) {
  return !(a !== "v4" && a || !nh.test(t)) || !(a !== "v6" && a || !ih.test(t));
}
class jt extends fe {
  _parse(a) {
    if (this._def.coerce && (a.data = String(a.data)), this._getType(a) !== J.string) {
      const i = this._getOrReturnCtx(a);
      return z(i, { code: M.invalid_type, expected: J.string, received: i.parsedType }), ne;
    }
    const r = new mt();
    let s;
    for (const i of this._def.checks) if (i.kind === "min") a.data.length < i.value && (s = this._getOrReturnCtx(a, s), z(s, { code: M.too_small, minimum: i.value, type: "string", inclusive: !0, exact: !1, message: i.message }), r.dirty());
    else if (i.kind === "max") a.data.length > i.value && (s = this._getOrReturnCtx(a, s), z(s, { code: M.too_big, maximum: i.value, type: "string", inclusive: !0, exact: !1, message: i.message }), r.dirty());
    else if (i.kind === "length") {
      const o = a.data.length > i.value, u = a.data.length < i.value;
      (o || u) && (s = this._getOrReturnCtx(a, s), o ? z(s, { code: M.too_big, maximum: i.value, type: "string", inclusive: !0, exact: !0, message: i.message }) : u && z(s, { code: M.too_small, minimum: i.value, type: "string", inclusive: !0, exact: !0, message: i.message }), r.dirty());
    } else if (i.kind === "email") eh.test(a.data) || (s = this._getOrReturnCtx(a, s), z(s, { validation: "email", code: M.invalid_string, message: i.message }), r.dirty());
    else if (i.kind === "emoji") mi || (mi = new RegExp("^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$", "u")), mi.test(a.data) || (s = this._getOrReturnCtx(a, s), z(s, { validation: "emoji", code: M.invalid_string, message: i.message }), r.dirty());
    else if (i.kind === "uuid") Zd.test(a.data) || (s = this._getOrReturnCtx(a, s), z(s, { validation: "uuid", code: M.invalid_string, message: i.message }), r.dirty());
    else if (i.kind === "nanoid") Kd.test(a.data) || (s = this._getOrReturnCtx(a, s), z(s, { validation: "nanoid", code: M.invalid_string, message: i.message }), r.dirty());
    else if (i.kind === "cuid") qd.test(a.data) || (s = this._getOrReturnCtx(a, s), z(s, { validation: "cuid", code: M.invalid_string, message: i.message }), r.dirty());
    else if (i.kind === "cuid2") Jd.test(a.data) || (s = this._getOrReturnCtx(a, s), z(s, { validation: "cuid2", code: M.invalid_string, message: i.message }), r.dirty());
    else if (i.kind === "ulid") Yd.test(a.data) || (s = this._getOrReturnCtx(a, s), z(s, { validation: "ulid", code: M.invalid_string, message: i.message }), r.dirty());
    else if (i.kind === "url") try {
      new URL(a.data);
    } catch {
      s = this._getOrReturnCtx(a, s), z(s, { validation: "url", code: M.invalid_string, message: i.message }), r.dirty();
    }
    else i.kind === "regex" ? (i.regex.lastIndex = 0, i.regex.test(a.data) || (s = this._getOrReturnCtx(a, s), z(s, { validation: "regex", code: M.invalid_string, message: i.message }), r.dirty())) : i.kind === "trim" ? a.data = a.data.trim() : i.kind === "includes" ? a.data.includes(i.value, i.position) || (s = this._getOrReturnCtx(a, s), z(s, { code: M.invalid_string, validation: { includes: i.value, position: i.position }, message: i.message }), r.dirty()) : i.kind === "toLowerCase" ? a.data = a.data.toLowerCase() : i.kind === "toUpperCase" ? a.data = a.data.toUpperCase() : i.kind === "startsWith" ? a.data.startsWith(i.value) || (s = this._getOrReturnCtx(a, s), z(s, { code: M.invalid_string, validation: { startsWith: i.value }, message: i.message }), r.dirty()) : i.kind === "endsWith" ? a.data.endsWith(i.value) || (s = this._getOrReturnCtx(a, s), z(s, { code: M.invalid_string, validation: { endsWith: i.value }, message: i.message }), r.dirty()) : i.kind === "datetime" ? uh(i).test(a.data) || (s = this._getOrReturnCtx(a, s), z(s, { code: M.invalid_string, validation: "datetime", message: i.message }), r.dirty()) : i.kind === "date" ? oh.test(a.data) || (s = this._getOrReturnCtx(a, s), z(s, { code: M.invalid_string, validation: "date", message: i.message }), r.dirty()) : i.kind === "time" ? new RegExp(`^${jo(i)}$`).test(a.data) || (s = this._getOrReturnCtx(a, s), z(s, { code: M.invalid_string, validation: "time", message: i.message }), r.dirty()) : i.kind === "duration" ? Xd.test(a.data) || (s = this._getOrReturnCtx(a, s), z(s, { validation: "duration", code: M.invalid_string, message: i.message }), r.dirty()) : i.kind === "ip" ? (n = a.data, ((e = i.version) !== "v4" && e || !th.test(n)) && (e !== "v6" && e || !rh.test(n)) && (s = this._getOrReturnCtx(a, s), z(s, { validation: "ip", code: M.invalid_string, message: i.message }), r.dirty())) : i.kind === "jwt" ? lh(a.data, i.alg) || (s = this._getOrReturnCtx(a, s), z(s, { validation: "jwt", code: M.invalid_string, message: i.message }), r.dirty()) : i.kind === "cidr" ? ch(a.data, i.version) || (s = this._getOrReturnCtx(a, s), z(s, { validation: "cidr", code: M.invalid_string, message: i.message }), r.dirty()) : i.kind === "base64" ? sh.test(a.data) || (s = this._getOrReturnCtx(a, s), z(s, { validation: "base64", code: M.invalid_string, message: i.message }), r.dirty()) : i.kind === "base64url" ? ah.test(a.data) || (s = this._getOrReturnCtx(a, s), z(s, { validation: "base64url", code: M.invalid_string, message: i.message }), r.dirty()) : xe.assertNever(i);
    var n, e;
    return { status: r.value, value: a.data };
  }
  _regex(a, r, s) {
    return this.refinement((n) => a.test(n), { validation: r, code: M.invalid_string, ...Y.errToObj(s) });
  }
  _addCheck(a) {
    return new jt({ ...this._def, checks: [...this._def.checks, a] });
  }
  email(a) {
    return this._addCheck({ kind: "email", ...Y.errToObj(a) });
  }
  url(a) {
    return this._addCheck({ kind: "url", ...Y.errToObj(a) });
  }
  emoji(a) {
    return this._addCheck({ kind: "emoji", ...Y.errToObj(a) });
  }
  uuid(a) {
    return this._addCheck({ kind: "uuid", ...Y.errToObj(a) });
  }
  nanoid(a) {
    return this._addCheck({ kind: "nanoid", ...Y.errToObj(a) });
  }
  cuid(a) {
    return this._addCheck({ kind: "cuid", ...Y.errToObj(a) });
  }
  cuid2(a) {
    return this._addCheck({ kind: "cuid2", ...Y.errToObj(a) });
  }
  ulid(a) {
    return this._addCheck({ kind: "ulid", ...Y.errToObj(a) });
  }
  base64(a) {
    return this._addCheck({ kind: "base64", ...Y.errToObj(a) });
  }
  base64url(a) {
    return this._addCheck({ kind: "base64url", ...Y.errToObj(a) });
  }
  jwt(a) {
    return this._addCheck({ kind: "jwt", ...Y.errToObj(a) });
  }
  ip(a) {
    return this._addCheck({ kind: "ip", ...Y.errToObj(a) });
  }
  cidr(a) {
    return this._addCheck({ kind: "cidr", ...Y.errToObj(a) });
  }
  datetime(a) {
    return typeof a == "string" ? this._addCheck({ kind: "datetime", precision: null, offset: !1, local: !1, message: a }) : this._addCheck({ kind: "datetime", precision: (a == null ? void 0 : a.precision) === void 0 ? null : a == null ? void 0 : a.precision, offset: (a == null ? void 0 : a.offset) ?? !1, local: (a == null ? void 0 : a.local) ?? !1, ...Y.errToObj(a == null ? void 0 : a.message) });
  }
  date(a) {
    return this._addCheck({ kind: "date", message: a });
  }
  time(a) {
    return typeof a == "string" ? this._addCheck({ kind: "time", precision: null, message: a }) : this._addCheck({ kind: "time", precision: (a == null ? void 0 : a.precision) === void 0 ? null : a == null ? void 0 : a.precision, ...Y.errToObj(a == null ? void 0 : a.message) });
  }
  duration(a) {
    return this._addCheck({ kind: "duration", ...Y.errToObj(a) });
  }
  regex(a, r) {
    return this._addCheck({ kind: "regex", regex: a, ...Y.errToObj(r) });
  }
  includes(a, r) {
    return this._addCheck({ kind: "includes", value: a, position: r == null ? void 0 : r.position, ...Y.errToObj(r == null ? void 0 : r.message) });
  }
  startsWith(a, r) {
    return this._addCheck({ kind: "startsWith", value: a, ...Y.errToObj(r) });
  }
  endsWith(a, r) {
    return this._addCheck({ kind: "endsWith", value: a, ...Y.errToObj(r) });
  }
  min(a, r) {
    return this._addCheck({ kind: "min", value: a, ...Y.errToObj(r) });
  }
  max(a, r) {
    return this._addCheck({ kind: "max", value: a, ...Y.errToObj(r) });
  }
  length(a, r) {
    return this._addCheck({ kind: "length", value: a, ...Y.errToObj(r) });
  }
  nonempty(a) {
    return this.min(1, Y.errToObj(a));
  }
  trim() {
    return new jt({ ...this._def, checks: [...this._def.checks, { kind: "trim" }] });
  }
  toLowerCase() {
    return new jt({ ...this._def, checks: [...this._def.checks, { kind: "toLowerCase" }] });
  }
  toUpperCase() {
    return new jt({ ...this._def, checks: [...this._def.checks, { kind: "toUpperCase" }] });
  }
  get isDatetime() {
    return !!this._def.checks.find((a) => a.kind === "datetime");
  }
  get isDate() {
    return !!this._def.checks.find((a) => a.kind === "date");
  }
  get isTime() {
    return !!this._def.checks.find((a) => a.kind === "time");
  }
  get isDuration() {
    return !!this._def.checks.find((a) => a.kind === "duration");
  }
  get isEmail() {
    return !!this._def.checks.find((a) => a.kind === "email");
  }
  get isURL() {
    return !!this._def.checks.find((a) => a.kind === "url");
  }
  get isEmoji() {
    return !!this._def.checks.find((a) => a.kind === "emoji");
  }
  get isUUID() {
    return !!this._def.checks.find((a) => a.kind === "uuid");
  }
  get isNANOID() {
    return !!this._def.checks.find((a) => a.kind === "nanoid");
  }
  get isCUID() {
    return !!this._def.checks.find((a) => a.kind === "cuid");
  }
  get isCUID2() {
    return !!this._def.checks.find((a) => a.kind === "cuid2");
  }
  get isULID() {
    return !!this._def.checks.find((a) => a.kind === "ulid");
  }
  get isIP() {
    return !!this._def.checks.find((a) => a.kind === "ip");
  }
  get isCIDR() {
    return !!this._def.checks.find((a) => a.kind === "cidr");
  }
  get isBase64() {
    return !!this._def.checks.find((a) => a.kind === "base64");
  }
  get isBase64url() {
    return !!this._def.checks.find((a) => a.kind === "base64url");
  }
  get minLength() {
    let a = null;
    for (const r of this._def.checks) r.kind === "min" && (a === null || r.value > a) && (a = r.value);
    return a;
  }
  get maxLength() {
    let a = null;
    for (const r of this._def.checks) r.kind === "max" && (a === null || r.value < a) && (a = r.value);
    return a;
  }
}
function dh(t, a) {
  const r = (t.toString().split(".")[1] || "").length, s = (a.toString().split(".")[1] || "").length, n = r > s ? r : s;
  return Number.parseInt(t.toFixed(n).replace(".", "")) % Number.parseInt(a.toFixed(n).replace(".", "")) / 10 ** n;
}
jt.create = (t) => new jt({ checks: [], typeName: ee.ZodString, coerce: (t == null ? void 0 : t.coerce) ?? !1, ...oe(t) });
class En extends fe {
  constructor() {
    super(...arguments), this.min = this.gte, this.max = this.lte, this.step = this.multipleOf;
  }
  _parse(a) {
    if (this._def.coerce && (a.data = Number(a.data)), this._getType(a) !== J.number) {
      const n = this._getOrReturnCtx(a);
      return z(n, { code: M.invalid_type, expected: J.number, received: n.parsedType }), ne;
    }
    let r;
    const s = new mt();
    for (const n of this._def.checks) n.kind === "int" ? xe.isInteger(a.data) || (r = this._getOrReturnCtx(a, r), z(r, { code: M.invalid_type, expected: "integer", received: "float", message: n.message }), s.dirty()) : n.kind === "min" ? (n.inclusive ? a.data < n.value : a.data <= n.value) && (r = this._getOrReturnCtx(a, r), z(r, { code: M.too_small, minimum: n.value, type: "number", inclusive: n.inclusive, exact: !1, message: n.message }), s.dirty()) : n.kind === "max" ? (n.inclusive ? a.data > n.value : a.data >= n.value) && (r = this._getOrReturnCtx(a, r), z(r, { code: M.too_big, maximum: n.value, type: "number", inclusive: n.inclusive, exact: !1, message: n.message }), s.dirty()) : n.kind === "multipleOf" ? dh(a.data, n.value) !== 0 && (r = this._getOrReturnCtx(a, r), z(r, { code: M.not_multiple_of, multipleOf: n.value, message: n.message }), s.dirty()) : n.kind === "finite" ? Number.isFinite(a.data) || (r = this._getOrReturnCtx(a, r), z(r, { code: M.not_finite, message: n.message }), s.dirty()) : xe.assertNever(n);
    return { status: s.value, value: a.data };
  }
  gte(a, r) {
    return this.setLimit("min", a, !0, Y.toString(r));
  }
  gt(a, r) {
    return this.setLimit("min", a, !1, Y.toString(r));
  }
  lte(a, r) {
    return this.setLimit("max", a, !0, Y.toString(r));
  }
  lt(a, r) {
    return this.setLimit("max", a, !1, Y.toString(r));
  }
  setLimit(a, r, s, n) {
    return new En({ ...this._def, checks: [...this._def.checks, { kind: a, value: r, inclusive: s, message: Y.toString(n) }] });
  }
  _addCheck(a) {
    return new En({ ...this._def, checks: [...this._def.checks, a] });
  }
  int(a) {
    return this._addCheck({ kind: "int", message: Y.toString(a) });
  }
  positive(a) {
    return this._addCheck({ kind: "min", value: 0, inclusive: !1, message: Y.toString(a) });
  }
  negative(a) {
    return this._addCheck({ kind: "max", value: 0, inclusive: !1, message: Y.toString(a) });
  }
  nonpositive(a) {
    return this._addCheck({ kind: "max", value: 0, inclusive: !0, message: Y.toString(a) });
  }
  nonnegative(a) {
    return this._addCheck({ kind: "min", value: 0, inclusive: !0, message: Y.toString(a) });
  }
  multipleOf(a, r) {
    return this._addCheck({ kind: "multipleOf", value: a, message: Y.toString(r) });
  }
  finite(a) {
    return this._addCheck({ kind: "finite", message: Y.toString(a) });
  }
  safe(a) {
    return this._addCheck({ kind: "min", inclusive: !0, value: Number.MIN_SAFE_INTEGER, message: Y.toString(a) })._addCheck({ kind: "max", inclusive: !0, value: Number.MAX_SAFE_INTEGER, message: Y.toString(a) });
  }
  get minValue() {
    let a = null;
    for (const r of this._def.checks) r.kind === "min" && (a === null || r.value > a) && (a = r.value);
    return a;
  }
  get maxValue() {
    let a = null;
    for (const r of this._def.checks) r.kind === "max" && (a === null || r.value < a) && (a = r.value);
    return a;
  }
  get isInt() {
    return !!this._def.checks.find((a) => a.kind === "int" || a.kind === "multipleOf" && xe.isInteger(a.value));
  }
  get isFinite() {
    let a = null, r = null;
    for (const s of this._def.checks) {
      if (s.kind === "finite" || s.kind === "int" || s.kind === "multipleOf") return !0;
      s.kind === "min" ? (r === null || s.value > r) && (r = s.value) : s.kind === "max" && (a === null || s.value < a) && (a = s.value);
    }
    return Number.isFinite(r) && Number.isFinite(a);
  }
}
En.create = (t) => new En({ checks: [], typeName: ee.ZodNumber, coerce: (t == null ? void 0 : t.coerce) || !1, ...oe(t) });
class nr extends fe {
  constructor() {
    super(...arguments), this.min = this.gte, this.max = this.lte;
  }
  _parse(a) {
    if (this._def.coerce) try {
      a.data = BigInt(a.data);
    } catch {
      return this._getInvalidInput(a);
    }
    if (this._getType(a) !== J.bigint) return this._getInvalidInput(a);
    let r;
    const s = new mt();
    for (const n of this._def.checks) n.kind === "min" ? (n.inclusive ? a.data < n.value : a.data <= n.value) && (r = this._getOrReturnCtx(a, r), z(r, { code: M.too_small, type: "bigint", minimum: n.value, inclusive: n.inclusive, message: n.message }), s.dirty()) : n.kind === "max" ? (n.inclusive ? a.data > n.value : a.data >= n.value) && (r = this._getOrReturnCtx(a, r), z(r, { code: M.too_big, type: "bigint", maximum: n.value, inclusive: n.inclusive, message: n.message }), s.dirty()) : n.kind === "multipleOf" ? a.data % n.value !== BigInt(0) && (r = this._getOrReturnCtx(a, r), z(r, { code: M.not_multiple_of, multipleOf: n.value, message: n.message }), s.dirty()) : xe.assertNever(n);
    return { status: s.value, value: a.data };
  }
  _getInvalidInput(a) {
    const r = this._getOrReturnCtx(a);
    return z(r, { code: M.invalid_type, expected: J.bigint, received: r.parsedType }), ne;
  }
  gte(a, r) {
    return this.setLimit("min", a, !0, Y.toString(r));
  }
  gt(a, r) {
    return this.setLimit("min", a, !1, Y.toString(r));
  }
  lte(a, r) {
    return this.setLimit("max", a, !0, Y.toString(r));
  }
  lt(a, r) {
    return this.setLimit("max", a, !1, Y.toString(r));
  }
  setLimit(a, r, s, n) {
    return new nr({ ...this._def, checks: [...this._def.checks, { kind: a, value: r, inclusive: s, message: Y.toString(n) }] });
  }
  _addCheck(a) {
    return new nr({ ...this._def, checks: [...this._def.checks, a] });
  }
  positive(a) {
    return this._addCheck({ kind: "min", value: BigInt(0), inclusive: !1, message: Y.toString(a) });
  }
  negative(a) {
    return this._addCheck({ kind: "max", value: BigInt(0), inclusive: !1, message: Y.toString(a) });
  }
  nonpositive(a) {
    return this._addCheck({ kind: "max", value: BigInt(0), inclusive: !0, message: Y.toString(a) });
  }
  nonnegative(a) {
    return this._addCheck({ kind: "min", value: BigInt(0), inclusive: !0, message: Y.toString(a) });
  }
  multipleOf(a, r) {
    return this._addCheck({ kind: "multipleOf", value: a, message: Y.toString(r) });
  }
  get minValue() {
    let a = null;
    for (const r of this._def.checks) r.kind === "min" && (a === null || r.value > a) && (a = r.value);
    return a;
  }
  get maxValue() {
    let a = null;
    for (const r of this._def.checks) r.kind === "max" && (a === null || r.value < a) && (a = r.value);
    return a;
  }
}
nr.create = (t) => new nr({ checks: [], typeName: ee.ZodBigInt, coerce: (t == null ? void 0 : t.coerce) ?? !1, ...oe(t) });
class Hi extends fe {
  _parse(a) {
    if (this._def.coerce && (a.data = !!a.data), this._getType(a) !== J.boolean) {
      const r = this._getOrReturnCtx(a);
      return z(r, { code: M.invalid_type, expected: J.boolean, received: r.parsedType }), ne;
    }
    return yt(a.data);
  }
}
Hi.create = (t) => new Hi({ typeName: ee.ZodBoolean, coerce: (t == null ? void 0 : t.coerce) || !1, ...oe(t) });
class $r extends fe {
  _parse(a) {
    if (this._def.coerce && (a.data = new Date(a.data)), this._getType(a) !== J.date) {
      const n = this._getOrReturnCtx(a);
      return z(n, { code: M.invalid_type, expected: J.date, received: n.parsedType }), ne;
    }
    if (Number.isNaN(a.data.getTime())) return z(this._getOrReturnCtx(a), { code: M.invalid_date }), ne;
    const r = new mt();
    let s;
    for (const n of this._def.checks) n.kind === "min" ? a.data.getTime() < n.value && (s = this._getOrReturnCtx(a, s), z(s, { code: M.too_small, message: n.message, inclusive: !0, exact: !1, minimum: n.value, type: "date" }), r.dirty()) : n.kind === "max" ? a.data.getTime() > n.value && (s = this._getOrReturnCtx(a, s), z(s, { code: M.too_big, message: n.message, inclusive: !0, exact: !1, maximum: n.value, type: "date" }), r.dirty()) : xe.assertNever(n);
    return { status: r.value, value: new Date(a.data.getTime()) };
  }
  _addCheck(a) {
    return new $r({ ...this._def, checks: [...this._def.checks, a] });
  }
  min(a, r) {
    return this._addCheck({ kind: "min", value: a.getTime(), message: Y.toString(r) });
  }
  max(a, r) {
    return this._addCheck({ kind: "max", value: a.getTime(), message: Y.toString(r) });
  }
  get minDate() {
    let a = null;
    for (const r of this._def.checks) r.kind === "min" && (a === null || r.value > a) && (a = r.value);
    return a != null ? new Date(a) : null;
  }
  get maxDate() {
    let a = null;
    for (const r of this._def.checks) r.kind === "max" && (a === null || r.value < a) && (a = r.value);
    return a != null ? new Date(a) : null;
  }
}
$r.create = (t) => new $r({ checks: [], coerce: (t == null ? void 0 : t.coerce) || !1, typeName: ee.ZodDate, ...oe(t) });
class ca extends fe {
  _parse(a) {
    if (this._getType(a) !== J.symbol) {
      const r = this._getOrReturnCtx(a);
      return z(r, { code: M.invalid_type, expected: J.symbol, received: r.parsedType }), ne;
    }
    return yt(a.data);
  }
}
ca.create = (t) => new ca({ typeName: ee.ZodSymbol, ...oe(t) });
class da extends fe {
  _parse(a) {
    if (this._getType(a) !== J.undefined) {
      const r = this._getOrReturnCtx(a);
      return z(r, { code: M.invalid_type, expected: J.undefined, received: r.parsedType }), ne;
    }
    return yt(a.data);
  }
}
da.create = (t) => new da({ typeName: ee.ZodUndefined, ...oe(t) });
class ha extends fe {
  _parse(a) {
    if (this._getType(a) !== J.null) {
      const r = this._getOrReturnCtx(a);
      return z(r, { code: M.invalid_type, expected: J.null, received: r.parsedType }), ne;
    }
    return yt(a.data);
  }
}
ha.create = (t) => new ha({ typeName: ee.ZodNull, ...oe(t) });
class fa extends fe {
  constructor() {
    super(...arguments), this._any = !0;
  }
  _parse(a) {
    return yt(a.data);
  }
}
fa.create = (t) => new fa({ typeName: ee.ZodAny, ...oe(t) });
class va extends fe {
  constructor() {
    super(...arguments), this._unknown = !0;
  }
  _parse(a) {
    return yt(a.data);
  }
}
va.create = (t) => new va({ typeName: ee.ZodUnknown, ...oe(t) });
class Yt extends fe {
  _parse(a) {
    const r = this._getOrReturnCtx(a);
    return z(r, { code: M.invalid_type, expected: J.never, received: r.parsedType }), ne;
  }
}
Yt.create = (t) => new Yt({ typeName: ee.ZodNever, ...oe(t) });
class pa extends fe {
  _parse(a) {
    if (this._getType(a) !== J.undefined) {
      const r = this._getOrReturnCtx(a);
      return z(r, { code: M.invalid_type, expected: J.void, received: r.parsedType }), ne;
    }
    return yt(a.data);
  }
}
pa.create = (t) => new pa({ typeName: ee.ZodVoid, ...oe(t) });
class kt extends fe {
  _parse(a) {
    const { ctx: r, status: s } = this._processInputParams(a), n = this._def;
    if (r.parsedType !== J.array) return z(r, { code: M.invalid_type, expected: J.array, received: r.parsedType }), ne;
    if (n.exactLength !== null) {
      const i = r.data.length > n.exactLength.value, o = r.data.length < n.exactLength.value;
      (i || o) && (z(r, { code: i ? M.too_big : M.too_small, minimum: o ? n.exactLength.value : void 0, maximum: i ? n.exactLength.value : void 0, type: "array", inclusive: !0, exact: !0, message: n.exactLength.message }), s.dirty());
    }
    if (n.minLength !== null && r.data.length < n.minLength.value && (z(r, { code: M.too_small, minimum: n.minLength.value, type: "array", inclusive: !0, exact: !1, message: n.minLength.message }), s.dirty()), n.maxLength !== null && r.data.length > n.maxLength.value && (z(r, { code: M.too_big, maximum: n.maxLength.value, type: "array", inclusive: !0, exact: !1, message: n.maxLength.message }), s.dirty()), r.common.async) return Promise.all([...r.data].map((i, o) => n.type._parseAsync(new Pt(r, i, r.path, o)))).then((i) => mt.mergeArray(s, i));
    const e = [...r.data].map((i, o) => n.type._parseSync(new Pt(r, i, r.path, o)));
    return mt.mergeArray(s, e);
  }
  get element() {
    return this._def.type;
  }
  min(a, r) {
    return new kt({ ...this._def, minLength: { value: a, message: Y.toString(r) } });
  }
  max(a, r) {
    return new kt({ ...this._def, maxLength: { value: a, message: Y.toString(r) } });
  }
  length(a, r) {
    return new kt({ ...this._def, exactLength: { value: a, message: Y.toString(r) } });
  }
  nonempty(a) {
    return this.min(1, a);
  }
}
function mn(t) {
  if (t instanceof Qe) {
    const a = {};
    for (const r in t.shape) {
      const s = t.shape[r];
      a[r] = Zt.create(mn(s));
    }
    return new Qe({ ...t._def, shape: () => a });
  }
  return t instanceof kt ? new kt({ ...t._def, type: mn(t.element) }) : t instanceof Zt ? Zt.create(mn(t.unwrap())) : t instanceof xn ? xn.create(mn(t.unwrap())) : t instanceof sn ? sn.create(t.items.map((a) => mn(a))) : t;
}
kt.create = (t, a) => new kt({ type: t, minLength: null, maxLength: null, exactLength: null, typeName: ee.ZodArray, ...oe(a) });
class Qe extends fe {
  constructor() {
    super(...arguments), this._cached = null, this.nonstrict = this.passthrough, this.augment = this.extend;
  }
  _getCached() {
    if (this._cached !== null) return this._cached;
    const a = this._def.shape(), r = xe.objectKeys(a);
    return this._cached = { shape: a, keys: r }, this._cached;
  }
  _parse(a) {
    if (this._getType(a) !== J.object) {
      const u = this._getOrReturnCtx(a);
      return z(u, { code: M.invalid_type, expected: J.object, received: u.parsedType }), ne;
    }
    const { status: r, ctx: s } = this._processInputParams(a), { shape: n, keys: e } = this._getCached(), i = [];
    if (!(this._def.catchall instanceof Yt && this._def.unknownKeys === "strip")) for (const u in s.data) e.includes(u) || i.push(u);
    const o = [];
    for (const u of e) {
      const l = n[u], c = s.data[u];
      o.push({ key: { status: "valid", value: u }, value: l._parse(new Pt(s, c, s.path, u)), alwaysSet: u in s.data });
    }
    if (this._def.catchall instanceof Yt) {
      const u = this._def.unknownKeys;
      if (u === "passthrough") for (const l of i) o.push({ key: { status: "valid", value: l }, value: { status: "valid", value: s.data[l] } });
      else if (u === "strict") i.length > 0 && (z(s, { code: M.unrecognized_keys, keys: i }), r.dirty());
      else if (u !== "strip") throw new Error("Internal ZodObject error: invalid unknownKeys value.");
    } else {
      const u = this._def.catchall;
      for (const l of i) {
        const c = s.data[l];
        o.push({ key: { status: "valid", value: l }, value: u._parse(new Pt(s, c, s.path, l)), alwaysSet: l in s.data });
      }
    }
    return s.common.async ? Promise.resolve().then(async () => {
      const u = [];
      for (const l of o) {
        const c = await l.key, d = await l.value;
        u.push({ key: c, value: d, alwaysSet: l.alwaysSet });
      }
      return u;
    }).then((u) => mt.mergeObjectSync(r, u)) : mt.mergeObjectSync(r, o);
  }
  get shape() {
    return this._def.shape();
  }
  strict(a) {
    return Y.errToObj, new Qe({ ...this._def, unknownKeys: "strict", ...a !== void 0 ? { errorMap: (r, s) => {
      var e, i;
      const n = ((i = (e = this._def).errorMap) == null ? void 0 : i.call(e, r, s).message) ?? s.defaultError;
      return r.code === "unrecognized_keys" ? { message: Y.errToObj(a).message ?? n } : { message: n };
    } } : {} });
  }
  strip() {
    return new Qe({ ...this._def, unknownKeys: "strip" });
  }
  passthrough() {
    return new Qe({ ...this._def, unknownKeys: "passthrough" });
  }
  extend(a) {
    return new Qe({ ...this._def, shape: () => ({ ...this._def.shape(), ...a }) });
  }
  merge(a) {
    return new Qe({ unknownKeys: a._def.unknownKeys, catchall: a._def.catchall, shape: () => ({ ...this._def.shape(), ...a._def.shape() }), typeName: ee.ZodObject });
  }
  setKey(a, r) {
    return this.augment({ [a]: r });
  }
  catchall(a) {
    return new Qe({ ...this._def, catchall: a });
  }
  pick(a) {
    const r = {};
    for (const s of xe.objectKeys(a)) a[s] && this.shape[s] && (r[s] = this.shape[s]);
    return new Qe({ ...this._def, shape: () => r });
  }
  omit(a) {
    const r = {};
    for (const s of xe.objectKeys(this.shape)) a[s] || (r[s] = this.shape[s]);
    return new Qe({ ...this._def, shape: () => r });
  }
  deepPartial() {
    return mn(this);
  }
  partial(a) {
    const r = {};
    for (const s of xe.objectKeys(this.shape)) {
      const n = this.shape[s];
      a && !a[s] ? r[s] = n : r[s] = n.optional();
    }
    return new Qe({ ...this._def, shape: () => r });
  }
  required(a) {
    const r = {};
    for (const s of xe.objectKeys(this.shape)) if (a && !a[s]) r[s] = this.shape[s];
    else {
      let n = this.shape[s];
      for (; n instanceof Zt; ) n = n._def.innerType;
      r[s] = n;
    }
    return new Qe({ ...this._def, shape: () => r });
  }
  keyof() {
    return Mo(xe.objectKeys(this.shape));
  }
}
Qe.create = (t, a) => new Qe({ shape: () => t, unknownKeys: "strip", catchall: Yt.create(), typeName: ee.ZodObject, ...oe(a) }), Qe.strictCreate = (t, a) => new Qe({ shape: () => t, unknownKeys: "strict", catchall: Yt.create(), typeName: ee.ZodObject, ...oe(a) }), Qe.lazycreate = (t, a) => new Qe({ shape: t, unknownKeys: "strip", catchall: Yt.create(), typeName: ee.ZodObject, ...oe(a) });
class Wr extends fe {
  _parse(a) {
    const { ctx: r } = this._processInputParams(a), s = this._def.options;
    if (r.common.async) return Promise.all(s.map(async (n) => {
      const e = { ...r, common: { ...r.common, issues: [] }, parent: null };
      return { result: await n._parseAsync({ data: r.data, path: r.path, parent: e }), ctx: e };
    })).then(function(n) {
      for (const i of n) if (i.result.status === "valid") return i.result;
      for (const i of n) if (i.result.status === "dirty") return r.common.issues.push(...i.ctx.common.issues), i.result;
      const e = n.map((i) => new Ft(i.ctx.common.issues));
      return z(r, { code: M.invalid_union, unionErrors: e }), ne;
    });
    {
      let n;
      const e = [];
      for (const o of s) {
        const u = { ...r, common: { ...r.common, issues: [] }, parent: null }, l = o._parseSync({ data: r.data, path: r.path, parent: u });
        if (l.status === "valid") return l;
        l.status !== "dirty" || n || (n = { result: l, ctx: u }), u.common.issues.length && e.push(u.common.issues);
      }
      if (n) return r.common.issues.push(...n.ctx.common.issues), n.result;
      const i = e.map((o) => new Ft(o));
      return z(r, { code: M.invalid_union, unionErrors: i }), ne;
    }
  }
  get options() {
    return this._def.options;
  }
}
function $i(t, a) {
  const r = Wt(t), s = Wt(a);
  if (t === a) return { valid: !0, data: t };
  if (r === J.object && s === J.object) {
    const n = xe.objectKeys(a), e = xe.objectKeys(t).filter((o) => n.indexOf(o) !== -1), i = { ...t, ...a };
    for (const o of e) {
      const u = $i(t[o], a[o]);
      if (!u.valid) return { valid: !1 };
      i[o] = u.data;
    }
    return { valid: !0, data: i };
  }
  if (r === J.array && s === J.array) {
    if (t.length !== a.length) return { valid: !1 };
    const n = [];
    for (let e = 0; e < t.length; e++) {
      const i = $i(t[e], a[e]);
      if (!i.valid) return { valid: !1 };
      n.push(i.data);
    }
    return { valid: !0, data: n };
  }
  return r === J.date && s === J.date && +t == +a ? { valid: !0, data: t } : { valid: !1 };
}
Wr.create = (t, a) => new Wr({ options: t, typeName: ee.ZodUnion, ...oe(a) });
class qr extends fe {
  _parse(a) {
    const { status: r, ctx: s } = this._processInputParams(a), n = (e, i) => {
      if (oa(e) || oa(i)) return ne;
      const o = $i(e.value, i.value);
      return o.valid ? ((ua(e) || ua(i)) && r.dirty(), { status: r.value, value: o.data }) : (z(s, { code: M.invalid_intersection_types }), ne);
    };
    return s.common.async ? Promise.all([this._def.left._parseAsync({ data: s.data, path: s.path, parent: s }), this._def.right._parseAsync({ data: s.data, path: s.path, parent: s })]).then(([e, i]) => n(e, i)) : n(this._def.left._parseSync({ data: s.data, path: s.path, parent: s }), this._def.right._parseSync({ data: s.data, path: s.path, parent: s }));
  }
}
qr.create = (t, a, r) => new qr({ left: t, right: a, typeName: ee.ZodIntersection, ...oe(r) });
class sn extends fe {
  _parse(a) {
    const { status: r, ctx: s } = this._processInputParams(a);
    if (s.parsedType !== J.array) return z(s, { code: M.invalid_type, expected: J.array, received: s.parsedType }), ne;
    if (s.data.length < this._def.items.length) return z(s, { code: M.too_small, minimum: this._def.items.length, inclusive: !0, exact: !1, type: "array" }), ne;
    !this._def.rest && s.data.length > this._def.items.length && (z(s, { code: M.too_big, maximum: this._def.items.length, inclusive: !0, exact: !1, type: "array" }), r.dirty());
    const n = [...s.data].map((e, i) => {
      const o = this._def.items[i] || this._def.rest;
      return o ? o._parse(new Pt(s, e, s.path, i)) : null;
    }).filter((e) => !!e);
    return s.common.async ? Promise.all(n).then((e) => mt.mergeArray(r, e)) : mt.mergeArray(r, n);
  }
  get items() {
    return this._def.items;
  }
  rest(a) {
    return new sn({ ...this._def, rest: a });
  }
}
sn.create = (t, a) => {
  if (!Array.isArray(t)) throw new Error("You must pass an array of schemas to z.tuple([ ... ])");
  return new sn({ items: t, typeName: ee.ZodTuple, rest: null, ...oe(a) });
};
class cs extends fe {
  get keySchema() {
    return this._def.keyType;
  }
  get valueSchema() {
    return this._def.valueType;
  }
  _parse(a) {
    const { status: r, ctx: s } = this._processInputParams(a);
    if (s.parsedType !== J.object) return z(s, { code: M.invalid_type, expected: J.object, received: s.parsedType }), ne;
    const n = [], e = this._def.keyType, i = this._def.valueType;
    for (const o in s.data) n.push({ key: e._parse(new Pt(s, o, s.path, o)), value: i._parse(new Pt(s, s.data[o], s.path, o)), alwaysSet: o in s.data });
    return s.common.async ? mt.mergeObjectAsync(r, n) : mt.mergeObjectSync(r, n);
  }
  get element() {
    return this._def.valueType;
  }
  static create(a, r, s) {
    return new cs(r instanceof fe ? { keyType: a, valueType: r, typeName: ee.ZodRecord, ...oe(s) } : { keyType: jt.create(), valueType: a, typeName: ee.ZodRecord, ...oe(r) });
  }
}
class ga extends fe {
  get keySchema() {
    return this._def.keyType;
  }
  get valueSchema() {
    return this._def.valueType;
  }
  _parse(a) {
    const { status: r, ctx: s } = this._processInputParams(a);
    if (s.parsedType !== J.map) return z(s, { code: M.invalid_type, expected: J.map, received: s.parsedType }), ne;
    const n = this._def.keyType, e = this._def.valueType, i = [...s.data.entries()].map(([o, u], l) => ({ key: n._parse(new Pt(s, o, s.path, [l, "key"])), value: e._parse(new Pt(s, u, s.path, [l, "value"])) }));
    if (s.common.async) {
      const o = /* @__PURE__ */ new Map();
      return Promise.resolve().then(async () => {
        for (const u of i) {
          const l = await u.key, c = await u.value;
          if (l.status === "aborted" || c.status === "aborted") return ne;
          l.status !== "dirty" && c.status !== "dirty" || r.dirty(), o.set(l.value, c.value);
        }
        return { status: r.value, value: o };
      });
    }
    {
      const o = /* @__PURE__ */ new Map();
      for (const u of i) {
        const l = u.key, c = u.value;
        if (l.status === "aborted" || c.status === "aborted") return ne;
        l.status !== "dirty" && c.status !== "dirty" || r.dirty(), o.set(l.value, c.value);
      }
      return { status: r.value, value: o };
    }
  }
}
ga.create = (t, a, r) => new ga({ valueType: a, keyType: t, typeName: ee.ZodMap, ...oe(r) });
class rr extends fe {
  _parse(a) {
    const { status: r, ctx: s } = this._processInputParams(a);
    if (s.parsedType !== J.set) return z(s, { code: M.invalid_type, expected: J.set, received: s.parsedType }), ne;
    const n = this._def;
    n.minSize !== null && s.data.size < n.minSize.value && (z(s, { code: M.too_small, minimum: n.minSize.value, type: "set", inclusive: !0, exact: !1, message: n.minSize.message }), r.dirty()), n.maxSize !== null && s.data.size > n.maxSize.value && (z(s, { code: M.too_big, maximum: n.maxSize.value, type: "set", inclusive: !0, exact: !1, message: n.maxSize.message }), r.dirty());
    const e = this._def.valueType;
    function i(u) {
      const l = /* @__PURE__ */ new Set();
      for (const c of u) {
        if (c.status === "aborted") return ne;
        c.status === "dirty" && r.dirty(), l.add(c.value);
      }
      return { status: r.value, value: l };
    }
    const o = [...s.data.values()].map((u, l) => e._parse(new Pt(s, u, s.path, l)));
    return s.common.async ? Promise.all(o).then((u) => i(u)) : i(o);
  }
  min(a, r) {
    return new rr({ ...this._def, minSize: { value: a, message: Y.toString(r) } });
  }
  max(a, r) {
    return new rr({ ...this._def, maxSize: { value: a, message: Y.toString(r) } });
  }
  size(a, r) {
    return this.min(a, r).max(a, r);
  }
  nonempty(a) {
    return this.min(1, a);
  }
}
rr.create = (t, a) => new rr({ valueType: t, minSize: null, maxSize: null, typeName: ee.ZodSet, ...oe(a) });
class ma extends fe {
  get schema() {
    return this._def.getter();
  }
  _parse(a) {
    const { ctx: r } = this._processInputParams(a);
    return this._def.getter()._parse({ data: r.data, path: r.path, parent: r });
  }
}
ma.create = (t, a) => new ma({ getter: t, typeName: ee.ZodLazy, ...oe(a) });
class Wi extends fe {
  _parse(a) {
    if (a.data !== this._def.value) {
      const r = this._getOrReturnCtx(a);
      return z(r, { received: r.data, code: M.invalid_literal, expected: this._def.value }), ne;
    }
    return { status: "valid", value: a.data };
  }
  get value() {
    return this._def.value;
  }
}
function Mo(t, a) {
  return new Cn({ values: t, typeName: ee.ZodEnum, ...oe(a) });
}
Wi.create = (t, a) => new Wi({ value: t, typeName: ee.ZodLiteral, ...oe(a) });
class Cn extends fe {
  _parse(a) {
    if (typeof a.data != "string") {
      const r = this._getOrReturnCtx(a), s = this._def.values;
      return z(r, { expected: xe.joinValues(s), received: r.parsedType, code: M.invalid_type }), ne;
    }
    if (this._cache || (this._cache = new Set(this._def.values)), !this._cache.has(a.data)) {
      const r = this._getOrReturnCtx(a), s = this._def.values;
      return z(r, { received: r.data, code: M.invalid_enum_value, options: s }), ne;
    }
    return yt(a.data);
  }
  get options() {
    return this._def.values;
  }
  get enum() {
    const a = {};
    for (const r of this._def.values) a[r] = r;
    return a;
  }
  get Values() {
    const a = {};
    for (const r of this._def.values) a[r] = r;
    return a;
  }
  get Enum() {
    const a = {};
    for (const r of this._def.values) a[r] = r;
    return a;
  }
  extract(a, r = this._def) {
    return Cn.create(a, { ...this._def, ...r });
  }
  exclude(a, r = this._def) {
    return Cn.create(this.options.filter((s) => !a.includes(s)), { ...this._def, ...r });
  }
}
Cn.create = Mo;
class ba extends fe {
  _parse(a) {
    const r = xe.getValidEnumValues(this._def.values), s = this._getOrReturnCtx(a);
    if (s.parsedType !== J.string && s.parsedType !== J.number) {
      const n = xe.objectValues(r);
      return z(s, { expected: xe.joinValues(n), received: s.parsedType, code: M.invalid_type }), ne;
    }
    if (this._cache || (this._cache = new Set(xe.getValidEnumValues(this._def.values))), !this._cache.has(a.data)) {
      const n = xe.objectValues(r);
      return z(s, { received: s.data, code: M.invalid_enum_value, options: n }), ne;
    }
    return yt(a.data);
  }
  get enum() {
    return this._def.values;
  }
}
ba.create = (t, a) => new ba({ values: t, typeName: ee.ZodNativeEnum, ...oe(a) });
class Jr extends fe {
  unwrap() {
    return this._def.type;
  }
  _parse(a) {
    const { ctx: r } = this._processInputParams(a);
    if (r.parsedType !== J.promise && r.common.async === !1) return z(r, { code: M.invalid_type, expected: J.promise, received: r.parsedType }), ne;
    const s = r.parsedType === J.promise ? r.data : Promise.resolve(r.data);
    return yt(s.then((n) => this._def.type.parseAsync(n, { path: r.path, errorMap: r.common.contextualErrorMap })));
  }
}
Jr.create = (t, a) => new Jr({ type: t, typeName: ee.ZodPromise, ...oe(a) });
class bn extends fe {
  innerType() {
    return this._def.schema;
  }
  sourceType() {
    return this._def.schema._def.typeName === ee.ZodEffects ? this._def.schema.sourceType() : this._def.schema;
  }
  _parse(a) {
    const { status: r, ctx: s } = this._processInputParams(a), n = this._def.effect || null, e = { addIssue: (i) => {
      z(s, i), i.fatal ? r.abort() : r.dirty();
    }, get path() {
      return s.path;
    } };
    if (e.addIssue = e.addIssue.bind(e), n.type === "preprocess") {
      const i = n.transform(s.data, e);
      if (s.common.async) return Promise.resolve(i).then(async (o) => {
        if (r.value === "aborted") return ne;
        const u = await this._def.schema._parseAsync({ data: o, path: s.path, parent: s });
        return u.status === "aborted" ? ne : u.status === "dirty" || r.value === "dirty" ? Gi(u.value) : u;
      });
      {
        if (r.value === "aborted") return ne;
        const o = this._def.schema._parseSync({ data: i, path: s.path, parent: s });
        return o.status === "aborted" ? ne : o.status === "dirty" || r.value === "dirty" ? Gi(o.value) : o;
      }
    }
    if (n.type === "refinement") {
      const i = (o) => {
        const u = n.refinement(o, e);
        if (s.common.async) return Promise.resolve(u);
        if (u instanceof Promise) throw new Error("Async refinement encountered during synchronous parse operation. Use .parseAsync instead.");
        return o;
      };
      if (s.common.async === !1) {
        const o = this._def.schema._parseSync({ data: s.data, path: s.path, parent: s });
        return o.status === "aborted" ? ne : (o.status === "dirty" && r.dirty(), i(o.value), { status: r.value, value: o.value });
      }
      return this._def.schema._parseAsync({ data: s.data, path: s.path, parent: s }).then((o) => o.status === "aborted" ? ne : (o.status === "dirty" && r.dirty(), i(o.value).then(() => ({ status: r.value, value: o.value }))));
    }
    if (n.type === "transform") {
      if (s.common.async === !1) {
        const i = this._def.schema._parseSync({ data: s.data, path: s.path, parent: s });
        if (!Tn(i)) return ne;
        const o = n.transform(i.value, e);
        if (o instanceof Promise) throw new Error("Asynchronous transform encountered during synchronous parse operation. Use .parseAsync instead.");
        return { status: r.value, value: o };
      }
      return this._def.schema._parseAsync({ data: s.data, path: s.path, parent: s }).then((i) => Tn(i) ? Promise.resolve(n.transform(i.value, e)).then((o) => ({ status: r.value, value: o })) : ne);
    }
    xe.assertNever(n);
  }
}
bn.create = (t, a, r) => new bn({ schema: t, typeName: ee.ZodEffects, effect: a, ...oe(r) }), bn.createWithPreprocess = (t, a, r) => new bn({ schema: a, effect: { type: "preprocess", transform: t }, typeName: ee.ZodEffects, ...oe(r) });
class Zt extends fe {
  _parse(a) {
    return this._getType(a) === J.undefined ? yt(void 0) : this._def.innerType._parse(a);
  }
  unwrap() {
    return this._def.innerType;
  }
}
Zt.create = (t, a) => new Zt({ innerType: t, typeName: ee.ZodOptional, ...oe(a) });
class xn extends fe {
  _parse(a) {
    return this._getType(a) === J.null ? yt(null) : this._def.innerType._parse(a);
  }
  unwrap() {
    return this._def.innerType;
  }
}
xn.create = (t, a) => new xn({ innerType: t, typeName: ee.ZodNullable, ...oe(a) });
class qi extends fe {
  _parse(a) {
    const { ctx: r } = this._processInputParams(a);
    let s = r.data;
    return r.parsedType === J.undefined && (s = this._def.defaultValue()), this._def.innerType._parse({ data: s, path: r.path, parent: r });
  }
  removeDefault() {
    return this._def.innerType;
  }
}
qi.create = (t, a) => new qi({ innerType: t, typeName: ee.ZodDefault, defaultValue: typeof a.default == "function" ? a.default : () => a.default, ...oe(a) });
class Ji extends fe {
  _parse(a) {
    const { ctx: r } = this._processInputParams(a), s = { ...r, common: { ...r.common, issues: [] } }, n = this._def.innerType._parse({ data: s.data, path: s.path, parent: { ...s } });
    return Hr(n) ? n.then((e) => ({ status: "valid", value: e.status === "valid" ? e.value : this._def.catchValue({ get error() {
      return new Ft(s.common.issues);
    }, input: s.data }) })) : { status: "valid", value: n.status === "valid" ? n.value : this._def.catchValue({ get error() {
      return new Ft(s.common.issues);
    }, input: s.data }) };
  }
  removeCatch() {
    return this._def.innerType;
  }
}
Ji.create = (t, a) => new Ji({ innerType: t, typeName: ee.ZodCatch, catchValue: typeof a.catch == "function" ? a.catch : () => a.catch, ...oe(a) });
class Sa extends fe {
  _parse(a) {
    if (this._getType(a) !== J.nan) {
      const r = this._getOrReturnCtx(a);
      return z(r, { code: M.invalid_type, expected: J.nan, received: r.parsedType }), ne;
    }
    return { status: "valid", value: a.data };
  }
}
Sa.create = (t) => new Sa({ typeName: ee.ZodNaN, ...oe(t) });
class hh extends fe {
  _parse(a) {
    const { ctx: r } = this._processInputParams(a), s = r.data;
    return this._def.type._parse({ data: s, path: r.path, parent: r });
  }
  unwrap() {
    return this._def.type;
  }
}
class ds extends fe {
  _parse(a) {
    const { status: r, ctx: s } = this._processInputParams(a);
    if (s.common.async) return (async () => {
      const n = await this._def.in._parseAsync({ data: s.data, path: s.path, parent: s });
      return n.status === "aborted" ? ne : n.status === "dirty" ? (r.dirty(), Gi(n.value)) : this._def.out._parseAsync({ data: n.value, path: s.path, parent: s });
    })();
    {
      const n = this._def.in._parseSync({ data: s.data, path: s.path, parent: s });
      return n.status === "aborted" ? ne : n.status === "dirty" ? (r.dirty(), { status: "dirty", value: n.value }) : this._def.out._parseSync({ data: n.value, path: s.path, parent: s });
    }
  }
  static create(a, r) {
    return new ds({ in: a, out: r, typeName: ee.ZodPipeline });
  }
}
class Yi extends fe {
  _parse(a) {
    const r = this._def.innerType._parse(a), s = (n) => (Tn(n) && (n.value = Object.freeze(n.value)), n);
    return Hr(r) ? r.then((n) => s(n)) : s(r);
  }
  unwrap() {
    return this._def.innerType;
  }
}
var ee;
Yi.create = (t, a) => new Yi({ innerType: t, typeName: ee.ZodReadonly, ...oe(a) }), function(t) {
  t.ZodString = "ZodString", t.ZodNumber = "ZodNumber", t.ZodNaN = "ZodNaN", t.ZodBigInt = "ZodBigInt", t.ZodBoolean = "ZodBoolean", t.ZodDate = "ZodDate", t.ZodSymbol = "ZodSymbol", t.ZodUndefined = "ZodUndefined", t.ZodNull = "ZodNull", t.ZodAny = "ZodAny", t.ZodUnknown = "ZodUnknown", t.ZodNever = "ZodNever", t.ZodVoid = "ZodVoid", t.ZodArray = "ZodArray", t.ZodObject = "ZodObject", t.ZodUnion = "ZodUnion", t.ZodDiscriminatedUnion = "ZodDiscriminatedUnion", t.ZodIntersection = "ZodIntersection", t.ZodTuple = "ZodTuple", t.ZodRecord = "ZodRecord", t.ZodMap = "ZodMap", t.ZodSet = "ZodSet", t.ZodFunction = "ZodFunction", t.ZodLazy = "ZodLazy", t.ZodLiteral = "ZodLiteral", t.ZodEnum = "ZodEnum", t.ZodEffects = "ZodEffects", t.ZodNativeEnum = "ZodNativeEnum", t.ZodOptional = "ZodOptional", t.ZodNullable = "ZodNullable", t.ZodDefault = "ZodDefault", t.ZodCatch = "ZodCatch", t.ZodPromise = "ZodPromise", t.ZodBranded = "ZodBranded", t.ZodPipeline = "ZodPipeline", t.ZodReadonly = "ZodReadonly";
}(ee || (ee = {}));
const A = jt.create, Z = En.create, ot = Hi.create, Be = (Yt.create, kt.create), Q = Qe.create, Tr = Wr.create, hs = (qr.create, sn.create, cs.create), Zi = Wi.create, Ce = Cn.create;
Jr.create, Zt.create, xn.create;
var Fo = Z().min(0).max(_n).refine(function(t) {
  return Math.abs(Math.round(10 * t) - 10 * t) < 1e-6;
}, { message: "score must be a multiple of 0.1" }), Vo = Ce(["N", "C"]);
Q({ status: Ce(["confirmed", "inferred", "unmapped"]), confidence: Ce(["high", "medium", "low"]), signals: Be(A()), confirmedBy: A().nullable(), confirmedAt: A().nullable(), source: Ce(["reviewer", "auto"]) });
var zo = Q({ id: A().optional(), type: Vo.default("N"), movementNumber: Z().int().positive(), description: A(), directive: A().optional(), location: A().optional(), coefficient: Z().min(0.01).max(10), section: Ce(["technical", "artistic", "quality"]).optional() }), fh = Q({ id: A().optional(), type: Vo.default("C"), movementNumber: Z().int().positive(), name: A(), directive: A().optional(), coefficient: Z().min(0.01).max(10) }), vh = zo.extend({ displayOrder: Z() }), ph = Q({ added: Be(vh).default([]), removed: Be(Z().int().positive()).default([]) }), Bo = ["standard", "small", "both"], Go = Q({ standard: Z().int().positive().nullable().optional(), small: Z().int().positive().nullable().optional() }), gh = Q({ arena: Ce(Bo).nullable().optional(), averageRideTime: Go.nullable().optional() });
Q({ id: A(), fvdId: Tr([Z(), A()]).nullable().optional(), source: Ce(["catalog", "custom"]).optional(), testCode: A(), organization: A().optional(), level: A().optional(), testNumber: Z().int().optional(), movements: Be(zo), collectives: Be(fh), arena: Ce(Bo).nullable().optional(), averageRideTime: Go.nullable().optional(), purpose: A().optional(), introduce: A().optional(), otherDeductions: Be(Q({ label: A(), unit: Ce(["points", "percent"]), value: Z().positive(), target: Ce(Uo), cumulative: ot().optional(), maxOccurrences: Z().int().positive().nullable().optional(), note: A().optional() })).optional(), errorRule: Q({ unit: Ce(["points", "percent"]).optional(), first: Tr([Z(), A()]).nullable().optional(), second: Tr([Z(), A()]).nullable().optional(), third: Tr([Z(), A()]).nullable().optional() }).nullable().optional(), collectivesLabel: A().default("Collective Marks"), commentMode: Ce(["perMovement", "generalOnly"]).default("perMovement"), hasRideTiming: ot().default(!0), sheetLayout: Ce(["movement-grid", "class-grid"]).default("movement-grid"), observations: Be(Q({ key: A(), group: A(), label: A(), optional: Zi(!0) })).default([]), panel: Q({ minJudges: Z().int().positive(), maxJudges: Z().int().positive(), consensus: ot().default(!1), judgeFloor: Z().int().positive().optional(), judgeFloorRule: A().optional() }).optional(), placing: Q({ source: Ce(["computed", "judge-entered"]).default("computed"), tieBreak: Ce(["standard", "none", "ride-off", "movement-totals"]).default("standard") }).optional(), publication: Q({ scoreSheet: Ce(["public", "suppressed"]).default("public"), rule: A().optional() }).optional() });
var mh = Q({ movementNumber: Z().int().positive(), score: Fo.optional().nullable(), remarks: A().max(500).optional(), flagged: ot().default(!1), annotatedDirective: A().optional(), annotatedDescription: A().optional(), deductions: Be(Q({ id: A(), reason: A(), points: Z().positive().optional(), percent: Z().positive().optional() }).refine(function(t) {
  return t.points !== void 0 != (t.percent !== void 0);
}, { message: "A deduction carries exactly one of points or percent" })).optional() }), bh = Q({ score: Fo.optional(), remarks: A().max(500).optional(), flagged: ot().optional(), annotatedName: A().optional(), annotatedDirective: A().optional() }), Sh = hs(A().regex(/^\d+$/), bh), wh = Q({ id: A(), movementNumber: Z().int().nullable().optional(), text: A().min(1).max(1e3), addedBy: A().nullable(), addedAt: A() });
Q({ id: A().optional(), rideId: A(), judgeId: A(), testId: A(), movementScores: Be(mh).default([]), collectives: Sh.default({}), annotations: Be(wh).default([]), annotatedPurpose: A().optional(), annotatedIntroduce: A().optional(), generalRemarks: A().max(2e3).optional(), entryTimeSeconds: Z().nonnegative().optional(), totalPoints: Z().optional(), maxPoints: Z().optional(), percentage: Z().nullable().optional(), observationMarks: hs(A(), Z()).optional(), place: Z().int().positive().nullable().optional(), placeSource: Ce(["auto", "scribe"]).nullable().optional(), technicalPoints: Z().optional(), technicalMaxPoints: Z().optional(), artisticPoints: Z().optional(), artisticMaxPoints: Z().optional(), qualityPoints: Z().optional(), qualityMaxPoints: Z().optional(), judgeSignature: A().optional(), signature: Q({ judgeId: A(), signatureHash: A(), signedAt: A() }).optional(), signatures: Be(Q({ judgeId: A(), signatureHash: A(), signedAt: A() })).optional(), compositeSignatures: Be(Q({ realJudgeId: A(), role: A().optional(), signatureHash: A(), signedAt: A() })).optional(), authoritative: ot().optional(), contenderOf: A().nullable().optional(), contenderPending: A().optional(), createKey: A().optional(), provenance: Q({ origin: Ce(["scribe", "admin", "fvd"]), author: A().nullable(), capturedAt: A(), device: A().nullable().optional(), method: Ce([pi.SCRIBE_LIVE, pi.ADMIN_PAPER, pi.RECONSTRUCTED]).optional() }).optional(), eliminations: Be(Q({ id: A(), reason: A(), movementNumber: Z().int().positive().nullable().optional(), fromError: ot().optional() })).optional(), errors: Be(Q({ id: A(), label: A(), points: Z().nonnegative().optional(), percent: Z().nonnegative().optional(), movementNumber: Z().int().positive().nullable().optional(), amountSource: Ce([Rr.RULE, Rr.MANUAL, Rr.OTHER_DEDUCTION]).optional(), target: Ce(Uo).optional() }).superRefine(function(t, a) {
  t.amountSource === Rr.OTHER_DEDUCTION ? (t.target || a.addIssue({ code: "custom", path: ["target"], message: "target is required on an otherDeduction occurrence" }), t.points === void 0 == (t.percent === void 0) && a.addIssue({ code: "custom", path: ["points"], message: "exactly one of points or percent is required on an otherDeduction occurrence" })) : t.target !== void 0 && a.addIssue({ code: "custom", path: ["target"], message: "target is only allowed on an otherDeduction occurrence" });
})).optional(), marksConfirmedAt: A().optional(), marksConfirmedBy: A().optional(), timeFault: Q({ exceeded: ot(), elapsedSeconds: Z(), limitSeconds: Z(), recordedAt: A() }).optional(), numericOnly: ot().optional(), noSignatureNeeded: ot().optional(), completedAt: A().optional(), version: Z().int().nonnegative().optional() });
Ce(Ao);
var wa = Q(Object.fromEntries(Ao.map(function(t) {
  return [t, Be(A()).optional()];
})));
Q({ id: A(), showId: A(), testId: A().optional(), testIdOverride: Q({ testId: A(), testName: A().nullable().optional(), reason: A().nullable().optional(), setBy: A().nullable().optional(), setAt: A().optional() }).optional(), className: A(), scheduledTime: A(), ring: A().optional(), judgeAssignments: wa.optional(), judgeIds: Be(A()).optional(), scribeAssignments: wa.optional(), qualityJudging: Q({ topology: Ce(["two-judge", "technical-only"]), qualityPosition: Ce(["E", "B"]).nullable().optional(), qualityJudge: A().nullable().optional(), technicalSeats: Z().int().min(1).max(5).nullable().optional(), qualitySeats: Z().int().min(1).max(5).nullable().optional() }).optional(), faultTimeLimitSeconds: Z().int().positive().default(45), errorDeductionScheme: Ce(Object.values(Jn)).default(Jn.POINTS), sectionJudgeAssignments: Q({ technical: A().nullable().optional(), quality: A().nullable().optional(), technicalJudges: Be(A()).max(5).optional(), qualityJudges: Be(A()).max(5).optional() }).optional(), expectedJudgeCountOverride: Q({ count: Z().int().positive(), reason: A().nullable().optional(), setBy: A().nullable().optional(), setAt: A().optional() }).optional(), walkTrotOnly: ot().default(!1), placesAwarded: Z().int().positive().optional(), hidden: ot().optional(), hiddenAutoSetAt: A().optional(), splitSection: ot().optional(), order: Z().optional(), testDisagreement: Q({ flagged: Zi(!0), signals: Be(Ce(Object.values(Bd))).min(1) }).nullable().optional(), qualityJudgingUnset: Zi(!0).nullable().optional(), sponsorId: A().nullable().optional(), prize: A().nullable().optional(), testOverrides: gh.nullable().optional() });
var yh = Q({ id: A(), type: Ce(Object.values(ls)), raisedByScribeId: A().nullable(), raisedByName: A().optional(), raisedAt: A(), acknowledged: Q({ byScribeId: A().nullable(), at: A() }).nullable().optional() });
Q({ type: Ce(Object.values(ls)) });
var Rh = Q({ eventId: A(), type: Ce(Object.values(ls)), clearedByScribeId: A().nullable(), clearedAt: A() });
Q({ id: A(), classId: A(), testId: A().optional(), testIdOverride: Q({ testId: A(), testName: A().nullable().optional(), reason: A().nullable().optional(), setBy: A().nullable().optional(), setAt: A().optional() }).optional(), horseId: A(), riderId: A(), rideNumber: Z().int().positive(), scheduledTime: A().optional(), status: A().optional(), percentage: Z().optional(), priorScore: Z().nullable().optional(), allSheetsCompletedAt: A().nullable().optional(), subsection: Z().int().positive().nullable().optional(), subsectionOrder: Z().int().nonnegative().nullable().optional(), subsectionEvents: Be(Q({ id: A(), at: A(), by: A().nullable(), from: Q({ subsection: Z().nullable(), subsectionOrder: Z().nullable() }), to: Q({ subsection: Z().nullable(), subsectionOrder: Z().nullable() }) })).optional(), adminConfirmedAt: A().nullable().optional(), adminConfirmedBy: A().nullable().optional(), compositePercentage: Z().nullable().optional(), placing: Z().int().positive().nullable().optional(), isManual: ot().optional(), needsReview: ot().optional(), judgeIds: Be(A()).optional(), competitorNumber: A().optional(), horseName: A().optional(), riderName: A().optional(), trainerId: A().optional(), coachId: A().optional(), resolvedIntoRideId: A().nullable().optional(), filledFromRideId: A().nullable().optional(), utilityEvents: Be(yh).optional(), utilityEventClears: Be(Rh).optional(), movementOverride: ph.optional(), placingStaleAt: A().nullable().optional(), fvdWriteBackBlockedByOverride: ot().nullable().optional(), noScoreRecorded: Q({ id: A(), reason: A(), by: A().nullable().optional(), at: A(), active: ot() }).nullable().optional(), noScoreRecordedEvents: Be(Q({ id: A(), action: Ce(["marked", "undone"]), reason: A(), by: A().nullable().optional(), at: A(), active: ot() })).optional(), terminationReason: Q({ reason: Ce(Object.values(gn)), setAt: A(), setBy: A().nullable().optional(), source: A() }).nullable().optional() });
Q({ classId: A(), showId: A().optional(), scheduledTime: A().optional(), testId: A().optional(), competitorNumber: A().optional(), horseName: A().optional(), riderName: A().optional(), createKey: A().min(1).max(200).optional(), deviceId: A().min(1).max(200).optional() });
Q({ id: A(), personType: Ce(["RIDER", "JUDGE", "SCRIBE"]), firstName: A(), lastName: A(), usefId: A().optional(), usdfId: A().optional(), email: A().optional(), scoresheetRecipients: hs(A(), Be(A())).optional(), unlockCode: A().regex(/^\d{4,6}$/, "unlockCode must be 4–6 digits").optional(), userId: A().optional() });
Q({ id: A(), name: A(), breed: A().optional(), foalYear: Z().int().optional(), usefId: A().optional(), usdfId: A().optional() });
const S = (ya = { default: () => rs.default }, bi = {}, qn.d(bi, ya), bi);
var ya, bi;
function Ho(t, a) {
  if (!(t instanceof a)) throw new TypeError("Cannot call a class as a function");
}
function Ki(t, a, r) {
  return Ki = fs() ? Reflect.construct : function(s, n, e) {
    var i = [null];
    i.push.apply(i, n);
    var o = new (Function.bind.apply(s, i))();
    return e && sr(o, e.prototype), o;
  }, Ki.apply(null, arguments);
}
function Dr(t, a, r) {
  return a in t ? Object.defineProperty(t, a, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : t[a] = r, t;
}
function ir(t) {
  return ir = Object.setPrototypeOf ? Object.getPrototypeOf : function(a) {
    return a.__proto__ || Object.getPrototypeOf(a);
  }, ir(t);
}
function sr(t, a) {
  return sr = Object.setPrototypeOf || function(r, s) {
    return r.__proto__ = s, r;
  }, sr(t, a);
}
function Qi(t) {
  var a = typeof Map == "function" ? /* @__PURE__ */ new Map() : void 0;
  return Qi = function(r) {
    if (r === null || (s = r, Function.toString.call(s).indexOf("[native code]") === -1)) return r;
    var s;
    if (typeof r != "function") throw new TypeError("Super expression must either be null or a function");
    if (a !== void 0) {
      if (a.has(r)) return a.get(r);
      a.set(r, n);
    }
    function n() {
      return Ki(r, arguments, ir(this).constructor);
    }
    return n.prototype = Object.create(r.prototype, { constructor: { value: n, enumerable: !1, writable: !0, configurable: !0 } }), sr(n, r);
  }, Qi(t);
}
function fs() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (fs = function() {
    return !!t;
  })();
}
var w = "http://localhost".replace(/\/+$/, ""), Le = function t(a) {
  var r, s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : w, n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : S.default;
  Ho(this, t), Dr(this, "basePath", void 0), Dr(this, "axios", void 0), Dr(this, "configuration", void 0), this.basePath = s, this.axios = n, a && (this.configuration = a, this.basePath = (r = a.basePath) !== null && r !== void 0 ? r : s);
}, Ih = function() {
  function t(a, r) {
    var s;
    return Ho(this, t), Dr(s = function(n, e, i) {
      return e = ir(e), o = n, !(u = fs() ? Reflect.construct(e, i || [], ir(n).constructor) : e.apply(n, i)) || ((l = u) && typeof Symbol < "u" && l.constructor === Symbol ? "symbol" : typeof l) != "object" && typeof u != "function" ? function(c) {
        if (c === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return c;
      }(o) : u;
      var o, u, l;
    }(this, t, [r]), "field", void 0), s.field = a, s.name = "RequiredError", s;
  }
  return function(a, r) {
    if (typeof r != "function" && r !== null) throw new TypeError("Super expression must either be null or a function");
    a.prototype = Object.create(r && r.prototype, { constructor: { value: a, writable: !0, configurable: !0 } }), r && sr(a, r);
  }(t, Qi(Error)), t;
}(), y = {};
function Ra(t, a, r, s, n, e, i) {
  try {
    var o = t[e](i), u = o.value;
  } catch (l) {
    return void r(l);
  }
  o.done ? a(u) : Promise.resolve(u).then(s, n);
}
function _h(t, a, r) {
  return a in t ? Object.defineProperty(t, a, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : t[a] = r, t;
}
var R = "https://example.com", b = function(t, a, r) {
  if (r == null) throw new Ih(a, "Required parameter ".concat(a, " was null or undefined when calling ").concat(t, "."));
}, E = function(t, a) {
  return (r = function() {
    var s, n;
    return function(e, i) {
      var o, u, l, c = { label: 0, sent: function() {
        if (1 & l[0]) throw l[1];
        return l[1];
      }, trys: [], ops: [] }, d = Object.create((typeof Iterator == "function" ? Iterator : Object).prototype);
      return d.next = h(0), d.throw = h(1), d.return = h(2), typeof Symbol == "function" && (d[Symbol.iterator] = function() {
        return this;
      }), d;
      function h(g) {
        return function(U) {
          return function(P) {
            if (o) throw new TypeError("Generator is already executing.");
            for (; d && (d = 0, P[0] && (c = 0)), c; ) try {
              if (o = 1, u && (l = 2 & P[0] ? u.return : P[0] ? u.throw || ((l = u.return) && l.call(u), 0) : u.next) && !(l = l.call(u, P[1])).done) return l;
              switch (u = 0, l && (P = [2 & P[0], l.value]), P[0]) {
                case 0:
                case 1:
                  l = P;
                  break;
                case 4:
                  return c.label++, { value: P[1], done: !1 };
                case 5:
                  c.label++, u = P[1], P = [0];
                  continue;
                case 7:
                  P = c.ops.pop(), c.trys.pop();
                  continue;
                default:
                  if (!((l = (l = c.trys).length > 0 && l[l.length - 1]) || P[0] !== 6 && P[0] !== 2)) {
                    c = 0;
                    continue;
                  }
                  if (P[0] === 3 && (!l || P[1] > l[0] && P[1] < l[3])) {
                    c.label = P[1];
                    break;
                  }
                  if (P[0] === 6 && c.label < l[1]) {
                    c.label = l[1], l = P;
                    break;
                  }
                  if (l && c.label < l[2]) {
                    c.label = l[2], c.ops.push(P);
                    break;
                  }
                  l[2] && c.ops.pop(), c.trys.pop();
                  continue;
              }
              P = i.call(e, c);
            } catch (D) {
              P = [6, D], u = 0;
            } finally {
              o = l = 0;
            }
            if (5 & P[0]) throw P[1];
            return { value: P[0] ? P[1] : void 0, done: !0 };
          }([g, U]);
        };
      }
    }(this, function(e) {
      switch (e.label) {
        case 0:
          return a && a.accessToken ? typeof a.accessToken != "function" ? [3, 2] : [4, a.accessToken()] : [3, 5];
        case 1:
          return n = e.sent(), [3, 4];
        case 2:
          return [4, a.accessToken];
        case 3:
          n = e.sent(), e.label = 4;
        case 4:
          s = n, t.Authorization = "Bearer " + s, e.label = 5;
        case 5:
          return [2];
      }
    });
  }, function() {
    var s = this, n = arguments;
    return new Promise(function(e, i) {
      var o = r.apply(s, n);
      function u(c) {
        Ra(o, e, i, u, l, "next", c);
      }
      function l(c) {
        Ra(o, e, i, u, l, "throw", c);
      }
      u(void 0);
    });
  })();
  var r;
};
function Xi(t, a) {
  var r, s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "";
  a != null && ((a === void 0 ? "undefined" : (r = a) && typeof Symbol < "u" && r.constructor === Symbol ? "symbol" : typeof r) == "object" ? Array.isArray(a) ? a.forEach(function(n) {
    return Xi(t, n, s);
  }) : Object.keys(a).forEach(function(n) {
    return Xi(t, a[n], "".concat(s).concat(s !== "" ? "." : "").concat(n));
  }) : t.has(s) ? t.append(s, a) : t.set(s, a));
}
var I = function(t) {
  for (var a = arguments.length, r = new Array(a > 1 ? a - 1 : 0), s = 1; s < a; s++) r[s - 1] = arguments[s];
  var n = new URLSearchParams(t.search);
  Xi(n, r), t.search = n.toString();
}, N = function(t, a, r) {
  var s = typeof t != "string";
  return (s && r && r.isJsonMime ? r.isJsonMime(a.headers["Content-Type"]) : s) ? JSON.stringify(t !== void 0 ? t : {}) : t || "";
}, _ = function(t) {
  return t.pathname + t.search + t.hash;
}, T = function(t, a, r, s) {
  return function() {
    var n, e, i, o = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : a, u = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : r, l = (e = function(c) {
      for (var d = 1; d < arguments.length; d++) {
        var h = arguments[d] != null ? arguments[d] : {}, g = Object.keys(h);
        typeof Object.getOwnPropertySymbols == "function" && (g = g.concat(Object.getOwnPropertySymbols(h).filter(function(U) {
          return Object.getOwnPropertyDescriptor(h, U).enumerable;
        }))), g.forEach(function(U) {
          _h(c, U, h[U]);
        });
      }
      return c;
    }({}, t.options), i = (i = { url: (o.defaults.baseURL ? "" : (n = s == null ? void 0 : s.basePath) !== null && n !== void 0 ? n : u) + t.url }) != null ? i : {}, Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(i)) : function(c) {
      var d = Object.keys(c);
      if (Object.getOwnPropertySymbols) {
        var h = Object.getOwnPropertySymbols(c);
        d.push.apply(d, h);
      }
      return d;
    }(Object(i)).forEach(function(c) {
      Object.defineProperty(e, c, Object.getOwnPropertyDescriptor(i, c));
    }), e);
    return o.request(l);
  };
};
function Ia(t, a, r, s, n, e, i) {
  try {
    var o = t[e](i), u = o.value;
  } catch (l) {
    return void r(l);
  }
  o.done ? a(u) : Promise.resolve(u).then(s, n);
}
function v(t) {
  return function() {
    var a = this, r = arguments;
    return new Promise(function(s, n) {
      var e = t.apply(a, r);
      function i(u) {
        Ia(e, s, n, i, o, "next", u);
      }
      function o(u) {
        Ia(e, s, n, i, o, "throw", u);
      }
      i(void 0);
    });
  };
}
function je(t, a, r) {
  return a = Yr(a), s = t, !(n = $o() ? Reflect.construct(a, r || [], Yr(t).constructor) : a.apply(t, r)) || ((e = n) && typeof Symbol < "u" && e.constructor === Symbol ? "symbol" : typeof e) != "object" && typeof n != "function" ? function(i) {
    if (i === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return i;
  }(s) : n;
  var s, n, e;
}
function Me(t, a) {
  if (!(t instanceof a)) throw new TypeError("Cannot call a class as a function");
}
function Th(t, a) {
  for (var r = 0; r < a.length; r++) {
    var s = a[r];
    s.enumerable = s.enumerable || !1, s.configurable = !0, "value" in s && (s.writable = !0), Object.defineProperty(t, s.key, s);
  }
}
function Fe(t, a, r) {
  return a && Th(t.prototype, a), t;
}
function Eh(t, a, r) {
  return a in t ? Object.defineProperty(t, a, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : t[a] = r, t;
}
function Yr(t) {
  return Yr = Object.setPrototypeOf ? Object.getPrototypeOf : function(a) {
    return a.__proto__ || Object.getPrototypeOf(a);
  }, Yr(t);
}
function Ve(t, a) {
  if (typeof a != "function" && a !== null) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(a && a.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), a && es(t, a);
}
function f(t) {
  for (var a = 1; a < arguments.length; a++) {
    var r = arguments[a] != null ? arguments[a] : {}, s = Object.keys(r);
    typeof Object.getOwnPropertySymbols == "function" && (s = s.concat(Object.getOwnPropertySymbols(r).filter(function(n) {
      return Object.getOwnPropertyDescriptor(r, n).enumerable;
    }))), s.forEach(function(n) {
      Eh(t, n, r[n]);
    });
  }
  return t;
}
function es(t, a) {
  return es = Object.setPrototypeOf || function(r, s) {
    return r.__proto__ = s, r;
  }, es(t, a);
}
function $o() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return ($o = function() {
    return !!t;
  })();
}
function p(t, a) {
  var r, s, n, e = { label: 0, sent: function() {
    if (1 & n[0]) throw n[1];
    return n[1];
  }, trys: [], ops: [] }, i = Object.create((typeof Iterator == "function" ? Iterator : Object).prototype);
  return i.next = o(0), i.throw = o(1), i.return = o(2), typeof Symbol == "function" && (i[Symbol.iterator] = function() {
    return this;
  }), i;
  function o(u) {
    return function(l) {
      return function(c) {
        if (r) throw new TypeError("Generator is already executing.");
        for (; i && (i = 0, c[0] && (e = 0)), e; ) try {
          if (r = 1, s && (n = 2 & c[0] ? s.return : c[0] ? s.throw || ((n = s.return) && n.call(s), 0) : s.next) && !(n = n.call(s, c[1])).done) return n;
          switch (s = 0, n && (c = [2 & c[0], n.value]), c[0]) {
            case 0:
            case 1:
              n = c;
              break;
            case 4:
              return e.label++, { value: c[1], done: !1 };
            case 5:
              e.label++, s = c[1], c = [0];
              continue;
            case 7:
              c = e.ops.pop(), e.trys.pop();
              continue;
            default:
              if (!((n = (n = e.trys).length > 0 && n[n.length - 1]) || c[0] !== 6 && c[0] !== 2)) {
                e = 0;
                continue;
              }
              if (c[0] === 3 && (!n || c[1] > n[0] && c[1] < n[3])) {
                e.label = c[1];
                break;
              }
              if (c[0] === 6 && e.label < n[1]) {
                e.label = n[1], n = c;
                break;
              }
              if (n && e.label < n[2]) {
                e.label = n[2], e.ops.push(c);
                break;
              }
              n[2] && e.ops.pop(), e.trys.pop();
              continue;
          }
          c = a.call(t, e);
        } catch (d) {
          c = [6, d], s = 0;
        } finally {
          r = n = 0;
        }
        if (5 & c[0]) throw c[1];
        return { value: c[0] ? c[1] : void 0, done: !0 };
      }([u, l]);
    };
  }
}
var Ch = function(t) {
  return { listBreaks: function(a, r) {
    var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return v(function() {
      var n, e, i, o, u, l;
      return p(this, function(c) {
        switch (c.label) {
          case 0:
            return b("listBreaks", "showId", a), n = new URL("/break", R), t && (e = t.baseOptions), i = f({ method: "GET" }, e, s), u = {}, [4, E(o = {}, t)];
          case 1:
            return c.sent(), a !== void 0 && (u.showId = a), r !== void 0 && (u.ring = r), I(n, u), l = e && e.headers ? e.headers : {}, i.headers = f({}, o, l, s.headers), [2, { url: _(n), options: i }];
        }
      });
    })();
  } };
}, xh = function(t) {
  var a = Ch(t);
  return { listBreaks: function(r, s, n) {
    return v(function() {
      var e, i, o, u, l, c;
      return p(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, a.listBreaks(r, s, n)];
          case 1:
            return o = d.sent(), l = (u = t == null ? void 0 : t.serverIndex) !== null && u !== void 0 ? u : 0, c = (i = y["BreaksApi.listBreaks"]) === null || i === void 0 || (e = i[l]) === null || e === void 0 ? void 0 : e.url, [2, function(h, g) {
              return T(o, S.default, w, t)(h, c || g);
            }];
        }
      });
    })();
  } };
};
(function(t) {
  function a() {
    return Me(this, a), je(this, a, arguments);
  }
  return Ve(a, t), Fe(a, [{ key: "listBreaks", value: function(r, s, n) {
    var e = this;
    return xh(this.configuration).listBreaks(r, s, n).then(function(i) {
      return i(e.axios, e.basePath);
    });
  } }]), a;
})(Le);
var Oh = function(t) {
  return { getCatalogTest: function(a) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return v(function() {
      var s, n, e, i, o, u, l;
      return p(this, function(c) {
        switch (c.label) {
          case 0:
            return b("getCatalogTest", "id", a), s = "/catalog/{id}".replace("{id}", encodeURIComponent(String(a))), n = new URL(s, R), t && (e = t.baseOptions), i = f({ method: "GET" }, e, r), u = {}, [4, E(o = {}, t)];
          case 1:
            return c.sent(), I(n, u), l = e && e.headers ? e.headers : {}, i.headers = f({}, o, l, r.headers), [2, { url: _(n), options: i }];
        }
      });
    })();
  }, listCatalog: function() {
    var a = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return v(function() {
      var r, s, n, e, i, o;
      return p(this, function(u) {
        switch (u.label) {
          case 0:
            return r = new URL("/catalog", R), t && (s = t.baseOptions), n = f({ method: "GET" }, s, a), i = {}, [4, E(e = {}, t)];
          case 1:
            return u.sent(), I(r, i), o = s && s.headers ? s.headers : {}, n.headers = f({}, e, o, a.headers), [2, { url: _(r), options: n }];
        }
      });
    })();
  }, patchCatalogTest: function(a, r) {
    var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return v(function() {
      var n, e, i, o, u, l, c;
      return p(this, function(d) {
        switch (d.label) {
          case 0:
            return b("patchCatalogTest", "id", a), n = "/catalog/{id}".replace("{id}", encodeURIComponent(String(a))), e = new URL(n, R), t && (i = t.baseOptions), o = f({ method: "PATCH" }, i, s), l = {}, [4, E(u = {}, t)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", I(e, l), c = i && i.headers ? i.headers : {}, o.headers = f({}, u, c, s.headers), o.data = N(r, o, t), [2, { url: _(e), options: o }];
        }
      });
    })();
  } };
}, Si = function(t) {
  var a = Oh(t);
  return { getCatalogTest: function(r, s) {
    return v(function() {
      var n, e, i, o, u, l;
      return p(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, a.getCatalogTest(r, s)];
          case 1:
            return i = c.sent(), u = (o = t == null ? void 0 : t.serverIndex) !== null && o !== void 0 ? o : 0, l = (e = y["CatalogApi.getCatalogTest"]) === null || e === void 0 || (n = e[u]) === null || n === void 0 ? void 0 : n.url, [2, function(d, h) {
              return T(i, S.default, w, t)(d, l || h);
            }];
        }
      });
    })();
  }, listCatalog: function(r) {
    return v(function() {
      var s, n, e, i, o, u;
      return p(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, a.listCatalog(r)];
          case 1:
            return e = l.sent(), o = (i = t == null ? void 0 : t.serverIndex) !== null && i !== void 0 ? i : 0, u = (n = y["CatalogApi.listCatalog"]) === null || n === void 0 || (s = n[o]) === null || s === void 0 ? void 0 : s.url, [2, function(c, d) {
              return T(e, S.default, w, t)(c, u || d);
            }];
        }
      });
    })();
  }, patchCatalogTest: function(r, s, n) {
    return v(function() {
      var e, i, o, u, l, c;
      return p(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, a.patchCatalogTest(r, s, n)];
          case 1:
            return o = d.sent(), l = (u = t == null ? void 0 : t.serverIndex) !== null && u !== void 0 ? u : 0, c = (i = y["CatalogApi.patchCatalogTest"]) === null || i === void 0 || (e = i[l]) === null || e === void 0 ? void 0 : e.url, [2, function(h, g) {
              return T(o, S.default, w, t)(h, c || g);
            }];
        }
      });
    })();
  } };
};
(function(t) {
  function a() {
    return Me(this, a), je(this, a, arguments);
  }
  return Ve(a, t), Fe(a, [{ key: "getCatalogTest", value: function(r, s) {
    var n = this;
    return Si(this.configuration).getCatalogTest(r, s).then(function(e) {
      return e(n.axios, n.basePath);
    });
  } }, { key: "listCatalog", value: function(r) {
    var s = this;
    return Si(this.configuration).listCatalog(r).then(function(n) {
      return n(s.axios, s.basePath);
    });
  } }, { key: "patchCatalogTest", value: function(r, s, n) {
    var e = this;
    return Si(this.configuration).patchCatalogTest(r, s, n).then(function(i) {
      return i(e.axios, e.basePath);
    });
  } }]), a;
})(Le);
var kh = function(t) {
  return { bulkUpdateClassConfig: function(a) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return v(function() {
      var s, n, e, i, o, u;
      return p(this, function(l) {
        switch (l.label) {
          case 0:
            return b("bulkUpdateClassConfig", "bulkUpdateClassConfigRequest", a), s = new URL("/class/bulk-config", R), t && (n = t.baseOptions), e = f({ method: "POST" }, n, r), o = {}, [4, E(i = {}, t)];
          case 1:
            return l.sent(), i["Content-Type"] = "application/json", I(s, o), u = n && n.headers ? n.headers : {}, e.headers = f({}, i, u, r.headers), e.data = N(a, e, t), [2, { url: _(s), options: e }];
        }
      });
    })();
  }, getChampionshipFillOptions: function(a) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return v(function() {
      var s, n, e, i, o, u, l;
      return p(this, function(c) {
        switch (c.label) {
          case 0:
            return b("getChampionshipFillOptions", "classId", a), s = "/class/{classId}/championship-fill-options".replace("{classId}", encodeURIComponent(String(a))), n = new URL(s, R), t && (e = t.baseOptions), i = f({ method: "GET" }, e, r), u = {}, [4, E(o = {}, t)];
          case 1:
            return c.sent(), I(n, u), l = e && e.headers ? e.headers : {}, i.headers = f({}, o, l, r.headers), [2, { url: _(n), options: i }];
        }
      });
    })();
  }, getClass: function(a) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return v(function() {
      var s, n, e, i, o, u, l;
      return p(this, function(c) {
        switch (c.label) {
          case 0:
            return b("getClass", "classId", a), s = "/class/{classId}".replace("{classId}", encodeURIComponent(String(a))), n = new URL(s, R), t && (e = t.baseOptions), i = f({ method: "GET" }, e, r), u = {}, [4, E(o = {}, t)];
          case 1:
            return c.sent(), I(n, u), l = e && e.headers ? e.headers : {}, i.headers = f({}, o, l, r.headers), [2, { url: _(n), options: i }];
        }
      });
    })();
  }, getClassPlacesAwarded: function(a) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return v(function() {
      var s, n, e, i, o, u, l;
      return p(this, function(c) {
        switch (c.label) {
          case 0:
            return b("getClassPlacesAwarded", "classId", a), s = "/class/{classId}/places-awarded".replace("{classId}", encodeURIComponent(String(a))), n = new URL(s, R), t && (e = t.baseOptions), i = f({ method: "GET" }, e, r), u = {}, [4, E(o = {}, t)];
          case 1:
            return c.sent(), I(n, u), l = e && e.headers ? e.headers : {}, i.headers = f({}, o, l, r.headers), [2, { url: _(n), options: i }];
        }
      });
    })();
  }, listClasses: function(a, r) {
    var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return v(function() {
      var n, e, i, o, u, l;
      return p(this, function(c) {
        switch (c.label) {
          case 0:
            return b("listClasses", "showId", a), n = new URL("/class", R), t && (e = t.baseOptions), i = f({ method: "GET" }, e, s), u = {}, [4, E(o = {}, t)];
          case 1:
            return c.sent(), a !== void 0 && (u.showId = a), r !== void 0 && (u.mine = r), I(n, u), l = e && e.headers ? e.headers : {}, i.headers = f({}, o, l, s.headers), [2, { url: _(n), options: i }];
        }
      });
    })();
  }, listClassesForShows: function(a) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return v(function() {
      var s, n, e, i, o, u;
      return p(this, function(l) {
        switch (l.label) {
          case 0:
            return b("listClassesForShows", "listClassesForShowsRequest", a), s = new URL("/class/batch", R), t && (n = t.baseOptions), e = f({ method: "POST" }, n, r), o = {}, [4, E(i = {}, t)];
          case 1:
            return l.sent(), i["Content-Type"] = "application/json", I(s, o), u = n && n.headers ? n.headers : {}, e.headers = f({}, i, u, r.headers), e.data = N(a, e, t), [2, { url: _(s), options: e }];
        }
      });
    })();
  }, setClassAutoPlace: function(a, r) {
    var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return v(function() {
      var n, e, i, o, u, l, c;
      return p(this, function(d) {
        switch (d.label) {
          case 0:
            return b("setClassAutoPlace", "classId", a), b("setClassAutoPlace", "setClassAutoPlaceRequest", r), n = "/class/{classId}/auto-place".replace("{classId}", encodeURIComponent(String(a))), e = new URL(n, R), t && (i = t.baseOptions), o = f({ method: "PUT" }, i, s), l = {}, [4, E(u = {}, t)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", I(e, l), c = i && i.headers ? i.headers : {}, o.headers = f({}, u, c, s.headers), o.data = N(r, o, t), [2, { url: _(e), options: o }];
        }
      });
    })();
  }, setClassDshbKindOverride: function(a, r) {
    var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return v(function() {
      var n, e, i, o, u, l, c;
      return p(this, function(d) {
        switch (d.label) {
          case 0:
            return b("setClassDshbKindOverride", "classId", a), b("setClassDshbKindOverride", "setClassDshbKindOverrideRequest", r), n = "/class/{classId}/dshb-kind-override".replace("{classId}", encodeURIComponent(String(a))), e = new URL(n, R), t && (i = t.baseOptions), o = f({ method: "PUT" }, i, s), l = {}, [4, E(u = {}, t)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", I(e, l), c = i && i.headers ? i.headers : {}, o.headers = f({}, u, c, s.headers), o.data = N(r, o, t), [2, { url: _(e), options: o }];
        }
      });
    })();
  }, setClassErrorDeductionScheme: function(a, r) {
    var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return v(function() {
      var n, e, i, o, u, l, c;
      return p(this, function(d) {
        switch (d.label) {
          case 0:
            return b("setClassErrorDeductionScheme", "classId", a), b("setClassErrorDeductionScheme", "setClassErrorDeductionSchemeRequest", r), n = "/class/{classId}/error-deduction-scheme".replace("{classId}", encodeURIComponent(String(a))), e = new URL(n, R), t && (i = t.baseOptions), o = f({ method: "PUT" }, i, s), l = {}, [4, E(u = {}, t)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", I(e, l), c = i && i.headers ? i.headers : {}, o.headers = f({}, u, c, s.headers), o.data = N(r, o, t), [2, { url: _(e), options: o }];
        }
      });
    })();
  }, setClassExpectedJudgeCount: function(a, r) {
    var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return v(function() {
      var n, e, i, o, u, l, c;
      return p(this, function(d) {
        switch (d.label) {
          case 0:
            return b("setClassExpectedJudgeCount", "classId", a), b("setClassExpectedJudgeCount", "setClassExpectedJudgeCountRequest", r), n = "/class/{classId}/expected-judge-count".replace("{classId}", encodeURIComponent(String(a))), e = new URL(n, R), t && (i = t.baseOptions), o = f({ method: "PUT" }, i, s), l = {}, [4, E(u = {}, t)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", I(e, l), c = i && i.headers ? i.headers : {}, o.headers = f({}, u, c, s.headers), o.data = N(r, o, t), [2, { url: _(e), options: o }];
        }
      });
    })();
  }, setClassFaultTimeLimit: function(a, r) {
    var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return v(function() {
      var n, e, i, o, u, l, c;
      return p(this, function(d) {
        switch (d.label) {
          case 0:
            return b("setClassFaultTimeLimit", "classId", a), b("setClassFaultTimeLimit", "setClassFaultTimeLimitRequest", r), n = "/class/{classId}/fault-time-limit".replace("{classId}", encodeURIComponent(String(a))), e = new URL(n, R), t && (i = t.baseOptions), o = f({ method: "PUT" }, i, s), l = {}, [4, E(u = {}, t)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", I(e, l), c = i && i.headers ? i.headers : {}, o.headers = f({}, u, c, s.headers), o.data = N(r, o, t), [2, { url: _(e), options: o }];
        }
      });
    })();
  }, setClassFriendlyName: function(a, r) {
    var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return v(function() {
      var n, e, i, o, u, l, c;
      return p(this, function(d) {
        switch (d.label) {
          case 0:
            return b("setClassFriendlyName", "classId", a), b("setClassFriendlyName", "setClassFriendlyNameRequest", r), n = "/class/{classId}/friendly-name".replace("{classId}", encodeURIComponent(String(a))), e = new URL(n, R), t && (i = t.baseOptions), o = f({ method: "PUT" }, i, s), l = {}, [4, E(u = {}, t)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", I(e, l), c = i && i.headers ? i.headers : {}, o.headers = f({}, u, c, s.headers), o.data = N(r, o, t), [2, { url: _(e), options: o }];
        }
      });
    })();
  }, setClassHidden: function(a, r) {
    var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return v(function() {
      var n, e, i, o, u, l, c;
      return p(this, function(d) {
        switch (d.label) {
          case 0:
            return b("setClassHidden", "classId", a), b("setClassHidden", "setClassHiddenRequest", r), n = "/class/{classId}/hidden".replace("{classId}", encodeURIComponent(String(a))), e = new URL(n, R), t && (i = t.baseOptions), o = f({ method: "PUT" }, i, s), l = {}, [4, E(u = {}, t)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", I(e, l), c = i && i.headers ? i.headers : {}, o.headers = f({}, u, c, s.headers), o.data = N(r, o, t), [2, { url: _(e), options: o }];
        }
      });
    })();
  }, setClassPaperEntry: function(a, r) {
    var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return v(function() {
      var n, e, i, o, u, l, c;
      return p(this, function(d) {
        switch (d.label) {
          case 0:
            return b("setClassPaperEntry", "classId", a), b("setClassPaperEntry", "setClassPaperEntryRequest", r), n = "/class/{classId}/paper-entry".replace("{classId}", encodeURIComponent(String(a))), e = new URL(n, R), t && (i = t.baseOptions), o = f({ method: "PUT" }, i, s), l = {}, [4, E(u = {}, t)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", I(e, l), c = i && i.headers ? i.headers : {}, o.headers = f({}, u, c, s.headers), o.data = N(r, o, t), [2, { url: _(e), options: o }];
        }
      });
    })();
  }, setClassPlacedByDivision: function(a, r) {
    var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return v(function() {
      var n, e, i, o, u, l, c;
      return p(this, function(d) {
        switch (d.label) {
          case 0:
            return b("setClassPlacedByDivision", "classId", a), b("setClassPlacedByDivision", "setClassPlacedByDivisionRequest", r), n = "/class/{classId}/placed-by-division".replace("{classId}", encodeURIComponent(String(a))), e = new URL(n, R), t && (i = t.baseOptions), o = f({ method: "PUT" }, i, s), l = {}, [4, E(u = {}, t)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", I(e, l), c = i && i.headers ? i.headers : {}, o.headers = f({}, u, c, s.headers), o.data = N(r, o, t), [2, { url: _(e), options: o }];
        }
      });
    })();
  }, setClassPlacesAwarded: function(a, r) {
    var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return v(function() {
      var n, e, i, o, u, l, c;
      return p(this, function(d) {
        switch (d.label) {
          case 0:
            return b("setClassPlacesAwarded", "classId", a), b("setClassPlacesAwarded", "setClassPlacesAwardedRequest", r), n = "/class/{classId}/places-awarded".replace("{classId}", encodeURIComponent(String(a))), e = new URL(n, R), t && (i = t.baseOptions), o = f({ method: "PUT" }, i, s), l = {}, [4, E(u = {}, t)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", I(e, l), c = i && i.headers ? i.headers : {}, o.headers = f({}, u, c, s.headers), o.data = N(r, o, t), [2, { url: _(e), options: o }];
        }
      });
    })();
  }, setClassQualityJudging: function(a, r) {
    var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return v(function() {
      var n, e, i, o, u, l, c;
      return p(this, function(d) {
        switch (d.label) {
          case 0:
            return b("setClassQualityJudging", "classId", a), b("setClassQualityJudging", "setClassQualityJudgingRequest", r), n = "/class/{classId}/quality-judging".replace("{classId}", encodeURIComponent(String(a))), e = new URL(n, R), t && (i = t.baseOptions), o = f({ method: "PUT" }, i, s), l = {}, [4, E(u = {}, t)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", I(e, l), c = i && i.headers ? i.headers : {}, o.headers = f({}, u, c, s.headers), o.data = N(r, o, t), [2, { url: _(e), options: o }];
        }
      });
    })();
  }, setClassResultDwell: function(a, r) {
    var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return v(function() {
      var n, e, i, o, u, l, c;
      return p(this, function(d) {
        switch (d.label) {
          case 0:
            return b("setClassResultDwell", "classId", a), b("setClassResultDwell", "setClassResultDwellRequest", r), n = "/class/{classId}/result-dwell".replace("{classId}", encodeURIComponent(String(a))), e = new URL(n, R), t && (i = t.baseOptions), o = f({ method: "PUT" }, i, s), l = {}, [4, E(u = {}, t)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", I(e, l), c = i && i.headers ? i.headers : {}, o.headers = f({}, u, c, s.headers), o.data = N(r, o, t), [2, { url: _(e), options: o }];
        }
      });
    })();
  }, setClassScribeAssignment: function(a, r) {
    var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return v(function() {
      var n, e, i, o, u, l, c;
      return p(this, function(d) {
        switch (d.label) {
          case 0:
            return b("setClassScribeAssignment", "classId", a), b("setClassScribeAssignment", "setClassScribeAssignmentRequest", r), n = "/class/{classId}/scribe-assignments".replace("{classId}", encodeURIComponent(String(a))), e = new URL(n, R), t && (i = t.baseOptions), o = f({ method: "PUT" }, i, s), l = {}, [4, E(u = {}, t)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", I(e, l), c = i && i.headers ? i.headers : {}, o.headers = f({}, u, c, s.headers), o.data = N(r, o, t), [2, { url: _(e), options: o }];
        }
      });
    })();
  }, setClassSectionJudgeAssignments: function(a, r) {
    var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return v(function() {
      var n, e, i, o, u, l, c;
      return p(this, function(d) {
        switch (d.label) {
          case 0:
            return b("setClassSectionJudgeAssignments", "classId", a), n = "/class/{classId}/section-judge-assignments".replace("{classId}", encodeURIComponent(String(a))), e = new URL(n, R), t && (i = t.baseOptions), o = f({ method: "PUT" }, i, s), l = {}, [4, E(u = {}, t)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", I(e, l), c = i && i.headers ? i.headers : {}, o.headers = f({}, u, c, s.headers), o.data = N(r, o, t), [2, { url: _(e), options: o }];
        }
      });
    })();
  }, setClassSkipUsefUpload: function(a, r) {
    var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return v(function() {
      var n, e, i, o, u, l, c;
      return p(this, function(d) {
        switch (d.label) {
          case 0:
            return b("setClassSkipUsefUpload", "classId", a), b("setClassSkipUsefUpload", "setClassSkipUsefUploadRequest", r), n = "/class/{classId}/skip-usef-upload".replace("{classId}", encodeURIComponent(String(a))), e = new URL(n, R), t && (i = t.baseOptions), o = f({ method: "PUT" }, i, s), l = {}, [4, E(u = {}, t)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", I(e, l), c = i && i.headers ? i.headers : {}, o.headers = f({}, u, c, s.headers), o.data = N(r, o, t), [2, { url: _(e), options: o }];
        }
      });
    })();
  }, setClassSplitSection: function(a, r) {
    var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return v(function() {
      var n, e, i, o, u, l, c;
      return p(this, function(d) {
        switch (d.label) {
          case 0:
            return b("setClassSplitSection", "classId", a), b("setClassSplitSection", "setClassSplitSectionRequest", r), n = "/class/{classId}/split-section".replace("{classId}", encodeURIComponent(String(a))), e = new URL(n, R), t && (i = t.baseOptions), o = f({ method: "PUT" }, i, s), l = {}, [4, E(u = {}, t)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", I(e, l), c = i && i.headers ? i.headers : {}, o.headers = f({}, u, c, s.headers), o.data = N(r, o, t), [2, { url: _(e), options: o }];
        }
      });
    })();
  }, setClassSponsorPrizeDisplay: function(a, r) {
    var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return v(function() {
      var n, e, i, o, u, l, c;
      return p(this, function(d) {
        switch (d.label) {
          case 0:
            return b("setClassSponsorPrizeDisplay", "classId", a), n = "/class/{classId}/sponsor-prize-display".replace("{classId}", encodeURIComponent(String(a))), e = new URL(n, R), t && (i = t.baseOptions), o = f({ method: "PUT" }, i, s), l = {}, [4, E(u = {}, t)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", I(e, l), c = i && i.headers ? i.headers : {}, o.headers = f({}, u, c, s.headers), o.data = N(r, o, t), [2, { url: _(e), options: o }];
        }
      });
    })();
  }, setClassSponsorship: function(a, r) {
    var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return v(function() {
      var n, e, i, o, u, l, c;
      return p(this, function(d) {
        switch (d.label) {
          case 0:
            return b("setClassSponsorship", "classId", a), n = "/class/{classId}/sponsorship".replace("{classId}", encodeURIComponent(String(a))), e = new URL(n, R), t && (i = t.baseOptions), o = f({ method: "PUT" }, i, s), l = {}, [4, E(u = {}, t)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", I(e, l), c = i && i.headers ? i.headers : {}, o.headers = f({}, u, c, s.headers), o.data = N(r, o, t), [2, { url: _(e), options: o }];
        }
      });
    })();
  }, setClassTest: function(a, r) {
    var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return v(function() {
      var n, e, i, o, u, l, c;
      return p(this, function(d) {
        switch (d.label) {
          case 0:
            return b("setClassTest", "classId", a), b("setClassTest", "setClassTestRequest", r), n = "/class/{classId}/test".replace("{classId}", encodeURIComponent(String(a))), e = new URL(n, R), t && (i = t.baseOptions), o = f({ method: "PUT" }, i, s), l = {}, [4, E(u = {}, t)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", I(e, l), c = i && i.headers ? i.headers : {}, o.headers = f({}, u, c, s.headers), o.data = N(r, o, t), [2, { url: _(e), options: o }];
        }
      });
    })();
  }, setClassTestOverrides: function(a, r) {
    var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return v(function() {
      var n, e, i, o, u, l, c;
      return p(this, function(d) {
        switch (d.label) {
          case 0:
            return b("setClassTestOverrides", "classId", a), n = "/class/{classId}/test-overrides".replace("{classId}", encodeURIComponent(String(a))), e = new URL(n, R), t && (i = t.baseOptions), o = f({ method: "PUT" }, i, s), l = {}, [4, E(u = {}, t)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", I(e, l), c = i && i.headers ? i.headers : {}, o.headers = f({}, u, c, s.headers), o.data = N(r, o, t), [2, { url: _(e), options: o }];
        }
      });
    })();
  }, setClassWalkTrotOnly: function(a, r) {
    var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return v(function() {
      var n, e, i, o, u, l, c;
      return p(this, function(d) {
        switch (d.label) {
          case 0:
            return b("setClassWalkTrotOnly", "classId", a), b("setClassWalkTrotOnly", "setClassWalkTrotOnlyRequest", r), n = "/class/{classId}/walk-trot-only".replace("{classId}", encodeURIComponent(String(a))), e = new URL(n, R), t && (i = t.baseOptions), o = f({ method: "PUT" }, i, s), l = {}, [4, E(u = {}, t)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", I(e, l), c = i && i.headers ? i.headers : {}, o.headers = f({}, u, c, s.headers), o.data = N(r, o, t), [2, { url: _(e), options: o }];
        }
      });
    })();
  }, setRingScribeAssignments: function(a, r) {
    var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return v(function() {
      var n, e, i, o, u, l, c;
      return p(this, function(d) {
        switch (d.label) {
          case 0:
            return b("setRingScribeAssignments", "ring", a), b("setRingScribeAssignments", "setRingScribeAssignmentsRequest", r), n = "/ring/{ring}/scribe-assignments".replace("{ring}", encodeURIComponent(String(a))), e = new URL(n, R), t && (i = t.baseOptions), o = f({ method: "PUT" }, i, s), l = {}, [4, E(u = {}, t)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", I(e, l), c = i && i.headers ? i.headers : {}, o.headers = f({}, u, c, s.headers), o.data = N(r, o, t), [2, { url: _(e), options: o }];
        }
      });
    })();
  } };
}, Pe = function(t) {
  var a = kh(t);
  return { bulkUpdateClassConfig: function(r, s) {
    return v(function() {
      var n, e, i, o, u, l;
      return p(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, a.bulkUpdateClassConfig(r, s)];
          case 1:
            return i = c.sent(), u = (o = t == null ? void 0 : t.serverIndex) !== null && o !== void 0 ? o : 0, l = (e = y["ClassesApi.bulkUpdateClassConfig"]) === null || e === void 0 || (n = e[u]) === null || n === void 0 ? void 0 : n.url, [2, function(d, h) {
              return T(i, S.default, w, t)(d, l || h);
            }];
        }
      });
    })();
  }, getChampionshipFillOptions: function(r, s) {
    return v(function() {
      var n, e, i, o, u, l;
      return p(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, a.getChampionshipFillOptions(r, s)];
          case 1:
            return i = c.sent(), u = (o = t == null ? void 0 : t.serverIndex) !== null && o !== void 0 ? o : 0, l = (e = y["ClassesApi.getChampionshipFillOptions"]) === null || e === void 0 || (n = e[u]) === null || n === void 0 ? void 0 : n.url, [2, function(d, h) {
              return T(i, S.default, w, t)(d, l || h);
            }];
        }
      });
    })();
  }, getClass: function(r, s) {
    return v(function() {
      var n, e, i, o, u, l;
      return p(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, a.getClass(r, s)];
          case 1:
            return i = c.sent(), u = (o = t == null ? void 0 : t.serverIndex) !== null && o !== void 0 ? o : 0, l = (e = y["ClassesApi.getClass"]) === null || e === void 0 || (n = e[u]) === null || n === void 0 ? void 0 : n.url, [2, function(d, h) {
              return T(i, S.default, w, t)(d, l || h);
            }];
        }
      });
    })();
  }, getClassPlacesAwarded: function(r, s) {
    return v(function() {
      var n, e, i, o, u, l;
      return p(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, a.getClassPlacesAwarded(r, s)];
          case 1:
            return i = c.sent(), u = (o = t == null ? void 0 : t.serverIndex) !== null && o !== void 0 ? o : 0, l = (e = y["ClassesApi.getClassPlacesAwarded"]) === null || e === void 0 || (n = e[u]) === null || n === void 0 ? void 0 : n.url, [2, function(d, h) {
              return T(i, S.default, w, t)(d, l || h);
            }];
        }
      });
    })();
  }, listClasses: function(r, s, n) {
    return v(function() {
      var e, i, o, u, l, c;
      return p(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, a.listClasses(r, s, n)];
          case 1:
            return o = d.sent(), l = (u = t == null ? void 0 : t.serverIndex) !== null && u !== void 0 ? u : 0, c = (i = y["ClassesApi.listClasses"]) === null || i === void 0 || (e = i[l]) === null || e === void 0 ? void 0 : e.url, [2, function(h, g) {
              return T(o, S.default, w, t)(h, c || g);
            }];
        }
      });
    })();
  }, listClassesForShows: function(r, s) {
    return v(function() {
      var n, e, i, o, u, l;
      return p(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, a.listClassesForShows(r, s)];
          case 1:
            return i = c.sent(), u = (o = t == null ? void 0 : t.serverIndex) !== null && o !== void 0 ? o : 0, l = (e = y["ClassesApi.listClassesForShows"]) === null || e === void 0 || (n = e[u]) === null || n === void 0 ? void 0 : n.url, [2, function(d, h) {
              return T(i, S.default, w, t)(d, l || h);
            }];
        }
      });
    })();
  }, setClassAutoPlace: function(r, s, n) {
    return v(function() {
      var e, i, o, u, l, c;
      return p(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, a.setClassAutoPlace(r, s, n)];
          case 1:
            return o = d.sent(), l = (u = t == null ? void 0 : t.serverIndex) !== null && u !== void 0 ? u : 0, c = (i = y["ClassesApi.setClassAutoPlace"]) === null || i === void 0 || (e = i[l]) === null || e === void 0 ? void 0 : e.url, [2, function(h, g) {
              return T(o, S.default, w, t)(h, c || g);
            }];
        }
      });
    })();
  }, setClassDshbKindOverride: function(r, s, n) {
    return v(function() {
      var e, i, o, u, l, c;
      return p(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, a.setClassDshbKindOverride(r, s, n)];
          case 1:
            return o = d.sent(), l = (u = t == null ? void 0 : t.serverIndex) !== null && u !== void 0 ? u : 0, c = (i = y["ClassesApi.setClassDshbKindOverride"]) === null || i === void 0 || (e = i[l]) === null || e === void 0 ? void 0 : e.url, [2, function(h, g) {
              return T(o, S.default, w, t)(h, c || g);
            }];
        }
      });
    })();
  }, setClassErrorDeductionScheme: function(r, s, n) {
    return v(function() {
      var e, i, o, u, l, c;
      return p(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, a.setClassErrorDeductionScheme(r, s, n)];
          case 1:
            return o = d.sent(), l = (u = t == null ? void 0 : t.serverIndex) !== null && u !== void 0 ? u : 0, c = (i = y["ClassesApi.setClassErrorDeductionScheme"]) === null || i === void 0 || (e = i[l]) === null || e === void 0 ? void 0 : e.url, [2, function(h, g) {
              return T(o, S.default, w, t)(h, c || g);
            }];
        }
      });
    })();
  }, setClassExpectedJudgeCount: function(r, s, n) {
    return v(function() {
      var e, i, o, u, l, c;
      return p(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, a.setClassExpectedJudgeCount(r, s, n)];
          case 1:
            return o = d.sent(), l = (u = t == null ? void 0 : t.serverIndex) !== null && u !== void 0 ? u : 0, c = (i = y["ClassesApi.setClassExpectedJudgeCount"]) === null || i === void 0 || (e = i[l]) === null || e === void 0 ? void 0 : e.url, [2, function(h, g) {
              return T(o, S.default, w, t)(h, c || g);
            }];
        }
      });
    })();
  }, setClassFaultTimeLimit: function(r, s, n) {
    return v(function() {
      var e, i, o, u, l, c;
      return p(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, a.setClassFaultTimeLimit(r, s, n)];
          case 1:
            return o = d.sent(), l = (u = t == null ? void 0 : t.serverIndex) !== null && u !== void 0 ? u : 0, c = (i = y["ClassesApi.setClassFaultTimeLimit"]) === null || i === void 0 || (e = i[l]) === null || e === void 0 ? void 0 : e.url, [2, function(h, g) {
              return T(o, S.default, w, t)(h, c || g);
            }];
        }
      });
    })();
  }, setClassFriendlyName: function(r, s, n) {
    return v(function() {
      var e, i, o, u, l, c;
      return p(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, a.setClassFriendlyName(r, s, n)];
          case 1:
            return o = d.sent(), l = (u = t == null ? void 0 : t.serverIndex) !== null && u !== void 0 ? u : 0, c = (i = y["ClassesApi.setClassFriendlyName"]) === null || i === void 0 || (e = i[l]) === null || e === void 0 ? void 0 : e.url, [2, function(h, g) {
              return T(o, S.default, w, t)(h, c || g);
            }];
        }
      });
    })();
  }, setClassHidden: function(r, s, n) {
    return v(function() {
      var e, i, o, u, l, c;
      return p(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, a.setClassHidden(r, s, n)];
          case 1:
            return o = d.sent(), l = (u = t == null ? void 0 : t.serverIndex) !== null && u !== void 0 ? u : 0, c = (i = y["ClassesApi.setClassHidden"]) === null || i === void 0 || (e = i[l]) === null || e === void 0 ? void 0 : e.url, [2, function(h, g) {
              return T(o, S.default, w, t)(h, c || g);
            }];
        }
      });
    })();
  }, setClassPaperEntry: function(r, s, n) {
    return v(function() {
      var e, i, o, u, l, c;
      return p(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, a.setClassPaperEntry(r, s, n)];
          case 1:
            return o = d.sent(), l = (u = t == null ? void 0 : t.serverIndex) !== null && u !== void 0 ? u : 0, c = (i = y["ClassesApi.setClassPaperEntry"]) === null || i === void 0 || (e = i[l]) === null || e === void 0 ? void 0 : e.url, [2, function(h, g) {
              return T(o, S.default, w, t)(h, c || g);
            }];
        }
      });
    })();
  }, setClassPlacedByDivision: function(r, s, n) {
    return v(function() {
      var e, i, o, u, l, c;
      return p(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, a.setClassPlacedByDivision(r, s, n)];
          case 1:
            return o = d.sent(), l = (u = t == null ? void 0 : t.serverIndex) !== null && u !== void 0 ? u : 0, c = (i = y["ClassesApi.setClassPlacedByDivision"]) === null || i === void 0 || (e = i[l]) === null || e === void 0 ? void 0 : e.url, [2, function(h, g) {
              return T(o, S.default, w, t)(h, c || g);
            }];
        }
      });
    })();
  }, setClassPlacesAwarded: function(r, s, n) {
    return v(function() {
      var e, i, o, u, l, c;
      return p(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, a.setClassPlacesAwarded(r, s, n)];
          case 1:
            return o = d.sent(), l = (u = t == null ? void 0 : t.serverIndex) !== null && u !== void 0 ? u : 0, c = (i = y["ClassesApi.setClassPlacesAwarded"]) === null || i === void 0 || (e = i[l]) === null || e === void 0 ? void 0 : e.url, [2, function(h, g) {
              return T(o, S.default, w, t)(h, c || g);
            }];
        }
      });
    })();
  }, setClassQualityJudging: function(r, s, n) {
    return v(function() {
      var e, i, o, u, l, c;
      return p(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, a.setClassQualityJudging(r, s, n)];
          case 1:
            return o = d.sent(), l = (u = t == null ? void 0 : t.serverIndex) !== null && u !== void 0 ? u : 0, c = (i = y["ClassesApi.setClassQualityJudging"]) === null || i === void 0 || (e = i[l]) === null || e === void 0 ? void 0 : e.url, [2, function(h, g) {
              return T(o, S.default, w, t)(h, c || g);
            }];
        }
      });
    })();
  }, setClassResultDwell: function(r, s, n) {
    return v(function() {
      var e, i, o, u, l, c;
      return p(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, a.setClassResultDwell(r, s, n)];
          case 1:
            return o = d.sent(), l = (u = t == null ? void 0 : t.serverIndex) !== null && u !== void 0 ? u : 0, c = (i = y["ClassesApi.setClassResultDwell"]) === null || i === void 0 || (e = i[l]) === null || e === void 0 ? void 0 : e.url, [2, function(h, g) {
              return T(o, S.default, w, t)(h, c || g);
            }];
        }
      });
    })();
  }, setClassScribeAssignment: function(r, s, n) {
    return v(function() {
      var e, i, o, u, l, c;
      return p(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, a.setClassScribeAssignment(r, s, n)];
          case 1:
            return o = d.sent(), l = (u = t == null ? void 0 : t.serverIndex) !== null && u !== void 0 ? u : 0, c = (i = y["ClassesApi.setClassScribeAssignment"]) === null || i === void 0 || (e = i[l]) === null || e === void 0 ? void 0 : e.url, [2, function(h, g) {
              return T(o, S.default, w, t)(h, c || g);
            }];
        }
      });
    })();
  }, setClassSectionJudgeAssignments: function(r, s, n) {
    return v(function() {
      var e, i, o, u, l, c;
      return p(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, a.setClassSectionJudgeAssignments(r, s, n)];
          case 1:
            return o = d.sent(), l = (u = t == null ? void 0 : t.serverIndex) !== null && u !== void 0 ? u : 0, c = (i = y["ClassesApi.setClassSectionJudgeAssignments"]) === null || i === void 0 || (e = i[l]) === null || e === void 0 ? void 0 : e.url, [2, function(h, g) {
              return T(o, S.default, w, t)(h, c || g);
            }];
        }
      });
    })();
  }, setClassSkipUsefUpload: function(r, s, n) {
    return v(function() {
      var e, i, o, u, l, c;
      return p(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, a.setClassSkipUsefUpload(r, s, n)];
          case 1:
            return o = d.sent(), l = (u = t == null ? void 0 : t.serverIndex) !== null && u !== void 0 ? u : 0, c = (i = y["ClassesApi.setClassSkipUsefUpload"]) === null || i === void 0 || (e = i[l]) === null || e === void 0 ? void 0 : e.url, [2, function(h, g) {
              return T(o, S.default, w, t)(h, c || g);
            }];
        }
      });
    })();
  }, setClassSplitSection: function(r, s, n) {
    return v(function() {
      var e, i, o, u, l, c;
      return p(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, a.setClassSplitSection(r, s, n)];
          case 1:
            return o = d.sent(), l = (u = t == null ? void 0 : t.serverIndex) !== null && u !== void 0 ? u : 0, c = (i = y["ClassesApi.setClassSplitSection"]) === null || i === void 0 || (e = i[l]) === null || e === void 0 ? void 0 : e.url, [2, function(h, g) {
              return T(o, S.default, w, t)(h, c || g);
            }];
        }
      });
    })();
  }, setClassSponsorPrizeDisplay: function(r, s, n) {
    return v(function() {
      var e, i, o, u, l, c;
      return p(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, a.setClassSponsorPrizeDisplay(r, s, n)];
          case 1:
            return o = d.sent(), l = (u = t == null ? void 0 : t.serverIndex) !== null && u !== void 0 ? u : 0, c = (i = y["ClassesApi.setClassSponsorPrizeDisplay"]) === null || i === void 0 || (e = i[l]) === null || e === void 0 ? void 0 : e.url, [2, function(h, g) {
              return T(o, S.default, w, t)(h, c || g);
            }];
        }
      });
    })();
  }, setClassSponsorship: function(r, s, n) {
    return v(function() {
      var e, i, o, u, l, c;
      return p(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, a.setClassSponsorship(r, s, n)];
          case 1:
            return o = d.sent(), l = (u = t == null ? void 0 : t.serverIndex) !== null && u !== void 0 ? u : 0, c = (i = y["ClassesApi.setClassSponsorship"]) === null || i === void 0 || (e = i[l]) === null || e === void 0 ? void 0 : e.url, [2, function(h, g) {
              return T(o, S.default, w, t)(h, c || g);
            }];
        }
      });
    })();
  }, setClassTest: function(r, s, n) {
    return v(function() {
      var e, i, o, u, l, c;
      return p(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, a.setClassTest(r, s, n)];
          case 1:
            return o = d.sent(), l = (u = t == null ? void 0 : t.serverIndex) !== null && u !== void 0 ? u : 0, c = (i = y["ClassesApi.setClassTest"]) === null || i === void 0 || (e = i[l]) === null || e === void 0 ? void 0 : e.url, [2, function(h, g) {
              return T(o, S.default, w, t)(h, c || g);
            }];
        }
      });
    })();
  }, setClassTestOverrides: function(r, s, n) {
    return v(function() {
      var e, i, o, u, l, c;
      return p(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, a.setClassTestOverrides(r, s, n)];
          case 1:
            return o = d.sent(), l = (u = t == null ? void 0 : t.serverIndex) !== null && u !== void 0 ? u : 0, c = (i = y["ClassesApi.setClassTestOverrides"]) === null || i === void 0 || (e = i[l]) === null || e === void 0 ? void 0 : e.url, [2, function(h, g) {
              return T(o, S.default, w, t)(h, c || g);
            }];
        }
      });
    })();
  }, setClassWalkTrotOnly: function(r, s, n) {
    return v(function() {
      var e, i, o, u, l, c;
      return p(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, a.setClassWalkTrotOnly(r, s, n)];
          case 1:
            return o = d.sent(), l = (u = t == null ? void 0 : t.serverIndex) !== null && u !== void 0 ? u : 0, c = (i = y["ClassesApi.setClassWalkTrotOnly"]) === null || i === void 0 || (e = i[l]) === null || e === void 0 ? void 0 : e.url, [2, function(h, g) {
              return T(o, S.default, w, t)(h, c || g);
            }];
        }
      });
    })();
  }, setRingScribeAssignments: function(r, s, n) {
    return v(function() {
      var e, i, o, u, l, c;
      return p(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, a.setRingScribeAssignments(r, s, n)];
          case 1:
            return o = d.sent(), l = (u = t == null ? void 0 : t.serverIndex) !== null && u !== void 0 ? u : 0, c = (i = y["ClassesApi.setRingScribeAssignments"]) === null || i === void 0 || (e = i[l]) === null || e === void 0 ? void 0 : e.url, [2, function(h, g) {
              return T(o, S.default, w, t)(h, c || g);
            }];
        }
      });
    })();
  } };
};
(function(t) {
  function a() {
    return Me(this, a), je(this, a, arguments);
  }
  return Ve(a, t), Fe(a, [{ key: "bulkUpdateClassConfig", value: function(r, s) {
    var n = this;
    return Pe(this.configuration).bulkUpdateClassConfig(r, s).then(function(e) {
      return e(n.axios, n.basePath);
    });
  } }, { key: "getChampionshipFillOptions", value: function(r, s) {
    var n = this;
    return Pe(this.configuration).getChampionshipFillOptions(r, s).then(function(e) {
      return e(n.axios, n.basePath);
    });
  } }, { key: "getClass", value: function(r, s) {
    var n = this;
    return Pe(this.configuration).getClass(r, s).then(function(e) {
      return e(n.axios, n.basePath);
    });
  } }, { key: "getClassPlacesAwarded", value: function(r, s) {
    var n = this;
    return Pe(this.configuration).getClassPlacesAwarded(r, s).then(function(e) {
      return e(n.axios, n.basePath);
    });
  } }, { key: "listClasses", value: function(r, s, n) {
    var e = this;
    return Pe(this.configuration).listClasses(r, s, n).then(function(i) {
      return i(e.axios, e.basePath);
    });
  } }, { key: "listClassesForShows", value: function(r, s) {
    var n = this;
    return Pe(this.configuration).listClassesForShows(r, s).then(function(e) {
      return e(n.axios, n.basePath);
    });
  } }, { key: "setClassAutoPlace", value: function(r, s, n) {
    var e = this;
    return Pe(this.configuration).setClassAutoPlace(r, s, n).then(function(i) {
      return i(e.axios, e.basePath);
    });
  } }, { key: "setClassDshbKindOverride", value: function(r, s, n) {
    var e = this;
    return Pe(this.configuration).setClassDshbKindOverride(r, s, n).then(function(i) {
      return i(e.axios, e.basePath);
    });
  } }, { key: "setClassErrorDeductionScheme", value: function(r, s, n) {
    var e = this;
    return Pe(this.configuration).setClassErrorDeductionScheme(r, s, n).then(function(i) {
      return i(e.axios, e.basePath);
    });
  } }, { key: "setClassExpectedJudgeCount", value: function(r, s, n) {
    var e = this;
    return Pe(this.configuration).setClassExpectedJudgeCount(r, s, n).then(function(i) {
      return i(e.axios, e.basePath);
    });
  } }, { key: "setClassFaultTimeLimit", value: function(r, s, n) {
    var e = this;
    return Pe(this.configuration).setClassFaultTimeLimit(r, s, n).then(function(i) {
      return i(e.axios, e.basePath);
    });
  } }, { key: "setClassFriendlyName", value: function(r, s, n) {
    var e = this;
    return Pe(this.configuration).setClassFriendlyName(r, s, n).then(function(i) {
      return i(e.axios, e.basePath);
    });
  } }, { key: "setClassHidden", value: function(r, s, n) {
    var e = this;
    return Pe(this.configuration).setClassHidden(r, s, n).then(function(i) {
      return i(e.axios, e.basePath);
    });
  } }, { key: "setClassPaperEntry", value: function(r, s, n) {
    var e = this;
    return Pe(this.configuration).setClassPaperEntry(r, s, n).then(function(i) {
      return i(e.axios, e.basePath);
    });
  } }, { key: "setClassPlacedByDivision", value: function(r, s, n) {
    var e = this;
    return Pe(this.configuration).setClassPlacedByDivision(r, s, n).then(function(i) {
      return i(e.axios, e.basePath);
    });
  } }, { key: "setClassPlacesAwarded", value: function(r, s, n) {
    var e = this;
    return Pe(this.configuration).setClassPlacesAwarded(r, s, n).then(function(i) {
      return i(e.axios, e.basePath);
    });
  } }, { key: "setClassQualityJudging", value: function(r, s, n) {
    var e = this;
    return Pe(this.configuration).setClassQualityJudging(r, s, n).then(function(i) {
      return i(e.axios, e.basePath);
    });
  } }, { key: "setClassResultDwell", value: function(r, s, n) {
    var e = this;
    return Pe(this.configuration).setClassResultDwell(r, s, n).then(function(i) {
      return i(e.axios, e.basePath);
    });
  } }, { key: "setClassScribeAssignment", value: function(r, s, n) {
    var e = this;
    return Pe(this.configuration).setClassScribeAssignment(r, s, n).then(function(i) {
      return i(e.axios, e.basePath);
    });
  } }, { key: "setClassSectionJudgeAssignments", value: function(r, s, n) {
    var e = this;
    return Pe(this.configuration).setClassSectionJudgeAssignments(r, s, n).then(function(i) {
      return i(e.axios, e.basePath);
    });
  } }, { key: "setClassSkipUsefUpload", value: function(r, s, n) {
    var e = this;
    return Pe(this.configuration).setClassSkipUsefUpload(r, s, n).then(function(i) {
      return i(e.axios, e.basePath);
    });
  } }, { key: "setClassSplitSection", value: function(r, s, n) {
    var e = this;
    return Pe(this.configuration).setClassSplitSection(r, s, n).then(function(i) {
      return i(e.axios, e.basePath);
    });
  } }, { key: "setClassSponsorPrizeDisplay", value: function(r, s, n) {
    var e = this;
    return Pe(this.configuration).setClassSponsorPrizeDisplay(r, s, n).then(function(i) {
      return i(e.axios, e.basePath);
    });
  } }, { key: "setClassSponsorship", value: function(r, s, n) {
    var e = this;
    return Pe(this.configuration).setClassSponsorship(r, s, n).then(function(i) {
      return i(e.axios, e.basePath);
    });
  } }, { key: "setClassTest", value: function(r, s, n) {
    var e = this;
    return Pe(this.configuration).setClassTest(r, s, n).then(function(i) {
      return i(e.axios, e.basePath);
    });
  } }, { key: "setClassTestOverrides", value: function(r, s, n) {
    var e = this;
    return Pe(this.configuration).setClassTestOverrides(r, s, n).then(function(i) {
      return i(e.axios, e.basePath);
    });
  } }, { key: "setClassWalkTrotOnly", value: function(r, s, n) {
    var e = this;
    return Pe(this.configuration).setClassWalkTrotOnly(r, s, n).then(function(i) {
      return i(e.axios, e.basePath);
    });
  } }, { key: "setRingScribeAssignments", value: function(r, s, n) {
    var e = this;
    return Pe(this.configuration).setRingScribeAssignments(r, s, n).then(function(i) {
      return i(e.axios, e.basePath);
    });
  } }]), a;
})(Le);
var Ph = function(t) {
  return { acceptFvdPointer: function(a, r) {
    var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return v(function() {
      var n, e, i, o, u, l, c;
      return p(this, function(d) {
        switch (d.label) {
          case 0:
            return b("acceptFvdPointer", "rideId", a), b("acceptFvdPointer", "acceptFvdPointerRequest", r), n = "/ride/{rideId}/use-fvd-pointer".replace("{rideId}", encodeURIComponent(String(a))), e = new URL(n, R), t && (i = t.baseOptions), o = f({ method: "POST" }, i, s), l = {}, [4, E(u = {}, t)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", I(e, l), c = i && i.headers ? i.headers : {}, o.headers = f({}, u, c, s.headers), o.data = N(r, o, t), [2, { url: _(e), options: o }];
        }
      });
    })();
  }, getDaysheetLastReconcile: function(a) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return v(function() {
      var s, n, e, i, o, u, l;
      return p(this, function(c) {
        switch (c.label) {
          case 0:
            return b("getDaysheetLastReconcile", "showId", a), s = "/daysheet/{showId}/last-reconcile".replace("{showId}", encodeURIComponent(String(a))), n = new URL(s, R), t && (e = t.baseOptions), i = f({ method: "GET" }, e, r), u = {}, [4, E(o = {}, t)];
          case 1:
            return c.sent(), I(n, u), l = e && e.headers ? e.headers : {}, i.headers = f({}, o, l, r.headers), [2, { url: _(n), options: i }];
        }
      });
    })();
  }, getDaysheetReconcileStatus: function(a) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return v(function() {
      var s, n, e, i, o, u, l;
      return p(this, function(c) {
        switch (c.label) {
          case 0:
            return b("getDaysheetReconcileStatus", "showId", a), s = "/daysheet/{showId}/status".replace("{showId}", encodeURIComponent(String(a))), n = new URL(s, R), t && (e = t.baseOptions), i = f({ method: "GET" }, e, r), u = {}, [4, E(o = {}, t)];
          case 1:
            return c.sent(), I(n, u), l = e && e.headers ? e.headers : {}, i.headers = f({}, o, l, r.headers), [2, { url: _(n), options: i }];
        }
      });
    })();
  }, reconcileDaysheet: function(a) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return v(function() {
      var s, n, e, i, o, u, l;
      return p(this, function(c) {
        switch (c.label) {
          case 0:
            return b("reconcileDaysheet", "showId", a), s = "/daysheet/{showId}/reconcile".replace("{showId}", encodeURIComponent(String(a))), n = new URL(s, R), t && (e = t.baseOptions), i = f({ method: "POST" }, e, r), u = {}, [4, E(o = {}, t)];
          case 1:
            return c.sent(), I(n, u), l = e && e.headers ? e.headers : {}, i.headers = f({}, o, l, r.headers), [2, { url: _(n), options: i }];
        }
      });
    })();
  } };
}, Er = function(t) {
  var a = Ph(t);
  return { acceptFvdPointer: function(r, s, n) {
    return v(function() {
      var e, i, o, u, l, c;
      return p(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, a.acceptFvdPointer(r, s, n)];
          case 1:
            return o = d.sent(), l = (u = t == null ? void 0 : t.serverIndex) !== null && u !== void 0 ? u : 0, c = (i = y["DaySheetApi.acceptFvdPointer"]) === null || i === void 0 || (e = i[l]) === null || e === void 0 ? void 0 : e.url, [2, function(h, g) {
              return T(o, S.default, w, t)(h, c || g);
            }];
        }
      });
    })();
  }, getDaysheetLastReconcile: function(r, s) {
    return v(function() {
      var n, e, i, o, u, l;
      return p(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, a.getDaysheetLastReconcile(r, s)];
          case 1:
            return i = c.sent(), u = (o = t == null ? void 0 : t.serverIndex) !== null && o !== void 0 ? o : 0, l = (e = y["DaySheetApi.getDaysheetLastReconcile"]) === null || e === void 0 || (n = e[u]) === null || n === void 0 ? void 0 : n.url, [2, function(d, h) {
              return T(i, S.default, w, t)(d, l || h);
            }];
        }
      });
    })();
  }, getDaysheetReconcileStatus: function(r, s) {
    return v(function() {
      var n, e, i, o, u, l;
      return p(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, a.getDaysheetReconcileStatus(r, s)];
          case 1:
            return i = c.sent(), u = (o = t == null ? void 0 : t.serverIndex) !== null && o !== void 0 ? o : 0, l = (e = y["DaySheetApi.getDaysheetReconcileStatus"]) === null || e === void 0 || (n = e[u]) === null || n === void 0 ? void 0 : n.url, [2, function(d, h) {
              return T(i, S.default, w, t)(d, l || h);
            }];
        }
      });
    })();
  }, reconcileDaysheet: function(r, s) {
    return v(function() {
      var n, e, i, o, u, l;
      return p(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, a.reconcileDaysheet(r, s)];
          case 1:
            return i = c.sent(), u = (o = t == null ? void 0 : t.serverIndex) !== null && o !== void 0 ? o : 0, l = (e = y["DaySheetApi.reconcileDaysheet"]) === null || e === void 0 || (n = e[u]) === null || n === void 0 ? void 0 : n.url, [2, function(d, h) {
              return T(i, S.default, w, t)(d, l || h);
            }];
        }
      });
    })();
  } };
};
(function(t) {
  function a() {
    return Me(this, a), je(this, a, arguments);
  }
  return Ve(a, t), Fe(a, [{ key: "acceptFvdPointer", value: function(r, s, n) {
    var e = this;
    return Er(this.configuration).acceptFvdPointer(r, s, n).then(function(i) {
      return i(e.axios, e.basePath);
    });
  } }, { key: "getDaysheetLastReconcile", value: function(r, s) {
    var n = this;
    return Er(this.configuration).getDaysheetLastReconcile(r, s).then(function(e) {
      return e(n.axios, n.basePath);
    });
  } }, { key: "getDaysheetReconcileStatus", value: function(r, s) {
    var n = this;
    return Er(this.configuration).getDaysheetReconcileStatus(r, s).then(function(e) {
      return e(n.axios, n.basePath);
    });
  } }, { key: "reconcileDaysheet", value: function(r, s) {
    var n = this;
    return Er(this.configuration).reconcileDaysheet(r, s).then(function(e) {
      return e(n.axios, n.basePath);
    });
  } }]), a;
})(Le);
var Ah = function(t) {
  return { reseedDemo: function(a) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return v(function() {
      var s, n, e, i, o, u;
      return p(this, function(l) {
        switch (l.label) {
          case 0:
            return b("reseedDemo", "reseedDemoRequest", a), s = new URL("/demo/reseed", R), t && (n = t.baseOptions), e = f({ method: "POST" }, n, r), o = {}, [4, E(i = {}, t)];
          case 1:
            return l.sent(), i["Content-Type"] = "application/json", I(s, o), u = n && n.headers ? n.headers : {}, e.headers = f({}, i, u, r.headers), e.data = N(a, e, t), [2, { url: _(s), options: e }];
        }
      });
    })();
  } };
}, Uh = function(t) {
  var a = Ah(t);
  return { reseedDemo: function(r, s) {
    return v(function() {
      var n, e, i, o, u, l;
      return p(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, a.reseedDemo(r, s)];
          case 1:
            return i = c.sent(), u = (o = t == null ? void 0 : t.serverIndex) !== null && o !== void 0 ? o : 0, l = (e = y["DemoApi.reseedDemo"]) === null || e === void 0 || (n = e[u]) === null || n === void 0 ? void 0 : n.url, [2, function(d, h) {
              return T(i, S.default, w, t)(d, l || h);
            }];
        }
      });
    })();
  } };
};
(function(t) {
  function a() {
    return Me(this, a), je(this, a, arguments);
  }
  return Ve(a, t), Fe(a, [{ key: "reseedDemo", value: function(r, s) {
    var n = this;
    return Uh(this.configuration).reseedDemo(r, s).then(function(e) {
      return e(n.axios, n.basePath);
    });
  } }]), a;
})(Le);
var Nh = function(t) {
  return { getHealth: function() {
    var a = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return v(function() {
      var r, s, n, e, i;
      return p(this, function(o) {
        return r = new URL("/health", R), t && (s = t.baseOptions), n = f({ method: "GET" }, s, a), e = {}, I(r, {}), i = s && s.headers ? s.headers : {}, n.headers = f({}, e, i, a.headers), [2, { url: _(r), options: n }];
      });
    })();
  } };
}, Dh = function(t) {
  var a = Nh(t);
  return { getHealth: function(r) {
    return v(function() {
      var s, n, e, i, o, u;
      return p(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, a.getHealth(r)];
          case 1:
            return e = l.sent(), o = (i = t == null ? void 0 : t.serverIndex) !== null && i !== void 0 ? i : 0, u = (n = y["HealthApi.getHealth"]) === null || n === void 0 || (s = n[o]) === null || s === void 0 ? void 0 : s.url, [2, function(c, d) {
              return T(e, S.default, w, t)(c, u || d);
            }];
        }
      });
    })();
  } };
};
(function(t) {
  function a() {
    return Me(this, a), je(this, a, arguments);
  }
  return Ve(a, t), Fe(a, [{ key: "getHealth", value: function(r) {
    var s = this;
    return Dh(this.configuration).getHealth(r).then(function(n) {
      return n(s.axios, s.basePath);
    });
  } }]), a;
})(Le);
var Lh = function(t) {
  return { getHorse: function(a) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return v(function() {
      var s, n, e, i, o, u, l;
      return p(this, function(c) {
        switch (c.label) {
          case 0:
            return b("getHorse", "id", a), s = "/horse/{id}".replace("{id}", encodeURIComponent(String(a))), n = new URL(s, R), t && (e = t.baseOptions), i = f({ method: "GET" }, e, r), u = {}, [4, E(o = {}, t)];
          case 1:
            return c.sent(), I(n, u), l = e && e.headers ? e.headers : {}, i.headers = f({}, o, l, r.headers), [2, { url: _(n), options: i }];
        }
      });
    })();
  }, listHorses: function() {
    var a = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return v(function() {
      var r, s, n, e, i, o;
      return p(this, function(u) {
        switch (u.label) {
          case 0:
            return r = new URL("/horse", R), t && (s = t.baseOptions), n = f({ method: "GET" }, s, a), i = {}, [4, E(e = {}, t)];
          case 1:
            return u.sent(), I(r, i), o = s && s.headers ? s.headers : {}, n.headers = f({}, e, o, a.headers), [2, { url: _(r), options: n }];
        }
      });
    })();
  } };
}, _a = function(t) {
  var a = Lh(t);
  return { getHorse: function(r, s) {
    return v(function() {
      var n, e, i, o, u, l;
      return p(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, a.getHorse(r, s)];
          case 1:
            return i = c.sent(), u = (o = t == null ? void 0 : t.serverIndex) !== null && o !== void 0 ? o : 0, l = (e = y["HorsesApi.getHorse"]) === null || e === void 0 || (n = e[u]) === null || n === void 0 ? void 0 : n.url, [2, function(d, h) {
              return T(i, S.default, w, t)(d, l || h);
            }];
        }
      });
    })();
  }, listHorses: function(r) {
    return v(function() {
      var s, n, e, i, o, u;
      return p(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, a.listHorses(r)];
          case 1:
            return e = l.sent(), o = (i = t == null ? void 0 : t.serverIndex) !== null && i !== void 0 ? i : 0, u = (n = y["HorsesApi.listHorses"]) === null || n === void 0 || (s = n[o]) === null || s === void 0 ? void 0 : s.url, [2, function(c, d) {
              return T(e, S.default, w, t)(c, u || d);
            }];
        }
      });
    })();
  } };
};
(function(t) {
  function a() {
    return Me(this, a), je(this, a, arguments);
  }
  return Ve(a, t), Fe(a, [{ key: "getHorse", value: function(r, s) {
    var n = this;
    return _a(this.configuration).getHorse(r, s).then(function(e) {
      return e(n.axios, n.basePath);
    });
  } }, { key: "listHorses", value: function(r) {
    var s = this;
    return _a(this.configuration).listHorses(r).then(function(n) {
      return n(s.axios, s.basePath);
    });
  } }]), a;
})(Le);
var jh = function(t) {
  return { getInstanceConfig: function(a) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return v(function() {
      var s, n, e, i, o, u, l;
      return p(this, function(c) {
        switch (c.label) {
          case 0:
            return b("getInstanceConfig", "instanceId", a), s = "/instance/{instanceId}/config".replace("{instanceId}", encodeURIComponent(String(a))), n = new URL(s, R), t && (e = t.baseOptions), i = f({ method: "GET" }, e, r), u = {}, [4, E(o = {}, t)];
          case 1:
            return c.sent(), I(n, u), l = e && e.headers ? e.headers : {}, i.headers = f({}, o, l, r.headers), [2, { url: _(n), options: i }];
        }
      });
    })();
  }, listInstances: function() {
    var a = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return v(function() {
      var r, s, n, e, i, o;
      return p(this, function(u) {
        switch (u.label) {
          case 0:
            return r = new URL("/instance", R), t && (s = t.baseOptions), n = f({ method: "GET" }, s, a), i = {}, [4, E(e = {}, t)];
          case 1:
            return u.sent(), I(r, i), o = s && s.headers ? s.headers : {}, n.headers = f({}, e, o, a.headers), [2, { url: _(r), options: n }];
        }
      });
    })();
  }, postInstanceStatus: function(a, r) {
    var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return v(function() {
      var n, e, i, o, u, l, c;
      return p(this, function(d) {
        switch (d.label) {
          case 0:
            return b("postInstanceStatus", "instanceId", a), b("postInstanceStatus", "postInstanceStatusRequest", r), n = "/instance/{instanceId}/status".replace("{instanceId}", encodeURIComponent(String(a))), e = new URL(n, R), t && (i = t.baseOptions), o = f({ method: "POST" }, i, s), l = {}, [4, E(u = {}, t)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", I(e, l), c = i && i.headers ? i.headers : {}, o.headers = f({}, u, c, s.headers), o.data = N(r, o, t), [2, { url: _(e), options: o }];
        }
      });
    })();
  }, putInstanceConfig: function(a, r) {
    var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return v(function() {
      var n, e, i, o, u, l, c;
      return p(this, function(d) {
        switch (d.label) {
          case 0:
            return b("putInstanceConfig", "instanceId", a), b("putInstanceConfig", "putInstanceConfigRequest", r), n = "/instance/{instanceId}/config".replace("{instanceId}", encodeURIComponent(String(a))), e = new URL(n, R), t && (i = t.baseOptions), o = f({ method: "PUT" }, i, s), l = {}, [4, E(u = {}, t)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", I(e, l), c = i && i.headers ? i.headers : {}, o.headers = f({}, u, c, s.headers), o.data = N(r, o, t), [2, { url: _(e), options: o }];
        }
      });
    })();
  } };
}, Cr = function(t) {
  var a = jh(t);
  return { getInstanceConfig: function(r, s) {
    return v(function() {
      var n, e, i, o, u, l;
      return p(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, a.getInstanceConfig(r, s)];
          case 1:
            return i = c.sent(), u = (o = t == null ? void 0 : t.serverIndex) !== null && o !== void 0 ? o : 0, l = (e = y["InstanceApi.getInstanceConfig"]) === null || e === void 0 || (n = e[u]) === null || n === void 0 ? void 0 : n.url, [2, function(d, h) {
              return T(i, S.default, w, t)(d, l || h);
            }];
        }
      });
    })();
  }, listInstances: function(r) {
    return v(function() {
      var s, n, e, i, o, u;
      return p(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, a.listInstances(r)];
          case 1:
            return e = l.sent(), o = (i = t == null ? void 0 : t.serverIndex) !== null && i !== void 0 ? i : 0, u = (n = y["InstanceApi.listInstances"]) === null || n === void 0 || (s = n[o]) === null || s === void 0 ? void 0 : s.url, [2, function(c, d) {
              return T(e, S.default, w, t)(c, u || d);
            }];
        }
      });
    })();
  }, postInstanceStatus: function(r, s, n) {
    return v(function() {
      var e, i, o, u, l, c;
      return p(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, a.postInstanceStatus(r, s, n)];
          case 1:
            return o = d.sent(), l = (u = t == null ? void 0 : t.serverIndex) !== null && u !== void 0 ? u : 0, c = (i = y["InstanceApi.postInstanceStatus"]) === null || i === void 0 || (e = i[l]) === null || e === void 0 ? void 0 : e.url, [2, function(h, g) {
              return T(o, S.default, w, t)(h, c || g);
            }];
        }
      });
    })();
  }, putInstanceConfig: function(r, s, n) {
    return v(function() {
      var e, i, o, u, l, c;
      return p(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, a.putInstanceConfig(r, s, n)];
          case 1:
            return o = d.sent(), l = (u = t == null ? void 0 : t.serverIndex) !== null && u !== void 0 ? u : 0, c = (i = y["InstanceApi.putInstanceConfig"]) === null || i === void 0 || (e = i[l]) === null || e === void 0 ? void 0 : e.url, [2, function(h, g) {
              return T(o, S.default, w, t)(h, c || g);
            }];
        }
      });
    })();
  } };
};
(function(t) {
  function a() {
    return Me(this, a), je(this, a, arguments);
  }
  return Ve(a, t), Fe(a, [{ key: "getInstanceConfig", value: function(r, s) {
    var n = this;
    return Cr(this.configuration).getInstanceConfig(r, s).then(function(e) {
      return e(n.axios, n.basePath);
    });
  } }, { key: "listInstances", value: function(r) {
    var s = this;
    return Cr(this.configuration).listInstances(r).then(function(n) {
      return n(s.axios, s.basePath);
    });
  } }, { key: "postInstanceStatus", value: function(r, s, n) {
    var e = this;
    return Cr(this.configuration).postInstanceStatus(r, s, n).then(function(i) {
      return i(e.axios, e.basePath);
    });
  } }, { key: "putInstanceConfig", value: function(r, s, n) {
    var e = this;
    return Cr(this.configuration).putInstanceConfig(r, s, n).then(function(i) {
      return i(e.axios, e.basePath);
    });
  } }]), a;
})(Le);
var Mh = function(t) {
  return { createCompositeJudgeMap: function(a) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return v(function() {
      var s, n, e, i, o, u;
      return p(this, function(l) {
        switch (l.label) {
          case 0:
            return b("createCompositeJudgeMap", "createCompositeJudgeMapRequest", a), s = new URL("/composite-judge-map", R), t && (n = t.baseOptions), e = f({ method: "POST" }, n, r), o = {}, [4, E(i = {}, t)];
          case 1:
            return l.sent(), i["Content-Type"] = "application/json", I(s, o), u = n && n.headers ? n.headers : {}, e.headers = f({}, i, u, r.headers), e.data = N(a, e, t), [2, { url: _(s), options: e }];
        }
      });
    })();
  }, deleteCompositeJudgeMap: function(a) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return v(function() {
      var s, n, e, i, o, u, l;
      return p(this, function(c) {
        switch (c.label) {
          case 0:
            return b("deleteCompositeJudgeMap", "id", a), s = "/composite-judge-map/{id}".replace("{id}", encodeURIComponent(String(a))), n = new URL(s, R), t && (e = t.baseOptions), i = f({ method: "DELETE" }, e, r), u = {}, [4, E(o = {}, t)];
          case 1:
            return c.sent(), I(n, u), l = e && e.headers ? e.headers : {}, i.headers = f({}, o, l, r.headers), [2, { url: _(n), options: i }];
        }
      });
    })();
  }, deleteJudgeSignature: function(a) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return v(function() {
      var s, n, e, i, o, u, l;
      return p(this, function(c) {
        switch (c.label) {
          case 0:
            return b("deleteJudgeSignature", "id", a), s = "/judge/{id}/signature".replace("{id}", encodeURIComponent(String(a))), n = new URL(s, R), t && (e = t.baseOptions), i = f({ method: "DELETE" }, e, r), u = {}, [4, E(o = {}, t)];
          case 1:
            return c.sent(), I(n, u), l = e && e.headers ? e.headers : {}, i.headers = f({}, o, l, r.headers), [2, { url: _(n), options: i }];
        }
      });
    })();
  }, getCompositeJudgeMap: function(a) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return v(function() {
      var s, n, e, i, o, u, l;
      return p(this, function(c) {
        switch (c.label) {
          case 0:
            return b("getCompositeJudgeMap", "id", a), s = "/composite-judge-map/{id}".replace("{id}", encodeURIComponent(String(a))), n = new URL(s, R), t && (e = t.baseOptions), i = f({ method: "GET" }, e, r), u = {}, [4, E(o = {}, t)];
          case 1:
            return c.sent(), I(n, u), l = e && e.headers ? e.headers : {}, i.headers = f({}, o, l, r.headers), [2, { url: _(n), options: i }];
        }
      });
    })();
  }, listCompositeJudgeMaps: function(a) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return v(function() {
      var s, n, e, i, o, u;
      return p(this, function(l) {
        switch (l.label) {
          case 0:
            return b("listCompositeJudgeMaps", "showId", a), s = new URL("/composite-judge-map", R), t && (n = t.baseOptions), e = f({ method: "GET" }, n, r), o = {}, [4, E(i = {}, t)];
          case 1:
            return l.sent(), a !== void 0 && (o.showId = a), I(s, o), u = n && n.headers ? n.headers : {}, e.headers = f({}, i, u, r.headers), [2, { url: _(s), options: e }];
        }
      });
    })();
  }, listJudges: function(a) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return v(function() {
      var s, n, e, i, o, u;
      return p(this, function(l) {
        switch (l.label) {
          case 0:
            return b("listJudges", "showId", a), s = new URL("/judge", R), t && (n = t.baseOptions), e = f({ method: "GET" }, n, r), o = {}, [4, E(i = {}, t)];
          case 1:
            return l.sent(), a !== void 0 && (o.showId = a), I(s, o), u = n && n.headers ? n.headers : {}, e.headers = f({}, i, u, r.headers), [2, { url: _(s), options: e }];
        }
      });
    })();
  }, putJudgeSignature: function(a, r) {
    var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return v(function() {
      var n, e, i, o, u, l, c;
      return p(this, function(d) {
        switch (d.label) {
          case 0:
            return b("putJudgeSignature", "id", a), b("putJudgeSignature", "putJudgeSignatureRequest", r), n = "/judge/{id}/signature".replace("{id}", encodeURIComponent(String(a))), e = new URL(n, R), t && (i = t.baseOptions), o = f({ method: "POST" }, i, s), l = {}, [4, E(u = {}, t)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", I(e, l), c = i && i.headers ? i.headers : {}, o.headers = f({}, u, c, s.headers), o.data = N(r, o, t), [2, { url: _(e), options: o }];
        }
      });
    })();
  }, resolveJudgeComposite: function(a) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return v(function() {
      var s, n, e, i, o, u, l;
      return p(this, function(c) {
        switch (c.label) {
          case 0:
            return b("resolveJudgeComposite", "id", a), s = "/judge/{id}/resolve".replace("{id}", encodeURIComponent(String(a))), n = new URL(s, R), t && (e = t.baseOptions), i = f({ method: "GET" }, e, r), u = {}, [4, E(o = {}, t)];
          case 1:
            return c.sent(), I(n, u), l = e && e.headers ? e.headers : {}, i.headers = f({}, o, l, r.headers), [2, { url: _(n), options: i }];
        }
      });
    })();
  }, setJudgeUsefId: function(a, r) {
    var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return v(function() {
      var n, e, i, o, u, l, c;
      return p(this, function(d) {
        switch (d.label) {
          case 0:
            return b("setJudgeUsefId", "id", a), b("setJudgeUsefId", "setJudgeUsefIdRequest", r), n = "/judge/{id}/usef-id".replace("{id}", encodeURIComponent(String(a))), e = new URL(n, R), t && (i = t.baseOptions), o = f({ method: "PUT" }, i, s), l = {}, [4, E(u = {}, t)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", I(e, l), c = i && i.headers ? i.headers : {}, o.headers = f({}, u, c, s.headers), o.data = N(r, o, t), [2, { url: _(e), options: o }];
        }
      });
    })();
  }, updateCompositeJudgeMap: function(a, r) {
    var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return v(function() {
      var n, e, i, o, u, l, c;
      return p(this, function(d) {
        switch (d.label) {
          case 0:
            return b("updateCompositeJudgeMap", "id", a), n = "/composite-judge-map/{id}".replace("{id}", encodeURIComponent(String(a))), e = new URL(n, R), t && (i = t.baseOptions), o = f({ method: "PUT" }, i, s), l = {}, [4, E(u = {}, t)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", I(e, l), c = i && i.headers ? i.headers : {}, o.headers = f({}, u, c, s.headers), o.data = N(r, o, t), [2, { url: _(e), options: o }];
        }
      });
    })();
  } };
}, Ct = function(t) {
  var a = Mh(t);
  return { createCompositeJudgeMap: function(r, s) {
    return v(function() {
      var n, e, i, o, u, l;
      return p(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, a.createCompositeJudgeMap(r, s)];
          case 1:
            return i = c.sent(), u = (o = t == null ? void 0 : t.serverIndex) !== null && o !== void 0 ? o : 0, l = (e = y["JudgesApi.createCompositeJudgeMap"]) === null || e === void 0 || (n = e[u]) === null || n === void 0 ? void 0 : n.url, [2, function(d, h) {
              return T(i, S.default, w, t)(d, l || h);
            }];
        }
      });
    })();
  }, deleteCompositeJudgeMap: function(r, s) {
    return v(function() {
      var n, e, i, o, u, l;
      return p(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, a.deleteCompositeJudgeMap(r, s)];
          case 1:
            return i = c.sent(), u = (o = t == null ? void 0 : t.serverIndex) !== null && o !== void 0 ? o : 0, l = (e = y["JudgesApi.deleteCompositeJudgeMap"]) === null || e === void 0 || (n = e[u]) === null || n === void 0 ? void 0 : n.url, [2, function(d, h) {
              return T(i, S.default, w, t)(d, l || h);
            }];
        }
      });
    })();
  }, deleteJudgeSignature: function(r, s) {
    return v(function() {
      var n, e, i, o, u, l;
      return p(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, a.deleteJudgeSignature(r, s)];
          case 1:
            return i = c.sent(), u = (o = t == null ? void 0 : t.serverIndex) !== null && o !== void 0 ? o : 0, l = (e = y["JudgesApi.deleteJudgeSignature"]) === null || e === void 0 || (n = e[u]) === null || n === void 0 ? void 0 : n.url, [2, function(d, h) {
              return T(i, S.default, w, t)(d, l || h);
            }];
        }
      });
    })();
  }, getCompositeJudgeMap: function(r, s) {
    return v(function() {
      var n, e, i, o, u, l;
      return p(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, a.getCompositeJudgeMap(r, s)];
          case 1:
            return i = c.sent(), u = (o = t == null ? void 0 : t.serverIndex) !== null && o !== void 0 ? o : 0, l = (e = y["JudgesApi.getCompositeJudgeMap"]) === null || e === void 0 || (n = e[u]) === null || n === void 0 ? void 0 : n.url, [2, function(d, h) {
              return T(i, S.default, w, t)(d, l || h);
            }];
        }
      });
    })();
  }, listCompositeJudgeMaps: function(r, s) {
    return v(function() {
      var n, e, i, o, u, l;
      return p(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, a.listCompositeJudgeMaps(r, s)];
          case 1:
            return i = c.sent(), u = (o = t == null ? void 0 : t.serverIndex) !== null && o !== void 0 ? o : 0, l = (e = y["JudgesApi.listCompositeJudgeMaps"]) === null || e === void 0 || (n = e[u]) === null || n === void 0 ? void 0 : n.url, [2, function(d, h) {
              return T(i, S.default, w, t)(d, l || h);
            }];
        }
      });
    })();
  }, listJudges: function(r, s) {
    return v(function() {
      var n, e, i, o, u, l;
      return p(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, a.listJudges(r, s)];
          case 1:
            return i = c.sent(), u = (o = t == null ? void 0 : t.serverIndex) !== null && o !== void 0 ? o : 0, l = (e = y["JudgesApi.listJudges"]) === null || e === void 0 || (n = e[u]) === null || n === void 0 ? void 0 : n.url, [2, function(d, h) {
              return T(i, S.default, w, t)(d, l || h);
            }];
        }
      });
    })();
  }, putJudgeSignature: function(r, s, n) {
    return v(function() {
      var e, i, o, u, l, c;
      return p(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, a.putJudgeSignature(r, s, n)];
          case 1:
            return o = d.sent(), l = (u = t == null ? void 0 : t.serverIndex) !== null && u !== void 0 ? u : 0, c = (i = y["JudgesApi.putJudgeSignature"]) === null || i === void 0 || (e = i[l]) === null || e === void 0 ? void 0 : e.url, [2, function(h, g) {
              return T(o, S.default, w, t)(h, c || g);
            }];
        }
      });
    })();
  }, resolveJudgeComposite: function(r, s) {
    return v(function() {
      var n, e, i, o, u, l;
      return p(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, a.resolveJudgeComposite(r, s)];
          case 1:
            return i = c.sent(), u = (o = t == null ? void 0 : t.serverIndex) !== null && o !== void 0 ? o : 0, l = (e = y["JudgesApi.resolveJudgeComposite"]) === null || e === void 0 || (n = e[u]) === null || n === void 0 ? void 0 : n.url, [2, function(d, h) {
              return T(i, S.default, w, t)(d, l || h);
            }];
        }
      });
    })();
  }, setJudgeUsefId: function(r, s, n) {
    return v(function() {
      var e, i, o, u, l, c;
      return p(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, a.setJudgeUsefId(r, s, n)];
          case 1:
            return o = d.sent(), l = (u = t == null ? void 0 : t.serverIndex) !== null && u !== void 0 ? u : 0, c = (i = y["JudgesApi.setJudgeUsefId"]) === null || i === void 0 || (e = i[l]) === null || e === void 0 ? void 0 : e.url, [2, function(h, g) {
              return T(o, S.default, w, t)(h, c || g);
            }];
        }
      });
    })();
  }, updateCompositeJudgeMap: function(r, s, n) {
    return v(function() {
      var e, i, o, u, l, c;
      return p(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, a.updateCompositeJudgeMap(r, s, n)];
          case 1:
            return o = d.sent(), l = (u = t == null ? void 0 : t.serverIndex) !== null && u !== void 0 ? u : 0, c = (i = y["JudgesApi.updateCompositeJudgeMap"]) === null || i === void 0 || (e = i[l]) === null || e === void 0 ? void 0 : e.url, [2, function(h, g) {
              return T(o, S.default, w, t)(h, c || g);
            }];
        }
      });
    })();
  } };
};
(function(t) {
  function a() {
    return Me(this, a), je(this, a, arguments);
  }
  return Ve(a, t), Fe(a, [{ key: "createCompositeJudgeMap", value: function(r, s) {
    var n = this;
    return Ct(this.configuration).createCompositeJudgeMap(r, s).then(function(e) {
      return e(n.axios, n.basePath);
    });
  } }, { key: "deleteCompositeJudgeMap", value: function(r, s) {
    var n = this;
    return Ct(this.configuration).deleteCompositeJudgeMap(r, s).then(function(e) {
      return e(n.axios, n.basePath);
    });
  } }, { key: "deleteJudgeSignature", value: function(r, s) {
    var n = this;
    return Ct(this.configuration).deleteJudgeSignature(r, s).then(function(e) {
      return e(n.axios, n.basePath);
    });
  } }, { key: "getCompositeJudgeMap", value: function(r, s) {
    var n = this;
    return Ct(this.configuration).getCompositeJudgeMap(r, s).then(function(e) {
      return e(n.axios, n.basePath);
    });
  } }, { key: "listCompositeJudgeMaps", value: function(r, s) {
    var n = this;
    return Ct(this.configuration).listCompositeJudgeMaps(r, s).then(function(e) {
      return e(n.axios, n.basePath);
    });
  } }, { key: "listJudges", value: function(r, s) {
    var n = this;
    return Ct(this.configuration).listJudges(r, s).then(function(e) {
      return e(n.axios, n.basePath);
    });
  } }, { key: "putJudgeSignature", value: function(r, s, n) {
    var e = this;
    return Ct(this.configuration).putJudgeSignature(r, s, n).then(function(i) {
      return i(e.axios, e.basePath);
    });
  } }, { key: "resolveJudgeComposite", value: function(r, s) {
    var n = this;
    return Ct(this.configuration).resolveJudgeComposite(r, s).then(function(e) {
      return e(n.axios, n.basePath);
    });
  } }, { key: "setJudgeUsefId", value: function(r, s, n) {
    var e = this;
    return Ct(this.configuration).setJudgeUsefId(r, s, n).then(function(i) {
      return i(e.axios, e.basePath);
    });
  } }, { key: "updateCompositeJudgeMap", value: function(r, s, n) {
    var e = this;
    return Ct(this.configuration).updateCompositeJudgeMap(r, s, n).then(function(i) {
      return i(e.axios, e.basePath);
    });
  } }]), a;
})(Le);
var Fh = function(t) {
  return { createPerson: function(a) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return v(function() {
      var s, n, e, i, o, u;
      return p(this, function(l) {
        switch (l.label) {
          case 0:
            return s = new URL("/people", R), t && (n = t.baseOptions), e = f({ method: "POST" }, n, r), o = {}, [4, E(i = {}, t)];
          case 1:
            return l.sent(), i["Content-Type"] = "application/json", I(s, o), u = n && n.headers ? n.headers : {}, e.headers = f({}, i, u, r.headers), e.data = N(a, e, t), [2, { url: _(s), options: e }];
        }
      });
    })();
  }, deletePerson: function(a) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return v(function() {
      var s, n, e, i, o, u, l;
      return p(this, function(c) {
        switch (c.label) {
          case 0:
            return b("deletePerson", "id", a), s = "/people/{id}".replace("{id}", encodeURIComponent(String(a))), n = new URL(s, R), t && (e = t.baseOptions), i = f({ method: "DELETE" }, e, r), u = {}, [4, E(o = {}, t)];
          case 1:
            return c.sent(), I(n, u), l = e && e.headers ? e.headers : {}, i.headers = f({}, o, l, r.headers), [2, { url: _(n), options: i }];
        }
      });
    })();
  }, getPerson: function(a) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return v(function() {
      var s, n, e, i, o, u, l;
      return p(this, function(c) {
        switch (c.label) {
          case 0:
            return b("getPerson", "id", a), s = "/people/{id}".replace("{id}", encodeURIComponent(String(a))), n = new URL(s, R), t && (e = t.baseOptions), i = f({ method: "GET" }, e, r), u = {}, [4, E(o = {}, t)];
          case 1:
            return c.sent(), I(n, u), l = e && e.headers ? e.headers : {}, i.headers = f({}, o, l, r.headers), [2, { url: _(n), options: i }];
        }
      });
    })();
  }, listPeople: function(a) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return v(function() {
      var s, n, e, i, o, u;
      return p(this, function(l) {
        switch (l.label) {
          case 0:
            return s = new URL("/people", R), t && (n = t.baseOptions), e = f({ method: "GET" }, n, r), o = {}, [4, E(i = {}, t)];
          case 1:
            return l.sent(), a !== void 0 && (o.personType = a), I(s, o), u = n && n.headers ? n.headers : {}, e.headers = f({}, i, u, r.headers), [2, { url: _(s), options: e }];
        }
      });
    })();
  }, listShowRiders: function(a) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return v(function() {
      var s, n, e, i, o, u, l;
      return p(this, function(c) {
        switch (c.label) {
          case 0:
            return b("listShowRiders", "showId", a), s = "/show/{showId}/riders".replace("{showId}", encodeURIComponent(String(a))), n = new URL(s, R), t && (e = t.baseOptions), i = f({ method: "GET" }, e, r), u = {}, [4, E(o = {}, t)];
          case 1:
            return c.sent(), I(n, u), l = e && e.headers ? e.headers : {}, i.headers = f({}, o, l, r.headers), [2, { url: _(n), options: i }];
        }
      });
    })();
  }, setScoresheetRecipients: function(a, r, s) {
    var n = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    return v(function() {
      var e, i, o, u, l, c, d;
      return p(this, function(h) {
        switch (h.label) {
          case 0:
            return b("setScoresheetRecipients", "showId", a), b("setScoresheetRecipients", "riderId", r), b("setScoresheetRecipients", "setScoresheetRecipientsRequest", s), e = "/show/{showId}/riders/{riderId}/scoresheet-recipients".replace("{showId}", encodeURIComponent(String(a))).replace("{riderId}", encodeURIComponent(String(r))), i = new URL(e, R), t && (o = t.baseOptions), u = f({ method: "PUT" }, o, n), c = {}, [4, E(l = {}, t)];
          case 1:
            return h.sent(), l["Content-Type"] = "application/json", I(i, c), d = o && o.headers ? o.headers : {}, u.headers = f({}, l, d, n.headers), u.data = N(s, u, t), [2, { url: _(i), options: u }];
        }
      });
    })();
  }, updatePerson: function(a, r) {
    var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return v(function() {
      var n, e, i, o, u, l, c;
      return p(this, function(d) {
        switch (d.label) {
          case 0:
            return b("updatePerson", "id", a), n = "/people/{id}".replace("{id}", encodeURIComponent(String(a))), e = new URL(n, R), t && (i = t.baseOptions), o = f({ method: "PUT" }, i, s), l = {}, [4, E(u = {}, t)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", I(e, l), c = i && i.headers ? i.headers : {}, o.headers = f({}, u, c, s.headers), o.data = N(r, o, t), [2, { url: _(e), options: o }];
        }
      });
    })();
  } };
}, en = function(t) {
  var a = Fh(t);
  return { createPerson: function(r, s) {
    return v(function() {
      var n, e, i, o, u, l;
      return p(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, a.createPerson(r, s)];
          case 1:
            return i = c.sent(), u = (o = t == null ? void 0 : t.serverIndex) !== null && o !== void 0 ? o : 0, l = (e = y["PeopleApi.createPerson"]) === null || e === void 0 || (n = e[u]) === null || n === void 0 ? void 0 : n.url, [2, function(d, h) {
              return T(i, S.default, w, t)(d, l || h);
            }];
        }
      });
    })();
  }, deletePerson: function(r, s) {
    return v(function() {
      var n, e, i, o, u, l;
      return p(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, a.deletePerson(r, s)];
          case 1:
            return i = c.sent(), u = (o = t == null ? void 0 : t.serverIndex) !== null && o !== void 0 ? o : 0, l = (e = y["PeopleApi.deletePerson"]) === null || e === void 0 || (n = e[u]) === null || n === void 0 ? void 0 : n.url, [2, function(d, h) {
              return T(i, S.default, w, t)(d, l || h);
            }];
        }
      });
    })();
  }, getPerson: function(r, s) {
    return v(function() {
      var n, e, i, o, u, l;
      return p(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, a.getPerson(r, s)];
          case 1:
            return i = c.sent(), u = (o = t == null ? void 0 : t.serverIndex) !== null && o !== void 0 ? o : 0, l = (e = y["PeopleApi.getPerson"]) === null || e === void 0 || (n = e[u]) === null || n === void 0 ? void 0 : n.url, [2, function(d, h) {
              return T(i, S.default, w, t)(d, l || h);
            }];
        }
      });
    })();
  }, listPeople: function(r, s) {
    return v(function() {
      var n, e, i, o, u, l;
      return p(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, a.listPeople(r, s)];
          case 1:
            return i = c.sent(), u = (o = t == null ? void 0 : t.serverIndex) !== null && o !== void 0 ? o : 0, l = (e = y["PeopleApi.listPeople"]) === null || e === void 0 || (n = e[u]) === null || n === void 0 ? void 0 : n.url, [2, function(d, h) {
              return T(i, S.default, w, t)(d, l || h);
            }];
        }
      });
    })();
  }, listShowRiders: function(r, s) {
    return v(function() {
      var n, e, i, o, u, l;
      return p(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, a.listShowRiders(r, s)];
          case 1:
            return i = c.sent(), u = (o = t == null ? void 0 : t.serverIndex) !== null && o !== void 0 ? o : 0, l = (e = y["PeopleApi.listShowRiders"]) === null || e === void 0 || (n = e[u]) === null || n === void 0 ? void 0 : n.url, [2, function(d, h) {
              return T(i, S.default, w, t)(d, l || h);
            }];
        }
      });
    })();
  }, setScoresheetRecipients: function(r, s, n, e) {
    return v(function() {
      var i, o, u, l, c, d;
      return p(this, function(h) {
        switch (h.label) {
          case 0:
            return [4, a.setScoresheetRecipients(r, s, n, e)];
          case 1:
            return u = h.sent(), c = (l = t == null ? void 0 : t.serverIndex) !== null && l !== void 0 ? l : 0, d = (o = y["PeopleApi.setScoresheetRecipients"]) === null || o === void 0 || (i = o[c]) === null || i === void 0 ? void 0 : i.url, [2, function(g, U) {
              return T(u, S.default, w, t)(g, d || U);
            }];
        }
      });
    })();
  }, updatePerson: function(r, s, n) {
    return v(function() {
      var e, i, o, u, l, c;
      return p(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, a.updatePerson(r, s, n)];
          case 1:
            return o = d.sent(), l = (u = t == null ? void 0 : t.serverIndex) !== null && u !== void 0 ? u : 0, c = (i = y["PeopleApi.updatePerson"]) === null || i === void 0 || (e = i[l]) === null || e === void 0 ? void 0 : e.url, [2, function(h, g) {
              return T(o, S.default, w, t)(h, c || g);
            }];
        }
      });
    })();
  } };
};
(function(t) {
  function a() {
    return Me(this, a), je(this, a, arguments);
  }
  return Ve(a, t), Fe(a, [{ key: "createPerson", value: function(r, s) {
    var n = this;
    return en(this.configuration).createPerson(r, s).then(function(e) {
      return e(n.axios, n.basePath);
    });
  } }, { key: "deletePerson", value: function(r, s) {
    var n = this;
    return en(this.configuration).deletePerson(r, s).then(function(e) {
      return e(n.axios, n.basePath);
    });
  } }, { key: "getPerson", value: function(r, s) {
    var n = this;
    return en(this.configuration).getPerson(r, s).then(function(e) {
      return e(n.axios, n.basePath);
    });
  } }, { key: "listPeople", value: function(r, s) {
    var n = this;
    return en(this.configuration).listPeople(r, s).then(function(e) {
      return e(n.axios, n.basePath);
    });
  } }, { key: "listShowRiders", value: function(r, s) {
    var n = this;
    return en(this.configuration).listShowRiders(r, s).then(function(e) {
      return e(n.axios, n.basePath);
    });
  } }, { key: "setScoresheetRecipients", value: function(r, s, n, e) {
    var i = this;
    return en(this.configuration).setScoresheetRecipients(r, s, n, e).then(function(o) {
      return o(i.axios, i.basePath);
    });
  } }, { key: "updatePerson", value: function(r, s, n) {
    var e = this;
    return en(this.configuration).updatePerson(r, s, n).then(function(i) {
      return i(e.axios, e.basePath);
    });
  } }]), a;
})(Le);
var Vh = function(t) {
  return { listPresence: function(a, r, s) {
    var n = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    return v(function() {
      var e, i, o, u, l, c;
      return p(this, function(d) {
        switch (d.label) {
          case 0:
            return b("listPresence", "showId", a), e = new URL("/presence", R), t && (i = t.baseOptions), o = f({ method: "GET" }, i, n), l = {}, [4, E(u = {}, t)];
          case 1:
            return d.sent(), a !== void 0 && (l.showId = a), r !== void 0 && (l.ring = r), s !== void 0 && (l.classId = s), I(e, l), c = i && i.headers ? i.headers : {}, o.headers = f({}, u, c, n.headers), [2, { url: _(e), options: o }];
        }
      });
    })();
  }, postHeartbeat: function(a) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return v(function() {
      var s, n, e, i, o, u;
      return p(this, function(l) {
        switch (l.label) {
          case 0:
            return b("postHeartbeat", "postHeartbeatRequest", a), s = new URL("/presence/heartbeat", R), t && (n = t.baseOptions), e = f({ method: "POST" }, n, r), o = {}, [4, E(i = {}, t)];
          case 1:
            return l.sent(), i["Content-Type"] = "application/json", I(s, o), u = n && n.headers ? n.headers : {}, e.headers = f({}, i, u, r.headers), e.data = N(a, e, t), [2, { url: _(s), options: e }];
        }
      });
    })();
  } };
}, Ta = function(t) {
  var a = Vh(t);
  return { listPresence: function(r, s, n, e) {
    return v(function() {
      var i, o, u, l, c, d;
      return p(this, function(h) {
        switch (h.label) {
          case 0:
            return [4, a.listPresence(r, s, n, e)];
          case 1:
            return u = h.sent(), c = (l = t == null ? void 0 : t.serverIndex) !== null && l !== void 0 ? l : 0, d = (o = y["PresenceApi.listPresence"]) === null || o === void 0 || (i = o[c]) === null || i === void 0 ? void 0 : i.url, [2, function(g, U) {
              return T(u, S.default, w, t)(g, d || U);
            }];
        }
      });
    })();
  }, postHeartbeat: function(r, s) {
    return v(function() {
      var n, e, i, o, u, l;
      return p(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, a.postHeartbeat(r, s)];
          case 1:
            return i = c.sent(), u = (o = t == null ? void 0 : t.serverIndex) !== null && o !== void 0 ? o : 0, l = (e = y["PresenceApi.postHeartbeat"]) === null || e === void 0 || (n = e[u]) === null || n === void 0 ? void 0 : n.url, [2, function(d, h) {
              return T(i, S.default, w, t)(d, l || h);
            }];
        }
      });
    })();
  } };
};
(function(t) {
  function a() {
    return Me(this, a), je(this, a, arguments);
  }
  return Ve(a, t), Fe(a, [{ key: "listPresence", value: function(r, s, n, e) {
    var i = this;
    return Ta(this.configuration).listPresence(r, s, n, e).then(function(o) {
      return o(i.axios, i.basePath);
    });
  } }, { key: "postHeartbeat", value: function(r, s) {
    var n = this;
    return Ta(this.configuration).postHeartbeat(r, s).then(function(e) {
      return e(n.axios, n.basePath);
    });
  } }]), a;
})(Le);
var zh = function(t) {
  return { applyQuarantinedPayload: function(a, r) {
    var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return v(function() {
      var n, e, i, o, u, l, c;
      return p(this, function(d) {
        switch (d.label) {
          case 0:
            return b("applyQuarantinedPayload", "id", a), n = "/quarantine/{id}/apply".replace("{id}", encodeURIComponent(String(a))), e = new URL(n, R), t && (i = t.baseOptions), o = f({ method: "POST" }, i, s), l = {}, [4, E(u = {}, t)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", I(e, l), c = i && i.headers ? i.headers : {}, o.headers = f({}, u, c, s.headers), o.data = N(r, o, t), [2, { url: _(e), options: o }];
        }
      });
    })();
  }, getQuarantinedPayload: function(a) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return v(function() {
      var s, n, e, i, o, u, l;
      return p(this, function(c) {
        switch (c.label) {
          case 0:
            return b("getQuarantinedPayload", "id", a), s = "/quarantine/{id}".replace("{id}", encodeURIComponent(String(a))), n = new URL(s, R), t && (e = t.baseOptions), i = f({ method: "GET" }, e, r), u = {}, [4, E(o = {}, t)];
          case 1:
            return c.sent(), I(n, u), l = e && e.headers ? e.headers : {}, i.headers = f({}, o, l, r.headers), [2, { url: _(n), options: i }];
        }
      });
    })();
  }, quarantinePayload: function(a) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return v(function() {
      var s, n, e, i, o, u;
      return p(this, function(l) {
        switch (l.label) {
          case 0:
            return s = new URL("/quarantine", R), t && (n = t.baseOptions), e = f({ method: "POST" }, n, r), o = {}, [4, E(i = {}, t)];
          case 1:
            return l.sent(), i["Content-Type"] = "application/json", I(s, o), u = n && n.headers ? n.headers : {}, e.headers = f({}, i, u, r.headers), e.data = N(a, e, t), [2, { url: _(s), options: e }];
        }
      });
    })();
  } };
}, wi = function(t) {
  var a = zh(t);
  return { applyQuarantinedPayload: function(r, s, n) {
    return v(function() {
      var e, i, o, u, l, c;
      return p(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, a.applyQuarantinedPayload(r, s, n)];
          case 1:
            return o = d.sent(), l = (u = t == null ? void 0 : t.serverIndex) !== null && u !== void 0 ? u : 0, c = (i = y["QuarantineApi.applyQuarantinedPayload"]) === null || i === void 0 || (e = i[l]) === null || e === void 0 ? void 0 : e.url, [2, function(h, g) {
              return T(o, S.default, w, t)(h, c || g);
            }];
        }
      });
    })();
  }, getQuarantinedPayload: function(r, s) {
    return v(function() {
      var n, e, i, o, u, l;
      return p(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, a.getQuarantinedPayload(r, s)];
          case 1:
            return i = c.sent(), u = (o = t == null ? void 0 : t.serverIndex) !== null && o !== void 0 ? o : 0, l = (e = y["QuarantineApi.getQuarantinedPayload"]) === null || e === void 0 || (n = e[u]) === null || n === void 0 ? void 0 : n.url, [2, function(d, h) {
              return T(i, S.default, w, t)(d, l || h);
            }];
        }
      });
    })();
  }, quarantinePayload: function(r, s) {
    return v(function() {
      var n, e, i, o, u, l;
      return p(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, a.quarantinePayload(r, s)];
          case 1:
            return i = c.sent(), u = (o = t == null ? void 0 : t.serverIndex) !== null && o !== void 0 ? o : 0, l = (e = y["QuarantineApi.quarantinePayload"]) === null || e === void 0 || (n = e[u]) === null || n === void 0 ? void 0 : n.url, [2, function(d, h) {
              return T(i, S.default, w, t)(d, l || h);
            }];
        }
      });
    })();
  } };
};
(function(t) {
  function a() {
    return Me(this, a), je(this, a, arguments);
  }
  return Ve(a, t), Fe(a, [{ key: "applyQuarantinedPayload", value: function(r, s, n) {
    var e = this;
    return wi(this.configuration).applyQuarantinedPayload(r, s, n).then(function(i) {
      return i(e.axios, e.basePath);
    });
  } }, { key: "getQuarantinedPayload", value: function(r, s) {
    var n = this;
    return wi(this.configuration).getQuarantinedPayload(r, s).then(function(e) {
      return e(n.axios, n.basePath);
    });
  } }, { key: "quarantinePayload", value: function(r, s) {
    var n = this;
    return wi(this.configuration).quarantinePayload(r, s).then(function(e) {
      return e(n.axios, n.basePath);
    });
  } }]), a;
})(Le);
var Bh = function(t) {
  return { commitPlaceClassByRules: function(a, r) {
    var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return v(function() {
      var n, e, i, o, u, l, c;
      return p(this, function(d) {
        switch (d.label) {
          case 0:
            return b("commitPlaceClassByRules", "classId", a), b("commitPlaceClassByRules", "commitPlaceClassByRulesRequest", r), n = "/class/{classId}/place-by-rules".replace("{classId}", encodeURIComponent(String(a))), e = new URL(n, R), t && (i = t.baseOptions), o = f({ method: "POST" }, i, s), l = {}, [4, E(u = {}, t)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", I(e, l), c = i && i.headers ? i.headers : {}, o.headers = f({}, u, c, s.headers), o.data = N(r, o, t), [2, { url: _(e), options: o }];
        }
      });
    })();
  }, getClassResults: function(a) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return v(function() {
      var s, n, e, i, o, u, l;
      return p(this, function(c) {
        switch (c.label) {
          case 0:
            return b("getClassResults", "classId", a), s = "/class/{classId}/results".replace("{classId}", encodeURIComponent(String(a))), n = new URL(s, R), t && (e = t.baseOptions), i = f({ method: "GET" }, e, r), u = {}, [4, E(o = {}, t)];
          case 1:
            return c.sent(), I(n, u), l = e && e.headers ? e.headers : {}, i.headers = f({}, o, l, r.headers), [2, { url: _(n), options: i }];
        }
      });
    })();
  }, getClassResultsSummary: function(a, r) {
    var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return v(function() {
      var n, e, i, o, u, l;
      return p(this, function(c) {
        switch (c.label) {
          case 0:
            return b("getClassResultsSummary", "showId", a), b("getClassResultsSummary", "ring", r), n = new URL("/class-results-summary", R), t && (e = t.baseOptions), i = f({ method: "GET" }, e, s), u = {}, [4, E(o = {}, t)];
          case 1:
            return c.sent(), a !== void 0 && (u.showId = a), r !== void 0 && (u.ring = r), I(n, u), l = e && e.headers ? e.headers : {}, i.headers = f({}, o, l, s.headers), [2, { url: _(n), options: i }];
        }
      });
    })();
  }, getRideResult: function(a) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return v(function() {
      var s, n, e, i, o, u, l;
      return p(this, function(c) {
        switch (c.label) {
          case 0:
            return b("getRideResult", "rideId", a), s = "/ride/{rideId}/results".replace("{rideId}", encodeURIComponent(String(a))), n = new URL(s, R), t && (e = t.baseOptions), i = f({ method: "GET" }, e, r), u = {}, [4, E(o = {}, t)];
          case 1:
            return c.sent(), I(n, u), l = e && e.headers ? e.headers : {}, i.headers = f({}, o, l, r.headers), [2, { url: _(n), options: i }];
        }
      });
    })();
  }, getShowResultsSummary: function(a) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return v(function() {
      var s, n, e, i, o, u;
      return p(this, function(l) {
        switch (l.label) {
          case 0:
            return b("getShowResultsSummary", "showId", a), s = new URL("/show-results-summary", R), t && (n = t.baseOptions), e = f({ method: "GET" }, n, r), o = {}, [4, E(i = {}, t)];
          case 1:
            return l.sent(), a !== void 0 && (o.showId = a), I(s, o), u = n && n.headers ? n.headers : {}, e.headers = f({}, i, u, r.headers), [2, { url: _(s), options: e }];
        }
      });
    })();
  }, previewPlaceClassByRules: function(a) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return v(function() {
      var s, n, e, i, o, u, l;
      return p(this, function(c) {
        switch (c.label) {
          case 0:
            return b("previewPlaceClassByRules", "classId", a), s = "/class/{classId}/place-by-rules".replace("{classId}", encodeURIComponent(String(a))), n = new URL(s, R), t && (e = t.baseOptions), i = f({ method: "GET" }, e, r), u = {}, [4, E(o = {}, t)];
          case 1:
            return c.sent(), I(n, u), l = e && e.headers ? e.headers : {}, i.headers = f({}, o, l, r.headers), [2, { url: _(n), options: i }];
        }
      });
    })();
  }, setClassPlacings: function(a, r) {
    var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return v(function() {
      var n, e, i, o, u, l, c;
      return p(this, function(d) {
        switch (d.label) {
          case 0:
            return b("setClassPlacings", "classId", a), b("setClassPlacings", "setClassPlacingsRequest", r), n = "/class/{classId}/placings".replace("{classId}", encodeURIComponent(String(a))), e = new URL(n, R), t && (i = t.baseOptions), o = f({ method: "PUT" }, i, s), l = {}, [4, E(u = {}, t)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", I(e, l), c = i && i.headers ? i.headers : {}, o.headers = f({}, u, c, s.headers), o.data = N(r, o, t), [2, { url: _(e), options: o }];
        }
      });
    })();
  }, setRidePlacing: function(a, r) {
    var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return v(function() {
      var n, e, i, o, u, l, c;
      return p(this, function(d) {
        switch (d.label) {
          case 0:
            return b("setRidePlacing", "rideId", a), n = "/ride/{rideId}/placing".replace("{rideId}", encodeURIComponent(String(a))), e = new URL(n, R), t && (i = t.baseOptions), o = f({ method: "PUT" }, i, s), l = {}, [4, E(u = {}, t)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", I(e, l), c = i && i.headers ? i.headers : {}, o.headers = f({}, u, c, s.headers), o.data = N(r, o, t), [2, { url: _(e), options: o }];
        }
      });
    })();
  } };
}, $t = function(t) {
  var a = Bh(t);
  return { commitPlaceClassByRules: function(r, s, n) {
    return v(function() {
      var e, i, o, u, l, c;
      return p(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, a.commitPlaceClassByRules(r, s, n)];
          case 1:
            return o = d.sent(), l = (u = t == null ? void 0 : t.serverIndex) !== null && u !== void 0 ? u : 0, c = (i = y["ResultsApi.commitPlaceClassByRules"]) === null || i === void 0 || (e = i[l]) === null || e === void 0 ? void 0 : e.url, [2, function(h, g) {
              return T(o, S.default, w, t)(h, c || g);
            }];
        }
      });
    })();
  }, getClassResults: function(r, s) {
    return v(function() {
      var n, e, i, o, u, l;
      return p(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, a.getClassResults(r, s)];
          case 1:
            return i = c.sent(), u = (o = t == null ? void 0 : t.serverIndex) !== null && o !== void 0 ? o : 0, l = (e = y["ResultsApi.getClassResults"]) === null || e === void 0 || (n = e[u]) === null || n === void 0 ? void 0 : n.url, [2, function(d, h) {
              return T(i, S.default, w, t)(d, l || h);
            }];
        }
      });
    })();
  }, getClassResultsSummary: function(r, s, n) {
    return v(function() {
      var e, i, o, u, l, c;
      return p(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, a.getClassResultsSummary(r, s, n)];
          case 1:
            return o = d.sent(), l = (u = t == null ? void 0 : t.serverIndex) !== null && u !== void 0 ? u : 0, c = (i = y["ResultsApi.getClassResultsSummary"]) === null || i === void 0 || (e = i[l]) === null || e === void 0 ? void 0 : e.url, [2, function(h, g) {
              return T(o, S.default, w, t)(h, c || g);
            }];
        }
      });
    })();
  }, getRideResult: function(r, s) {
    return v(function() {
      var n, e, i, o, u, l;
      return p(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, a.getRideResult(r, s)];
          case 1:
            return i = c.sent(), u = (o = t == null ? void 0 : t.serverIndex) !== null && o !== void 0 ? o : 0, l = (e = y["ResultsApi.getRideResult"]) === null || e === void 0 || (n = e[u]) === null || n === void 0 ? void 0 : n.url, [2, function(d, h) {
              return T(i, S.default, w, t)(d, l || h);
            }];
        }
      });
    })();
  }, getShowResultsSummary: function(r, s) {
    return v(function() {
      var n, e, i, o, u, l;
      return p(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, a.getShowResultsSummary(r, s)];
          case 1:
            return i = c.sent(), u = (o = t == null ? void 0 : t.serverIndex) !== null && o !== void 0 ? o : 0, l = (e = y["ResultsApi.getShowResultsSummary"]) === null || e === void 0 || (n = e[u]) === null || n === void 0 ? void 0 : n.url, [2, function(d, h) {
              return T(i, S.default, w, t)(d, l || h);
            }];
        }
      });
    })();
  }, previewPlaceClassByRules: function(r, s) {
    return v(function() {
      var n, e, i, o, u, l;
      return p(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, a.previewPlaceClassByRules(r, s)];
          case 1:
            return i = c.sent(), u = (o = t == null ? void 0 : t.serverIndex) !== null && o !== void 0 ? o : 0, l = (e = y["ResultsApi.previewPlaceClassByRules"]) === null || e === void 0 || (n = e[u]) === null || n === void 0 ? void 0 : n.url, [2, function(d, h) {
              return T(i, S.default, w, t)(d, l || h);
            }];
        }
      });
    })();
  }, setClassPlacings: function(r, s, n) {
    return v(function() {
      var e, i, o, u, l, c;
      return p(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, a.setClassPlacings(r, s, n)];
          case 1:
            return o = d.sent(), l = (u = t == null ? void 0 : t.serverIndex) !== null && u !== void 0 ? u : 0, c = (i = y["ResultsApi.setClassPlacings"]) === null || i === void 0 || (e = i[l]) === null || e === void 0 ? void 0 : e.url, [2, function(h, g) {
              return T(o, S.default, w, t)(h, c || g);
            }];
        }
      });
    })();
  }, setRidePlacing: function(r, s, n) {
    return v(function() {
      var e, i, o, u, l, c;
      return p(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, a.setRidePlacing(r, s, n)];
          case 1:
            return o = d.sent(), l = (u = t == null ? void 0 : t.serverIndex) !== null && u !== void 0 ? u : 0, c = (i = y["ResultsApi.setRidePlacing"]) === null || i === void 0 || (e = i[l]) === null || e === void 0 ? void 0 : e.url, [2, function(h, g) {
              return T(o, S.default, w, t)(h, c || g);
            }];
        }
      });
    })();
  } };
};
(function(t) {
  function a() {
    return Me(this, a), je(this, a, arguments);
  }
  return Ve(a, t), Fe(a, [{ key: "commitPlaceClassByRules", value: function(r, s, n) {
    var e = this;
    return $t(this.configuration).commitPlaceClassByRules(r, s, n).then(function(i) {
      return i(e.axios, e.basePath);
    });
  } }, { key: "getClassResults", value: function(r, s) {
    var n = this;
    return $t(this.configuration).getClassResults(r, s).then(function(e) {
      return e(n.axios, n.basePath);
    });
  } }, { key: "getClassResultsSummary", value: function(r, s, n) {
    var e = this;
    return $t(this.configuration).getClassResultsSummary(r, s, n).then(function(i) {
      return i(e.axios, e.basePath);
    });
  } }, { key: "getRideResult", value: function(r, s) {
    var n = this;
    return $t(this.configuration).getRideResult(r, s).then(function(e) {
      return e(n.axios, n.basePath);
    });
  } }, { key: "getShowResultsSummary", value: function(r, s) {
    var n = this;
    return $t(this.configuration).getShowResultsSummary(r, s).then(function(e) {
      return e(n.axios, n.basePath);
    });
  } }, { key: "previewPlaceClassByRules", value: function(r, s) {
    var n = this;
    return $t(this.configuration).previewPlaceClassByRules(r, s).then(function(e) {
      return e(n.axios, n.basePath);
    });
  } }, { key: "setClassPlacings", value: function(r, s, n) {
    var e = this;
    return $t(this.configuration).setClassPlacings(r, s, n).then(function(i) {
      return i(e.axios, e.basePath);
    });
  } }, { key: "setRidePlacing", value: function(r, s, n) {
    var e = this;
    return $t(this.configuration).setRidePlacing(r, s, n).then(function(i) {
      return i(e.axios, e.basePath);
    });
  } }]), a;
})(Le);
var Gh = function(t) {
  return { attachOrphanSheet: function(a, r) {
    var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return v(function() {
      var n, e, i, o, u, l, c;
      return p(this, function(d) {
        switch (d.label) {
          case 0:
            return b("attachOrphanSheet", "sheetId", a), b("attachOrphanSheet", "attachOrphanSheetRequest", r), n = "/review-queue/orphan-sheet/{sheetId}/attach".replace("{sheetId}", encodeURIComponent(String(a))), e = new URL(n, R), t && (i = t.baseOptions), o = f({ method: "POST" }, i, s), l = {}, [4, E(u = {}, t)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", I(e, l), c = i && i.headers ? i.headers : {}, o.headers = f({}, u, c, s.headers), o.data = N(r, o, t), [2, { url: _(e), options: o }];
        }
      });
    })();
  }, listReviewDone: function(a) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return v(function() {
      var s, n, e, i, o, u;
      return p(this, function(l) {
        switch (l.label) {
          case 0:
            return s = new URL("/review-queue/done", R), t && (n = t.baseOptions), e = f({ method: "GET" }, n, r), o = {}, [4, E(i = {}, t)];
          case 1:
            return l.sent(), a !== void 0 && (o.showId = a), I(s, o), u = n && n.headers ? n.headers : {}, e.headers = f({}, i, u, r.headers), [2, { url: _(s), options: e }];
        }
      });
    })();
  }, listReviewQueue: function(a) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return v(function() {
      var s, n, e, i, o, u;
      return p(this, function(l) {
        switch (l.label) {
          case 0:
            return s = new URL("/review-queue", R), t && (n = t.baseOptions), e = f({ method: "GET" }, n, r), o = {}, [4, E(i = {}, t)];
          case 1:
            return l.sent(), a !== void 0 && (o.showId = a), I(s, o), u = n && n.headers ? n.headers : {}, e.headers = f({}, i, u, r.headers), [2, { url: _(s), options: e }];
        }
      });
    })();
  }, resolveReviewItem: function(a, r) {
    var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return v(function() {
      var n, e, i, o, u, l, c;
      return p(this, function(d) {
        switch (d.label) {
          case 0:
            return b("resolveReviewItem", "itemId", a), b("resolveReviewItem", "resolveReviewItemRequest", r), n = "/review-queue/{itemId}/resolve".replace("{itemId}", encodeURIComponent(String(a))), e = new URL(n, R), t && (i = t.baseOptions), o = f({ method: "POST" }, i, s), l = {}, [4, E(u = {}, t)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", I(e, l), c = i && i.headers ? i.headers : {}, o.headers = f({}, u, c, s.headers), o.data = N(r, o, t), [2, { url: _(e), options: o }];
        }
      });
    })();
  }, undoReviewItem: function(a) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return v(function() {
      var s, n, e, i, o, u;
      return p(this, function(l) {
        switch (l.label) {
          case 0:
            return b("undoReviewItem", "undoReviewItemRequest", a), s = new URL("/review-queue/undo", R), t && (n = t.baseOptions), e = f({ method: "POST" }, n, r), o = {}, [4, E(i = {}, t)];
          case 1:
            return l.sent(), i["Content-Type"] = "application/json", I(s, o), u = n && n.headers ? n.headers : {}, e.headers = f({}, i, u, r.headers), e.data = N(a, e, t), [2, { url: _(s), options: e }];
        }
      });
    })();
  } };
}, Hn = function(t) {
  var a = Gh(t);
  return { attachOrphanSheet: function(r, s, n) {
    return v(function() {
      var e, i, o, u, l, c;
      return p(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, a.attachOrphanSheet(r, s, n)];
          case 1:
            return o = d.sent(), l = (u = t == null ? void 0 : t.serverIndex) !== null && u !== void 0 ? u : 0, c = (i = y["ReviewQueueApi.attachOrphanSheet"]) === null || i === void 0 || (e = i[l]) === null || e === void 0 ? void 0 : e.url, [2, function(h, g) {
              return T(o, S.default, w, t)(h, c || g);
            }];
        }
      });
    })();
  }, listReviewDone: function(r, s) {
    return v(function() {
      var n, e, i, o, u, l;
      return p(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, a.listReviewDone(r, s)];
          case 1:
            return i = c.sent(), u = (o = t == null ? void 0 : t.serverIndex) !== null && o !== void 0 ? o : 0, l = (e = y["ReviewQueueApi.listReviewDone"]) === null || e === void 0 || (n = e[u]) === null || n === void 0 ? void 0 : n.url, [2, function(d, h) {
              return T(i, S.default, w, t)(d, l || h);
            }];
        }
      });
    })();
  }, listReviewQueue: function(r, s) {
    return v(function() {
      var n, e, i, o, u, l;
      return p(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, a.listReviewQueue(r, s)];
          case 1:
            return i = c.sent(), u = (o = t == null ? void 0 : t.serverIndex) !== null && o !== void 0 ? o : 0, l = (e = y["ReviewQueueApi.listReviewQueue"]) === null || e === void 0 || (n = e[u]) === null || n === void 0 ? void 0 : n.url, [2, function(d, h) {
              return T(i, S.default, w, t)(d, l || h);
            }];
        }
      });
    })();
  }, resolveReviewItem: function(r, s, n) {
    return v(function() {
      var e, i, o, u, l, c;
      return p(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, a.resolveReviewItem(r, s, n)];
          case 1:
            return o = d.sent(), l = (u = t == null ? void 0 : t.serverIndex) !== null && u !== void 0 ? u : 0, c = (i = y["ReviewQueueApi.resolveReviewItem"]) === null || i === void 0 || (e = i[l]) === null || e === void 0 ? void 0 : e.url, [2, function(h, g) {
              return T(o, S.default, w, t)(h, c || g);
            }];
        }
      });
    })();
  }, undoReviewItem: function(r, s) {
    return v(function() {
      var n, e, i, o, u, l;
      return p(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, a.undoReviewItem(r, s)];
          case 1:
            return i = c.sent(), u = (o = t == null ? void 0 : t.serverIndex) !== null && o !== void 0 ? o : 0, l = (e = y["ReviewQueueApi.undoReviewItem"]) === null || e === void 0 || (n = e[u]) === null || n === void 0 ? void 0 : n.url, [2, function(d, h) {
              return T(i, S.default, w, t)(d, l || h);
            }];
        }
      });
    })();
  } };
};
(function(t) {
  function a() {
    return Me(this, a), je(this, a, arguments);
  }
  return Ve(a, t), Fe(a, [{ key: "attachOrphanSheet", value: function(r, s, n) {
    var e = this;
    return Hn(this.configuration).attachOrphanSheet(r, s, n).then(function(i) {
      return i(e.axios, e.basePath);
    });
  } }, { key: "listReviewDone", value: function(r, s) {
    var n = this;
    return Hn(this.configuration).listReviewDone(r, s).then(function(e) {
      return e(n.axios, n.basePath);
    });
  } }, { key: "listReviewQueue", value: function(r, s) {
    var n = this;
    return Hn(this.configuration).listReviewQueue(r, s).then(function(e) {
      return e(n.axios, n.basePath);
    });
  } }, { key: "resolveReviewItem", value: function(r, s, n) {
    var e = this;
    return Hn(this.configuration).resolveReviewItem(r, s, n).then(function(i) {
      return i(e.axios, e.basePath);
    });
  } }, { key: "undoReviewItem", value: function(r, s) {
    var n = this;
    return Hn(this.configuration).undoReviewItem(r, s).then(function(e) {
      return e(n.axios, n.basePath);
    });
  } }]), a;
})(Le);
var Hh = function(t) {
  return { addRideMovement: function(a, r) {
    var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return v(function() {
      var n, e, i, o, u, l, c;
      return p(this, function(d) {
        switch (d.label) {
          case 0:
            return b("addRideMovement", "rideId", a), n = "/ride/{rideId}/movements".replace("{rideId}", encodeURIComponent(String(a))), e = new URL(n, R), t && (i = t.baseOptions), o = f({ method: "POST" }, i, s), l = {}, [4, E(u = {}, t)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", I(e, l), c = i && i.headers ? i.headers : {}, o.headers = f({}, u, c, s.headers), o.data = N(r, o, t), [2, { url: _(e), options: o }];
        }
      });
    })();
  }, batchRideStatus: function(a) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return v(function() {
      var s, n, e, i, o, u;
      return p(this, function(l) {
        switch (l.label) {
          case 0:
            return b("batchRideStatus", "batchRideStatusRequest", a), s = new URL("/rides/status", R), t && (n = t.baseOptions), e = f({ method: "POST" }, n, r), o = {}, [4, E(i = {}, t)];
          case 1:
            return l.sent(), i["Content-Type"] = "application/json", I(s, o), u = n && n.headers ? n.headers : {}, e.headers = f({}, i, u, r.headers), e.data = N(a, e, t), [2, { url: _(s), options: e }];
        }
      });
    })();
  }, batchSetRideSubsections: function(a) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return v(function() {
      var s, n, e, i, o, u;
      return p(this, function(l) {
        switch (l.label) {
          case 0:
            return b("batchSetRideSubsections", "batchSetRideSubsectionsRequest", a), s = new URL("/rides/subsection", R), t && (n = t.baseOptions), e = f({ method: "POST" }, n, r), o = {}, [4, E(i = {}, t)];
          case 1:
            return l.sent(), i["Content-Type"] = "application/json", I(s, o), u = n && n.headers ? n.headers : {}, e.headers = f({}, i, u, r.headers), e.data = N(a, e, t), [2, { url: _(s), options: e }];
        }
      });
    })();
  }, createRide: function(a) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return v(function() {
      var s, n, e, i, o, u;
      return p(this, function(l) {
        switch (l.label) {
          case 0:
            return s = new URL("/ride", R), t && (n = t.baseOptions), e = f({ method: "POST" }, n, r), o = {}, [4, E(i = {}, t)];
          case 1:
            return l.sent(), i["Content-Type"] = "application/json", I(s, o), u = n && n.headers ? n.headers : {}, e.headers = f({}, i, u, r.headers), e.data = N(a, e, t), [2, { url: _(s), options: e }];
        }
      });
    })();
  }, createRideUtilityEvent: function(a, r) {
    var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return v(function() {
      var n, e, i, o, u, l, c;
      return p(this, function(d) {
        switch (d.label) {
          case 0:
            return b("createRideUtilityEvent", "rideId", a), b("createRideUtilityEvent", "createRideUtilityEventRequest", r), n = "/ride/{rideId}/utility-events".replace("{rideId}", encodeURIComponent(String(a))), e = new URL(n, R), t && (i = t.baseOptions), o = f({ method: "POST" }, i, s), l = {}, [4, E(u = {}, t)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", I(e, l), c = i && i.headers ? i.headers : {}, o.headers = f({}, u, c, s.headers), o.data = N(r, o, t), [2, { url: _(e), options: o }];
        }
      });
    })();
  }, deleteRideUtilityEvent: function(a, r, s) {
    var n = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    return v(function() {
      var e, i, o, u, l, c, d;
      return p(this, function(h) {
        switch (h.label) {
          case 0:
            return b("deleteRideUtilityEvent", "rideId", a), b("deleteRideUtilityEvent", "eventId", r), e = "/ride/{rideId}/utility-events/{eventId}".replace("{rideId}", encodeURIComponent(String(a))).replace("{eventId}", encodeURIComponent(String(r))), i = new URL(e, R), t && (o = t.baseOptions), u = f({ method: "DELETE" }, o, n), c = {}, [4, E(l = {}, t)];
          case 1:
            return h.sent(), s && (c.writerDeviceId = s), I(i, c), d = o && o.headers ? o.headers : {}, u.headers = f({}, l, d, n.headers), [2, { url: _(i), options: u }];
        }
      });
    })();
  }, dismissRideFvdPushFailure: function(a, r) {
    var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return v(function() {
      var n, e, i, o, u, l, c;
      return p(this, function(d) {
        switch (d.label) {
          case 0:
            return b("dismissRideFvdPushFailure", "rideId", a), n = "/ride/{rideId}/dismiss-fvd-push-failure".replace("{rideId}", encodeURIComponent(String(a))), e = new URL(n, R), t && (i = t.baseOptions), o = f({ method: "POST" }, i, s), l = {}, [4, E(u = {}, t)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", I(e, l), c = i && i.headers ? i.headers : {}, o.headers = f({}, u, c, s.headers), o.data = N(r, o, t), [2, { url: _(e), options: o }];
        }
      });
    })();
  }, fillChampionshipSlot: function(a, r) {
    var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return v(function() {
      var n, e, i, o, u, l, c;
      return p(this, function(d) {
        switch (d.label) {
          case 0:
            return b("fillChampionshipSlot", "rideId", a), b("fillChampionshipSlot", "fillChampionshipSlotRequest", r), n = "/ride/{rideId}/championship-slot".replace("{rideId}", encodeURIComponent(String(a))), e = new URL(n, R), t && (i = t.baseOptions), o = f({ method: "PUT" }, i, s), l = {}, [4, E(u = {}, t)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", I(e, l), c = i && i.headers ? i.headers : {}, o.headers = f({}, u, c, s.headers), o.data = N(r, o, t), [2, { url: _(e), options: o }];
        }
      });
    })();
  }, getRide: function(a) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return v(function() {
      var s, n, e, i, o, u, l;
      return p(this, function(c) {
        switch (c.label) {
          case 0:
            return b("getRide", "rideId", a), s = "/ride/{rideId}".replace("{rideId}", encodeURIComponent(String(a))), n = new URL(s, R), t && (e = t.baseOptions), i = f({ method: "GET" }, e, r), u = {}, [4, E(o = {}, t)];
          case 1:
            return c.sent(), I(n, u), l = e && e.headers ? e.headers : {}, i.headers = f({}, o, l, r.headers), [2, { url: _(n), options: i }];
        }
      });
    })();
  }, getRideExcused: function(a) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return v(function() {
      var s, n, e, i, o, u, l;
      return p(this, function(c) {
        switch (c.label) {
          case 0:
            return b("getRideExcused", "rideId", a), s = "/ride/{rideId}/excused".replace("{rideId}", encodeURIComponent(String(a))), n = new URL(s, R), t && (e = t.baseOptions), i = f({ method: "GET" }, e, r), u = {}, [4, E(o = {}, t)];
          case 1:
            return c.sent(), I(n, u), l = e && e.headers ? e.headers : {}, i.headers = f({}, o, l, r.headers), [2, { url: _(n), options: i }];
        }
      });
    })();
  }, getRideNoShow: function(a) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return v(function() {
      var s, n, e, i, o, u, l;
      return p(this, function(c) {
        switch (c.label) {
          case 0:
            return b("getRideNoShow", "rideId", a), s = "/ride/{rideId}/no-show".replace("{rideId}", encodeURIComponent(String(a))), n = new URL(s, R), t && (e = t.baseOptions), i = f({ method: "GET" }, e, r), u = {}, [4, E(o = {}, t)];
          case 1:
            return c.sent(), I(n, u), l = e && e.headers ? e.headers : {}, i.headers = f({}, o, l, r.headers), [2, { url: _(n), options: i }];
        }
      });
    })();
  }, getRideWithdrawn: function(a) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return v(function() {
      var s, n, e, i, o, u, l;
      return p(this, function(c) {
        switch (c.label) {
          case 0:
            return b("getRideWithdrawn", "rideId", a), s = "/ride/{rideId}/withdrawn".replace("{rideId}", encodeURIComponent(String(a))), n = new URL(s, R), t && (e = t.baseOptions), i = f({ method: "GET" }, e, r), u = {}, [4, E(o = {}, t)];
          case 1:
            return c.sent(), I(n, u), l = e && e.headers ? e.headers : {}, i.headers = f({}, o, l, r.headers), [2, { url: _(n), options: i }];
        }
      });
    })();
  }, listRideUtilityEvents: function(a) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return v(function() {
      var s, n, e, i, o, u, l;
      return p(this, function(c) {
        switch (c.label) {
          case 0:
            return b("listRideUtilityEvents", "rideId", a), s = "/ride/{rideId}/utility-events".replace("{rideId}", encodeURIComponent(String(a))), n = new URL(s, R), t && (e = t.baseOptions), i = f({ method: "GET" }, e, r), u = {}, [4, E(o = {}, t)];
          case 1:
            return c.sent(), I(n, u), l = e && e.headers ? e.headers : {}, i.headers = f({}, o, l, r.headers), [2, { url: _(n), options: i }];
        }
      });
    })();
  }, listRides: function(a, r, s, n, e, i, o, u, l, c) {
    var d = arguments.length > 10 && arguments[10] !== void 0 ? arguments[10] : {};
    return v(function() {
      var h, g, U, P, D, j;
      return p(this, function(F) {
        switch (F.label) {
          case 0:
            return h = new URL("/ride", R), t && (g = t.baseOptions), U = f({ method: "GET" }, g, d), D = {}, [4, E(P = {}, t)];
          case 1:
            return F.sent(), a !== void 0 && (D.classId = a), r !== void 0 && (D.showId = r), s !== void 0 && (D.day = s), n !== void 0 && (D.ring = n), e !== void 0 && (D.needsReview = e), i !== void 0 && (D.riderId = i), o !== void 0 && (D.horseId = o), u !== void 0 && (D.fvdPushStatus = u), l !== void 0 && (D.unscheduled = l), c !== void 0 && (D.includeResolved = c), I(h, D), j = g && g.headers ? g.headers : {}, U.headers = f({}, P, j, d.headers), [2, { url: _(h), options: U }];
        }
      });
    })();
  }, markRideCreatedByMistake: function(a, r) {
    var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return v(function() {
      var n, e, i, o, u, l, c;
      return p(this, function(d) {
        switch (d.label) {
          case 0:
            return b("markRideCreatedByMistake", "rideId", a), n = "/ride/{rideId}/created-by-mistake".replace("{rideId}", encodeURIComponent(String(a))), e = new URL(n, R), t && (i = t.baseOptions), o = f({ method: "POST" }, i, s), l = {}, [4, E(u = {}, t)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", I(e, l), c = i && i.headers ? i.headers : {}, o.headers = f({}, u, c, s.headers), o.data = N(r, o, t), [2, { url: _(e), options: o }];
        }
      });
    })();
  }, markRideEntryRemovedInFvd: function(a, r) {
    var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return v(function() {
      var n, e, i, o, u, l, c;
      return p(this, function(d) {
        switch (d.label) {
          case 0:
            return b("markRideEntryRemovedInFvd", "rideId", a), n = "/ride/{rideId}/entry-removed-in-fvd".replace("{rideId}", encodeURIComponent(String(a))), e = new URL(n, R), t && (i = t.baseOptions), o = f({ method: "POST" }, i, s), l = {}, [4, E(u = {}, t)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", I(e, l), c = i && i.headers ? i.headers : {}, o.headers = f({}, u, c, s.headers), o.data = N(r, o, t), [2, { url: _(e), options: o }];
        }
      });
    })();
  }, markRideExcused: function(a) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return v(function() {
      var s, n, e, i, o, u, l;
      return p(this, function(c) {
        switch (c.label) {
          case 0:
            return b("markRideExcused", "rideId", a), s = "/ride/{rideId}/excused".replace("{rideId}", encodeURIComponent(String(a))), n = new URL(s, R), t && (e = t.baseOptions), i = f({ method: "POST" }, e, r), u = {}, [4, E(o = {}, t)];
          case 1:
            return c.sent(), I(n, u), l = e && e.headers ? e.headers : {}, i.headers = f({}, o, l, r.headers), [2, { url: _(n), options: i }];
        }
      });
    })();
  }, markRideNoScoreRecorded: function(a, r) {
    var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return v(function() {
      var n, e, i, o, u, l, c;
      return p(this, function(d) {
        switch (d.label) {
          case 0:
            return b("markRideNoScoreRecorded", "rideId", a), b("markRideNoScoreRecorded", "markRideNoScoreRecordedRequest", r), n = "/ride/{rideId}/no-score-recorded".replace("{rideId}", encodeURIComponent(String(a))), e = new URL(n, R), t && (i = t.baseOptions), o = f({ method: "POST" }, i, s), l = {}, [4, E(u = {}, t)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", I(e, l), c = i && i.headers ? i.headers : {}, o.headers = f({}, u, c, s.headers), o.data = N(r, o, t), [2, { url: _(e), options: o }];
        }
      });
    })();
  }, markRideNoShow: function(a) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return v(function() {
      var s, n, e, i, o, u, l;
      return p(this, function(c) {
        switch (c.label) {
          case 0:
            return b("markRideNoShow", "rideId", a), s = "/ride/{rideId}/no-show".replace("{rideId}", encodeURIComponent(String(a))), n = new URL(s, R), t && (e = t.baseOptions), i = f({ method: "POST" }, e, r), u = {}, [4, E(o = {}, t)];
          case 1:
            return c.sent(), I(n, u), l = e && e.headers ? e.headers : {}, i.headers = f({}, o, l, r.headers), [2, { url: _(n), options: i }];
        }
      });
    })();
  }, markRideWithdrawn: function(a) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return v(function() {
      var s, n, e, i, o, u, l;
      return p(this, function(c) {
        switch (c.label) {
          case 0:
            return b("markRideWithdrawn", "rideId", a), s = "/ride/{rideId}/withdrawn".replace("{rideId}", encodeURIComponent(String(a))), n = new URL(s, R), t && (e = t.baseOptions), i = f({ method: "POST" }, e, r), u = {}, [4, E(o = {}, t)];
          case 1:
            return c.sent(), I(n, u), l = e && e.headers ? e.headers : {}, i.headers = f({}, o, l, r.headers), [2, { url: _(n), options: i }];
        }
      });
    })();
  }, reconcileRideTermination: function(a) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return v(function() {
      var s, n, e, i, o, u, l;
      return p(this, function(c) {
        switch (c.label) {
          case 0:
            return b("reconcileRideTermination", "rideId", a), s = "/ride/{rideId}/reconcile-termination".replace("{rideId}", encodeURIComponent(String(a))), n = new URL(s, R), t && (e = t.baseOptions), i = f({ method: "POST" }, e, r), u = {}, [4, E(o = {}, t)];
          case 1:
            return c.sent(), I(n, u), l = e && e.headers ? e.headers : {}, i.headers = f({}, o, l, r.headers), [2, { url: _(n), options: i }];
        }
      });
    })();
  }, removeRideMovement: function(a, r) {
    var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return v(function() {
      var n, e, i, o, u, l, c;
      return p(this, function(d) {
        switch (d.label) {
          case 0:
            return b("removeRideMovement", "rideId", a), b("removeRideMovement", "movementNumber", r), n = "/ride/{rideId}/movements/{movementNumber}".replace("{rideId}", encodeURIComponent(String(a))).replace("{movementNumber}", encodeURIComponent(String(r))), e = new URL(n, R), t && (i = t.baseOptions), o = f({ method: "DELETE" }, i, s), l = {}, [4, E(u = {}, t)];
          case 1:
            return d.sent(), I(e, l), c = i && i.headers ? i.headers : {}, o.headers = f({}, u, c, s.headers), [2, { url: _(e), options: o }];
        }
      });
    })();
  }, repointRide: function(a, r) {
    var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return v(function() {
      var n, e, i, o, u, l, c;
      return p(this, function(d) {
        switch (d.label) {
          case 0:
            return b("repointRide", "rideId", a), b("repointRide", "repointRideRequest", r), n = "/ride/{rideId}/repoint".replace("{rideId}", encodeURIComponent(String(a))), e = new URL(n, R), t && (i = t.baseOptions), o = f({ method: "POST" }, i, s), l = {}, [4, E(u = {}, t)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", I(e, l), c = i && i.headers ? i.headers : {}, o.headers = f({}, u, c, s.headers), o.data = N(r, o, t), [2, { url: _(e), options: o }];
        }
      });
    })();
  }, reportFvdPushStatus: function(a) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return v(function() {
      var s, n, e, i, o, u;
      return p(this, function(l) {
        switch (l.label) {
          case 0:
            return b("reportFvdPushStatus", "reportFvdPushStatusRequest", a), s = new URL("/rides/fvd-push-status", R), t && (n = t.baseOptions), e = f({ method: "POST" }, n, r), o = {}, [4, E(i = {}, t)];
          case 1:
            return l.sent(), i["Content-Type"] = "application/json", I(s, o), u = n && n.headers ? n.headers : {}, e.headers = f({}, i, u, r.headers), e.data = N(a, e, t), [2, { url: _(s), options: e }];
        }
      });
    })();
  }, requestRideReview: function(a, r) {
    var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return v(function() {
      var n, e, i, o, u, l, c;
      return p(this, function(d) {
        switch (d.label) {
          case 0:
            return b("requestRideReview", "rideId", a), n = "/ride/{rideId}/review".replace("{rideId}", encodeURIComponent(String(a))), e = new URL(n, R), t && (i = t.baseOptions), o = f({ method: "POST" }, i, s), l = {}, [4, E(u = {}, t)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", I(e, l), c = i && i.headers ? i.headers : {}, o.headers = f({}, u, c, s.headers), o.data = N(r, o, t), [2, { url: _(e), options: o }];
        }
      });
    })();
  }, resolveManualRide: function(a, r) {
    var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return v(function() {
      var n, e, i, o, u, l, c;
      return p(this, function(d) {
        switch (d.label) {
          case 0:
            return b("resolveManualRide", "rideId", a), b("resolveManualRide", "resolveManualRideRequest", r), n = "/ride/{rideId}/resolve".replace("{rideId}", encodeURIComponent(String(a))), e = new URL(n, R), t && (i = t.baseOptions), o = f({ method: "POST" }, i, s), l = {}, [4, E(u = {}, t)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", I(e, l), c = i && i.headers ? i.headers : {}, o.headers = f({}, u, c, s.headers), o.data = N(r, o, t), [2, { url: _(e), options: o }];
        }
      });
    })();
  }, restoreRideEntryRemovedInFvd: function(a) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return v(function() {
      var s, n, e, i, o, u, l;
      return p(this, function(c) {
        switch (c.label) {
          case 0:
            return b("restoreRideEntryRemovedInFvd", "rideId", a), s = "/ride/{rideId}/restore-entry-removed-in-fvd".replace("{rideId}", encodeURIComponent(String(a))), n = new URL(s, R), t && (e = t.baseOptions), i = f({ method: "POST" }, e, r), u = {}, [4, E(o = {}, t)];
          case 1:
            return c.sent(), I(n, u), l = e && e.headers ? e.headers : {}, i.headers = f({}, o, l, r.headers), [2, { url: _(n), options: i }];
        }
      });
    })();
  }, restoreRideFromMistake: function(a) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return v(function() {
      var s, n, e, i, o, u, l;
      return p(this, function(c) {
        switch (c.label) {
          case 0:
            return b("restoreRideFromMistake", "rideId", a), s = "/ride/{rideId}/restore-from-mistake".replace("{rideId}", encodeURIComponent(String(a))), n = new URL(s, R), t && (e = t.baseOptions), i = f({ method: "POST" }, e, r), u = {}, [4, E(o = {}, t)];
          case 1:
            return c.sent(), I(n, u), l = e && e.headers ? e.headers : {}, i.headers = f({}, o, l, r.headers), [2, { url: _(n), options: i }];
        }
      });
    })();
  }, setManualRideDetails: function(a, r) {
    var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return v(function() {
      var n, e, i, o, u, l, c;
      return p(this, function(d) {
        switch (d.label) {
          case 0:
            return b("setManualRideDetails", "rideId", a), n = "/ride/{rideId}/details".replace("{rideId}", encodeURIComponent(String(a))), e = new URL(n, R), t && (i = t.baseOptions), o = f({ method: "PUT" }, i, s), l = {}, [4, E(u = {}, t)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", I(e, l), c = i && i.headers ? i.headers : {}, o.headers = f({}, u, c, s.headers), o.data = N(r, o, t), [2, { url: _(e), options: o }];
        }
      });
    })();
  }, setManualRideRing: function(a, r) {
    var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return v(function() {
      var n, e, i, o, u, l, c;
      return p(this, function(d) {
        switch (d.label) {
          case 0:
            return b("setManualRideRing", "rideId", a), b("setManualRideRing", "setManualRideRingRequest", r), n = "/ride/{rideId}/ring".replace("{rideId}", encodeURIComponent(String(a))), e = new URL(n, R), t && (i = t.baseOptions), o = f({ method: "PUT" }, i, s), l = {}, [4, E(u = {}, t)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", I(e, l), c = i && i.headers ? i.headers : {}, o.headers = f({}, u, c, s.headers), o.data = N(r, o, t), [2, { url: _(e), options: o }];
        }
      });
    })();
  }, setRideEntryTimer: function(a, r) {
    var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return v(function() {
      var n, e, i, o, u, l, c;
      return p(this, function(d) {
        switch (d.label) {
          case 0:
            return b("setRideEntryTimer", "rideId", a), b("setRideEntryTimer", "setRideEntryTimerRequest", r), n = "/ride/{rideId}/entry-timer".replace("{rideId}", encodeURIComponent(String(a))), e = new URL(n, R), t && (i = t.baseOptions), o = f({ method: "POST" }, i, s), l = {}, [4, E(u = {}, t)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", I(e, l), c = i && i.headers ? i.headers : {}, o.headers = f({}, u, c, s.headers), o.data = N(r, o, t), [2, { url: _(e), options: o }];
        }
      });
    })();
  }, setRideStatus: function(a, r) {
    var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return v(function() {
      var n, e, i, o, u, l, c;
      return p(this, function(d) {
        switch (d.label) {
          case 0:
            return b("setRideStatus", "rideId", a), b("setRideStatus", "setRideStatusRequest", r), n = "/ride/{rideId}/status".replace("{rideId}", encodeURIComponent(String(a))), e = new URL(n, R), t && (i = t.baseOptions), o = f({ method: "PUT" }, i, s), l = {}, [4, E(u = {}, t)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", I(e, l), c = i && i.headers ? i.headers : {}, o.headers = f({}, u, c, s.headers), o.data = N(r, o, t), [2, { url: _(e), options: o }];
        }
      });
    })();
  }, setRideSubsection: function(a, r) {
    var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return v(function() {
      var n, e, i, o, u, l, c;
      return p(this, function(d) {
        switch (d.label) {
          case 0:
            return b("setRideSubsection", "rideId", a), b("setRideSubsection", "setRideSubsectionRequest", r), n = "/ride/{rideId}/subsection".replace("{rideId}", encodeURIComponent(String(a))), e = new URL(n, R), t && (i = t.baseOptions), o = f({ method: "PUT" }, i, s), l = {}, [4, E(u = {}, t)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", I(e, l), c = i && i.headers ? i.headers : {}, o.headers = f({}, u, c, s.headers), o.data = N(r, o, t), [2, { url: _(e), options: o }];
        }
      });
    })();
  }, setRideTest: function(a, r) {
    var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return v(function() {
      var n, e, i, o, u, l, c;
      return p(this, function(d) {
        switch (d.label) {
          case 0:
            return b("setRideTest", "rideId", a), b("setRideTest", "setClassTestRequest", r), n = "/ride/{rideId}/test".replace("{rideId}", encodeURIComponent(String(a))), e = new URL(n, R), t && (i = t.baseOptions), o = f({ method: "PUT" }, i, s), l = {}, [4, E(u = {}, t)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", I(e, l), c = i && i.headers ? i.headers : {}, o.headers = f({}, u, c, s.headers), o.data = N(r, o, t), [2, { url: _(e), options: o }];
        }
      });
    })();
  }, undoRideExcused: function(a) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return v(function() {
      var s, n, e, i, o, u, l;
      return p(this, function(c) {
        switch (c.label) {
          case 0:
            return b("undoRideExcused", "rideId", a), s = "/ride/{rideId}/excused".replace("{rideId}", encodeURIComponent(String(a))), n = new URL(s, R), t && (e = t.baseOptions), i = f({ method: "DELETE" }, e, r), u = {}, [4, E(o = {}, t)];
          case 1:
            return c.sent(), I(n, u), l = e && e.headers ? e.headers : {}, i.headers = f({}, o, l, r.headers), [2, { url: _(n), options: i }];
        }
      });
    })();
  }, undoRideNoScoreRecorded: function(a) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return v(function() {
      var s, n, e, i, o, u, l;
      return p(this, function(c) {
        switch (c.label) {
          case 0:
            return b("undoRideNoScoreRecorded", "rideId", a), s = "/ride/{rideId}/no-score-recorded".replace("{rideId}", encodeURIComponent(String(a))), n = new URL(s, R), t && (e = t.baseOptions), i = f({ method: "DELETE" }, e, r), u = {}, [4, E(o = {}, t)];
          case 1:
            return c.sent(), I(n, u), l = e && e.headers ? e.headers : {}, i.headers = f({}, o, l, r.headers), [2, { url: _(n), options: i }];
        }
      });
    })();
  }, undoRideNoShow: function(a) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return v(function() {
      var s, n, e, i, o, u, l;
      return p(this, function(c) {
        switch (c.label) {
          case 0:
            return b("undoRideNoShow", "rideId", a), s = "/ride/{rideId}/no-show".replace("{rideId}", encodeURIComponent(String(a))), n = new URL(s, R), t && (e = t.baseOptions), i = f({ method: "DELETE" }, e, r), u = {}, [4, E(o = {}, t)];
          case 1:
            return c.sent(), I(n, u), l = e && e.headers ? e.headers : {}, i.headers = f({}, o, l, r.headers), [2, { url: _(n), options: i }];
        }
      });
    })();
  }, undoRideWithdrawn: function(a) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return v(function() {
      var s, n, e, i, o, u, l;
      return p(this, function(c) {
        switch (c.label) {
          case 0:
            return b("undoRideWithdrawn", "rideId", a), s = "/ride/{rideId}/withdrawn".replace("{rideId}", encodeURIComponent(String(a))), n = new URL(s, R), t && (e = t.baseOptions), i = f({ method: "DELETE" }, e, r), u = {}, [4, E(o = {}, t)];
          case 1:
            return c.sent(), I(n, u), l = e && e.headers ? e.headers : {}, i.headers = f({}, o, l, r.headers), [2, { url: _(n), options: i }];
        }
      });
    })();
  }, unfinalizeRide: function(a, r) {
    var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return v(function() {
      var n, e, i, o, u, l, c;
      return p(this, function(d) {
        switch (d.label) {
          case 0:
            return b("unfinalizeRide", "rideId", a), b("unfinalizeRide", "unfinalizeRideRequest", r), n = "/ride/{rideId}/unfinalize".replace("{rideId}", encodeURIComponent(String(a))), e = new URL(n, R), t && (i = t.baseOptions), o = f({ method: "POST" }, i, s), l = {}, [4, E(u = {}, t)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", I(e, l), c = i && i.headers ? i.headers : {}, o.headers = f({}, u, c, s.headers), o.data = N(r, o, t), [2, { url: _(e), options: o }];
        }
      });
    })();
  } };
}, ue = function(t) {
  var a = Hh(t);
  return { addRideMovement: function(r, s, n) {
    return v(function() {
      var e, i, o, u, l, c;
      return p(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, a.addRideMovement(r, s, n)];
          case 1:
            return o = d.sent(), l = (u = t == null ? void 0 : t.serverIndex) !== null && u !== void 0 ? u : 0, c = (i = y["RidesApi.addRideMovement"]) === null || i === void 0 || (e = i[l]) === null || e === void 0 ? void 0 : e.url, [2, function(h, g) {
              return T(o, S.default, w, t)(h, c || g);
            }];
        }
      });
    })();
  }, batchRideStatus: function(r, s) {
    return v(function() {
      var n, e, i, o, u, l;
      return p(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, a.batchRideStatus(r, s)];
          case 1:
            return i = c.sent(), u = (o = t == null ? void 0 : t.serverIndex) !== null && o !== void 0 ? o : 0, l = (e = y["RidesApi.batchRideStatus"]) === null || e === void 0 || (n = e[u]) === null || n === void 0 ? void 0 : n.url, [2, function(d, h) {
              return T(i, S.default, w, t)(d, l || h);
            }];
        }
      });
    })();
  }, batchSetRideSubsections: function(r, s) {
    return v(function() {
      var n, e, i, o, u, l;
      return p(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, a.batchSetRideSubsections(r, s)];
          case 1:
            return i = c.sent(), u = (o = t == null ? void 0 : t.serverIndex) !== null && o !== void 0 ? o : 0, l = (e = y["RidesApi.batchSetRideSubsections"]) === null || e === void 0 || (n = e[u]) === null || n === void 0 ? void 0 : n.url, [2, function(d, h) {
              return T(i, S.default, w, t)(d, l || h);
            }];
        }
      });
    })();
  }, createRide: function(r, s) {
    return v(function() {
      var n, e, i, o, u, l;
      return p(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, a.createRide(r, s)];
          case 1:
            return i = c.sent(), u = (o = t == null ? void 0 : t.serverIndex) !== null && o !== void 0 ? o : 0, l = (e = y["RidesApi.createRide"]) === null || e === void 0 || (n = e[u]) === null || n === void 0 ? void 0 : n.url, [2, function(d, h) {
              return T(i, S.default, w, t)(d, l || h);
            }];
        }
      });
    })();
  }, createRideUtilityEvent: function(r, s, n) {
    return v(function() {
      var e, i, o, u, l, c;
      return p(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, a.createRideUtilityEvent(r, s, n)];
          case 1:
            return o = d.sent(), l = (u = t == null ? void 0 : t.serverIndex) !== null && u !== void 0 ? u : 0, c = (i = y["RidesApi.createRideUtilityEvent"]) === null || i === void 0 || (e = i[l]) === null || e === void 0 ? void 0 : e.url, [2, function(h, g) {
              return T(o, S.default, w, t)(h, c || g);
            }];
        }
      });
    })();
  }, deleteRideUtilityEvent: function(r, s, n, e) {
    return v(function() {
      var i, o, u, l, c, d;
      return p(this, function(h) {
        switch (h.label) {
          case 0:
            return [4, a.deleteRideUtilityEvent(r, s, n, e)];
          case 1:
            return u = h.sent(), c = (l = t == null ? void 0 : t.serverIndex) !== null && l !== void 0 ? l : 0, d = (o = y["RidesApi.deleteRideUtilityEvent"]) === null || o === void 0 || (i = o[c]) === null || i === void 0 ? void 0 : i.url, [2, function(g, U) {
              return T(u, S.default, w, t)(g, d || U);
            }];
        }
      });
    })();
  }, dismissRideFvdPushFailure: function(r, s, n) {
    return v(function() {
      var e, i, o, u, l, c;
      return p(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, a.dismissRideFvdPushFailure(r, s, n)];
          case 1:
            return o = d.sent(), l = (u = t == null ? void 0 : t.serverIndex) !== null && u !== void 0 ? u : 0, c = (i = y["RidesApi.dismissRideFvdPushFailure"]) === null || i === void 0 || (e = i[l]) === null || e === void 0 ? void 0 : e.url, [2, function(h, g) {
              return T(o, S.default, w, t)(h, c || g);
            }];
        }
      });
    })();
  }, fillChampionshipSlot: function(r, s, n) {
    return v(function() {
      var e, i, o, u, l, c;
      return p(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, a.fillChampionshipSlot(r, s, n)];
          case 1:
            return o = d.sent(), l = (u = t == null ? void 0 : t.serverIndex) !== null && u !== void 0 ? u : 0, c = (i = y["RidesApi.fillChampionshipSlot"]) === null || i === void 0 || (e = i[l]) === null || e === void 0 ? void 0 : e.url, [2, function(h, g) {
              return T(o, S.default, w, t)(h, c || g);
            }];
        }
      });
    })();
  }, getRide: function(r, s) {
    return v(function() {
      var n, e, i, o, u, l;
      return p(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, a.getRide(r, s)];
          case 1:
            return i = c.sent(), u = (o = t == null ? void 0 : t.serverIndex) !== null && o !== void 0 ? o : 0, l = (e = y["RidesApi.getRide"]) === null || e === void 0 || (n = e[u]) === null || n === void 0 ? void 0 : n.url, [2, function(d, h) {
              return T(i, S.default, w, t)(d, l || h);
            }];
        }
      });
    })();
  }, getRideExcused: function(r, s) {
    return v(function() {
      var n, e, i, o, u, l;
      return p(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, a.getRideExcused(r, s)];
          case 1:
            return i = c.sent(), u = (o = t == null ? void 0 : t.serverIndex) !== null && o !== void 0 ? o : 0, l = (e = y["RidesApi.getRideExcused"]) === null || e === void 0 || (n = e[u]) === null || n === void 0 ? void 0 : n.url, [2, function(d, h) {
              return T(i, S.default, w, t)(d, l || h);
            }];
        }
      });
    })();
  }, getRideNoShow: function(r, s) {
    return v(function() {
      var n, e, i, o, u, l;
      return p(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, a.getRideNoShow(r, s)];
          case 1:
            return i = c.sent(), u = (o = t == null ? void 0 : t.serverIndex) !== null && o !== void 0 ? o : 0, l = (e = y["RidesApi.getRideNoShow"]) === null || e === void 0 || (n = e[u]) === null || n === void 0 ? void 0 : n.url, [2, function(d, h) {
              return T(i, S.default, w, t)(d, l || h);
            }];
        }
      });
    })();
  }, getRideWithdrawn: function(r, s) {
    return v(function() {
      var n, e, i, o, u, l;
      return p(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, a.getRideWithdrawn(r, s)];
          case 1:
            return i = c.sent(), u = (o = t == null ? void 0 : t.serverIndex) !== null && o !== void 0 ? o : 0, l = (e = y["RidesApi.getRideWithdrawn"]) === null || e === void 0 || (n = e[u]) === null || n === void 0 ? void 0 : n.url, [2, function(d, h) {
              return T(i, S.default, w, t)(d, l || h);
            }];
        }
      });
    })();
  }, listRideUtilityEvents: function(r, s) {
    return v(function() {
      var n, e, i, o, u, l;
      return p(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, a.listRideUtilityEvents(r, s)];
          case 1:
            return i = c.sent(), u = (o = t == null ? void 0 : t.serverIndex) !== null && o !== void 0 ? o : 0, l = (e = y["RidesApi.listRideUtilityEvents"]) === null || e === void 0 || (n = e[u]) === null || n === void 0 ? void 0 : n.url, [2, function(d, h) {
              return T(i, S.default, w, t)(d, l || h);
            }];
        }
      });
    })();
  }, listRides: function(r, s, n, e, i, o, u, l, c, d, h) {
    return v(function() {
      var g, U, P, D, j, F;
      return p(this, function(V) {
        switch (V.label) {
          case 0:
            return [4, a.listRides(r, s, n, e, i, o, u, l, c, d, h)];
          case 1:
            return P = V.sent(), j = (D = t == null ? void 0 : t.serverIndex) !== null && D !== void 0 ? D : 0, F = (U = y["RidesApi.listRides"]) === null || U === void 0 || (g = U[j]) === null || g === void 0 ? void 0 : g.url, [2, function(te, ge) {
              return T(P, S.default, w, t)(te, F || ge);
            }];
        }
      });
    })();
  }, markRideCreatedByMistake: function(r, s, n) {
    return v(function() {
      var e, i, o, u, l, c;
      return p(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, a.markRideCreatedByMistake(r, s, n)];
          case 1:
            return o = d.sent(), l = (u = t == null ? void 0 : t.serverIndex) !== null && u !== void 0 ? u : 0, c = (i = y["RidesApi.markRideCreatedByMistake"]) === null || i === void 0 || (e = i[l]) === null || e === void 0 ? void 0 : e.url, [2, function(h, g) {
              return T(o, S.default, w, t)(h, c || g);
            }];
        }
      });
    })();
  }, markRideEntryRemovedInFvd: function(r, s, n) {
    return v(function() {
      var e, i, o, u, l, c;
      return p(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, a.markRideEntryRemovedInFvd(r, s, n)];
          case 1:
            return o = d.sent(), l = (u = t == null ? void 0 : t.serverIndex) !== null && u !== void 0 ? u : 0, c = (i = y["RidesApi.markRideEntryRemovedInFvd"]) === null || i === void 0 || (e = i[l]) === null || e === void 0 ? void 0 : e.url, [2, function(h, g) {
              return T(o, S.default, w, t)(h, c || g);
            }];
        }
      });
    })();
  }, markRideExcused: function(r, s) {
    return v(function() {
      var n, e, i, o, u, l;
      return p(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, a.markRideExcused(r, s)];
          case 1:
            return i = c.sent(), u = (o = t == null ? void 0 : t.serverIndex) !== null && o !== void 0 ? o : 0, l = (e = y["RidesApi.markRideExcused"]) === null || e === void 0 || (n = e[u]) === null || n === void 0 ? void 0 : n.url, [2, function(d, h) {
              return T(i, S.default, w, t)(d, l || h);
            }];
        }
      });
    })();
  }, markRideNoScoreRecorded: function(r, s, n) {
    return v(function() {
      var e, i, o, u, l, c;
      return p(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, a.markRideNoScoreRecorded(r, s, n)];
          case 1:
            return o = d.sent(), l = (u = t == null ? void 0 : t.serverIndex) !== null && u !== void 0 ? u : 0, c = (i = y["RidesApi.markRideNoScoreRecorded"]) === null || i === void 0 || (e = i[l]) === null || e === void 0 ? void 0 : e.url, [2, function(h, g) {
              return T(o, S.default, w, t)(h, c || g);
            }];
        }
      });
    })();
  }, markRideNoShow: function(r, s) {
    return v(function() {
      var n, e, i, o, u, l;
      return p(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, a.markRideNoShow(r, s)];
          case 1:
            return i = c.sent(), u = (o = t == null ? void 0 : t.serverIndex) !== null && o !== void 0 ? o : 0, l = (e = y["RidesApi.markRideNoShow"]) === null || e === void 0 || (n = e[u]) === null || n === void 0 ? void 0 : n.url, [2, function(d, h) {
              return T(i, S.default, w, t)(d, l || h);
            }];
        }
      });
    })();
  }, markRideWithdrawn: function(r, s) {
    return v(function() {
      var n, e, i, o, u, l;
      return p(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, a.markRideWithdrawn(r, s)];
          case 1:
            return i = c.sent(), u = (o = t == null ? void 0 : t.serverIndex) !== null && o !== void 0 ? o : 0, l = (e = y["RidesApi.markRideWithdrawn"]) === null || e === void 0 || (n = e[u]) === null || n === void 0 ? void 0 : n.url, [2, function(d, h) {
              return T(i, S.default, w, t)(d, l || h);
            }];
        }
      });
    })();
  }, reconcileRideTermination: function(r, s) {
    return v(function() {
      var n, e, i, o, u, l;
      return p(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, a.reconcileRideTermination(r, s)];
          case 1:
            return i = c.sent(), u = (o = t == null ? void 0 : t.serverIndex) !== null && o !== void 0 ? o : 0, l = (e = y["RidesApi.reconcileRideTermination"]) === null || e === void 0 || (n = e[u]) === null || n === void 0 ? void 0 : n.url, [2, function(d, h) {
              return T(i, S.default, w, t)(d, l || h);
            }];
        }
      });
    })();
  }, removeRideMovement: function(r, s, n) {
    return v(function() {
      var e, i, o, u, l, c;
      return p(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, a.removeRideMovement(r, s, n)];
          case 1:
            return o = d.sent(), l = (u = t == null ? void 0 : t.serverIndex) !== null && u !== void 0 ? u : 0, c = (i = y["RidesApi.removeRideMovement"]) === null || i === void 0 || (e = i[l]) === null || e === void 0 ? void 0 : e.url, [2, function(h, g) {
              return T(o, S.default, w, t)(h, c || g);
            }];
        }
      });
    })();
  }, repointRide: function(r, s, n) {
    return v(function() {
      var e, i, o, u, l, c;
      return p(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, a.repointRide(r, s, n)];
          case 1:
            return o = d.sent(), l = (u = t == null ? void 0 : t.serverIndex) !== null && u !== void 0 ? u : 0, c = (i = y["RidesApi.repointRide"]) === null || i === void 0 || (e = i[l]) === null || e === void 0 ? void 0 : e.url, [2, function(h, g) {
              return T(o, S.default, w, t)(h, c || g);
            }];
        }
      });
    })();
  }, reportFvdPushStatus: function(r, s) {
    return v(function() {
      var n, e, i, o, u, l;
      return p(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, a.reportFvdPushStatus(r, s)];
          case 1:
            return i = c.sent(), u = (o = t == null ? void 0 : t.serverIndex) !== null && o !== void 0 ? o : 0, l = (e = y["RidesApi.reportFvdPushStatus"]) === null || e === void 0 || (n = e[u]) === null || n === void 0 ? void 0 : n.url, [2, function(d, h) {
              return T(i, S.default, w, t)(d, l || h);
            }];
        }
      });
    })();
  }, requestRideReview: function(r, s, n) {
    return v(function() {
      var e, i, o, u, l, c;
      return p(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, a.requestRideReview(r, s, n)];
          case 1:
            return o = d.sent(), l = (u = t == null ? void 0 : t.serverIndex) !== null && u !== void 0 ? u : 0, c = (i = y["RidesApi.requestRideReview"]) === null || i === void 0 || (e = i[l]) === null || e === void 0 ? void 0 : e.url, [2, function(h, g) {
              return T(o, S.default, w, t)(h, c || g);
            }];
        }
      });
    })();
  }, resolveManualRide: function(r, s, n) {
    return v(function() {
      var e, i, o, u, l, c;
      return p(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, a.resolveManualRide(r, s, n)];
          case 1:
            return o = d.sent(), l = (u = t == null ? void 0 : t.serverIndex) !== null && u !== void 0 ? u : 0, c = (i = y["RidesApi.resolveManualRide"]) === null || i === void 0 || (e = i[l]) === null || e === void 0 ? void 0 : e.url, [2, function(h, g) {
              return T(o, S.default, w, t)(h, c || g);
            }];
        }
      });
    })();
  }, restoreRideEntryRemovedInFvd: function(r, s) {
    return v(function() {
      var n, e, i, o, u, l;
      return p(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, a.restoreRideEntryRemovedInFvd(r, s)];
          case 1:
            return i = c.sent(), u = (o = t == null ? void 0 : t.serverIndex) !== null && o !== void 0 ? o : 0, l = (e = y["RidesApi.restoreRideEntryRemovedInFvd"]) === null || e === void 0 || (n = e[u]) === null || n === void 0 ? void 0 : n.url, [2, function(d, h) {
              return T(i, S.default, w, t)(d, l || h);
            }];
        }
      });
    })();
  }, restoreRideFromMistake: function(r, s) {
    return v(function() {
      var n, e, i, o, u, l;
      return p(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, a.restoreRideFromMistake(r, s)];
          case 1:
            return i = c.sent(), u = (o = t == null ? void 0 : t.serverIndex) !== null && o !== void 0 ? o : 0, l = (e = y["RidesApi.restoreRideFromMistake"]) === null || e === void 0 || (n = e[u]) === null || n === void 0 ? void 0 : n.url, [2, function(d, h) {
              return T(i, S.default, w, t)(d, l || h);
            }];
        }
      });
    })();
  }, setManualRideDetails: function(r, s, n) {
    return v(function() {
      var e, i, o, u, l, c;
      return p(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, a.setManualRideDetails(r, s, n)];
          case 1:
            return o = d.sent(), l = (u = t == null ? void 0 : t.serverIndex) !== null && u !== void 0 ? u : 0, c = (i = y["RidesApi.setManualRideDetails"]) === null || i === void 0 || (e = i[l]) === null || e === void 0 ? void 0 : e.url, [2, function(h, g) {
              return T(o, S.default, w, t)(h, c || g);
            }];
        }
      });
    })();
  }, setManualRideRing: function(r, s, n) {
    return v(function() {
      var e, i, o, u, l, c;
      return p(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, a.setManualRideRing(r, s, n)];
          case 1:
            return o = d.sent(), l = (u = t == null ? void 0 : t.serverIndex) !== null && u !== void 0 ? u : 0, c = (i = y["RidesApi.setManualRideRing"]) === null || i === void 0 || (e = i[l]) === null || e === void 0 ? void 0 : e.url, [2, function(h, g) {
              return T(o, S.default, w, t)(h, c || g);
            }];
        }
      });
    })();
  }, setRideEntryTimer: function(r, s, n) {
    return v(function() {
      var e, i, o, u, l, c;
      return p(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, a.setRideEntryTimer(r, s, n)];
          case 1:
            return o = d.sent(), l = (u = t == null ? void 0 : t.serverIndex) !== null && u !== void 0 ? u : 0, c = (i = y["RidesApi.setRideEntryTimer"]) === null || i === void 0 || (e = i[l]) === null || e === void 0 ? void 0 : e.url, [2, function(h, g) {
              return T(o, S.default, w, t)(h, c || g);
            }];
        }
      });
    })();
  }, setRideStatus: function(r, s, n) {
    return v(function() {
      var e, i, o, u, l, c;
      return p(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, a.setRideStatus(r, s, n)];
          case 1:
            return o = d.sent(), l = (u = t == null ? void 0 : t.serverIndex) !== null && u !== void 0 ? u : 0, c = (i = y["RidesApi.setRideStatus"]) === null || i === void 0 || (e = i[l]) === null || e === void 0 ? void 0 : e.url, [2, function(h, g) {
              return T(o, S.default, w, t)(h, c || g);
            }];
        }
      });
    })();
  }, setRideSubsection: function(r, s, n) {
    return v(function() {
      var e, i, o, u, l, c;
      return p(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, a.setRideSubsection(r, s, n)];
          case 1:
            return o = d.sent(), l = (u = t == null ? void 0 : t.serverIndex) !== null && u !== void 0 ? u : 0, c = (i = y["RidesApi.setRideSubsection"]) === null || i === void 0 || (e = i[l]) === null || e === void 0 ? void 0 : e.url, [2, function(h, g) {
              return T(o, S.default, w, t)(h, c || g);
            }];
        }
      });
    })();
  }, setRideTest: function(r, s, n) {
    return v(function() {
      var e, i, o, u, l, c;
      return p(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, a.setRideTest(r, s, n)];
          case 1:
            return o = d.sent(), l = (u = t == null ? void 0 : t.serverIndex) !== null && u !== void 0 ? u : 0, c = (i = y["RidesApi.setRideTest"]) === null || i === void 0 || (e = i[l]) === null || e === void 0 ? void 0 : e.url, [2, function(h, g) {
              return T(o, S.default, w, t)(h, c || g);
            }];
        }
      });
    })();
  }, undoRideExcused: function(r, s) {
    return v(function() {
      var n, e, i, o, u, l;
      return p(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, a.undoRideExcused(r, s)];
          case 1:
            return i = c.sent(), u = (o = t == null ? void 0 : t.serverIndex) !== null && o !== void 0 ? o : 0, l = (e = y["RidesApi.undoRideExcused"]) === null || e === void 0 || (n = e[u]) === null || n === void 0 ? void 0 : n.url, [2, function(d, h) {
              return T(i, S.default, w, t)(d, l || h);
            }];
        }
      });
    })();
  }, undoRideNoScoreRecorded: function(r, s) {
    return v(function() {
      var n, e, i, o, u, l;
      return p(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, a.undoRideNoScoreRecorded(r, s)];
          case 1:
            return i = c.sent(), u = (o = t == null ? void 0 : t.serverIndex) !== null && o !== void 0 ? o : 0, l = (e = y["RidesApi.undoRideNoScoreRecorded"]) === null || e === void 0 || (n = e[u]) === null || n === void 0 ? void 0 : n.url, [2, function(d, h) {
              return T(i, S.default, w, t)(d, l || h);
            }];
        }
      });
    })();
  }, undoRideNoShow: function(r, s) {
    return v(function() {
      var n, e, i, o, u, l;
      return p(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, a.undoRideNoShow(r, s)];
          case 1:
            return i = c.sent(), u = (o = t == null ? void 0 : t.serverIndex) !== null && o !== void 0 ? o : 0, l = (e = y["RidesApi.undoRideNoShow"]) === null || e === void 0 || (n = e[u]) === null || n === void 0 ? void 0 : n.url, [2, function(d, h) {
              return T(i, S.default, w, t)(d, l || h);
            }];
        }
      });
    })();
  }, undoRideWithdrawn: function(r, s) {
    return v(function() {
      var n, e, i, o, u, l;
      return p(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, a.undoRideWithdrawn(r, s)];
          case 1:
            return i = c.sent(), u = (o = t == null ? void 0 : t.serverIndex) !== null && o !== void 0 ? o : 0, l = (e = y["RidesApi.undoRideWithdrawn"]) === null || e === void 0 || (n = e[u]) === null || n === void 0 ? void 0 : n.url, [2, function(d, h) {
              return T(i, S.default, w, t)(d, l || h);
            }];
        }
      });
    })();
  }, unfinalizeRide: function(r, s, n) {
    return v(function() {
      var e, i, o, u, l, c;
      return p(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, a.unfinalizeRide(r, s, n)];
          case 1:
            return o = d.sent(), l = (u = t == null ? void 0 : t.serverIndex) !== null && u !== void 0 ? u : 0, c = (i = y["RidesApi.unfinalizeRide"]) === null || i === void 0 || (e = i[l]) === null || e === void 0 ? void 0 : e.url, [2, function(h, g) {
              return T(o, S.default, w, t)(h, c || g);
            }];
        }
      });
    })();
  } };
};
(function(t) {
  function a() {
    return Me(this, a), je(this, a, arguments);
  }
  return Ve(a, t), Fe(a, [{ key: "addRideMovement", value: function(r, s, n) {
    var e = this;
    return ue(this.configuration).addRideMovement(r, s, n).then(function(i) {
      return i(e.axios, e.basePath);
    });
  } }, { key: "batchRideStatus", value: function(r, s) {
    var n = this;
    return ue(this.configuration).batchRideStatus(r, s).then(function(e) {
      return e(n.axios, n.basePath);
    });
  } }, { key: "batchSetRideSubsections", value: function(r, s) {
    var n = this;
    return ue(this.configuration).batchSetRideSubsections(r, s).then(function(e) {
      return e(n.axios, n.basePath);
    });
  } }, { key: "createRide", value: function(r, s) {
    var n = this;
    return ue(this.configuration).createRide(r, s).then(function(e) {
      return e(n.axios, n.basePath);
    });
  } }, { key: "createRideUtilityEvent", value: function(r, s, n) {
    var e = this;
    return ue(this.configuration).createRideUtilityEvent(r, s, n).then(function(i) {
      return i(e.axios, e.basePath);
    });
  } }, { key: "deleteRideUtilityEvent", value: function(r, s, n, e) {
    var i = this;
    return ue(this.configuration).deleteRideUtilityEvent(r, s, n, e).then(function(o) {
      return o(i.axios, i.basePath);
    });
  } }, { key: "dismissRideFvdPushFailure", value: function(r, s, n) {
    var e = this;
    return ue(this.configuration).dismissRideFvdPushFailure(r, s, n).then(function(i) {
      return i(e.axios, e.basePath);
    });
  } }, { key: "fillChampionshipSlot", value: function(r, s, n) {
    var e = this;
    return ue(this.configuration).fillChampionshipSlot(r, s, n).then(function(i) {
      return i(e.axios, e.basePath);
    });
  } }, { key: "getRide", value: function(r, s) {
    var n = this;
    return ue(this.configuration).getRide(r, s).then(function(e) {
      return e(n.axios, n.basePath);
    });
  } }, { key: "getRideExcused", value: function(r, s) {
    var n = this;
    return ue(this.configuration).getRideExcused(r, s).then(function(e) {
      return e(n.axios, n.basePath);
    });
  } }, { key: "getRideNoShow", value: function(r, s) {
    var n = this;
    return ue(this.configuration).getRideNoShow(r, s).then(function(e) {
      return e(n.axios, n.basePath);
    });
  } }, { key: "getRideWithdrawn", value: function(r, s) {
    var n = this;
    return ue(this.configuration).getRideWithdrawn(r, s).then(function(e) {
      return e(n.axios, n.basePath);
    });
  } }, { key: "listRideUtilityEvents", value: function(r, s) {
    var n = this;
    return ue(this.configuration).listRideUtilityEvents(r, s).then(function(e) {
      return e(n.axios, n.basePath);
    });
  } }, { key: "listRides", value: function(r, s, n, e, i, o, u, l, c, d, h) {
    var g = this;
    return ue(this.configuration).listRides(r, s, n, e, i, o, u, l, c, d, h).then(function(U) {
      return U(g.axios, g.basePath);
    });
  } }, { key: "markRideCreatedByMistake", value: function(r, s, n) {
    var e = this;
    return ue(this.configuration).markRideCreatedByMistake(r, s, n).then(function(i) {
      return i(e.axios, e.basePath);
    });
  } }, { key: "markRideEntryRemovedInFvd", value: function(r, s, n) {
    var e = this;
    return ue(this.configuration).markRideEntryRemovedInFvd(r, s, n).then(function(i) {
      return i(e.axios, e.basePath);
    });
  } }, { key: "markRideExcused", value: function(r, s) {
    var n = this;
    return ue(this.configuration).markRideExcused(r, s).then(function(e) {
      return e(n.axios, n.basePath);
    });
  } }, { key: "markRideNoScoreRecorded", value: function(r, s, n) {
    var e = this;
    return ue(this.configuration).markRideNoScoreRecorded(r, s, n).then(function(i) {
      return i(e.axios, e.basePath);
    });
  } }, { key: "markRideNoShow", value: function(r, s) {
    var n = this;
    return ue(this.configuration).markRideNoShow(r, s).then(function(e) {
      return e(n.axios, n.basePath);
    });
  } }, { key: "markRideWithdrawn", value: function(r, s) {
    var n = this;
    return ue(this.configuration).markRideWithdrawn(r, s).then(function(e) {
      return e(n.axios, n.basePath);
    });
  } }, { key: "reconcileRideTermination", value: function(r, s) {
    var n = this;
    return ue(this.configuration).reconcileRideTermination(r, s).then(function(e) {
      return e(n.axios, n.basePath);
    });
  } }, { key: "removeRideMovement", value: function(r, s, n) {
    var e = this;
    return ue(this.configuration).removeRideMovement(r, s, n).then(function(i) {
      return i(e.axios, e.basePath);
    });
  } }, { key: "repointRide", value: function(r, s, n) {
    var e = this;
    return ue(this.configuration).repointRide(r, s, n).then(function(i) {
      return i(e.axios, e.basePath);
    });
  } }, { key: "reportFvdPushStatus", value: function(r, s) {
    var n = this;
    return ue(this.configuration).reportFvdPushStatus(r, s).then(function(e) {
      return e(n.axios, n.basePath);
    });
  } }, { key: "requestRideReview", value: function(r, s, n) {
    var e = this;
    return ue(this.configuration).requestRideReview(r, s, n).then(function(i) {
      return i(e.axios, e.basePath);
    });
  } }, { key: "resolveManualRide", value: function(r, s, n) {
    var e = this;
    return ue(this.configuration).resolveManualRide(r, s, n).then(function(i) {
      return i(e.axios, e.basePath);
    });
  } }, { key: "restoreRideEntryRemovedInFvd", value: function(r, s) {
    var n = this;
    return ue(this.configuration).restoreRideEntryRemovedInFvd(r, s).then(function(e) {
      return e(n.axios, n.basePath);
    });
  } }, { key: "restoreRideFromMistake", value: function(r, s) {
    var n = this;
    return ue(this.configuration).restoreRideFromMistake(r, s).then(function(e) {
      return e(n.axios, n.basePath);
    });
  } }, { key: "setManualRideDetails", value: function(r, s, n) {
    var e = this;
    return ue(this.configuration).setManualRideDetails(r, s, n).then(function(i) {
      return i(e.axios, e.basePath);
    });
  } }, { key: "setManualRideRing", value: function(r, s, n) {
    var e = this;
    return ue(this.configuration).setManualRideRing(r, s, n).then(function(i) {
      return i(e.axios, e.basePath);
    });
  } }, { key: "setRideEntryTimer", value: function(r, s, n) {
    var e = this;
    return ue(this.configuration).setRideEntryTimer(r, s, n).then(function(i) {
      return i(e.axios, e.basePath);
    });
  } }, { key: "setRideStatus", value: function(r, s, n) {
    var e = this;
    return ue(this.configuration).setRideStatus(r, s, n).then(function(i) {
      return i(e.axios, e.basePath);
    });
  } }, { key: "setRideSubsection", value: function(r, s, n) {
    var e = this;
    return ue(this.configuration).setRideSubsection(r, s, n).then(function(i) {
      return i(e.axios, e.basePath);
    });
  } }, { key: "setRideTest", value: function(r, s, n) {
    var e = this;
    return ue(this.configuration).setRideTest(r, s, n).then(function(i) {
      return i(e.axios, e.basePath);
    });
  } }, { key: "undoRideExcused", value: function(r, s) {
    var n = this;
    return ue(this.configuration).undoRideExcused(r, s).then(function(e) {
      return e(n.axios, n.basePath);
    });
  } }, { key: "undoRideNoScoreRecorded", value: function(r, s) {
    var n = this;
    return ue(this.configuration).undoRideNoScoreRecorded(r, s).then(function(e) {
      return e(n.axios, n.basePath);
    });
  } }, { key: "undoRideNoShow", value: function(r, s) {
    var n = this;
    return ue(this.configuration).undoRideNoShow(r, s).then(function(e) {
      return e(n.axios, n.basePath);
    });
  } }, { key: "undoRideWithdrawn", value: function(r, s) {
    var n = this;
    return ue(this.configuration).undoRideWithdrawn(r, s).then(function(e) {
      return e(n.axios, n.basePath);
    });
  } }, { key: "unfinalizeRide", value: function(r, s, n) {
    var e = this;
    return ue(this.configuration).unfinalizeRide(r, s, n).then(function(i) {
      return i(e.axios, e.basePath);
    });
  } }]), a;
})(Le);
var $h = function(t) {
  return { clearRingState: function(a, r) {
    var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return v(function() {
      var n, e, i, o, u, l, c;
      return p(this, function(d) {
        switch (d.label) {
          case 0:
            return b("clearRingState", "showId", a), b("clearRingState", "ring", r), n = "/ring-state/{ring}".replace("{ring}", encodeURIComponent(String(r))), e = new URL(n, R), t && (i = t.baseOptions), o = f({ method: "DELETE" }, i, s), l = {}, [4, E(u = {}, t)];
          case 1:
            return d.sent(), a !== void 0 && (l.showId = a), I(e, l), c = i && i.headers ? i.headers : {}, o.headers = f({}, u, c, s.headers), [2, { url: _(e), options: o }];
        }
      });
    })();
  }, getRingState: function(a, r) {
    var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return v(function() {
      var n, e, i, o, u, l, c;
      return p(this, function(d) {
        switch (d.label) {
          case 0:
            return b("getRingState", "showId", a), b("getRingState", "ring", r), n = "/ring-state/{ring}".replace("{ring}", encodeURIComponent(String(r))), e = new URL(n, R), t && (i = t.baseOptions), o = f({ method: "GET" }, i, s), l = {}, [4, E(u = {}, t)];
          case 1:
            return d.sent(), a !== void 0 && (l.showId = a), I(e, l), c = i && i.headers ? i.headers : {}, o.headers = f({}, u, c, s.headers), [2, { url: _(e), options: o }];
        }
      });
    })();
  }, listRingStates: function(a) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return v(function() {
      var s, n, e, i, o, u;
      return p(this, function(l) {
        switch (l.label) {
          case 0:
            return b("listRingStates", "showId", a), s = new URL("/ring-state", R), t && (n = t.baseOptions), e = f({ method: "GET" }, n, r), o = {}, [4, E(i = {}, t)];
          case 1:
            return l.sent(), a !== void 0 && (o.showId = a), I(s, o), u = n && n.headers ? n.headers : {}, e.headers = f({}, i, u, r.headers), [2, { url: _(s), options: e }];
        }
      });
    })();
  }, setRingState: function(a) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return v(function() {
      var s, n, e, i, o, u;
      return p(this, function(l) {
        switch (l.label) {
          case 0:
            return b("setRingState", "setRingStateRequest", a), s = new URL("/ring-state", R), t && (n = t.baseOptions), e = f({ method: "PUT" }, n, r), o = {}, [4, E(i = {}, t)];
          case 1:
            return l.sent(), i["Content-Type"] = "application/json", I(s, o), u = n && n.headers ? n.headers : {}, e.headers = f({}, i, u, r.headers), e.data = N(a, e, t), [2, { url: _(s), options: e }];
        }
      });
    })();
  } };
}, xr = function(t) {
  var a = $h(t);
  return { clearRingState: function(r, s, n) {
    return v(function() {
      var e, i, o, u, l, c;
      return p(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, a.clearRingState(r, s, n)];
          case 1:
            return o = d.sent(), l = (u = t == null ? void 0 : t.serverIndex) !== null && u !== void 0 ? u : 0, c = (i = y["RingStateApi.clearRingState"]) === null || i === void 0 || (e = i[l]) === null || e === void 0 ? void 0 : e.url, [2, function(h, g) {
              return T(o, S.default, w, t)(h, c || g);
            }];
        }
      });
    })();
  }, getRingState: function(r, s, n) {
    return v(function() {
      var e, i, o, u, l, c;
      return p(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, a.getRingState(r, s, n)];
          case 1:
            return o = d.sent(), l = (u = t == null ? void 0 : t.serverIndex) !== null && u !== void 0 ? u : 0, c = (i = y["RingStateApi.getRingState"]) === null || i === void 0 || (e = i[l]) === null || e === void 0 ? void 0 : e.url, [2, function(h, g) {
              return T(o, S.default, w, t)(h, c || g);
            }];
        }
      });
    })();
  }, listRingStates: function(r, s) {
    return v(function() {
      var n, e, i, o, u, l;
      return p(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, a.listRingStates(r, s)];
          case 1:
            return i = c.sent(), u = (o = t == null ? void 0 : t.serverIndex) !== null && o !== void 0 ? o : 0, l = (e = y["RingStateApi.listRingStates"]) === null || e === void 0 || (n = e[u]) === null || n === void 0 ? void 0 : n.url, [2, function(d, h) {
              return T(i, S.default, w, t)(d, l || h);
            }];
        }
      });
    })();
  }, setRingState: function(r, s) {
    return v(function() {
      var n, e, i, o, u, l;
      return p(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, a.setRingState(r, s)];
          case 1:
            return i = c.sent(), u = (o = t == null ? void 0 : t.serverIndex) !== null && o !== void 0 ? o : 0, l = (e = y["RingStateApi.setRingState"]) === null || e === void 0 || (n = e[u]) === null || n === void 0 ? void 0 : n.url, [2, function(d, h) {
              return T(i, S.default, w, t)(d, l || h);
            }];
        }
      });
    })();
  } };
};
(function(t) {
  function a() {
    return Me(this, a), je(this, a, arguments);
  }
  return Ve(a, t), Fe(a, [{ key: "clearRingState", value: function(r, s, n) {
    var e = this;
    return xr(this.configuration).clearRingState(r, s, n).then(function(i) {
      return i(e.axios, e.basePath);
    });
  } }, { key: "getRingState", value: function(r, s, n) {
    var e = this;
    return xr(this.configuration).getRingState(r, s, n).then(function(i) {
      return i(e.axios, e.basePath);
    });
  } }, { key: "listRingStates", value: function(r, s) {
    var n = this;
    return xr(this.configuration).listRingStates(r, s).then(function(e) {
      return e(n.axios, n.basePath);
    });
  } }, { key: "setRingState", value: function(r, s) {
    var n = this;
    return xr(this.configuration).setRingState(r, s).then(function(e) {
      return e(n.axios, n.basePath);
    });
  } }]), a;
})(Le);
var Wh = function(t) {
  return { addScoreSheetAnnotation: function(a, r) {
    var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return v(function() {
      var n, e, i, o, u, l, c;
      return p(this, function(d) {
        switch (d.label) {
          case 0:
            return b("addScoreSheetAnnotation", "id", a), b("addScoreSheetAnnotation", "addScoreSheetAnnotationRequest", r), n = "/scoresheet/{id}/annotations".replace("{id}", encodeURIComponent(String(a))), e = new URL(n, R), t && (i = t.baseOptions), o = f({ method: "POST" }, i, s), l = {}, [4, E(u = {}, t)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", I(e, l), c = i && i.headers ? i.headers : {}, o.headers = f({}, u, c, s.headers), o.data = N(r, o, t), [2, { url: _(e), options: o }];
        }
      });
    })();
  }, applyArchivedHeldCopy: function(a, r) {
    var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return v(function() {
      var n, e, i, o, u, l, c;
      return p(this, function(d) {
        switch (d.label) {
          case 0:
            return b("applyArchivedHeldCopy", "id", a), b("applyArchivedHeldCopy", "applyArchivedHeldCopyRequest", r), n = "/scoresheet/{id}/apply-archived-held-copy".replace("{id}", encodeURIComponent(String(a))), e = new URL(n, R), t && (i = t.baseOptions), o = f({ method: "POST" }, i, s), l = {}, [4, E(u = {}, t)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", I(e, l), c = i && i.headers ? i.headers : {}, o.headers = f({}, u, c, s.headers), o.data = N(r, o, t), [2, { url: _(e), options: o }];
        }
      });
    })();
  }, applySheetTabletMarks: function(a, r) {
    var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return v(function() {
      var n, e, i, o, u, l, c;
      return p(this, function(d) {
        switch (d.label) {
          case 0:
            return b("applySheetTabletMarks", "id", a), b("applySheetTabletMarks", "applySheetTabletMarksRequest", r), n = "/scoresheet/{id}/apply-tablet-marks".replace("{id}", encodeURIComponent(String(a))), e = new URL(n, R), t && (i = t.baseOptions), o = f({ method: "POST" }, i, s), l = {}, [4, E(u = {}, t)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", I(e, l), c = i && i.headers ? i.headers : {}, o.headers = f({}, u, c, s.headers), o.data = N(r, o, t), [2, { url: _(e), options: o }];
        }
      });
    })();
  }, commitScoreSheetEdit: function(a, r) {
    var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return v(function() {
      var n, e, i, o, u, l, c;
      return p(this, function(d) {
        switch (d.label) {
          case 0:
            return b("commitScoreSheetEdit", "id", a), b("commitScoreSheetEdit", "commitScoreSheetEditRequest", r), n = "/scoresheet/{id}/commit".replace("{id}", encodeURIComponent(String(a))), e = new URL(n, R), t && (i = t.baseOptions), o = f({ method: "POST" }, i, s), l = {}, [4, E(u = {}, t)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", I(e, l), c = i && i.headers ? i.headers : {}, o.headers = f({}, u, c, s.headers), o.data = N(r, o, t), [2, { url: _(e), options: o }];
        }
      });
    })();
  }, completeScoreSheet: function(a, r) {
    var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return v(function() {
      var n, e, i, o, u, l, c;
      return p(this, function(d) {
        switch (d.label) {
          case 0:
            return b("completeScoreSheet", "id", a), n = "/scoresheet/{id}/complete".replace("{id}", encodeURIComponent(String(a))), e = new URL(n, R), t && (i = t.baseOptions), o = f({ method: "POST" }, i, s), l = {}, [4, E(u = {}, t)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", I(e, l), c = i && i.headers ? i.headers : {}, o.headers = f({}, u, c, s.headers), o.data = N(r, o, t), [2, { url: _(e), options: o }];
        }
      });
    })();
  }, confirmScoreSheetMarks: function(a, r) {
    var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return v(function() {
      var n, e, i, o, u, l, c;
      return p(this, function(d) {
        switch (d.label) {
          case 0:
            return b("confirmScoreSheetMarks", "id", a), n = "/scoresheet/{id}/confirm-marks".replace("{id}", encodeURIComponent(String(a))), e = new URL(n, R), t && (i = t.baseOptions), o = f({ method: "POST" }, i, s), l = {}, [4, E(u = {}, t)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", I(e, l), c = i && i.headers ? i.headers : {}, o.headers = f({}, u, c, s.headers), o.data = N(r, o, t), [2, { url: _(e), options: o }];
        }
      });
    })();
  }, createScoreSheet: function(a) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return v(function() {
      var s, n, e, i, o, u;
      return p(this, function(l) {
        switch (l.label) {
          case 0:
            return s = new URL("/scoresheet", R), t && (n = t.baseOptions), e = f({ method: "POST" }, n, r), o = {}, [4, E(i = {}, t)];
          case 1:
            return l.sent(), i["Content-Type"] = "application/json", I(s, o), u = n && n.headers ? n.headers : {}, e.headers = f({}, i, u, r.headers), e.data = N(a, e, t), [2, { url: _(s), options: e }];
        }
      });
    })();
  }, discardScoreSheetDraft: function(a) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return v(function() {
      var s, n, e, i, o, u, l;
      return p(this, function(c) {
        switch (c.label) {
          case 0:
            return b("discardScoreSheetDraft", "id", a), s = "/scoresheet/{id}/draft".replace("{id}", encodeURIComponent(String(a))), n = new URL(s, R), t && (e = t.baseOptions), i = f({ method: "DELETE" }, e, r), u = {}, [4, E(o = {}, t)];
          case 1:
            return c.sent(), I(n, u), l = e && e.headers ? e.headers : {}, i.headers = f({}, o, l, r.headers), [2, { url: _(n), options: i }];
        }
      });
    })();
  }, getRideAuditTrail: function(a) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return v(function() {
      var s, n, e, i, o, u, l;
      return p(this, function(c) {
        switch (c.label) {
          case 0:
            return b("getRideAuditTrail", "rideId", a), s = "/ride/{rideId}/audit".replace("{rideId}", encodeURIComponent(String(a))), n = new URL(s, R), t && (e = t.baseOptions), i = f({ method: "GET" }, e, r), u = {}, [4, E(o = {}, t)];
          case 1:
            return c.sent(), I(n, u), l = e && e.headers ? e.headers : {}, i.headers = f({}, o, l, r.headers), [2, { url: _(n), options: i }];
        }
      });
    })();
  }, getScoreSheet: function(a) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return v(function() {
      var s, n, e, i, o, u, l;
      return p(this, function(c) {
        switch (c.label) {
          case 0:
            return b("getScoreSheet", "id", a), s = "/scoresheet/{id}".replace("{id}", encodeURIComponent(String(a))), n = new URL(s, R), t && (e = t.baseOptions), i = f({ method: "GET" }, e, r), u = {}, [4, E(o = {}, t)];
          case 1:
            return c.sent(), I(n, u), l = e && e.headers ? e.headers : {}, i.headers = f({}, o, l, r.headers), [2, { url: _(n), options: i }];
        }
      });
    })();
  }, getScoreSheetAuditTrail: function(a) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return v(function() {
      var s, n, e, i, o, u, l;
      return p(this, function(c) {
        switch (c.label) {
          case 0:
            return b("getScoreSheetAuditTrail", "id", a), s = "/scoresheet/{id}/audit".replace("{id}", encodeURIComponent(String(a))), n = new URL(s, R), t && (e = t.baseOptions), i = f({ method: "GET" }, e, r), u = {}, [4, E(o = {}, t)];
          case 1:
            return c.sent(), I(n, u), l = e && e.headers ? e.headers : {}, i.headers = f({}, o, l, r.headers), [2, { url: _(n), options: i }];
        }
      });
    })();
  }, getScoreSheetDraft: function(a) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return v(function() {
      var s, n, e, i, o, u, l;
      return p(this, function(c) {
        switch (c.label) {
          case 0:
            return b("getScoreSheetDraft", "id", a), s = "/scoresheet/{id}/draft".replace("{id}", encodeURIComponent(String(a))), n = new URL(s, R), t && (e = t.baseOptions), i = f({ method: "GET" }, e, r), u = {}, [4, E(o = {}, t)];
          case 1:
            return c.sent(), I(n, u), l = e && e.headers ? e.headers : {}, i.headers = f({}, o, l, r.headers), [2, { url: _(n), options: i }];
        }
      });
    })();
  }, getScoreSheetSignature: function(a) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return v(function() {
      var s, n, e, i, o, u, l;
      return p(this, function(c) {
        switch (c.label) {
          case 0:
            return b("getScoreSheetSignature", "id", a), s = "/scoresheet/{id}/signature".replace("{id}", encodeURIComponent(String(a))), n = new URL(s, R), t && (e = t.baseOptions), i = f({ method: "GET" }, e, r), u = {}, [4, E(o = {}, t)];
          case 1:
            return c.sent(), I(n, u), l = e && e.headers ? e.headers : {}, i.headers = f({}, o, l, r.headers), [2, { url: _(n), options: i }];
        }
      });
    })();
  }, getSheetTabletMarks: function(a) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return v(function() {
      var s, n, e, i, o, u, l;
      return p(this, function(c) {
        switch (c.label) {
          case 0:
            return b("getSheetTabletMarks", "id", a), s = "/scoresheet/{id}/tablet-marks".replace("{id}", encodeURIComponent(String(a))), n = new URL(s, R), t && (e = t.baseOptions), i = f({ method: "GET" }, e, r), u = {}, [4, E(o = {}, t)];
          case 1:
            return c.sent(), I(n, u), l = e && e.headers ? e.headers : {}, i.headers = f({}, o, l, r.headers), [2, { url: _(n), options: i }];
        }
      });
    })();
  }, listScoreSheets: function(a, r) {
    var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return v(function() {
      var n, e, i, o, u, l;
      return p(this, function(c) {
        switch (c.label) {
          case 0:
            return n = new URL("/scoresheet", R), t && (e = t.baseOptions), i = f({ method: "GET" }, e, s), u = {}, [4, E(o = {}, t)];
          case 1:
            return c.sent(), a !== void 0 && (u.rideId = a), r !== void 0 && (u.judgeId = r), I(n, u), l = e && e.headers ? e.headers : {}, i.headers = f({}, o, l, s.headers), [2, { url: _(n), options: i }];
        }
      });
    })();
  }, listScoreSheetsForRides: function(a) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return v(function() {
      var s, n, e, i, o, u;
      return p(this, function(l) {
        switch (l.label) {
          case 0:
            return b("listScoreSheetsForRides", "listScoreSheetsForRidesRequest", a), s = new URL("/scoresheet/batch", R), t && (n = t.baseOptions), e = f({ method: "POST" }, n, r), o = {}, [4, E(i = {}, t)];
          case 1:
            return l.sent(), i["Content-Type"] = "application/json", I(s, o), u = n && n.headers ? n.headers : {}, e.headers = f({}, i, u, r.headers), e.data = N(a, e, t), [2, { url: _(s), options: e }];
        }
      });
    })();
  }, markScoreSheetCreatedByMistake: function(a, r) {
    var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return v(function() {
      var n, e, i, o, u, l, c;
      return p(this, function(d) {
        switch (d.label) {
          case 0:
            return b("markScoreSheetCreatedByMistake", "id", a), n = "/scoresheet/{id}/created-by-mistake".replace("{id}", encodeURIComponent(String(a))), e = new URL(n, R), t && (i = t.baseOptions), o = f({ method: "POST" }, i, s), l = {}, [4, E(u = {}, t)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", I(e, l), c = i && i.headers ? i.headers : {}, o.headers = f({}, u, c, s.headers), o.data = N(r, o, t), [2, { url: _(e), options: o }];
        }
      });
    })();
  }, pickSheetVersion: function(a, r) {
    var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return v(function() {
      var n, e, i, o, u, l, c;
      return p(this, function(d) {
        switch (d.label) {
          case 0:
            return b("pickSheetVersion", "id", a), b("pickSheetVersion", "pickSheetVersionRequest", r), n = "/scoresheet/{id}/pick-version".replace("{id}", encodeURIComponent(String(a))), e = new URL(n, R), t && (i = t.baseOptions), o = f({ method: "POST" }, i, s), l = {}, [4, E(u = {}, t)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", I(e, l), c = i && i.headers ? i.headers : {}, o.headers = f({}, u, c, s.headers), o.data = N(r, o, t), [2, { url: _(e), options: o }];
        }
      });
    })();
  }, previewSheetVersionTotals: function(a, r) {
    var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return v(function() {
      var n, e, i, o, u, l, c;
      return p(this, function(d) {
        switch (d.label) {
          case 0:
            return b("previewSheetVersionTotals", "version", a), b("previewSheetVersionTotals", "id", r), n = "/scoresheet/{id}/pick-version-preview".replace("{id}", encodeURIComponent(String(r))), e = new URL(n, R), t && (i = t.baseOptions), o = f({ method: "GET" }, i, s), l = {}, [4, E(u = {}, t)];
          case 1:
            return d.sent(), a !== void 0 && (l.version = a), I(e, l), c = i && i.headers ? i.headers : {}, o.headers = f({}, u, c, s.headers), [2, { url: _(e), options: o }];
        }
      });
    })();
  }, putScoreSheetDraft: function(a, r) {
    var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return v(function() {
      var n, e, i, o, u, l, c;
      return p(this, function(d) {
        switch (d.label) {
          case 0:
            return b("putScoreSheetDraft", "id", a), n = "/scoresheet/{id}/draft".replace("{id}", encodeURIComponent(String(a))), e = new URL(n, R), t && (i = t.baseOptions), o = f({ method: "PUT" }, i, s), l = {}, [4, E(u = {}, t)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", I(e, l), c = i && i.headers ? i.headers : {}, o.headers = f({}, u, c, s.headers), o.data = N(r, o, t), [2, { url: _(e), options: o }];
        }
      });
    })();
  }, rereadScoreSheetTest: function(a) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return v(function() {
      var s, n, e, i, o, u, l;
      return p(this, function(c) {
        switch (c.label) {
          case 0:
            return b("rereadScoreSheetTest", "id", a), s = "/scoresheet/{id}/reread-test".replace("{id}", encodeURIComponent(String(a))), n = new URL(s, R), t && (e = t.baseOptions), i = f({ method: "POST" }, e, r), u = {}, [4, E(o = {}, t)];
          case 1:
            return c.sent(), I(n, u), l = e && e.headers ? e.headers : {}, i.headers = f({}, o, l, r.headers), [2, { url: _(n), options: i }];
        }
      });
    })();
  }, resolveStaleWriteConflict: function(a, r) {
    var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return v(function() {
      var n, e, i, o, u, l, c;
      return p(this, function(d) {
        switch (d.label) {
          case 0:
            return b("resolveStaleWriteConflict", "id", a), b("resolveStaleWriteConflict", "resolveStaleWriteConflictRequest", r), n = "/scoresheet/{id}/resolve-stale-write-conflict".replace("{id}", encodeURIComponent(String(a))), e = new URL(n, R), t && (i = t.baseOptions), o = f({ method: "POST" }, i, s), l = {}, [4, E(u = {}, t)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", I(e, l), c = i && i.headers ? i.headers : {}, o.headers = f({}, u, c, s.headers), o.data = N(r, o, t), [2, { url: _(e), options: o }];
        }
      });
    })();
  }, restoreScoreSheetFromMistake: function(a) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return v(function() {
      var s, n, e, i, o, u, l;
      return p(this, function(c) {
        switch (c.label) {
          case 0:
            return b("restoreScoreSheetFromMistake", "id", a), s = "/scoresheet/{id}/restore-from-mistake".replace("{id}", encodeURIComponent(String(a))), n = new URL(s, R), t && (e = t.baseOptions), i = f({ method: "POST" }, e, r), u = {}, [4, E(o = {}, t)];
          case 1:
            return c.sent(), I(n, u), l = e && e.headers ? e.headers : {}, i.headers = f({}, o, l, r.headers), [2, { url: _(n), options: i }];
        }
      });
    })();
  }, restoreScoreSheetVersion: function(a, r) {
    var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return v(function() {
      var n, e, i, o, u, l, c;
      return p(this, function(d) {
        switch (d.label) {
          case 0:
            return b("restoreScoreSheetVersion", "id", a), b("restoreScoreSheetVersion", "restoreScoreSheetVersionRequest", r), n = "/scoresheet/{id}/restore".replace("{id}", encodeURIComponent(String(a))), e = new URL(n, R), t && (i = t.baseOptions), o = f({ method: "POST" }, i, s), l = {}, [4, E(u = {}, t)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", I(e, l), c = i && i.headers ? i.headers : {}, o.headers = f({}, u, c, s.headers), o.data = N(r, o, t), [2, { url: _(e), options: o }];
        }
      });
    })();
  }, signScoreSheetPanel: function(a, r) {
    var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return v(function() {
      var n, e, i, o, u, l, c;
      return p(this, function(d) {
        switch (d.label) {
          case 0:
            return b("signScoreSheetPanel", "id", a), b("signScoreSheetPanel", "signScoreSheetPanelRequest", r), n = "/scoresheet/{id}/panel-signature".replace("{id}", encodeURIComponent(String(a))), e = new URL(n, R), t && (i = t.baseOptions), o = f({ method: "POST" }, i, s), l = {}, [4, E(u = {}, t)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", I(e, l), c = i && i.headers ? i.headers : {}, o.headers = f({}, u, c, s.headers), o.data = N(r, o, t), [2, { url: _(e), options: o }];
        }
      });
    })();
  }, switchAuthoritativeScoreSheet: function(a) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return v(function() {
      var s, n, e, i, o, u, l;
      return p(this, function(c) {
        switch (c.label) {
          case 0:
            return b("switchAuthoritativeScoreSheet", "id", a), s = "/scoresheet/{id}/switch-authoritative".replace("{id}", encodeURIComponent(String(a))), n = new URL(s, R), t && (e = t.baseOptions), i = f({ method: "POST" }, e, r), u = {}, [4, E(o = {}, t)];
          case 1:
            return c.sent(), I(n, u), l = e && e.headers ? e.headers : {}, i.headers = f({}, o, l, r.headers), [2, { url: _(n), options: i }];
        }
      });
    })();
  }, unlockScoreSheet: function(a, r) {
    var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return v(function() {
      var n, e, i, o, u, l, c;
      return p(this, function(d) {
        switch (d.label) {
          case 0:
            return b("unlockScoreSheet", "id", a), b("unlockScoreSheet", "unlockScoreSheetRequest", r), n = "/scoresheet/{id}/unlock".replace("{id}", encodeURIComponent(String(a))), e = new URL(n, R), t && (i = t.baseOptions), o = f({ method: "POST" }, i, s), l = {}, [4, E(u = {}, t)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", I(e, l), c = i && i.headers ? i.headers : {}, o.headers = f({}, u, c, s.headers), o.data = N(r, o, t), [2, { url: _(e), options: o }];
        }
      });
    })();
  }, updateScoreSheet: function(a, r) {
    var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return v(function() {
      var n, e, i, o, u, l, c;
      return p(this, function(d) {
        switch (d.label) {
          case 0:
            return b("updateScoreSheet", "id", a), n = "/scoresheet/{id}".replace("{id}", encodeURIComponent(String(a))), e = new URL(n, R), t && (i = t.baseOptions), o = f({ method: "PUT" }, i, s), l = {}, [4, E(u = {}, t)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", I(e, l), c = i && i.headers ? i.headers : {}, o.headers = f({}, u, c, s.headers), o.data = N(r, o, t), [2, { url: _(e), options: o }];
        }
      });
    })();
  } };
}, Ae = function(t) {
  var a = Wh(t);
  return { addScoreSheetAnnotation: function(r, s, n) {
    return v(function() {
      var e, i, o, u, l, c;
      return p(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, a.addScoreSheetAnnotation(r, s, n)];
          case 1:
            return o = d.sent(), l = (u = t == null ? void 0 : t.serverIndex) !== null && u !== void 0 ? u : 0, c = (i = y["ScoreSheetsApi.addScoreSheetAnnotation"]) === null || i === void 0 || (e = i[l]) === null || e === void 0 ? void 0 : e.url, [2, function(h, g) {
              return T(o, S.default, w, t)(h, c || g);
            }];
        }
      });
    })();
  }, applyArchivedHeldCopy: function(r, s, n) {
    return v(function() {
      var e, i, o, u, l, c;
      return p(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, a.applyArchivedHeldCopy(r, s, n)];
          case 1:
            return o = d.sent(), l = (u = t == null ? void 0 : t.serverIndex) !== null && u !== void 0 ? u : 0, c = (i = y["ScoreSheetsApi.applyArchivedHeldCopy"]) === null || i === void 0 || (e = i[l]) === null || e === void 0 ? void 0 : e.url, [2, function(h, g) {
              return T(o, S.default, w, t)(h, c || g);
            }];
        }
      });
    })();
  }, applySheetTabletMarks: function(r, s, n) {
    return v(function() {
      var e, i, o, u, l, c;
      return p(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, a.applySheetTabletMarks(r, s, n)];
          case 1:
            return o = d.sent(), l = (u = t == null ? void 0 : t.serverIndex) !== null && u !== void 0 ? u : 0, c = (i = y["ScoreSheetsApi.applySheetTabletMarks"]) === null || i === void 0 || (e = i[l]) === null || e === void 0 ? void 0 : e.url, [2, function(h, g) {
              return T(o, S.default, w, t)(h, c || g);
            }];
        }
      });
    })();
  }, commitScoreSheetEdit: function(r, s, n) {
    return v(function() {
      var e, i, o, u, l, c;
      return p(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, a.commitScoreSheetEdit(r, s, n)];
          case 1:
            return o = d.sent(), l = (u = t == null ? void 0 : t.serverIndex) !== null && u !== void 0 ? u : 0, c = (i = y["ScoreSheetsApi.commitScoreSheetEdit"]) === null || i === void 0 || (e = i[l]) === null || e === void 0 ? void 0 : e.url, [2, function(h, g) {
              return T(o, S.default, w, t)(h, c || g);
            }];
        }
      });
    })();
  }, completeScoreSheet: function(r, s, n) {
    return v(function() {
      var e, i, o, u, l, c;
      return p(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, a.completeScoreSheet(r, s, n)];
          case 1:
            return o = d.sent(), l = (u = t == null ? void 0 : t.serverIndex) !== null && u !== void 0 ? u : 0, c = (i = y["ScoreSheetsApi.completeScoreSheet"]) === null || i === void 0 || (e = i[l]) === null || e === void 0 ? void 0 : e.url, [2, function(h, g) {
              return T(o, S.default, w, t)(h, c || g);
            }];
        }
      });
    })();
  }, confirmScoreSheetMarks: function(r, s, n) {
    return v(function() {
      var e, i, o, u, l, c;
      return p(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, a.confirmScoreSheetMarks(r, s, n)];
          case 1:
            return o = d.sent(), l = (u = t == null ? void 0 : t.serverIndex) !== null && u !== void 0 ? u : 0, c = (i = y["ScoreSheetsApi.confirmScoreSheetMarks"]) === null || i === void 0 || (e = i[l]) === null || e === void 0 ? void 0 : e.url, [2, function(h, g) {
              return T(o, S.default, w, t)(h, c || g);
            }];
        }
      });
    })();
  }, createScoreSheet: function(r, s) {
    return v(function() {
      var n, e, i, o, u, l;
      return p(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, a.createScoreSheet(r, s)];
          case 1:
            return i = c.sent(), u = (o = t == null ? void 0 : t.serverIndex) !== null && o !== void 0 ? o : 0, l = (e = y["ScoreSheetsApi.createScoreSheet"]) === null || e === void 0 || (n = e[u]) === null || n === void 0 ? void 0 : n.url, [2, function(d, h) {
              return T(i, S.default, w, t)(d, l || h);
            }];
        }
      });
    })();
  }, discardScoreSheetDraft: function(r, s) {
    return v(function() {
      var n, e, i, o, u, l;
      return p(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, a.discardScoreSheetDraft(r, s)];
          case 1:
            return i = c.sent(), u = (o = t == null ? void 0 : t.serverIndex) !== null && o !== void 0 ? o : 0, l = (e = y["ScoreSheetsApi.discardScoreSheetDraft"]) === null || e === void 0 || (n = e[u]) === null || n === void 0 ? void 0 : n.url, [2, function(d, h) {
              return T(i, S.default, w, t)(d, l || h);
            }];
        }
      });
    })();
  }, getRideAuditTrail: function(r, s) {
    return v(function() {
      var n, e, i, o, u, l;
      return p(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, a.getRideAuditTrail(r, s)];
          case 1:
            return i = c.sent(), u = (o = t == null ? void 0 : t.serverIndex) !== null && o !== void 0 ? o : 0, l = (e = y["ScoreSheetsApi.getRideAuditTrail"]) === null || e === void 0 || (n = e[u]) === null || n === void 0 ? void 0 : n.url, [2, function(d, h) {
              return T(i, S.default, w, t)(d, l || h);
            }];
        }
      });
    })();
  }, getScoreSheet: function(r, s) {
    return v(function() {
      var n, e, i, o, u, l;
      return p(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, a.getScoreSheet(r, s)];
          case 1:
            return i = c.sent(), u = (o = t == null ? void 0 : t.serverIndex) !== null && o !== void 0 ? o : 0, l = (e = y["ScoreSheetsApi.getScoreSheet"]) === null || e === void 0 || (n = e[u]) === null || n === void 0 ? void 0 : n.url, [2, function(d, h) {
              return T(i, S.default, w, t)(d, l || h);
            }];
        }
      });
    })();
  }, getScoreSheetAuditTrail: function(r, s) {
    return v(function() {
      var n, e, i, o, u, l;
      return p(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, a.getScoreSheetAuditTrail(r, s)];
          case 1:
            return i = c.sent(), u = (o = t == null ? void 0 : t.serverIndex) !== null && o !== void 0 ? o : 0, l = (e = y["ScoreSheetsApi.getScoreSheetAuditTrail"]) === null || e === void 0 || (n = e[u]) === null || n === void 0 ? void 0 : n.url, [2, function(d, h) {
              return T(i, S.default, w, t)(d, l || h);
            }];
        }
      });
    })();
  }, getScoreSheetDraft: function(r, s) {
    return v(function() {
      var n, e, i, o, u, l;
      return p(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, a.getScoreSheetDraft(r, s)];
          case 1:
            return i = c.sent(), u = (o = t == null ? void 0 : t.serverIndex) !== null && o !== void 0 ? o : 0, l = (e = y["ScoreSheetsApi.getScoreSheetDraft"]) === null || e === void 0 || (n = e[u]) === null || n === void 0 ? void 0 : n.url, [2, function(d, h) {
              return T(i, S.default, w, t)(d, l || h);
            }];
        }
      });
    })();
  }, getScoreSheetSignature: function(r, s) {
    return v(function() {
      var n, e, i, o, u, l;
      return p(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, a.getScoreSheetSignature(r, s)];
          case 1:
            return i = c.sent(), u = (o = t == null ? void 0 : t.serverIndex) !== null && o !== void 0 ? o : 0, l = (e = y["ScoreSheetsApi.getScoreSheetSignature"]) === null || e === void 0 || (n = e[u]) === null || n === void 0 ? void 0 : n.url, [2, function(d, h) {
              return T(i, S.default, w, t)(d, l || h);
            }];
        }
      });
    })();
  }, getSheetTabletMarks: function(r, s) {
    return v(function() {
      var n, e, i, o, u, l;
      return p(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, a.getSheetTabletMarks(r, s)];
          case 1:
            return i = c.sent(), u = (o = t == null ? void 0 : t.serverIndex) !== null && o !== void 0 ? o : 0, l = (e = y["ScoreSheetsApi.getSheetTabletMarks"]) === null || e === void 0 || (n = e[u]) === null || n === void 0 ? void 0 : n.url, [2, function(d, h) {
              return T(i, S.default, w, t)(d, l || h);
            }];
        }
      });
    })();
  }, listScoreSheets: function(r, s, n) {
    return v(function() {
      var e, i, o, u, l, c;
      return p(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, a.listScoreSheets(r, s, n)];
          case 1:
            return o = d.sent(), l = (u = t == null ? void 0 : t.serverIndex) !== null && u !== void 0 ? u : 0, c = (i = y["ScoreSheetsApi.listScoreSheets"]) === null || i === void 0 || (e = i[l]) === null || e === void 0 ? void 0 : e.url, [2, function(h, g) {
              return T(o, S.default, w, t)(h, c || g);
            }];
        }
      });
    })();
  }, listScoreSheetsForRides: function(r, s) {
    return v(function() {
      var n, e, i, o, u, l;
      return p(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, a.listScoreSheetsForRides(r, s)];
          case 1:
            return i = c.sent(), u = (o = t == null ? void 0 : t.serverIndex) !== null && o !== void 0 ? o : 0, l = (e = y["ScoreSheetsApi.listScoreSheetsForRides"]) === null || e === void 0 || (n = e[u]) === null || n === void 0 ? void 0 : n.url, [2, function(d, h) {
              return T(i, S.default, w, t)(d, l || h);
            }];
        }
      });
    })();
  }, markScoreSheetCreatedByMistake: function(r, s, n) {
    return v(function() {
      var e, i, o, u, l, c;
      return p(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, a.markScoreSheetCreatedByMistake(r, s, n)];
          case 1:
            return o = d.sent(), l = (u = t == null ? void 0 : t.serverIndex) !== null && u !== void 0 ? u : 0, c = (i = y["ScoreSheetsApi.markScoreSheetCreatedByMistake"]) === null || i === void 0 || (e = i[l]) === null || e === void 0 ? void 0 : e.url, [2, function(h, g) {
              return T(o, S.default, w, t)(h, c || g);
            }];
        }
      });
    })();
  }, pickSheetVersion: function(r, s, n) {
    return v(function() {
      var e, i, o, u, l, c;
      return p(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, a.pickSheetVersion(r, s, n)];
          case 1:
            return o = d.sent(), l = (u = t == null ? void 0 : t.serverIndex) !== null && u !== void 0 ? u : 0, c = (i = y["ScoreSheetsApi.pickSheetVersion"]) === null || i === void 0 || (e = i[l]) === null || e === void 0 ? void 0 : e.url, [2, function(h, g) {
              return T(o, S.default, w, t)(h, c || g);
            }];
        }
      });
    })();
  }, previewSheetVersionTotals: function(r, s, n) {
    return v(function() {
      var e, i, o, u, l, c;
      return p(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, a.previewSheetVersionTotals(r, s, n)];
          case 1:
            return o = d.sent(), l = (u = t == null ? void 0 : t.serverIndex) !== null && u !== void 0 ? u : 0, c = (i = y["ScoreSheetsApi.previewSheetVersionTotals"]) === null || i === void 0 || (e = i[l]) === null || e === void 0 ? void 0 : e.url, [2, function(h, g) {
              return T(o, S.default, w, t)(h, c || g);
            }];
        }
      });
    })();
  }, putScoreSheetDraft: function(r, s, n) {
    return v(function() {
      var e, i, o, u, l, c;
      return p(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, a.putScoreSheetDraft(r, s, n)];
          case 1:
            return o = d.sent(), l = (u = t == null ? void 0 : t.serverIndex) !== null && u !== void 0 ? u : 0, c = (i = y["ScoreSheetsApi.putScoreSheetDraft"]) === null || i === void 0 || (e = i[l]) === null || e === void 0 ? void 0 : e.url, [2, function(h, g) {
              return T(o, S.default, w, t)(h, c || g);
            }];
        }
      });
    })();
  }, rereadScoreSheetTest: function(r, s) {
    return v(function() {
      var n, e, i, o, u, l;
      return p(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, a.rereadScoreSheetTest(r, s)];
          case 1:
            return i = c.sent(), u = (o = t == null ? void 0 : t.serverIndex) !== null && o !== void 0 ? o : 0, l = (e = y["ScoreSheetsApi.rereadScoreSheetTest"]) === null || e === void 0 || (n = e[u]) === null || n === void 0 ? void 0 : n.url, [2, function(d, h) {
              return T(i, S.default, w, t)(d, l || h);
            }];
        }
      });
    })();
  }, resolveStaleWriteConflict: function(r, s, n) {
    return v(function() {
      var e, i, o, u, l, c;
      return p(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, a.resolveStaleWriteConflict(r, s, n)];
          case 1:
            return o = d.sent(), l = (u = t == null ? void 0 : t.serverIndex) !== null && u !== void 0 ? u : 0, c = (i = y["ScoreSheetsApi.resolveStaleWriteConflict"]) === null || i === void 0 || (e = i[l]) === null || e === void 0 ? void 0 : e.url, [2, function(h, g) {
              return T(o, S.default, w, t)(h, c || g);
            }];
        }
      });
    })();
  }, restoreScoreSheetFromMistake: function(r, s) {
    return v(function() {
      var n, e, i, o, u, l;
      return p(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, a.restoreScoreSheetFromMistake(r, s)];
          case 1:
            return i = c.sent(), u = (o = t == null ? void 0 : t.serverIndex) !== null && o !== void 0 ? o : 0, l = (e = y["ScoreSheetsApi.restoreScoreSheetFromMistake"]) === null || e === void 0 || (n = e[u]) === null || n === void 0 ? void 0 : n.url, [2, function(d, h) {
              return T(i, S.default, w, t)(d, l || h);
            }];
        }
      });
    })();
  }, restoreScoreSheetVersion: function(r, s, n) {
    return v(function() {
      var e, i, o, u, l, c;
      return p(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, a.restoreScoreSheetVersion(r, s, n)];
          case 1:
            return o = d.sent(), l = (u = t == null ? void 0 : t.serverIndex) !== null && u !== void 0 ? u : 0, c = (i = y["ScoreSheetsApi.restoreScoreSheetVersion"]) === null || i === void 0 || (e = i[l]) === null || e === void 0 ? void 0 : e.url, [2, function(h, g) {
              return T(o, S.default, w, t)(h, c || g);
            }];
        }
      });
    })();
  }, signScoreSheetPanel: function(r, s, n) {
    return v(function() {
      var e, i, o, u, l, c;
      return p(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, a.signScoreSheetPanel(r, s, n)];
          case 1:
            return o = d.sent(), l = (u = t == null ? void 0 : t.serverIndex) !== null && u !== void 0 ? u : 0, c = (i = y["ScoreSheetsApi.signScoreSheetPanel"]) === null || i === void 0 || (e = i[l]) === null || e === void 0 ? void 0 : e.url, [2, function(h, g) {
              return T(o, S.default, w, t)(h, c || g);
            }];
        }
      });
    })();
  }, switchAuthoritativeScoreSheet: function(r, s) {
    return v(function() {
      var n, e, i, o, u, l;
      return p(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, a.switchAuthoritativeScoreSheet(r, s)];
          case 1:
            return i = c.sent(), u = (o = t == null ? void 0 : t.serverIndex) !== null && o !== void 0 ? o : 0, l = (e = y["ScoreSheetsApi.switchAuthoritativeScoreSheet"]) === null || e === void 0 || (n = e[u]) === null || n === void 0 ? void 0 : n.url, [2, function(d, h) {
              return T(i, S.default, w, t)(d, l || h);
            }];
        }
      });
    })();
  }, unlockScoreSheet: function(r, s, n) {
    return v(function() {
      var e, i, o, u, l, c;
      return p(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, a.unlockScoreSheet(r, s, n)];
          case 1:
            return o = d.sent(), l = (u = t == null ? void 0 : t.serverIndex) !== null && u !== void 0 ? u : 0, c = (i = y["ScoreSheetsApi.unlockScoreSheet"]) === null || i === void 0 || (e = i[l]) === null || e === void 0 ? void 0 : e.url, [2, function(h, g) {
              return T(o, S.default, w, t)(h, c || g);
            }];
        }
      });
    })();
  }, updateScoreSheet: function(r, s, n) {
    return v(function() {
      var e, i, o, u, l, c;
      return p(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, a.updateScoreSheet(r, s, n)];
          case 1:
            return o = d.sent(), l = (u = t == null ? void 0 : t.serverIndex) !== null && u !== void 0 ? u : 0, c = (i = y["ScoreSheetsApi.updateScoreSheet"]) === null || i === void 0 || (e = i[l]) === null || e === void 0 ? void 0 : e.url, [2, function(h, g) {
              return T(o, S.default, w, t)(h, c || g);
            }];
        }
      });
    })();
  } };
};
(function(t) {
  function a() {
    return Me(this, a), je(this, a, arguments);
  }
  return Ve(a, t), Fe(a, [{ key: "addScoreSheetAnnotation", value: function(r, s, n) {
    var e = this;
    return Ae(this.configuration).addScoreSheetAnnotation(r, s, n).then(function(i) {
      return i(e.axios, e.basePath);
    });
  } }, { key: "applyArchivedHeldCopy", value: function(r, s, n) {
    var e = this;
    return Ae(this.configuration).applyArchivedHeldCopy(r, s, n).then(function(i) {
      return i(e.axios, e.basePath);
    });
  } }, { key: "applySheetTabletMarks", value: function(r, s, n) {
    var e = this;
    return Ae(this.configuration).applySheetTabletMarks(r, s, n).then(function(i) {
      return i(e.axios, e.basePath);
    });
  } }, { key: "commitScoreSheetEdit", value: function(r, s, n) {
    var e = this;
    return Ae(this.configuration).commitScoreSheetEdit(r, s, n).then(function(i) {
      return i(e.axios, e.basePath);
    });
  } }, { key: "completeScoreSheet", value: function(r, s, n) {
    var e = this;
    return Ae(this.configuration).completeScoreSheet(r, s, n).then(function(i) {
      return i(e.axios, e.basePath);
    });
  } }, { key: "confirmScoreSheetMarks", value: function(r, s, n) {
    var e = this;
    return Ae(this.configuration).confirmScoreSheetMarks(r, s, n).then(function(i) {
      return i(e.axios, e.basePath);
    });
  } }, { key: "createScoreSheet", value: function(r, s) {
    var n = this;
    return Ae(this.configuration).createScoreSheet(r, s).then(function(e) {
      return e(n.axios, n.basePath);
    });
  } }, { key: "discardScoreSheetDraft", value: function(r, s) {
    var n = this;
    return Ae(this.configuration).discardScoreSheetDraft(r, s).then(function(e) {
      return e(n.axios, n.basePath);
    });
  } }, { key: "getRideAuditTrail", value: function(r, s) {
    var n = this;
    return Ae(this.configuration).getRideAuditTrail(r, s).then(function(e) {
      return e(n.axios, n.basePath);
    });
  } }, { key: "getScoreSheet", value: function(r, s) {
    var n = this;
    return Ae(this.configuration).getScoreSheet(r, s).then(function(e) {
      return e(n.axios, n.basePath);
    });
  } }, { key: "getScoreSheetAuditTrail", value: function(r, s) {
    var n = this;
    return Ae(this.configuration).getScoreSheetAuditTrail(r, s).then(function(e) {
      return e(n.axios, n.basePath);
    });
  } }, { key: "getScoreSheetDraft", value: function(r, s) {
    var n = this;
    return Ae(this.configuration).getScoreSheetDraft(r, s).then(function(e) {
      return e(n.axios, n.basePath);
    });
  } }, { key: "getScoreSheetSignature", value: function(r, s) {
    var n = this;
    return Ae(this.configuration).getScoreSheetSignature(r, s).then(function(e) {
      return e(n.axios, n.basePath);
    });
  } }, { key: "getSheetTabletMarks", value: function(r, s) {
    var n = this;
    return Ae(this.configuration).getSheetTabletMarks(r, s).then(function(e) {
      return e(n.axios, n.basePath);
    });
  } }, { key: "listScoreSheets", value: function(r, s, n) {
    var e = this;
    return Ae(this.configuration).listScoreSheets(r, s, n).then(function(i) {
      return i(e.axios, e.basePath);
    });
  } }, { key: "listScoreSheetsForRides", value: function(r, s) {
    var n = this;
    return Ae(this.configuration).listScoreSheetsForRides(r, s).then(function(e) {
      return e(n.axios, n.basePath);
    });
  } }, { key: "markScoreSheetCreatedByMistake", value: function(r, s, n) {
    var e = this;
    return Ae(this.configuration).markScoreSheetCreatedByMistake(r, s, n).then(function(i) {
      return i(e.axios, e.basePath);
    });
  } }, { key: "pickSheetVersion", value: function(r, s, n) {
    var e = this;
    return Ae(this.configuration).pickSheetVersion(r, s, n).then(function(i) {
      return i(e.axios, e.basePath);
    });
  } }, { key: "previewSheetVersionTotals", value: function(r, s, n) {
    var e = this;
    return Ae(this.configuration).previewSheetVersionTotals(r, s, n).then(function(i) {
      return i(e.axios, e.basePath);
    });
  } }, { key: "putScoreSheetDraft", value: function(r, s, n) {
    var e = this;
    return Ae(this.configuration).putScoreSheetDraft(r, s, n).then(function(i) {
      return i(e.axios, e.basePath);
    });
  } }, { key: "rereadScoreSheetTest", value: function(r, s) {
    var n = this;
    return Ae(this.configuration).rereadScoreSheetTest(r, s).then(function(e) {
      return e(n.axios, n.basePath);
    });
  } }, { key: "resolveStaleWriteConflict", value: function(r, s, n) {
    var e = this;
    return Ae(this.configuration).resolveStaleWriteConflict(r, s, n).then(function(i) {
      return i(e.axios, e.basePath);
    });
  } }, { key: "restoreScoreSheetFromMistake", value: function(r, s) {
    var n = this;
    return Ae(this.configuration).restoreScoreSheetFromMistake(r, s).then(function(e) {
      return e(n.axios, n.basePath);
    });
  } }, { key: "restoreScoreSheetVersion", value: function(r, s, n) {
    var e = this;
    return Ae(this.configuration).restoreScoreSheetVersion(r, s, n).then(function(i) {
      return i(e.axios, e.basePath);
    });
  } }, { key: "signScoreSheetPanel", value: function(r, s, n) {
    var e = this;
    return Ae(this.configuration).signScoreSheetPanel(r, s, n).then(function(i) {
      return i(e.axios, e.basePath);
    });
  } }, { key: "switchAuthoritativeScoreSheet", value: function(r, s) {
    var n = this;
    return Ae(this.configuration).switchAuthoritativeScoreSheet(r, s).then(function(e) {
      return e(n.axios, n.basePath);
    });
  } }, { key: "unlockScoreSheet", value: function(r, s, n) {
    var e = this;
    return Ae(this.configuration).unlockScoreSheet(r, s, n).then(function(i) {
      return i(e.axios, e.basePath);
    });
  } }, { key: "updateScoreSheet", value: function(r, s, n) {
    var e = this;
    return Ae(this.configuration).updateScoreSheet(r, s, n).then(function(i) {
      return i(e.axios, e.basePath);
    });
  } }]), a;
})(Le);
var qh = function(t) {
  return { copyScoreboardViewsFromShow: function(a, r) {
    var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return v(function() {
      var n, e, i, o, u, l, c;
      return p(this, function(d) {
        switch (d.label) {
          case 0:
            return b("copyScoreboardViewsFromShow", "showId", a), b("copyScoreboardViewsFromShow", "sourceShowId", r), n = "/scoreboard/show/{showId}/views/copy-from/{sourceShowId}".replace("{showId}", encodeURIComponent(String(a))).replace("{sourceShowId}", encodeURIComponent(String(r))), e = new URL(n, R), t && (i = t.baseOptions), o = f({ method: "POST" }, i, s), l = {}, [4, E(u = {}, t)];
          case 1:
            return d.sent(), I(e, l), c = i && i.headers ? i.headers : {}, o.headers = f({}, u, c, s.headers), [2, { url: _(e), options: o }];
        }
      });
    })();
  }, createBrandAsset: function(a) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return v(function() {
      var s, n, e, i, o, u;
      return p(this, function(l) {
        switch (l.label) {
          case 0:
            return b("createBrandAsset", "createBrandAssetRequest", a), s = new URL("/scoreboard/asset", R), t && (n = t.baseOptions), e = f({ method: "POST" }, n, r), o = {}, [4, E(i = {}, t)];
          case 1:
            return l.sent(), i["Content-Type"] = "application/json", I(s, o), u = n && n.headers ? n.headers : {}, e.headers = f({}, i, u, r.headers), e.data = N(a, e, t), [2, { url: _(s), options: e }];
        }
      });
    })();
  }, createScoreboardView: function(a) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return v(function() {
      var s, n, e, i, o, u;
      return p(this, function(l) {
        switch (l.label) {
          case 0:
            return s = new URL("/scoreboard/view", R), t && (n = t.baseOptions), e = f({ method: "POST" }, n, r), o = {}, [4, E(i = {}, t)];
          case 1:
            return l.sent(), i["Content-Type"] = "application/json", I(s, o), u = n && n.headers ? n.headers : {}, e.headers = f({}, i, u, r.headers), e.data = N(a, e, t), [2, { url: _(s), options: e }];
        }
      });
    })();
  }, createSlideshow: function(a) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return v(function() {
      var s, n, e, i, o, u;
      return p(this, function(l) {
        switch (l.label) {
          case 0:
            return b("createSlideshow", "createSlideshowRequest", a), s = new URL("/scoreboard/slideshow", R), t && (n = t.baseOptions), e = f({ method: "POST" }, n, r), o = {}, [4, E(i = {}, t)];
          case 1:
            return l.sent(), i["Content-Type"] = "application/json", I(s, o), u = n && n.headers ? n.headers : {}, e.headers = f({}, i, u, r.headers), e.data = N(a, e, t), [2, { url: _(s), options: e }];
        }
      });
    })();
  }, deleteBrandAsset: function(a) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return v(function() {
      var s, n, e, i, o, u, l;
      return p(this, function(c) {
        switch (c.label) {
          case 0:
            return b("deleteBrandAsset", "id", a), s = "/scoreboard/asset/{id}".replace("{id}", encodeURIComponent(String(a))), n = new URL(s, R), t && (e = t.baseOptions), i = f({ method: "DELETE" }, e, r), u = {}, [4, E(o = {}, t)];
          case 1:
            return c.sent(), I(n, u), l = e && e.headers ? e.headers : {}, i.headers = f({}, o, l, r.headers), [2, { url: _(n), options: i }];
        }
      });
    })();
  }, deleteScoreboardTheme: function(a) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return v(function() {
      var s, n, e, i, o, u, l;
      return p(this, function(c) {
        switch (c.label) {
          case 0:
            return b("deleteScoreboardTheme", "id", a), s = "/scoreboard/theme/{id}".replace("{id}", encodeURIComponent(String(a))), n = new URL(s, R), t && (e = t.baseOptions), i = f({ method: "DELETE" }, e, r), u = {}, [4, E(o = {}, t)];
          case 1:
            return c.sent(), I(n, u), l = e && e.headers ? e.headers : {}, i.headers = f({}, o, l, r.headers), [2, { url: _(n), options: i }];
        }
      });
    })();
  }, deleteScoreboardView: function(a) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return v(function() {
      var s, n, e, i, o, u, l;
      return p(this, function(c) {
        switch (c.label) {
          case 0:
            return b("deleteScoreboardView", "id", a), s = "/scoreboard/view/{id}".replace("{id}", encodeURIComponent(String(a))), n = new URL(s, R), t && (e = t.baseOptions), i = f({ method: "DELETE" }, e, r), u = {}, [4, E(o = {}, t)];
          case 1:
            return c.sent(), I(n, u), l = e && e.headers ? e.headers : {}, i.headers = f({}, o, l, r.headers), [2, { url: _(n), options: i }];
        }
      });
    })();
  }, deleteSlideshow: function(a) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return v(function() {
      var s, n, e, i, o, u, l;
      return p(this, function(c) {
        switch (c.label) {
          case 0:
            return b("deleteSlideshow", "id", a), s = "/scoreboard/slideshow/{id}".replace("{id}", encodeURIComponent(String(a))), n = new URL(s, R), t && (e = t.baseOptions), i = f({ method: "DELETE" }, e, r), u = {}, [4, E(o = {}, t)];
          case 1:
            return c.sent(), I(n, u), l = e && e.headers ? e.headers : {}, i.headers = f({}, o, l, r.headers), [2, { url: _(n), options: i }];
        }
      });
    })();
  }, deleteSponsor: function(a) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return v(function() {
      var s, n, e, i, o, u, l;
      return p(this, function(c) {
        switch (c.label) {
          case 0:
            return b("deleteSponsor", "id", a), s = "/scoreboard/sponsor/{id}".replace("{id}", encodeURIComponent(String(a))), n = new URL(s, R), t && (e = t.baseOptions), i = f({ method: "DELETE" }, e, r), u = {}, [4, E(o = {}, t)];
          case 1:
            return c.sent(), I(n, u), l = e && e.headers ? e.headers : {}, i.headers = f({}, o, l, r.headers), [2, { url: _(n), options: i }];
        }
      });
    })();
  }, duplicateScoreboardView: function(a) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return v(function() {
      var s, n, e, i, o, u, l;
      return p(this, function(c) {
        switch (c.label) {
          case 0:
            return b("duplicateScoreboardView", "id", a), s = "/scoreboard/view/{id}/duplicate".replace("{id}", encodeURIComponent(String(a))), n = new URL(s, R), t && (e = t.baseOptions), i = f({ method: "POST" }, e, r), u = {}, [4, E(o = {}, t)];
          case 1:
            return c.sent(), I(n, u), l = e && e.headers ? e.headers : {}, i.headers = f({}, o, l, r.headers), [2, { url: _(n), options: i }];
        }
      });
    })();
  }, getPublicChanges: function(a) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return v(function() {
      var s, n, e, i, o, u;
      return p(this, function(l) {
        return b("getPublicChanges", "showId", a), s = "/public/scoreboard/changes/{showId}".replace("{showId}", encodeURIComponent(String(a))), n = new URL(s, R), t && (e = t.baseOptions), i = f({ method: "GET" }, e, r), o = {}, I(n, {}), u = e && e.headers ? e.headers : {}, i.headers = f({}, o, u, r.headers), [2, { url: _(n), options: i }];
      });
    })();
  }, getPublicClassResults: function(a, r) {
    var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return v(function() {
      var n, e, i, o, u, l;
      return p(this, function(c) {
        return b("getPublicClassResults", "showId", a), b("getPublicClassResults", "classId", r), n = "/public/scoreboard/{showId}/class/{classId}/results".replace("{showId}", encodeURIComponent(String(a))).replace("{classId}", encodeURIComponent(String(r))), e = new URL(n, R), t && (i = t.baseOptions), o = f({ method: "GET" }, i, s), u = {}, I(e, {}), l = i && i.headers ? i.headers : {}, o.headers = f({}, u, l, s.headers), [2, { url: _(e), options: o }];
      });
    })();
  }, getPublicLivePhone: function(a) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return v(function() {
      var s, n, e, i, o, u;
      return p(this, function(l) {
        return b("getPublicLivePhone", "code", a), s = "/public/scoreboard/phone/live/{code}".replace("{code}", encodeURIComponent(String(a))), n = new URL(s, R), t && (e = t.baseOptions), i = f({ method: "GET" }, e, r), o = {}, I(n, {}), u = e && e.headers ? e.headers : {}, i.headers = f({}, o, u, r.headers), [2, { url: _(n), options: i }];
      });
    })();
  }, getPublicPhoneChanges: function(a) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return v(function() {
      var s, n, e, i, o, u;
      return p(this, function(l) {
        return b("getPublicPhoneChanges", "showId", a), s = "/public/scoreboard/phone/changes/{showId}".replace("{showId}", encodeURIComponent(String(a))), n = new URL(s, R), t && (e = t.baseOptions), i = f({ method: "GET" }, e, r), o = {}, I(n, {}), u = e && e.headers ? e.headers : {}, i.headers = f({}, o, u, r.headers), [2, { url: _(n), options: i }];
      });
    })();
  }, getPublicScoreboard: function(a, r, s, n) {
    var e = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : {};
    return v(function() {
      var i, o, u, l, c, d, h;
      return p(this, function(g) {
        return b("getPublicScoreboard", "showId", a), b("getPublicScoreboard", "year", r), b("getPublicScoreboard", "slug", s), i = "/public/scoreboard/{showId}/{year}/{slug}".replace("{showId}", encodeURIComponent(String(a))).replace("{year}", encodeURIComponent(String(r))).replace("{slug}", encodeURIComponent(String(s))), o = new URL(i, R), t && (u = t.baseOptions), l = f({ method: "GET" }, u, e), c = {}, d = {}, n !== void 0 && (d.previewModeId = n), I(o, d), h = u && u.headers ? u.headers : {}, l.headers = f({}, c, h, e.headers), [2, { url: _(o), options: l }];
      });
    })();
  }, getPublicScoreboardDefaultView: function(a, r, s) {
    var n = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    return v(function() {
      var e, i, o, u, l, c, d;
      return p(this, function(h) {
        return b("getPublicScoreboardDefaultView", "showId", a), b("getPublicScoreboardDefaultView", "year", r), e = "/public/scoreboard/{showId}/{year}".replace("{showId}", encodeURIComponent(String(a))).replace("{year}", encodeURIComponent(String(r))), i = new URL(e, R), t && (o = t.baseOptions), u = f({ method: "GET" }, o, n), l = {}, c = {}, s !== void 0 && (c.previewModeId = s), I(i, c), d = o && o.headers ? o.headers : {}, u.headers = f({}, l, d, n.headers), [2, { url: _(i), options: u }];
      });
    })();
  }, getPublicScoreboardPhone: function(a, r, s) {
    var n = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    return v(function() {
      var e, i, o, u, l, c;
      return p(this, function(d) {
        return b("getPublicScoreboardPhone", "showId", a), b("getPublicScoreboardPhone", "year", r), b("getPublicScoreboardPhone", "slug", s), e = "/public/scoreboard/phone/{showId}/{year}/{slug}".replace("{showId}", encodeURIComponent(String(a))).replace("{year}", encodeURIComponent(String(r))).replace("{slug}", encodeURIComponent(String(s))), i = new URL(e, R), t && (o = t.baseOptions), u = f({ method: "GET" }, o, n), l = {}, I(i, {}), c = o && o.headers ? o.headers : {}, u.headers = f({}, l, c, n.headers), [2, { url: _(i), options: u }];
      });
    })();
  }, getPublicScoreboardPhoneDefaultView: function(a, r) {
    var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return v(function() {
      var n, e, i, o, u, l;
      return p(this, function(c) {
        return b("getPublicScoreboardPhoneDefaultView", "showId", a), b("getPublicScoreboardPhoneDefaultView", "year", r), n = "/public/scoreboard/phone/{showId}/{year}".replace("{showId}", encodeURIComponent(String(a))).replace("{year}", encodeURIComponent(String(r))), e = new URL(n, R), t && (i = t.baseOptions), o = f({ method: "GET" }, i, s), u = {}, I(e, {}), l = i && i.headers ? i.headers : {}, o.headers = f({}, u, l, s.headers), [2, { url: _(e), options: o }];
      });
    })();
  }, getPublicScreenCurrent: function(a) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return v(function() {
      var s, n, e, i, o, u;
      return p(this, function(l) {
        return b("getPublicScreenCurrent", "screenId", a), s = "/public/scoreboard/screen/{screenId}/current".replace("{screenId}", encodeURIComponent(String(a))), n = new URL(s, R), t && (e = t.baseOptions), i = f({ method: "GET" }, e, r), o = {}, I(n, {}), u = e && e.headers ? e.headers : {}, i.headers = f({}, o, u, r.headers), [2, { url: _(n), options: i }];
      });
    })();
  }, getSlideshow: function(a) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return v(function() {
      var s, n, e, i, o, u, l;
      return p(this, function(c) {
        switch (c.label) {
          case 0:
            return b("getSlideshow", "id", a), s = "/scoreboard/slideshow/{id}".replace("{id}", encodeURIComponent(String(a))), n = new URL(s, R), t && (e = t.baseOptions), i = f({ method: "GET" }, e, r), u = {}, [4, E(o = {}, t)];
          case 1:
            return c.sent(), I(n, u), l = e && e.headers ? e.headers : {}, i.headers = f({}, o, l, r.headers), [2, { url: _(n), options: i }];
        }
      });
    })();
  }, listBrandAssets: function() {
    var a = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return v(function() {
      var r, s, n, e, i, o;
      return p(this, function(u) {
        switch (u.label) {
          case 0:
            return r = new URL("/scoreboard/assets", R), t && (s = t.baseOptions), n = f({ method: "GET" }, s, a), i = {}, [4, E(e = {}, t)];
          case 1:
            return u.sent(), I(r, i), o = s && s.headers ? s.headers : {}, n.headers = f({}, e, o, a.headers), [2, { url: _(r), options: n }];
        }
      });
    })();
  }, listScoreboardThemes: function() {
    var a = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return v(function() {
      var r, s, n, e, i, o;
      return p(this, function(u) {
        switch (u.label) {
          case 0:
            return r = new URL("/scoreboard/themes", R), t && (s = t.baseOptions), n = f({ method: "GET" }, s, a), i = {}, [4, E(e = {}, t)];
          case 1:
            return u.sent(), I(r, i), o = s && s.headers ? s.headers : {}, n.headers = f({}, e, o, a.headers), [2, { url: _(r), options: n }];
        }
      });
    })();
  }, listScoreboardViews: function(a) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return v(function() {
      var s, n, e, i, o, u;
      return p(this, function(l) {
        switch (l.label) {
          case 0:
            return b("listScoreboardViews", "showId", a), s = new URL("/scoreboard/views", R), t && (n = t.baseOptions), e = f({ method: "GET" }, n, r), o = {}, [4, E(i = {}, t)];
          case 1:
            return l.sent(), a !== void 0 && (o.showId = a), I(s, o), u = n && n.headers ? n.headers : {}, e.headers = f({}, i, u, r.headers), [2, { url: _(s), options: e }];
        }
      });
    })();
  }, listSlideshows: function() {
    var a = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return v(function() {
      var r, s, n, e, i, o;
      return p(this, function(u) {
        switch (u.label) {
          case 0:
            return r = new URL("/scoreboard/slideshows", R), t && (s = t.baseOptions), n = f({ method: "GET" }, s, a), i = {}, [4, E(e = {}, t)];
          case 1:
            return u.sent(), I(r, i), o = s && s.headers ? s.headers : {}, n.headers = f({}, e, o, a.headers), [2, { url: _(r), options: n }];
        }
      });
    })();
  }, listSponsors: function() {
    var a = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return v(function() {
      var r, s, n, e, i, o;
      return p(this, function(u) {
        switch (u.label) {
          case 0:
            return r = new URL("/scoreboard/sponsors", R), t && (s = t.baseOptions), n = f({ method: "GET" }, s, a), i = {}, [4, E(e = {}, t)];
          case 1:
            return u.sent(), I(r, i), o = s && s.headers ? s.headers : {}, n.headers = f({}, e, o, a.headers), [2, { url: _(r), options: n }];
        }
      });
    })();
  }, putScoreboardTheme: function(a) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return v(function() {
      var s, n, e, i, o, u;
      return p(this, function(l) {
        switch (l.label) {
          case 0:
            return s = new URL("/scoreboard/theme", R), t && (n = t.baseOptions), e = f({ method: "POST" }, n, r), o = {}, [4, E(i = {}, t)];
          case 1:
            return l.sent(), i["Content-Type"] = "application/json", I(s, o), u = n && n.headers ? n.headers : {}, e.headers = f({}, i, u, r.headers), e.data = N(a, e, t), [2, { url: _(s), options: e }];
        }
      });
    })();
  }, putSponsor: function(a) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return v(function() {
      var s, n, e, i, o, u;
      return p(this, function(l) {
        switch (l.label) {
          case 0:
            return s = new URL("/scoreboard/sponsor", R), t && (n = t.baseOptions), e = f({ method: "POST" }, n, r), o = {}, [4, E(i = {}, t)];
          case 1:
            return l.sent(), i["Content-Type"] = "application/json", I(s, o), u = n && n.headers ? n.headers : {}, e.headers = f({}, i, u, r.headers), e.data = N(a, e, t), [2, { url: _(s), options: e }];
        }
      });
    })();
  }, releaseScoreboardViewPin: function(a, r) {
    var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return v(function() {
      var n, e, i, o, u, l, c;
      return p(this, function(d) {
        switch (d.label) {
          case 0:
            return b("releaseScoreboardViewPin", "id", a), n = "/scoreboard/view/{id}/automatic".replace("{id}", encodeURIComponent(String(a))), e = new URL(n, R), t && (i = t.baseOptions), o = f({ method: "POST" }, i, s), l = {}, [4, E(u = {}, t)];
          case 1:
            return d.sent(), r !== void 0 && (l.catchUp = r), I(e, l), c = i && i.headers ? i.headers : {}, o.headers = f({}, u, c, s.headers), [2, { url: _(e), options: o }];
        }
      });
    })();
  }, resolveClassByNumber: function(a, r) {
    var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return v(function() {
      var n, e, i, o, u, l;
      return p(this, function(c) {
        return b("resolveClassByNumber", "showId", a), b("resolveClassByNumber", "classNumber", r), n = "/public/scoreboard/{showId}/class-number/{classNumber}".replace("{showId}", encodeURIComponent(String(a))).replace("{classNumber}", encodeURIComponent(String(r))), e = new URL(n, R), t && (i = t.baseOptions), o = f({ method: "GET" }, i, s), u = {}, I(e, {}), l = i && i.headers ? i.headers : {}, o.headers = f({}, u, l, s.headers), [2, { url: _(e), options: o }];
      });
    })();
  }, setScoreboardViewCurrentMode: function(a, r) {
    var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return v(function() {
      var n, e, i, o, u, l, c;
      return p(this, function(d) {
        switch (d.label) {
          case 0:
            return b("setScoreboardViewCurrentMode", "id", a), n = "/scoreboard/view/{id}/current-mode".replace("{id}", encodeURIComponent(String(a))), e = new URL(n, R), t && (i = t.baseOptions), o = f({ method: "POST" }, i, s), l = {}, [4, E(u = {}, t)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", I(e, l), c = i && i.headers ? i.headers : {}, o.headers = f({}, u, c, s.headers), o.data = N(r, o, t), [2, { url: _(e), options: o }];
        }
      });
    })();
  }, setScoreboardViewRidePick: function(a, r) {
    var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return v(function() {
      var n, e, i, o, u, l, c;
      return p(this, function(d) {
        switch (d.label) {
          case 0:
            return b("setScoreboardViewRidePick", "id", a), n = "/scoreboard/view/{id}/ride-pick".replace("{id}", encodeURIComponent(String(a))), e = new URL(n, R), t && (i = t.baseOptions), o = f({ method: "POST" }, i, s), l = {}, [4, E(u = {}, t)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", I(e, l), c = i && i.headers ? i.headers : {}, o.headers = f({}, u, c, s.headers), o.data = N(r, o, t), [2, { url: _(e), options: o }];
        }
      });
    })();
  }, updateScoreboardView: function(a, r) {
    var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return v(function() {
      var n, e, i, o, u, l, c;
      return p(this, function(d) {
        switch (d.label) {
          case 0:
            return b("updateScoreboardView", "id", a), n = "/scoreboard/view/{id}".replace("{id}", encodeURIComponent(String(a))), e = new URL(n, R), t && (i = t.baseOptions), o = f({ method: "PATCH" }, i, s), l = {}, [4, E(u = {}, t)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", I(e, l), c = i && i.headers ? i.headers : {}, o.headers = f({}, u, c, s.headers), o.data = N(r, o, t), [2, { url: _(e), options: o }];
        }
      });
    })();
  }, updateSlideshow: function(a, r) {
    var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return v(function() {
      var n, e, i, o, u, l, c;
      return p(this, function(d) {
        switch (d.label) {
          case 0:
            return b("updateSlideshow", "id", a), b("updateSlideshow", "createSlideshowRequest", r), n = "/scoreboard/slideshow/{id}".replace("{id}", encodeURIComponent(String(a))), e = new URL(n, R), t && (i = t.baseOptions), o = f({ method: "PATCH" }, i, s), l = {}, [4, E(u = {}, t)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", I(e, l), c = i && i.headers ? i.headers : {}, o.headers = f({}, u, c, s.headers), o.data = N(r, o, t), [2, { url: _(e), options: o }];
        }
      });
    })();
  } };
}, Se = function(t) {
  var a = qh(t);
  return { copyScoreboardViewsFromShow: function(r, s, n) {
    return v(function() {
      var e, i, o, u, l, c;
      return p(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, a.copyScoreboardViewsFromShow(r, s, n)];
          case 1:
            return o = d.sent(), l = (u = t == null ? void 0 : t.serverIndex) !== null && u !== void 0 ? u : 0, c = (i = y["ScoreboardApi.copyScoreboardViewsFromShow"]) === null || i === void 0 || (e = i[l]) === null || e === void 0 ? void 0 : e.url, [2, function(h, g) {
              return T(o, S.default, w, t)(h, c || g);
            }];
        }
      });
    })();
  }, createBrandAsset: function(r, s) {
    return v(function() {
      var n, e, i, o, u, l;
      return p(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, a.createBrandAsset(r, s)];
          case 1:
            return i = c.sent(), u = (o = t == null ? void 0 : t.serverIndex) !== null && o !== void 0 ? o : 0, l = (e = y["ScoreboardApi.createBrandAsset"]) === null || e === void 0 || (n = e[u]) === null || n === void 0 ? void 0 : n.url, [2, function(d, h) {
              return T(i, S.default, w, t)(d, l || h);
            }];
        }
      });
    })();
  }, createScoreboardView: function(r, s) {
    return v(function() {
      var n, e, i, o, u, l;
      return p(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, a.createScoreboardView(r, s)];
          case 1:
            return i = c.sent(), u = (o = t == null ? void 0 : t.serverIndex) !== null && o !== void 0 ? o : 0, l = (e = y["ScoreboardApi.createScoreboardView"]) === null || e === void 0 || (n = e[u]) === null || n === void 0 ? void 0 : n.url, [2, function(d, h) {
              return T(i, S.default, w, t)(d, l || h);
            }];
        }
      });
    })();
  }, createSlideshow: function(r, s) {
    return v(function() {
      var n, e, i, o, u, l;
      return p(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, a.createSlideshow(r, s)];
          case 1:
            return i = c.sent(), u = (o = t == null ? void 0 : t.serverIndex) !== null && o !== void 0 ? o : 0, l = (e = y["ScoreboardApi.createSlideshow"]) === null || e === void 0 || (n = e[u]) === null || n === void 0 ? void 0 : n.url, [2, function(d, h) {
              return T(i, S.default, w, t)(d, l || h);
            }];
        }
      });
    })();
  }, deleteBrandAsset: function(r, s) {
    return v(function() {
      var n, e, i, o, u, l;
      return p(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, a.deleteBrandAsset(r, s)];
          case 1:
            return i = c.sent(), u = (o = t == null ? void 0 : t.serverIndex) !== null && o !== void 0 ? o : 0, l = (e = y["ScoreboardApi.deleteBrandAsset"]) === null || e === void 0 || (n = e[u]) === null || n === void 0 ? void 0 : n.url, [2, function(d, h) {
              return T(i, S.default, w, t)(d, l || h);
            }];
        }
      });
    })();
  }, deleteScoreboardTheme: function(r, s) {
    return v(function() {
      var n, e, i, o, u, l;
      return p(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, a.deleteScoreboardTheme(r, s)];
          case 1:
            return i = c.sent(), u = (o = t == null ? void 0 : t.serverIndex) !== null && o !== void 0 ? o : 0, l = (e = y["ScoreboardApi.deleteScoreboardTheme"]) === null || e === void 0 || (n = e[u]) === null || n === void 0 ? void 0 : n.url, [2, function(d, h) {
              return T(i, S.default, w, t)(d, l || h);
            }];
        }
      });
    })();
  }, deleteScoreboardView: function(r, s) {
    return v(function() {
      var n, e, i, o, u, l;
      return p(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, a.deleteScoreboardView(r, s)];
          case 1:
            return i = c.sent(), u = (o = t == null ? void 0 : t.serverIndex) !== null && o !== void 0 ? o : 0, l = (e = y["ScoreboardApi.deleteScoreboardView"]) === null || e === void 0 || (n = e[u]) === null || n === void 0 ? void 0 : n.url, [2, function(d, h) {
              return T(i, S.default, w, t)(d, l || h);
            }];
        }
      });
    })();
  }, deleteSlideshow: function(r, s) {
    return v(function() {
      var n, e, i, o, u, l;
      return p(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, a.deleteSlideshow(r, s)];
          case 1:
            return i = c.sent(), u = (o = t == null ? void 0 : t.serverIndex) !== null && o !== void 0 ? o : 0, l = (e = y["ScoreboardApi.deleteSlideshow"]) === null || e === void 0 || (n = e[u]) === null || n === void 0 ? void 0 : n.url, [2, function(d, h) {
              return T(i, S.default, w, t)(d, l || h);
            }];
        }
      });
    })();
  }, deleteSponsor: function(r, s) {
    return v(function() {
      var n, e, i, o, u, l;
      return p(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, a.deleteSponsor(r, s)];
          case 1:
            return i = c.sent(), u = (o = t == null ? void 0 : t.serverIndex) !== null && o !== void 0 ? o : 0, l = (e = y["ScoreboardApi.deleteSponsor"]) === null || e === void 0 || (n = e[u]) === null || n === void 0 ? void 0 : n.url, [2, function(d, h) {
              return T(i, S.default, w, t)(d, l || h);
            }];
        }
      });
    })();
  }, duplicateScoreboardView: function(r, s) {
    return v(function() {
      var n, e, i, o, u, l;
      return p(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, a.duplicateScoreboardView(r, s)];
          case 1:
            return i = c.sent(), u = (o = t == null ? void 0 : t.serverIndex) !== null && o !== void 0 ? o : 0, l = (e = y["ScoreboardApi.duplicateScoreboardView"]) === null || e === void 0 || (n = e[u]) === null || n === void 0 ? void 0 : n.url, [2, function(d, h) {
              return T(i, S.default, w, t)(d, l || h);
            }];
        }
      });
    })();
  }, getPublicChanges: function(r, s) {
    return v(function() {
      var n, e, i, o, u, l;
      return p(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, a.getPublicChanges(r, s)];
          case 1:
            return i = c.sent(), u = (o = t == null ? void 0 : t.serverIndex) !== null && o !== void 0 ? o : 0, l = (e = y["ScoreboardApi.getPublicChanges"]) === null || e === void 0 || (n = e[u]) === null || n === void 0 ? void 0 : n.url, [2, function(d, h) {
              return T(i, S.default, w, t)(d, l || h);
            }];
        }
      });
    })();
  }, getPublicClassResults: function(r, s, n) {
    return v(function() {
      var e, i, o, u, l, c;
      return p(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, a.getPublicClassResults(r, s, n)];
          case 1:
            return o = d.sent(), l = (u = t == null ? void 0 : t.serverIndex) !== null && u !== void 0 ? u : 0, c = (i = y["ScoreboardApi.getPublicClassResults"]) === null || i === void 0 || (e = i[l]) === null || e === void 0 ? void 0 : e.url, [2, function(h, g) {
              return T(o, S.default, w, t)(h, c || g);
            }];
        }
      });
    })();
  }, getPublicLivePhone: function(r, s) {
    return v(function() {
      var n, e, i, o, u, l;
      return p(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, a.getPublicLivePhone(r, s)];
          case 1:
            return i = c.sent(), u = (o = t == null ? void 0 : t.serverIndex) !== null && o !== void 0 ? o : 0, l = (e = y["ScoreboardApi.getPublicLivePhone"]) === null || e === void 0 || (n = e[u]) === null || n === void 0 ? void 0 : n.url, [2, function(d, h) {
              return T(i, S.default, w, t)(d, l || h);
            }];
        }
      });
    })();
  }, getPublicPhoneChanges: function(r, s) {
    return v(function() {
      var n, e, i, o, u, l;
      return p(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, a.getPublicPhoneChanges(r, s)];
          case 1:
            return i = c.sent(), u = (o = t == null ? void 0 : t.serverIndex) !== null && o !== void 0 ? o : 0, l = (e = y["ScoreboardApi.getPublicPhoneChanges"]) === null || e === void 0 || (n = e[u]) === null || n === void 0 ? void 0 : n.url, [2, function(d, h) {
              return T(i, S.default, w, t)(d, l || h);
            }];
        }
      });
    })();
  }, getPublicScoreboard: function(r, s, n, e, i) {
    return v(function() {
      var o, u, l, c, d, h;
      return p(this, function(g) {
        switch (g.label) {
          case 0:
            return [4, a.getPublicScoreboard(r, s, n, e, i)];
          case 1:
            return l = g.sent(), d = (c = t == null ? void 0 : t.serverIndex) !== null && c !== void 0 ? c : 0, h = (u = y["ScoreboardApi.getPublicScoreboard"]) === null || u === void 0 || (o = u[d]) === null || o === void 0 ? void 0 : o.url, [2, function(U, P) {
              return T(l, S.default, w, t)(U, h || P);
            }];
        }
      });
    })();
  }, getPublicScoreboardDefaultView: function(r, s, n, e) {
    return v(function() {
      var i, o, u, l, c, d;
      return p(this, function(h) {
        switch (h.label) {
          case 0:
            return [4, a.getPublicScoreboardDefaultView(r, s, n, e)];
          case 1:
            return u = h.sent(), c = (l = t == null ? void 0 : t.serverIndex) !== null && l !== void 0 ? l : 0, d = (o = y["ScoreboardApi.getPublicScoreboardDefaultView"]) === null || o === void 0 || (i = o[c]) === null || i === void 0 ? void 0 : i.url, [2, function(g, U) {
              return T(u, S.default, w, t)(g, d || U);
            }];
        }
      });
    })();
  }, getPublicScoreboardPhone: function(r, s, n, e) {
    return v(function() {
      var i, o, u, l, c, d;
      return p(this, function(h) {
        switch (h.label) {
          case 0:
            return [4, a.getPublicScoreboardPhone(r, s, n, e)];
          case 1:
            return u = h.sent(), c = (l = t == null ? void 0 : t.serverIndex) !== null && l !== void 0 ? l : 0, d = (o = y["ScoreboardApi.getPublicScoreboardPhone"]) === null || o === void 0 || (i = o[c]) === null || i === void 0 ? void 0 : i.url, [2, function(g, U) {
              return T(u, S.default, w, t)(g, d || U);
            }];
        }
      });
    })();
  }, getPublicScoreboardPhoneDefaultView: function(r, s, n) {
    return v(function() {
      var e, i, o, u, l, c;
      return p(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, a.getPublicScoreboardPhoneDefaultView(r, s, n)];
          case 1:
            return o = d.sent(), l = (u = t == null ? void 0 : t.serverIndex) !== null && u !== void 0 ? u : 0, c = (i = y["ScoreboardApi.getPublicScoreboardPhoneDefaultView"]) === null || i === void 0 || (e = i[l]) === null || e === void 0 ? void 0 : e.url, [2, function(h, g) {
              return T(o, S.default, w, t)(h, c || g);
            }];
        }
      });
    })();
  }, getPublicScreenCurrent: function(r, s) {
    return v(function() {
      var n, e, i, o, u, l;
      return p(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, a.getPublicScreenCurrent(r, s)];
          case 1:
            return i = c.sent(), u = (o = t == null ? void 0 : t.serverIndex) !== null && o !== void 0 ? o : 0, l = (e = y["ScoreboardApi.getPublicScreenCurrent"]) === null || e === void 0 || (n = e[u]) === null || n === void 0 ? void 0 : n.url, [2, function(d, h) {
              return T(i, S.default, w, t)(d, l || h);
            }];
        }
      });
    })();
  }, getSlideshow: function(r, s) {
    return v(function() {
      var n, e, i, o, u, l;
      return p(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, a.getSlideshow(r, s)];
          case 1:
            return i = c.sent(), u = (o = t == null ? void 0 : t.serverIndex) !== null && o !== void 0 ? o : 0, l = (e = y["ScoreboardApi.getSlideshow"]) === null || e === void 0 || (n = e[u]) === null || n === void 0 ? void 0 : n.url, [2, function(d, h) {
              return T(i, S.default, w, t)(d, l || h);
            }];
        }
      });
    })();
  }, listBrandAssets: function(r) {
    return v(function() {
      var s, n, e, i, o, u;
      return p(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, a.listBrandAssets(r)];
          case 1:
            return e = l.sent(), o = (i = t == null ? void 0 : t.serverIndex) !== null && i !== void 0 ? i : 0, u = (n = y["ScoreboardApi.listBrandAssets"]) === null || n === void 0 || (s = n[o]) === null || s === void 0 ? void 0 : s.url, [2, function(c, d) {
              return T(e, S.default, w, t)(c, u || d);
            }];
        }
      });
    })();
  }, listScoreboardThemes: function(r) {
    return v(function() {
      var s, n, e, i, o, u;
      return p(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, a.listScoreboardThemes(r)];
          case 1:
            return e = l.sent(), o = (i = t == null ? void 0 : t.serverIndex) !== null && i !== void 0 ? i : 0, u = (n = y["ScoreboardApi.listScoreboardThemes"]) === null || n === void 0 || (s = n[o]) === null || s === void 0 ? void 0 : s.url, [2, function(c, d) {
              return T(e, S.default, w, t)(c, u || d);
            }];
        }
      });
    })();
  }, listScoreboardViews: function(r, s) {
    return v(function() {
      var n, e, i, o, u, l;
      return p(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, a.listScoreboardViews(r, s)];
          case 1:
            return i = c.sent(), u = (o = t == null ? void 0 : t.serverIndex) !== null && o !== void 0 ? o : 0, l = (e = y["ScoreboardApi.listScoreboardViews"]) === null || e === void 0 || (n = e[u]) === null || n === void 0 ? void 0 : n.url, [2, function(d, h) {
              return T(i, S.default, w, t)(d, l || h);
            }];
        }
      });
    })();
  }, listSlideshows: function(r) {
    return v(function() {
      var s, n, e, i, o, u;
      return p(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, a.listSlideshows(r)];
          case 1:
            return e = l.sent(), o = (i = t == null ? void 0 : t.serverIndex) !== null && i !== void 0 ? i : 0, u = (n = y["ScoreboardApi.listSlideshows"]) === null || n === void 0 || (s = n[o]) === null || s === void 0 ? void 0 : s.url, [2, function(c, d) {
              return T(e, S.default, w, t)(c, u || d);
            }];
        }
      });
    })();
  }, listSponsors: function(r) {
    return v(function() {
      var s, n, e, i, o, u;
      return p(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, a.listSponsors(r)];
          case 1:
            return e = l.sent(), o = (i = t == null ? void 0 : t.serverIndex) !== null && i !== void 0 ? i : 0, u = (n = y["ScoreboardApi.listSponsors"]) === null || n === void 0 || (s = n[o]) === null || s === void 0 ? void 0 : s.url, [2, function(c, d) {
              return T(e, S.default, w, t)(c, u || d);
            }];
        }
      });
    })();
  }, putScoreboardTheme: function(r, s) {
    return v(function() {
      var n, e, i, o, u, l;
      return p(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, a.putScoreboardTheme(r, s)];
          case 1:
            return i = c.sent(), u = (o = t == null ? void 0 : t.serverIndex) !== null && o !== void 0 ? o : 0, l = (e = y["ScoreboardApi.putScoreboardTheme"]) === null || e === void 0 || (n = e[u]) === null || n === void 0 ? void 0 : n.url, [2, function(d, h) {
              return T(i, S.default, w, t)(d, l || h);
            }];
        }
      });
    })();
  }, putSponsor: function(r, s) {
    return v(function() {
      var n, e, i, o, u, l;
      return p(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, a.putSponsor(r, s)];
          case 1:
            return i = c.sent(), u = (o = t == null ? void 0 : t.serverIndex) !== null && o !== void 0 ? o : 0, l = (e = y["ScoreboardApi.putSponsor"]) === null || e === void 0 || (n = e[u]) === null || n === void 0 ? void 0 : n.url, [2, function(d, h) {
              return T(i, S.default, w, t)(d, l || h);
            }];
        }
      });
    })();
  }, releaseScoreboardViewPin: function(r, s, n) {
    return v(function() {
      var e, i, o, u, l, c;
      return p(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, a.releaseScoreboardViewPin(r, s, n)];
          case 1:
            return o = d.sent(), l = (u = t == null ? void 0 : t.serverIndex) !== null && u !== void 0 ? u : 0, c = (i = y["ScoreboardApi.releaseScoreboardViewPin"]) === null || i === void 0 || (e = i[l]) === null || e === void 0 ? void 0 : e.url, [2, function(h, g) {
              return T(o, S.default, w, t)(h, c || g);
            }];
        }
      });
    })();
  }, resolveClassByNumber: function(r, s, n) {
    return v(function() {
      var e, i, o, u, l, c;
      return p(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, a.resolveClassByNumber(r, s, n)];
          case 1:
            return o = d.sent(), l = (u = t == null ? void 0 : t.serverIndex) !== null && u !== void 0 ? u : 0, c = (i = y["ScoreboardApi.resolveClassByNumber"]) === null || i === void 0 || (e = i[l]) === null || e === void 0 ? void 0 : e.url, [2, function(h, g) {
              return T(o, S.default, w, t)(h, c || g);
            }];
        }
      });
    })();
  }, setScoreboardViewCurrentMode: function(r, s, n) {
    return v(function() {
      var e, i, o, u, l, c;
      return p(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, a.setScoreboardViewCurrentMode(r, s, n)];
          case 1:
            return o = d.sent(), l = (u = t == null ? void 0 : t.serverIndex) !== null && u !== void 0 ? u : 0, c = (i = y["ScoreboardApi.setScoreboardViewCurrentMode"]) === null || i === void 0 || (e = i[l]) === null || e === void 0 ? void 0 : e.url, [2, function(h, g) {
              return T(o, S.default, w, t)(h, c || g);
            }];
        }
      });
    })();
  }, setScoreboardViewRidePick: function(r, s, n) {
    return v(function() {
      var e, i, o, u, l, c;
      return p(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, a.setScoreboardViewRidePick(r, s, n)];
          case 1:
            return o = d.sent(), l = (u = t == null ? void 0 : t.serverIndex) !== null && u !== void 0 ? u : 0, c = (i = y["ScoreboardApi.setScoreboardViewRidePick"]) === null || i === void 0 || (e = i[l]) === null || e === void 0 ? void 0 : e.url, [2, function(h, g) {
              return T(o, S.default, w, t)(h, c || g);
            }];
        }
      });
    })();
  }, updateScoreboardView: function(r, s, n) {
    return v(function() {
      var e, i, o, u, l, c;
      return p(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, a.updateScoreboardView(r, s, n)];
          case 1:
            return o = d.sent(), l = (u = t == null ? void 0 : t.serverIndex) !== null && u !== void 0 ? u : 0, c = (i = y["ScoreboardApi.updateScoreboardView"]) === null || i === void 0 || (e = i[l]) === null || e === void 0 ? void 0 : e.url, [2, function(h, g) {
              return T(o, S.default, w, t)(h, c || g);
            }];
        }
      });
    })();
  }, updateSlideshow: function(r, s, n) {
    return v(function() {
      var e, i, o, u, l, c;
      return p(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, a.updateSlideshow(r, s, n)];
          case 1:
            return o = d.sent(), l = (u = t == null ? void 0 : t.serverIndex) !== null && u !== void 0 ? u : 0, c = (i = y["ScoreboardApi.updateSlideshow"]) === null || i === void 0 || (e = i[l]) === null || e === void 0 ? void 0 : e.url, [2, function(h, g) {
              return T(o, S.default, w, t)(h, c || g);
            }];
        }
      });
    })();
  } };
};
(function(t) {
  function a() {
    return Me(this, a), je(this, a, arguments);
  }
  return Ve(a, t), Fe(a, [{ key: "copyScoreboardViewsFromShow", value: function(r, s, n) {
    var e = this;
    return Se(this.configuration).copyScoreboardViewsFromShow(r, s, n).then(function(i) {
      return i(e.axios, e.basePath);
    });
  } }, { key: "createBrandAsset", value: function(r, s) {
    var n = this;
    return Se(this.configuration).createBrandAsset(r, s).then(function(e) {
      return e(n.axios, n.basePath);
    });
  } }, { key: "createScoreboardView", value: function(r, s) {
    var n = this;
    return Se(this.configuration).createScoreboardView(r, s).then(function(e) {
      return e(n.axios, n.basePath);
    });
  } }, { key: "createSlideshow", value: function(r, s) {
    var n = this;
    return Se(this.configuration).createSlideshow(r, s).then(function(e) {
      return e(n.axios, n.basePath);
    });
  } }, { key: "deleteBrandAsset", value: function(r, s) {
    var n = this;
    return Se(this.configuration).deleteBrandAsset(r, s).then(function(e) {
      return e(n.axios, n.basePath);
    });
  } }, { key: "deleteScoreboardTheme", value: function(r, s) {
    var n = this;
    return Se(this.configuration).deleteScoreboardTheme(r, s).then(function(e) {
      return e(n.axios, n.basePath);
    });
  } }, { key: "deleteScoreboardView", value: function(r, s) {
    var n = this;
    return Se(this.configuration).deleteScoreboardView(r, s).then(function(e) {
      return e(n.axios, n.basePath);
    });
  } }, { key: "deleteSlideshow", value: function(r, s) {
    var n = this;
    return Se(this.configuration).deleteSlideshow(r, s).then(function(e) {
      return e(n.axios, n.basePath);
    });
  } }, { key: "deleteSponsor", value: function(r, s) {
    var n = this;
    return Se(this.configuration).deleteSponsor(r, s).then(function(e) {
      return e(n.axios, n.basePath);
    });
  } }, { key: "duplicateScoreboardView", value: function(r, s) {
    var n = this;
    return Se(this.configuration).duplicateScoreboardView(r, s).then(function(e) {
      return e(n.axios, n.basePath);
    });
  } }, { key: "getPublicChanges", value: function(r, s) {
    var n = this;
    return Se(this.configuration).getPublicChanges(r, s).then(function(e) {
      return e(n.axios, n.basePath);
    });
  } }, { key: "getPublicClassResults", value: function(r, s, n) {
    var e = this;
    return Se(this.configuration).getPublicClassResults(r, s, n).then(function(i) {
      return i(e.axios, e.basePath);
    });
  } }, { key: "getPublicLivePhone", value: function(r, s) {
    var n = this;
    return Se(this.configuration).getPublicLivePhone(r, s).then(function(e) {
      return e(n.axios, n.basePath);
    });
  } }, { key: "getPublicPhoneChanges", value: function(r, s) {
    var n = this;
    return Se(this.configuration).getPublicPhoneChanges(r, s).then(function(e) {
      return e(n.axios, n.basePath);
    });
  } }, { key: "getPublicScoreboard", value: function(r, s, n, e, i) {
    var o = this;
    return Se(this.configuration).getPublicScoreboard(r, s, n, e, i).then(function(u) {
      return u(o.axios, o.basePath);
    });
  } }, { key: "getPublicScoreboardDefaultView", value: function(r, s, n, e) {
    var i = this;
    return Se(this.configuration).getPublicScoreboardDefaultView(r, s, n, e).then(function(o) {
      return o(i.axios, i.basePath);
    });
  } }, { key: "getPublicScoreboardPhone", value: function(r, s, n, e) {
    var i = this;
    return Se(this.configuration).getPublicScoreboardPhone(r, s, n, e).then(function(o) {
      return o(i.axios, i.basePath);
    });
  } }, { key: "getPublicScoreboardPhoneDefaultView", value: function(r, s, n) {
    var e = this;
    return Se(this.configuration).getPublicScoreboardPhoneDefaultView(r, s, n).then(function(i) {
      return i(e.axios, e.basePath);
    });
  } }, { key: "getPublicScreenCurrent", value: function(r, s) {
    var n = this;
    return Se(this.configuration).getPublicScreenCurrent(r, s).then(function(e) {
      return e(n.axios, n.basePath);
    });
  } }, { key: "getSlideshow", value: function(r, s) {
    var n = this;
    return Se(this.configuration).getSlideshow(r, s).then(function(e) {
      return e(n.axios, n.basePath);
    });
  } }, { key: "listBrandAssets", value: function(r) {
    var s = this;
    return Se(this.configuration).listBrandAssets(r).then(function(n) {
      return n(s.axios, s.basePath);
    });
  } }, { key: "listScoreboardThemes", value: function(r) {
    var s = this;
    return Se(this.configuration).listScoreboardThemes(r).then(function(n) {
      return n(s.axios, s.basePath);
    });
  } }, { key: "listScoreboardViews", value: function(r, s) {
    var n = this;
    return Se(this.configuration).listScoreboardViews(r, s).then(function(e) {
      return e(n.axios, n.basePath);
    });
  } }, { key: "listSlideshows", value: function(r) {
    var s = this;
    return Se(this.configuration).listSlideshows(r).then(function(n) {
      return n(s.axios, s.basePath);
    });
  } }, { key: "listSponsors", value: function(r) {
    var s = this;
    return Se(this.configuration).listSponsors(r).then(function(n) {
      return n(s.axios, s.basePath);
    });
  } }, { key: "putScoreboardTheme", value: function(r, s) {
    var n = this;
    return Se(this.configuration).putScoreboardTheme(r, s).then(function(e) {
      return e(n.axios, n.basePath);
    });
  } }, { key: "putSponsor", value: function(r, s) {
    var n = this;
    return Se(this.configuration).putSponsor(r, s).then(function(e) {
      return e(n.axios, n.basePath);
    });
  } }, { key: "releaseScoreboardViewPin", value: function(r, s, n) {
    var e = this;
    return Se(this.configuration).releaseScoreboardViewPin(r, s, n).then(function(i) {
      return i(e.axios, e.basePath);
    });
  } }, { key: "resolveClassByNumber", value: function(r, s, n) {
    var e = this;
    return Se(this.configuration).resolveClassByNumber(r, s, n).then(function(i) {
      return i(e.axios, e.basePath);
    });
  } }, { key: "setScoreboardViewCurrentMode", value: function(r, s, n) {
    var e = this;
    return Se(this.configuration).setScoreboardViewCurrentMode(r, s, n).then(function(i) {
      return i(e.axios, e.basePath);
    });
  } }, { key: "setScoreboardViewRidePick", value: function(r, s, n) {
    var e = this;
    return Se(this.configuration).setScoreboardViewRidePick(r, s, n).then(function(i) {
      return i(e.axios, e.basePath);
    });
  } }, { key: "updateScoreboardView", value: function(r, s, n) {
    var e = this;
    return Se(this.configuration).updateScoreboardView(r, s, n).then(function(i) {
      return i(e.axios, e.basePath);
    });
  } }, { key: "updateSlideshow", value: function(r, s, n) {
    var e = this;
    return Se(this.configuration).updateSlideshow(r, s, n).then(function(i) {
      return i(e.axios, e.basePath);
    });
  } }]), a;
})(Le);
var Jh = function(t) {
  return { createScreen: function(a, r) {
    var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return v(function() {
      var n, e, i, o, u, l, c;
      return p(this, function(d) {
        switch (d.label) {
          case 0:
            return b("createScreen", "id", a), n = "/venues/{id}/screens".replace("{id}", encodeURIComponent(String(a))), e = new URL(n, R), t && (i = t.baseOptions), o = f({ method: "POST" }, i, s), l = {}, [4, E(u = {}, t)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", I(e, l), c = i && i.headers ? i.headers : {}, o.headers = f({}, u, c, s.headers), o.data = N(r, o, t), [2, { url: _(e), options: o }];
        }
      });
    })();
  }, deleteScreen: function(a) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return v(function() {
      var s, n, e, i, o, u, l;
      return p(this, function(c) {
        switch (c.label) {
          case 0:
            return b("deleteScreen", "id", a), s = "/screens/{id}".replace("{id}", encodeURIComponent(String(a))), n = new URL(s, R), t && (e = t.baseOptions), i = f({ method: "DELETE" }, e, r), u = {}, [4, E(o = {}, t)];
          case 1:
            return c.sent(), I(n, u), l = e && e.headers ? e.headers : {}, i.headers = f({}, o, l, r.headers), [2, { url: _(n), options: i }];
        }
      });
    })();
  }, getScreen: function(a) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return v(function() {
      var s, n, e, i, o, u, l;
      return p(this, function(c) {
        switch (c.label) {
          case 0:
            return b("getScreen", "id", a), s = "/screens/{id}".replace("{id}", encodeURIComponent(String(a))), n = new URL(s, R), t && (e = t.baseOptions), i = f({ method: "GET" }, e, r), u = {}, [4, E(o = {}, t)];
          case 1:
            return c.sent(), I(n, u), l = e && e.headers ? e.headers : {}, i.headers = f({}, o, l, r.headers), [2, { url: _(n), options: i }];
        }
      });
    })();
  }, getScreenUsage: function(a) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return v(function() {
      var s, n, e, i, o, u, l;
      return p(this, function(c) {
        switch (c.label) {
          case 0:
            return b("getScreenUsage", "id", a), s = "/screens/{id}/usage".replace("{id}", encodeURIComponent(String(a))), n = new URL(s, R), t && (e = t.baseOptions), i = f({ method: "GET" }, e, r), u = {}, [4, E(o = {}, t)];
          case 1:
            return c.sent(), I(n, u), l = e && e.headers ? e.headers : {}, i.headers = f({}, o, l, r.headers), [2, { url: _(n), options: i }];
        }
      });
    })();
  }, listScreens: function(a) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return v(function() {
      var s, n, e, i, o, u, l;
      return p(this, function(c) {
        switch (c.label) {
          case 0:
            return b("listScreens", "id", a), s = "/venues/{id}/screens".replace("{id}", encodeURIComponent(String(a))), n = new URL(s, R), t && (e = t.baseOptions), i = f({ method: "GET" }, e, r), u = {}, [4, E(o = {}, t)];
          case 1:
            return c.sent(), I(n, u), l = e && e.headers ? e.headers : {}, i.headers = f({}, o, l, r.headers), [2, { url: _(n), options: i }];
        }
      });
    })();
  }, updateScreen: function(a, r) {
    var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return v(function() {
      var n, e, i, o, u, l, c;
      return p(this, function(d) {
        switch (d.label) {
          case 0:
            return b("updateScreen", "id", a), n = "/screens/{id}".replace("{id}", encodeURIComponent(String(a))), e = new URL(n, R), t && (i = t.baseOptions), o = f({ method: "PATCH" }, i, s), l = {}, [4, E(u = {}, t)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", I(e, l), c = i && i.headers ? i.headers : {}, o.headers = f({}, u, c, s.headers), o.data = N(r, o, t), [2, { url: _(e), options: o }];
        }
      });
    })();
  } };
}, vn = function(t) {
  var a = Jh(t);
  return { createScreen: function(r, s, n) {
    return v(function() {
      var e, i, o, u, l, c;
      return p(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, a.createScreen(r, s, n)];
          case 1:
            return o = d.sent(), l = (u = t == null ? void 0 : t.serverIndex) !== null && u !== void 0 ? u : 0, c = (i = y["ScreensApi.createScreen"]) === null || i === void 0 || (e = i[l]) === null || e === void 0 ? void 0 : e.url, [2, function(h, g) {
              return T(o, S.default, w, t)(h, c || g);
            }];
        }
      });
    })();
  }, deleteScreen: function(r, s) {
    return v(function() {
      var n, e, i, o, u, l;
      return p(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, a.deleteScreen(r, s)];
          case 1:
            return i = c.sent(), u = (o = t == null ? void 0 : t.serverIndex) !== null && o !== void 0 ? o : 0, l = (e = y["ScreensApi.deleteScreen"]) === null || e === void 0 || (n = e[u]) === null || n === void 0 ? void 0 : n.url, [2, function(d, h) {
              return T(i, S.default, w, t)(d, l || h);
            }];
        }
      });
    })();
  }, getScreen: function(r, s) {
    return v(function() {
      var n, e, i, o, u, l;
      return p(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, a.getScreen(r, s)];
          case 1:
            return i = c.sent(), u = (o = t == null ? void 0 : t.serverIndex) !== null && o !== void 0 ? o : 0, l = (e = y["ScreensApi.getScreen"]) === null || e === void 0 || (n = e[u]) === null || n === void 0 ? void 0 : n.url, [2, function(d, h) {
              return T(i, S.default, w, t)(d, l || h);
            }];
        }
      });
    })();
  }, getScreenUsage: function(r, s) {
    return v(function() {
      var n, e, i, o, u, l;
      return p(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, a.getScreenUsage(r, s)];
          case 1:
            return i = c.sent(), u = (o = t == null ? void 0 : t.serverIndex) !== null && o !== void 0 ? o : 0, l = (e = y["ScreensApi.getScreenUsage"]) === null || e === void 0 || (n = e[u]) === null || n === void 0 ? void 0 : n.url, [2, function(d, h) {
              return T(i, S.default, w, t)(d, l || h);
            }];
        }
      });
    })();
  }, listScreens: function(r, s) {
    return v(function() {
      var n, e, i, o, u, l;
      return p(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, a.listScreens(r, s)];
          case 1:
            return i = c.sent(), u = (o = t == null ? void 0 : t.serverIndex) !== null && o !== void 0 ? o : 0, l = (e = y["ScreensApi.listScreens"]) === null || e === void 0 || (n = e[u]) === null || n === void 0 ? void 0 : n.url, [2, function(d, h) {
              return T(i, S.default, w, t)(d, l || h);
            }];
        }
      });
    })();
  }, updateScreen: function(r, s, n) {
    return v(function() {
      var e, i, o, u, l, c;
      return p(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, a.updateScreen(r, s, n)];
          case 1:
            return o = d.sent(), l = (u = t == null ? void 0 : t.serverIndex) !== null && u !== void 0 ? u : 0, c = (i = y["ScreensApi.updateScreen"]) === null || i === void 0 || (e = i[l]) === null || e === void 0 ? void 0 : e.url, [2, function(h, g) {
              return T(o, S.default, w, t)(h, c || g);
            }];
        }
      });
    })();
  } };
};
(function(t) {
  function a() {
    return Me(this, a), je(this, a, arguments);
  }
  return Ve(a, t), Fe(a, [{ key: "createScreen", value: function(r, s, n) {
    var e = this;
    return vn(this.configuration).createScreen(r, s, n).then(function(i) {
      return i(e.axios, e.basePath);
    });
  } }, { key: "deleteScreen", value: function(r, s) {
    var n = this;
    return vn(this.configuration).deleteScreen(r, s).then(function(e) {
      return e(n.axios, n.basePath);
    });
  } }, { key: "getScreen", value: function(r, s) {
    var n = this;
    return vn(this.configuration).getScreen(r, s).then(function(e) {
      return e(n.axios, n.basePath);
    });
  } }, { key: "getScreenUsage", value: function(r, s) {
    var n = this;
    return vn(this.configuration).getScreenUsage(r, s).then(function(e) {
      return e(n.axios, n.basePath);
    });
  } }, { key: "listScreens", value: function(r, s) {
    var n = this;
    return vn(this.configuration).listScreens(r, s).then(function(e) {
      return e(n.axios, n.basePath);
    });
  } }, { key: "updateScreen", value: function(r, s, n) {
    var e = this;
    return vn(this.configuration).updateScreen(r, s, n).then(function(i) {
      return i(e.axios, e.basePath);
    });
  } }]), a;
})(Le);
var Yh = function(t) {
  return { backToPreShowSetup: function(a) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return v(function() {
      var s, n, e, i, o, u, l;
      return p(this, function(c) {
        switch (c.label) {
          case 0:
            return b("backToPreShowSetup", "showId", a), s = "/show/{showId}/setup/back-to-pre-show".replace("{showId}", encodeURIComponent(String(a))), n = new URL(s, R), t && (e = t.baseOptions), i = f({ method: "POST" }, e, r), u = {}, [4, E(o = {}, t)];
          case 1:
            return c.sent(), I(n, u), l = e && e.headers ? e.headers : {}, i.headers = f({}, o, l, r.headers), [2, { url: _(n), options: i }];
        }
      });
    })();
  }, ensureShowLiveCode: function(a) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return v(function() {
      var s, n, e, i, o, u, l;
      return p(this, function(c) {
        switch (c.label) {
          case 0:
            return b("ensureShowLiveCode", "id", a), s = "/show/{id}/live-code".replace("{id}", encodeURIComponent(String(a))), n = new URL(s, R), t && (e = t.baseOptions), i = f({ method: "POST" }, e, r), u = {}, [4, E(o = {}, t)];
          case 1:
            return c.sent(), I(n, u), l = e && e.headers ? e.headers : {}, i.headers = f({}, o, l, r.headers), [2, { url: _(n), options: i }];
        }
      });
    })();
  }, getBadgeCounts: function(a) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return v(function() {
      var s, n, e, i, o, u, l;
      return p(this, function(c) {
        switch (c.label) {
          case 0:
            return b("getBadgeCounts", "showId", a), s = "/show/{showId}/badge-counts".replace("{showId}", encodeURIComponent(String(a))), n = new URL(s, R), t && (e = t.baseOptions), i = f({ method: "GET" }, e, r), u = {}, [4, E(o = {}, t)];
          case 1:
            return c.sent(), I(n, u), l = e && e.headers ? e.headers : {}, i.headers = f({}, o, l, r.headers), [2, { url: _(n), options: i }];
        }
      });
    })();
  }, getShow: function(a) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return v(function() {
      var s, n, e, i, o, u, l;
      return p(this, function(c) {
        switch (c.label) {
          case 0:
            return b("getShow", "id", a), s = "/show/{id}".replace("{id}", encodeURIComponent(String(a))), n = new URL(s, R), t && (e = t.baseOptions), i = f({ method: "GET" }, e, r), u = {}, [4, E(o = {}, t)];
          case 1:
            return c.sent(), I(n, u), l = e && e.headers ? e.headers : {}, i.headers = f({}, o, l, r.headers), [2, { url: _(n), options: i }];
        }
      });
    })();
  }, getShowChanges: function(a) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return v(function() {
      var s, n, e, i, o, u, l;
      return p(this, function(c) {
        switch (c.label) {
          case 0:
            return b("getShowChanges", "showId", a), s = "/show/{showId}/changes".replace("{showId}", encodeURIComponent(String(a))), n = new URL(s, R), t && (e = t.baseOptions), i = f({ method: "GET" }, e, r), u = {}, [4, E(o = {}, t)];
          case 1:
            return c.sent(), I(n, u), l = e && e.headers ? e.headers : {}, i.headers = f({}, o, l, r.headers), [2, { url: _(n), options: i }];
        }
      });
    })();
  }, getShowPlaceProblems: function(a) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return v(function() {
      var s, n, e, i, o, u, l;
      return p(this, function(c) {
        switch (c.label) {
          case 0:
            return b("getShowPlaceProblems", "showId", a), s = "/show/{showId}/place-problems".replace("{showId}", encodeURIComponent(String(a))), n = new URL(s, R), t && (e = t.baseOptions), i = f({ method: "GET" }, e, r), u = {}, [4, E(o = {}, t)];
          case 1:
            return c.sent(), I(n, u), l = e && e.headers ? e.headers : {}, i.headers = f({}, o, l, r.headers), [2, { url: _(n), options: i }];
        }
      });
    })();
  }, getShowSetup: function(a) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return v(function() {
      var s, n, e, i, o, u, l;
      return p(this, function(c) {
        switch (c.label) {
          case 0:
            return b("getShowSetup", "showId", a), s = "/show/{showId}/setup".replace("{showId}", encodeURIComponent(String(a))), n = new URL(s, R), t && (e = t.baseOptions), i = f({ method: "GET" }, e, r), u = {}, [4, E(o = {}, t)];
          case 1:
            return c.sent(), I(n, u), l = e && e.headers ? e.headers : {}, i.headers = f({}, o, l, r.headers), [2, { url: _(n), options: i }];
        }
      });
    })();
  }, listShows: function() {
    var a = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return v(function() {
      var r, s, n, e, i, o;
      return p(this, function(u) {
        switch (u.label) {
          case 0:
            return r = new URL("/show", R), t && (s = t.baseOptions), n = f({ method: "GET" }, s, a), i = {}, [4, E(e = {}, t)];
          case 1:
            return u.sent(), I(r, i), o = s && s.headers ? s.headers : {}, n.headers = f({}, e, o, a.headers), [2, { url: _(r), options: n }];
        }
      });
    })();
  }, recordUsdfDownload: function(a) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return v(function() {
      var s, n, e, i, o, u, l;
      return p(this, function(c) {
        switch (c.label) {
          case 0:
            return b("recordUsdfDownload", "id", a), s = "/show/{id}/usdf-downloaded".replace("{id}", encodeURIComponent(String(a))), n = new URL(s, R), t && (e = t.baseOptions), i = f({ method: "PUT" }, e, r), u = {}, [4, E(o = {}, t)];
          case 1:
            return c.sent(), I(n, u), l = e && e.headers ? e.headers : {}, i.headers = f({}, o, l, r.headers), [2, { url: _(n), options: i }];
        }
      });
    })();
  }, setShowAutoPlaceClasses: function(a, r) {
    var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return v(function() {
      var n, e, i, o, u, l, c;
      return p(this, function(d) {
        switch (d.label) {
          case 0:
            return b("setShowAutoPlaceClasses", "id", a), b("setShowAutoPlaceClasses", "setShowAutoPlaceClassesRequest", r), n = "/show/{id}/auto-place-classes".replace("{id}", encodeURIComponent(String(a))), e = new URL(n, R), t && (i = t.baseOptions), o = f({ method: "PUT" }, i, s), l = {}, [4, E(u = {}, t)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", I(e, l), c = i && i.headers ? i.headers : {}, o.headers = f({}, u, c, s.headers), o.data = N(r, o, t), [2, { url: _(e), options: o }];
        }
      });
    })();
  }, setShowFriendlyName: function(a, r) {
    var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return v(function() {
      var n, e, i, o, u, l, c;
      return p(this, function(d) {
        switch (d.label) {
          case 0:
            return b("setShowFriendlyName", "id", a), b("setShowFriendlyName", "setShowFriendlyNameRequest", r), n = "/show/{id}/friendly-name".replace("{id}", encodeURIComponent(String(a))), e = new URL(n, R), t && (i = t.baseOptions), o = f({ method: "PUT" }, i, s), l = {}, [4, E(u = {}, t)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", I(e, l), c = i && i.headers ? i.headers : {}, o.headers = f({}, u, c, s.headers), o.data = N(r, o, t), [2, { url: _(e), options: o }];
        }
      });
    })();
  }, setShowInstantUpdates: function(a, r) {
    var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return v(function() {
      var n, e, i, o, u, l, c;
      return p(this, function(d) {
        switch (d.label) {
          case 0:
            return b("setShowInstantUpdates", "id", a), b("setShowInstantUpdates", "setShowInstantUpdatesRequest", r), n = "/show/{id}/instant-updates".replace("{id}", encodeURIComponent(String(a))), e = new URL(n, R), t && (i = t.baseOptions), o = f({ method: "PUT" }, i, s), l = {}, [4, E(u = {}, t)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", I(e, l), c = i && i.headers ? i.headers : {}, o.headers = f({}, u, c, s.headers), o.data = N(r, o, t), [2, { url: _(e), options: o }];
        }
      });
    })();
  }, setShowLogo: function(a, r) {
    var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return v(function() {
      var n, e, i, o, u, l, c;
      return p(this, function(d) {
        switch (d.label) {
          case 0:
            return b("setShowLogo", "id", a), n = "/show/{id}/logo".replace("{id}", encodeURIComponent(String(a))), e = new URL(n, R), t && (i = t.baseOptions), o = f({ method: "PUT" }, i, s), l = {}, [4, E(u = {}, t)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", I(e, l), c = i && i.headers ? i.headers : {}, o.headers = f({}, u, c, s.headers), o.data = N(r, o, t), [2, { url: _(e), options: o }];
        }
      });
    })();
  }, setShowNoFoxbox: function(a, r) {
    var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return v(function() {
      var n, e, i, o, u, l, c;
      return p(this, function(d) {
        switch (d.label) {
          case 0:
            return b("setShowNoFoxbox", "id", a), b("setShowNoFoxbox", "setShowNoFoxboxRequest", r), n = "/show/{id}/no-foxbox".replace("{id}", encodeURIComponent(String(a))), e = new URL(n, R), t && (i = t.baseOptions), o = f({ method: "PUT" }, i, s), l = {}, [4, E(u = {}, t)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", I(e, l), c = i && i.headers ? i.headers : {}, o.headers = f({}, u, c, s.headers), o.data = N(r, o, t), [2, { url: _(e), options: o }];
        }
      });
    })();
  }, setShowPhonePollAfterMs: function(a, r) {
    var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return v(function() {
      var n, e, i, o, u, l, c;
      return p(this, function(d) {
        switch (d.label) {
          case 0:
            return b("setShowPhonePollAfterMs", "id", a), b("setShowPhonePollAfterMs", "setShowPhonePollAfterMsRequest", r), n = "/show/{id}/phone-poll-after-ms".replace("{id}", encodeURIComponent(String(a))), e = new URL(n, R), t && (i = t.baseOptions), o = f({ method: "PUT" }, i, s), l = {}, [4, E(u = {}, t)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", I(e, l), c = i && i.headers ? i.headers : {}, o.headers = f({}, u, c, s.headers), o.data = N(r, o, t), [2, { url: _(e), options: o }];
        }
      });
    })();
  }, setShowRosetteColors: function(a, r) {
    var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return v(function() {
      var n, e, i, o, u, l, c;
      return p(this, function(d) {
        switch (d.label) {
          case 0:
            return b("setShowRosetteColors", "id", a), b("setShowRosetteColors", "setShowRosetteColorsRequest", r), n = "/show/{id}/rosette-colors".replace("{id}", encodeURIComponent(String(a))), e = new URL(n, R), t && (i = t.baseOptions), o = f({ method: "PUT" }, i, s), l = {}, [4, E(u = {}, t)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", I(e, l), c = i && i.headers ? i.headers : {}, o.headers = f({}, u, c, s.headers), o.data = N(r, o, t), [2, { url: _(e), options: o }];
        }
      });
    })();
  }, setShowScribeUnlockPin: function(a, r) {
    var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return v(function() {
      var n, e, i, o, u, l, c;
      return p(this, function(d) {
        switch (d.label) {
          case 0:
            return b("setShowScribeUnlockPin", "id", a), n = "/show/{id}/scribe-unlock-pin".replace("{id}", encodeURIComponent(String(a))), e = new URL(n, R), t && (i = t.baseOptions), o = f({ method: "PUT" }, i, s), l = {}, [4, E(u = {}, t)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", I(e, l), c = i && i.headers ? i.headers : {}, o.headers = f({}, u, c, s.headers), o.data = N(r, o, t), [2, { url: _(e), options: o }];
        }
      });
    })();
  }, setShowSectionSettings: function(a, r) {
    var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return v(function() {
      var n, e, i, o, u, l, c;
      return p(this, function(d) {
        switch (d.label) {
          case 0:
            return b("setShowSectionSettings", "id", a), n = "/show/{id}/section-settings".replace("{id}", encodeURIComponent(String(a))), e = new URL(n, R), t && (i = t.baseOptions), o = f({ method: "PUT" }, i, s), l = {}, [4, E(u = {}, t)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", I(e, l), c = i && i.headers ? i.headers : {}, o.headers = f({}, u, c, s.headers), o.data = N(r, o, t), [2, { url: _(e), options: o }];
        }
      });
    })();
  }, setShowSetupHandCheck: function(a, r, s) {
    var n = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    return v(function() {
      var e, i, o, u, l, c, d;
      return p(this, function(h) {
        switch (h.label) {
          case 0:
            return b("setShowSetupHandCheck", "showId", a), b("setShowSetupHandCheck", "itemKey", r), b("setShowSetupHandCheck", "setShowSetupHandCheckRequest", s), e = "/show/{showId}/setup/hand-check/{itemKey}".replace("{showId}", encodeURIComponent(String(a))).replace("{itemKey}", encodeURIComponent(String(r))), i = new URL(e, R), t && (o = t.baseOptions), u = f({ method: "PUT" }, o, n), c = {}, [4, E(l = {}, t)];
          case 1:
            return h.sent(), l["Content-Type"] = "application/json", I(i, c), d = o && o.headers ? o.headers : {}, u.headers = f({}, l, d, n.headers), u.data = N(s, u, t), [2, { url: _(i), options: u }];
        }
      });
    })();
  }, setShowSponsorPrizeSettings: function(a, r) {
    var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return v(function() {
      var n, e, i, o, u, l, c;
      return p(this, function(d) {
        switch (d.label) {
          case 0:
            return b("setShowSponsorPrizeSettings", "id", a), n = "/show/{id}/sponsor-prize-settings".replace("{id}", encodeURIComponent(String(a))), e = new URL(n, R), t && (i = t.baseOptions), o = f({ method: "PUT" }, i, s), l = {}, [4, E(u = {}, t)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", I(e, l), c = i && i.headers ? i.headers : {}, o.headers = f({}, u, c, s.headers), o.data = N(r, o, t), [2, { url: _(e), options: o }];
        }
      });
    })();
  }, setShowUsdfResultsEmailed: function(a, r) {
    var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return v(function() {
      var n, e, i, o, u, l, c;
      return p(this, function(d) {
        switch (d.label) {
          case 0:
            return b("setShowUsdfResultsEmailed", "id", a), b("setShowUsdfResultsEmailed", "setShowUsdfResultsEmailedRequest", r), n = "/show/{id}/usdf-results-emailed".replace("{id}", encodeURIComponent(String(a))), e = new URL(n, R), t && (i = t.baseOptions), o = f({ method: "PUT" }, i, s), l = {}, [4, E(u = {}, t)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", I(e, l), c = i && i.headers ? i.headers : {}, o.headers = f({}, u, c, s.headers), o.data = N(r, o, t), [2, { url: _(e), options: o }];
        }
      });
    })();
  }, setShowVenue: function(a, r) {
    var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return v(function() {
      var n, e, i, o, u, l, c;
      return p(this, function(d) {
        switch (d.label) {
          case 0:
            return b("setShowVenue", "id", a), n = "/show/{id}/venue".replace("{id}", encodeURIComponent(String(a))), e = new URL(n, R), t && (i = t.baseOptions), o = f({ method: "PUT" }, i, s), l = {}, [4, E(u = {}, t)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", I(e, l), c = i && i.headers ? i.headers : {}, o.headers = f({}, u, c, s.headers), o.data = N(r, o, t), [2, { url: _(e), options: o }];
        }
      });
    })();
  }, setShowVenueTimezone: function(a, r) {
    var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return v(function() {
      var n, e, i, o, u, l, c;
      return p(this, function(d) {
        switch (d.label) {
          case 0:
            return b("setShowVenueTimezone", "id", a), n = "/show/{id}/venue-timezone".replace("{id}", encodeURIComponent(String(a))), e = new URL(n, R), t && (i = t.baseOptions), o = f({ method: "PUT" }, i, s), l = {}, [4, E(u = {}, t)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", I(e, l), c = i && i.headers ? i.headers : {}, o.headers = f({}, u, c, s.headers), o.data = N(r, o, t), [2, { url: _(e), options: o }];
        }
      });
    })();
  }, startShowSetup: function(a) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return v(function() {
      var s, n, e, i, o, u, l;
      return p(this, function(c) {
        switch (c.label) {
          case 0:
            return b("startShowSetup", "showId", a), s = "/show/{showId}/setup/start".replace("{showId}", encodeURIComponent(String(a))), n = new URL(s, R), t && (e = t.baseOptions), i = f({ method: "POST" }, e, r), u = {}, [4, E(o = {}, t)];
          case 1:
            return c.sent(), I(n, u), l = e && e.headers ? e.headers : {}, i.headers = f({}, o, l, r.headers), [2, { url: _(n), options: i }];
        }
      });
    })();
  } };
}, Ge = function(t) {
  var a = Yh(t);
  return { backToPreShowSetup: function(r, s) {
    return v(function() {
      var n, e, i, o, u, l;
      return p(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, a.backToPreShowSetup(r, s)];
          case 1:
            return i = c.sent(), u = (o = t == null ? void 0 : t.serverIndex) !== null && o !== void 0 ? o : 0, l = (e = y["ShowsApi.backToPreShowSetup"]) === null || e === void 0 || (n = e[u]) === null || n === void 0 ? void 0 : n.url, [2, function(d, h) {
              return T(i, S.default, w, t)(d, l || h);
            }];
        }
      });
    })();
  }, ensureShowLiveCode: function(r, s) {
    return v(function() {
      var n, e, i, o, u, l;
      return p(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, a.ensureShowLiveCode(r, s)];
          case 1:
            return i = c.sent(), u = (o = t == null ? void 0 : t.serverIndex) !== null && o !== void 0 ? o : 0, l = (e = y["ShowsApi.ensureShowLiveCode"]) === null || e === void 0 || (n = e[u]) === null || n === void 0 ? void 0 : n.url, [2, function(d, h) {
              return T(i, S.default, w, t)(d, l || h);
            }];
        }
      });
    })();
  }, getBadgeCounts: function(r, s) {
    return v(function() {
      var n, e, i, o, u, l;
      return p(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, a.getBadgeCounts(r, s)];
          case 1:
            return i = c.sent(), u = (o = t == null ? void 0 : t.serverIndex) !== null && o !== void 0 ? o : 0, l = (e = y["ShowsApi.getBadgeCounts"]) === null || e === void 0 || (n = e[u]) === null || n === void 0 ? void 0 : n.url, [2, function(d, h) {
              return T(i, S.default, w, t)(d, l || h);
            }];
        }
      });
    })();
  }, getShow: function(r, s) {
    return v(function() {
      var n, e, i, o, u, l;
      return p(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, a.getShow(r, s)];
          case 1:
            return i = c.sent(), u = (o = t == null ? void 0 : t.serverIndex) !== null && o !== void 0 ? o : 0, l = (e = y["ShowsApi.getShow"]) === null || e === void 0 || (n = e[u]) === null || n === void 0 ? void 0 : n.url, [2, function(d, h) {
              return T(i, S.default, w, t)(d, l || h);
            }];
        }
      });
    })();
  }, getShowChanges: function(r, s) {
    return v(function() {
      var n, e, i, o, u, l;
      return p(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, a.getShowChanges(r, s)];
          case 1:
            return i = c.sent(), u = (o = t == null ? void 0 : t.serverIndex) !== null && o !== void 0 ? o : 0, l = (e = y["ShowsApi.getShowChanges"]) === null || e === void 0 || (n = e[u]) === null || n === void 0 ? void 0 : n.url, [2, function(d, h) {
              return T(i, S.default, w, t)(d, l || h);
            }];
        }
      });
    })();
  }, getShowPlaceProblems: function(r, s) {
    return v(function() {
      var n, e, i, o, u, l;
      return p(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, a.getShowPlaceProblems(r, s)];
          case 1:
            return i = c.sent(), u = (o = t == null ? void 0 : t.serverIndex) !== null && o !== void 0 ? o : 0, l = (e = y["ShowsApi.getShowPlaceProblems"]) === null || e === void 0 || (n = e[u]) === null || n === void 0 ? void 0 : n.url, [2, function(d, h) {
              return T(i, S.default, w, t)(d, l || h);
            }];
        }
      });
    })();
  }, getShowSetup: function(r, s) {
    return v(function() {
      var n, e, i, o, u, l;
      return p(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, a.getShowSetup(r, s)];
          case 1:
            return i = c.sent(), u = (o = t == null ? void 0 : t.serverIndex) !== null && o !== void 0 ? o : 0, l = (e = y["ShowsApi.getShowSetup"]) === null || e === void 0 || (n = e[u]) === null || n === void 0 ? void 0 : n.url, [2, function(d, h) {
              return T(i, S.default, w, t)(d, l || h);
            }];
        }
      });
    })();
  }, listShows: function(r) {
    return v(function() {
      var s, n, e, i, o, u;
      return p(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, a.listShows(r)];
          case 1:
            return e = l.sent(), o = (i = t == null ? void 0 : t.serverIndex) !== null && i !== void 0 ? i : 0, u = (n = y["ShowsApi.listShows"]) === null || n === void 0 || (s = n[o]) === null || s === void 0 ? void 0 : s.url, [2, function(c, d) {
              return T(e, S.default, w, t)(c, u || d);
            }];
        }
      });
    })();
  }, recordUsdfDownload: function(r, s) {
    return v(function() {
      var n, e, i, o, u, l;
      return p(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, a.recordUsdfDownload(r, s)];
          case 1:
            return i = c.sent(), u = (o = t == null ? void 0 : t.serverIndex) !== null && o !== void 0 ? o : 0, l = (e = y["ShowsApi.recordUsdfDownload"]) === null || e === void 0 || (n = e[u]) === null || n === void 0 ? void 0 : n.url, [2, function(d, h) {
              return T(i, S.default, w, t)(d, l || h);
            }];
        }
      });
    })();
  }, setShowAutoPlaceClasses: function(r, s, n) {
    return v(function() {
      var e, i, o, u, l, c;
      return p(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, a.setShowAutoPlaceClasses(r, s, n)];
          case 1:
            return o = d.sent(), l = (u = t == null ? void 0 : t.serverIndex) !== null && u !== void 0 ? u : 0, c = (i = y["ShowsApi.setShowAutoPlaceClasses"]) === null || i === void 0 || (e = i[l]) === null || e === void 0 ? void 0 : e.url, [2, function(h, g) {
              return T(o, S.default, w, t)(h, c || g);
            }];
        }
      });
    })();
  }, setShowFriendlyName: function(r, s, n) {
    return v(function() {
      var e, i, o, u, l, c;
      return p(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, a.setShowFriendlyName(r, s, n)];
          case 1:
            return o = d.sent(), l = (u = t == null ? void 0 : t.serverIndex) !== null && u !== void 0 ? u : 0, c = (i = y["ShowsApi.setShowFriendlyName"]) === null || i === void 0 || (e = i[l]) === null || e === void 0 ? void 0 : e.url, [2, function(h, g) {
              return T(o, S.default, w, t)(h, c || g);
            }];
        }
      });
    })();
  }, setShowInstantUpdates: function(r, s, n) {
    return v(function() {
      var e, i, o, u, l, c;
      return p(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, a.setShowInstantUpdates(r, s, n)];
          case 1:
            return o = d.sent(), l = (u = t == null ? void 0 : t.serverIndex) !== null && u !== void 0 ? u : 0, c = (i = y["ShowsApi.setShowInstantUpdates"]) === null || i === void 0 || (e = i[l]) === null || e === void 0 ? void 0 : e.url, [2, function(h, g) {
              return T(o, S.default, w, t)(h, c || g);
            }];
        }
      });
    })();
  }, setShowLogo: function(r, s, n) {
    return v(function() {
      var e, i, o, u, l, c;
      return p(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, a.setShowLogo(r, s, n)];
          case 1:
            return o = d.sent(), l = (u = t == null ? void 0 : t.serverIndex) !== null && u !== void 0 ? u : 0, c = (i = y["ShowsApi.setShowLogo"]) === null || i === void 0 || (e = i[l]) === null || e === void 0 ? void 0 : e.url, [2, function(h, g) {
              return T(o, S.default, w, t)(h, c || g);
            }];
        }
      });
    })();
  }, setShowNoFoxbox: function(r, s, n) {
    return v(function() {
      var e, i, o, u, l, c;
      return p(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, a.setShowNoFoxbox(r, s, n)];
          case 1:
            return o = d.sent(), l = (u = t == null ? void 0 : t.serverIndex) !== null && u !== void 0 ? u : 0, c = (i = y["ShowsApi.setShowNoFoxbox"]) === null || i === void 0 || (e = i[l]) === null || e === void 0 ? void 0 : e.url, [2, function(h, g) {
              return T(o, S.default, w, t)(h, c || g);
            }];
        }
      });
    })();
  }, setShowPhonePollAfterMs: function(r, s, n) {
    return v(function() {
      var e, i, o, u, l, c;
      return p(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, a.setShowPhonePollAfterMs(r, s, n)];
          case 1:
            return o = d.sent(), l = (u = t == null ? void 0 : t.serverIndex) !== null && u !== void 0 ? u : 0, c = (i = y["ShowsApi.setShowPhonePollAfterMs"]) === null || i === void 0 || (e = i[l]) === null || e === void 0 ? void 0 : e.url, [2, function(h, g) {
              return T(o, S.default, w, t)(h, c || g);
            }];
        }
      });
    })();
  }, setShowRosetteColors: function(r, s, n) {
    return v(function() {
      var e, i, o, u, l, c;
      return p(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, a.setShowRosetteColors(r, s, n)];
          case 1:
            return o = d.sent(), l = (u = t == null ? void 0 : t.serverIndex) !== null && u !== void 0 ? u : 0, c = (i = y["ShowsApi.setShowRosetteColors"]) === null || i === void 0 || (e = i[l]) === null || e === void 0 ? void 0 : e.url, [2, function(h, g) {
              return T(o, S.default, w, t)(h, c || g);
            }];
        }
      });
    })();
  }, setShowScribeUnlockPin: function(r, s, n) {
    return v(function() {
      var e, i, o, u, l, c;
      return p(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, a.setShowScribeUnlockPin(r, s, n)];
          case 1:
            return o = d.sent(), l = (u = t == null ? void 0 : t.serverIndex) !== null && u !== void 0 ? u : 0, c = (i = y["ShowsApi.setShowScribeUnlockPin"]) === null || i === void 0 || (e = i[l]) === null || e === void 0 ? void 0 : e.url, [2, function(h, g) {
              return T(o, S.default, w, t)(h, c || g);
            }];
        }
      });
    })();
  }, setShowSectionSettings: function(r, s, n) {
    return v(function() {
      var e, i, o, u, l, c;
      return p(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, a.setShowSectionSettings(r, s, n)];
          case 1:
            return o = d.sent(), l = (u = t == null ? void 0 : t.serverIndex) !== null && u !== void 0 ? u : 0, c = (i = y["ShowsApi.setShowSectionSettings"]) === null || i === void 0 || (e = i[l]) === null || e === void 0 ? void 0 : e.url, [2, function(h, g) {
              return T(o, S.default, w, t)(h, c || g);
            }];
        }
      });
    })();
  }, setShowSetupHandCheck: function(r, s, n, e) {
    return v(function() {
      var i, o, u, l, c, d;
      return p(this, function(h) {
        switch (h.label) {
          case 0:
            return [4, a.setShowSetupHandCheck(r, s, n, e)];
          case 1:
            return u = h.sent(), c = (l = t == null ? void 0 : t.serverIndex) !== null && l !== void 0 ? l : 0, d = (o = y["ShowsApi.setShowSetupHandCheck"]) === null || o === void 0 || (i = o[c]) === null || i === void 0 ? void 0 : i.url, [2, function(g, U) {
              return T(u, S.default, w, t)(g, d || U);
            }];
        }
      });
    })();
  }, setShowSponsorPrizeSettings: function(r, s, n) {
    return v(function() {
      var e, i, o, u, l, c;
      return p(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, a.setShowSponsorPrizeSettings(r, s, n)];
          case 1:
            return o = d.sent(), l = (u = t == null ? void 0 : t.serverIndex) !== null && u !== void 0 ? u : 0, c = (i = y["ShowsApi.setShowSponsorPrizeSettings"]) === null || i === void 0 || (e = i[l]) === null || e === void 0 ? void 0 : e.url, [2, function(h, g) {
              return T(o, S.default, w, t)(h, c || g);
            }];
        }
      });
    })();
  }, setShowUsdfResultsEmailed: function(r, s, n) {
    return v(function() {
      var e, i, o, u, l, c;
      return p(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, a.setShowUsdfResultsEmailed(r, s, n)];
          case 1:
            return o = d.sent(), l = (u = t == null ? void 0 : t.serverIndex) !== null && u !== void 0 ? u : 0, c = (i = y["ShowsApi.setShowUsdfResultsEmailed"]) === null || i === void 0 || (e = i[l]) === null || e === void 0 ? void 0 : e.url, [2, function(h, g) {
              return T(o, S.default, w, t)(h, c || g);
            }];
        }
      });
    })();
  }, setShowVenue: function(r, s, n) {
    return v(function() {
      var e, i, o, u, l, c;
      return p(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, a.setShowVenue(r, s, n)];
          case 1:
            return o = d.sent(), l = (u = t == null ? void 0 : t.serverIndex) !== null && u !== void 0 ? u : 0, c = (i = y["ShowsApi.setShowVenue"]) === null || i === void 0 || (e = i[l]) === null || e === void 0 ? void 0 : e.url, [2, function(h, g) {
              return T(o, S.default, w, t)(h, c || g);
            }];
        }
      });
    })();
  }, setShowVenueTimezone: function(r, s, n) {
    return v(function() {
      var e, i, o, u, l, c;
      return p(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, a.setShowVenueTimezone(r, s, n)];
          case 1:
            return o = d.sent(), l = (u = t == null ? void 0 : t.serverIndex) !== null && u !== void 0 ? u : 0, c = (i = y["ShowsApi.setShowVenueTimezone"]) === null || i === void 0 || (e = i[l]) === null || e === void 0 ? void 0 : e.url, [2, function(h, g) {
              return T(o, S.default, w, t)(h, c || g);
            }];
        }
      });
    })();
  }, startShowSetup: function(r, s) {
    return v(function() {
      var n, e, i, o, u, l;
      return p(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, a.startShowSetup(r, s)];
          case 1:
            return i = c.sent(), u = (o = t == null ? void 0 : t.serverIndex) !== null && o !== void 0 ? o : 0, l = (e = y["ShowsApi.startShowSetup"]) === null || e === void 0 || (n = e[u]) === null || n === void 0 ? void 0 : n.url, [2, function(d, h) {
              return T(i, S.default, w, t)(d, l || h);
            }];
        }
      });
    })();
  } };
};
(function(t) {
  function a() {
    return Me(this, a), je(this, a, arguments);
  }
  return Ve(a, t), Fe(a, [{ key: "backToPreShowSetup", value: function(r, s) {
    var n = this;
    return Ge(this.configuration).backToPreShowSetup(r, s).then(function(e) {
      return e(n.axios, n.basePath);
    });
  } }, { key: "ensureShowLiveCode", value: function(r, s) {
    var n = this;
    return Ge(this.configuration).ensureShowLiveCode(r, s).then(function(e) {
      return e(n.axios, n.basePath);
    });
  } }, { key: "getBadgeCounts", value: function(r, s) {
    var n = this;
    return Ge(this.configuration).getBadgeCounts(r, s).then(function(e) {
      return e(n.axios, n.basePath);
    });
  } }, { key: "getShow", value: function(r, s) {
    var n = this;
    return Ge(this.configuration).getShow(r, s).then(function(e) {
      return e(n.axios, n.basePath);
    });
  } }, { key: "getShowChanges", value: function(r, s) {
    var n = this;
    return Ge(this.configuration).getShowChanges(r, s).then(function(e) {
      return e(n.axios, n.basePath);
    });
  } }, { key: "getShowPlaceProblems", value: function(r, s) {
    var n = this;
    return Ge(this.configuration).getShowPlaceProblems(r, s).then(function(e) {
      return e(n.axios, n.basePath);
    });
  } }, { key: "getShowSetup", value: function(r, s) {
    var n = this;
    return Ge(this.configuration).getShowSetup(r, s).then(function(e) {
      return e(n.axios, n.basePath);
    });
  } }, { key: "listShows", value: function(r) {
    var s = this;
    return Ge(this.configuration).listShows(r).then(function(n) {
      return n(s.axios, s.basePath);
    });
  } }, { key: "recordUsdfDownload", value: function(r, s) {
    var n = this;
    return Ge(this.configuration).recordUsdfDownload(r, s).then(function(e) {
      return e(n.axios, n.basePath);
    });
  } }, { key: "setShowAutoPlaceClasses", value: function(r, s, n) {
    var e = this;
    return Ge(this.configuration).setShowAutoPlaceClasses(r, s, n).then(function(i) {
      return i(e.axios, e.basePath);
    });
  } }, { key: "setShowFriendlyName", value: function(r, s, n) {
    var e = this;
    return Ge(this.configuration).setShowFriendlyName(r, s, n).then(function(i) {
      return i(e.axios, e.basePath);
    });
  } }, { key: "setShowInstantUpdates", value: function(r, s, n) {
    var e = this;
    return Ge(this.configuration).setShowInstantUpdates(r, s, n).then(function(i) {
      return i(e.axios, e.basePath);
    });
  } }, { key: "setShowLogo", value: function(r, s, n) {
    var e = this;
    return Ge(this.configuration).setShowLogo(r, s, n).then(function(i) {
      return i(e.axios, e.basePath);
    });
  } }, { key: "setShowNoFoxbox", value: function(r, s, n) {
    var e = this;
    return Ge(this.configuration).setShowNoFoxbox(r, s, n).then(function(i) {
      return i(e.axios, e.basePath);
    });
  } }, { key: "setShowPhonePollAfterMs", value: function(r, s, n) {
    var e = this;
    return Ge(this.configuration).setShowPhonePollAfterMs(r, s, n).then(function(i) {
      return i(e.axios, e.basePath);
    });
  } }, { key: "setShowRosetteColors", value: function(r, s, n) {
    var e = this;
    return Ge(this.configuration).setShowRosetteColors(r, s, n).then(function(i) {
      return i(e.axios, e.basePath);
    });
  } }, { key: "setShowScribeUnlockPin", value: function(r, s, n) {
    var e = this;
    return Ge(this.configuration).setShowScribeUnlockPin(r, s, n).then(function(i) {
      return i(e.axios, e.basePath);
    });
  } }, { key: "setShowSectionSettings", value: function(r, s, n) {
    var e = this;
    return Ge(this.configuration).setShowSectionSettings(r, s, n).then(function(i) {
      return i(e.axios, e.basePath);
    });
  } }, { key: "setShowSetupHandCheck", value: function(r, s, n, e) {
    var i = this;
    return Ge(this.configuration).setShowSetupHandCheck(r, s, n, e).then(function(o) {
      return o(i.axios, i.basePath);
    });
  } }, { key: "setShowSponsorPrizeSettings", value: function(r, s, n) {
    var e = this;
    return Ge(this.configuration).setShowSponsorPrizeSettings(r, s, n).then(function(i) {
      return i(e.axios, e.basePath);
    });
  } }, { key: "setShowUsdfResultsEmailed", value: function(r, s, n) {
    var e = this;
    return Ge(this.configuration).setShowUsdfResultsEmailed(r, s, n).then(function(i) {
      return i(e.axios, e.basePath);
    });
  } }, { key: "setShowVenue", value: function(r, s, n) {
    var e = this;
    return Ge(this.configuration).setShowVenue(r, s, n).then(function(i) {
      return i(e.axios, e.basePath);
    });
  } }, { key: "setShowVenueTimezone", value: function(r, s, n) {
    var e = this;
    return Ge(this.configuration).setShowVenueTimezone(r, s, n).then(function(i) {
      return i(e.axios, e.basePath);
    });
  } }, { key: "startShowSetup", value: function(r, s) {
    var n = this;
    return Ge(this.configuration).startShowSetup(r, s).then(function(e) {
      return e(n.axios, n.basePath);
    });
  } }]), a;
})(Le);
var Zh = function(t) {
  return { clearStationMonitorStation: function(a, r) {
    var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return v(function() {
      var n, e, i, o, u, l, c;
      return p(this, function(d) {
        switch (d.label) {
          case 0:
            return b("clearStationMonitorStation", "showId", a), b("clearStationMonitorStation", "deviceId", r), n = "/show/{showId}/station-monitor/{deviceId}/clear".replace("{showId}", encodeURIComponent(String(a))).replace("{deviceId}", encodeURIComponent(String(r))), e = new URL(n, R), t && (i = t.baseOptions), o = f({ method: "POST" }, i, s), l = {}, [4, E(u = {}, t)];
          case 1:
            return d.sent(), I(e, l), c = i && i.headers ? i.headers : {}, o.headers = f({}, u, c, s.headers), [2, { url: _(e), options: o }];
        }
      });
    })();
  }, getStationMonitor: function(a) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return v(function() {
      var s, n, e, i, o, u, l;
      return p(this, function(c) {
        switch (c.label) {
          case 0:
            return b("getStationMonitor", "showId", a), s = "/show/{showId}/station-monitor".replace("{showId}", encodeURIComponent(String(a))), n = new URL(s, R), t && (e = t.baseOptions), i = f({ method: "GET" }, e, r), u = {}, [4, E(o = {}, t)];
          case 1:
            return c.sent(), I(n, u), l = e && e.headers ? e.headers : {}, i.headers = f({}, o, l, r.headers), [2, { url: _(n), options: i }];
        }
      });
    })();
  }, requestStationMachineClear: function(a, r) {
    var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return v(function() {
      var n, e, i, o, u, l, c;
      return p(this, function(d) {
        switch (d.label) {
          case 0:
            return b("requestStationMachineClear", "showId", a), b("requestStationMachineClear", "deviceId", r), n = "/show/{showId}/station-monitor/{deviceId}/clear-machine".replace("{showId}", encodeURIComponent(String(a))).replace("{deviceId}", encodeURIComponent(String(r))), e = new URL(n, R), t && (i = t.baseOptions), o = f({ method: "POST" }, i, s), l = {}, [4, E(u = {}, t)];
          case 1:
            return d.sent(), I(e, l), c = i && i.headers ? i.headers : {}, o.headers = f({}, u, c, s.headers), [2, { url: _(e), options: o }];
        }
      });
    })();
  }, restoreStationMonitorStation: function(a, r) {
    var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return v(function() {
      var n, e, i, o, u, l, c;
      return p(this, function(d) {
        switch (d.label) {
          case 0:
            return b("restoreStationMonitorStation", "showId", a), b("restoreStationMonitorStation", "deviceId", r), n = "/show/{showId}/station-monitor/{deviceId}/clear".replace("{showId}", encodeURIComponent(String(a))).replace("{deviceId}", encodeURIComponent(String(r))), e = new URL(n, R), t && (i = t.baseOptions), o = f({ method: "DELETE" }, i, s), l = {}, [4, E(u = {}, t)];
          case 1:
            return d.sent(), I(e, l), c = i && i.headers ? i.headers : {}, o.headers = f({}, u, c, s.headers), [2, { url: _(e), options: o }];
        }
      });
    })();
  } };
}, Or = function(t) {
  var a = Zh(t);
  return { clearStationMonitorStation: function(r, s, n) {
    return v(function() {
      var e, i, o, u, l, c;
      return p(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, a.clearStationMonitorStation(r, s, n)];
          case 1:
            return o = d.sent(), l = (u = t == null ? void 0 : t.serverIndex) !== null && u !== void 0 ? u : 0, c = (i = y["StationMonitorApi.clearStationMonitorStation"]) === null || i === void 0 || (e = i[l]) === null || e === void 0 ? void 0 : e.url, [2, function(h, g) {
              return T(o, S.default, w, t)(h, c || g);
            }];
        }
      });
    })();
  }, getStationMonitor: function(r, s) {
    return v(function() {
      var n, e, i, o, u, l;
      return p(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, a.getStationMonitor(r, s)];
          case 1:
            return i = c.sent(), u = (o = t == null ? void 0 : t.serverIndex) !== null && o !== void 0 ? o : 0, l = (e = y["StationMonitorApi.getStationMonitor"]) === null || e === void 0 || (n = e[u]) === null || n === void 0 ? void 0 : n.url, [2, function(d, h) {
              return T(i, S.default, w, t)(d, l || h);
            }];
        }
      });
    })();
  }, requestStationMachineClear: function(r, s, n) {
    return v(function() {
      var e, i, o, u, l, c;
      return p(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, a.requestStationMachineClear(r, s, n)];
          case 1:
            return o = d.sent(), l = (u = t == null ? void 0 : t.serverIndex) !== null && u !== void 0 ? u : 0, c = (i = y["StationMonitorApi.requestStationMachineClear"]) === null || i === void 0 || (e = i[l]) === null || e === void 0 ? void 0 : e.url, [2, function(h, g) {
              return T(o, S.default, w, t)(h, c || g);
            }];
        }
      });
    })();
  }, restoreStationMonitorStation: function(r, s, n) {
    return v(function() {
      var e, i, o, u, l, c;
      return p(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, a.restoreStationMonitorStation(r, s, n)];
          case 1:
            return o = d.sent(), l = (u = t == null ? void 0 : t.serverIndex) !== null && u !== void 0 ? u : 0, c = (i = y["StationMonitorApi.restoreStationMonitorStation"]) === null || i === void 0 || (e = i[l]) === null || e === void 0 ? void 0 : e.url, [2, function(h, g) {
              return T(o, S.default, w, t)(h, c || g);
            }];
        }
      });
    })();
  } };
};
(function(t) {
  function a() {
    return Me(this, a), je(this, a, arguments);
  }
  return Ve(a, t), Fe(a, [{ key: "clearStationMonitorStation", value: function(r, s, n) {
    var e = this;
    return Or(this.configuration).clearStationMonitorStation(r, s, n).then(function(i) {
      return i(e.axios, e.basePath);
    });
  } }, { key: "getStationMonitor", value: function(r, s) {
    var n = this;
    return Or(this.configuration).getStationMonitor(r, s).then(function(e) {
      return e(n.axios, n.basePath);
    });
  } }, { key: "requestStationMachineClear", value: function(r, s, n) {
    var e = this;
    return Or(this.configuration).requestStationMachineClear(r, s, n).then(function(i) {
      return i(e.axios, e.basePath);
    });
  } }, { key: "restoreStationMonitorStation", value: function(r, s, n) {
    var e = this;
    return Or(this.configuration).restoreStationMonitorStation(r, s, n).then(function(i) {
      return i(e.axios, e.basePath);
    });
  } }]), a;
})(Le);
var Kh = function(t) {
  return { checkSheetManifest: function(a, r) {
    var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return v(function() {
      var n, e, i, o, u, l, c;
      return p(this, function(d) {
        switch (d.label) {
          case 0:
            return b("checkSheetManifest", "showId", a), b("checkSheetManifest", "checkSheetManifestRequest", r), n = "/show/{showId}/sheet-manifest".replace("{showId}", encodeURIComponent(String(a))), e = new URL(n, R), t && (i = t.baseOptions), o = f({ method: "POST" }, i, s), l = {}, [4, E(u = {}, t)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", I(e, l), c = i && i.headers ? i.headers : {}, o.headers = f({}, u, c, s.headers), o.data = N(r, o, t), [2, { url: _(e), options: o }];
        }
      });
    })();
  }, listStationSnapshots: function(a) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return v(function() {
      var s, n, e, i, o, u, l;
      return p(this, function(c) {
        switch (c.label) {
          case 0:
            return b("listStationSnapshots", "showId", a), s = "/show/{showId}/station-snapshot".replace("{showId}", encodeURIComponent(String(a))), n = new URL(s, R), t && (e = t.baseOptions), i = f({ method: "GET" }, e, r), u = {}, [4, E(o = {}, t)];
          case 1:
            return c.sent(), I(n, u), l = e && e.headers ? e.headers : {}, i.headers = f({}, o, l, r.headers), [2, { url: _(n), options: i }];
        }
      });
    })();
  }, markStationReconcileReviewed: function(a, r, s, n) {
    var e = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : {};
    return v(function() {
      var i, o, u, l, c, d, h;
      return p(this, function(g) {
        switch (g.label) {
          case 0:
            return b("markStationReconcileReviewed", "showId", a), b("markStationReconcileReviewed", "deviceId", r), b("markStationReconcileReviewed", "scribeSub", s), b("markStationReconcileReviewed", "markStationReconcileReviewedRequest", n), i = "/show/{showId}/station-snapshot/{deviceId}/{scribeSub}/reconcile/review".replace("{showId}", encodeURIComponent(String(a))).replace("{deviceId}", encodeURIComponent(String(r))).replace("{scribeSub}", encodeURIComponent(String(s))), o = new URL(i, R), t && (u = t.baseOptions), l = f({ method: "POST" }, u, e), d = {}, [4, E(c = {}, t)];
          case 1:
            return g.sent(), c["Content-Type"] = "application/json", I(o, d), h = u && u.headers ? u.headers : {}, l.headers = f({}, c, h, e.headers), l.data = N(n, l, t), [2, { url: _(o), options: l }];
        }
      });
    })();
  }, postStationSnapshot: function(a, r, s) {
    var n = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    return v(function() {
      var e, i, o, u, l, c, d;
      return p(this, function(h) {
        switch (h.label) {
          case 0:
            return b("postStationSnapshot", "showId", a), b("postStationSnapshot", "deviceId", r), e = "/show/{showId}/station-snapshot/{deviceId}".replace("{showId}", encodeURIComponent(String(a))).replace("{deviceId}", encodeURIComponent(String(r))), i = new URL(e, R), t && (o = t.baseOptions), u = f({ method: "POST" }, o, n), c = {}, [4, E(l = {}, t)];
          case 1:
            return h.sent(), l["Content-Type"] = "application/json", I(i, c), d = o && o.headers ? o.headers : {}, u.headers = f({}, l, d, n.headers), u.data = N(s, u, t), [2, { url: _(i), options: u }];
        }
      });
    })();
  } };
}, kr = function(t) {
  var a = Kh(t);
  return { checkSheetManifest: function(r, s, n) {
    return v(function() {
      var e, i, o, u, l, c;
      return p(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, a.checkSheetManifest(r, s, n)];
          case 1:
            return o = d.sent(), l = (u = t == null ? void 0 : t.serverIndex) !== null && u !== void 0 ? u : 0, c = (i = y["StationSnapshotApi.checkSheetManifest"]) === null || i === void 0 || (e = i[l]) === null || e === void 0 ? void 0 : e.url, [2, function(h, g) {
              return T(o, S.default, w, t)(h, c || g);
            }];
        }
      });
    })();
  }, listStationSnapshots: function(r, s) {
    return v(function() {
      var n, e, i, o, u, l;
      return p(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, a.listStationSnapshots(r, s)];
          case 1:
            return i = c.sent(), u = (o = t == null ? void 0 : t.serverIndex) !== null && o !== void 0 ? o : 0, l = (e = y["StationSnapshotApi.listStationSnapshots"]) === null || e === void 0 || (n = e[u]) === null || n === void 0 ? void 0 : n.url, [2, function(d, h) {
              return T(i, S.default, w, t)(d, l || h);
            }];
        }
      });
    })();
  }, markStationReconcileReviewed: function(r, s, n, e, i) {
    return v(function() {
      var o, u, l, c, d, h;
      return p(this, function(g) {
        switch (g.label) {
          case 0:
            return [4, a.markStationReconcileReviewed(r, s, n, e, i)];
          case 1:
            return l = g.sent(), d = (c = t == null ? void 0 : t.serverIndex) !== null && c !== void 0 ? c : 0, h = (u = y["StationSnapshotApi.markStationReconcileReviewed"]) === null || u === void 0 || (o = u[d]) === null || o === void 0 ? void 0 : o.url, [2, function(U, P) {
              return T(l, S.default, w, t)(U, h || P);
            }];
        }
      });
    })();
  }, postStationSnapshot: function(r, s, n, e) {
    return v(function() {
      var i, o, u, l, c, d;
      return p(this, function(h) {
        switch (h.label) {
          case 0:
            return [4, a.postStationSnapshot(r, s, n, e)];
          case 1:
            return u = h.sent(), c = (l = t == null ? void 0 : t.serverIndex) !== null && l !== void 0 ? l : 0, d = (o = y["StationSnapshotApi.postStationSnapshot"]) === null || o === void 0 || (i = o[c]) === null || i === void 0 ? void 0 : i.url, [2, function(g, U) {
              return T(u, S.default, w, t)(g, d || U);
            }];
        }
      });
    })();
  } };
};
(function(t) {
  function a() {
    return Me(this, a), je(this, a, arguments);
  }
  return Ve(a, t), Fe(a, [{ key: "checkSheetManifest", value: function(r, s, n) {
    var e = this;
    return kr(this.configuration).checkSheetManifest(r, s, n).then(function(i) {
      return i(e.axios, e.basePath);
    });
  } }, { key: "listStationSnapshots", value: function(r, s) {
    var n = this;
    return kr(this.configuration).listStationSnapshots(r, s).then(function(e) {
      return e(n.axios, n.basePath);
    });
  } }, { key: "markStationReconcileReviewed", value: function(r, s, n, e, i) {
    var o = this;
    return kr(this.configuration).markStationReconcileReviewed(r, s, n, e, i).then(function(u) {
      return u(o.axios, o.basePath);
    });
  } }, { key: "postStationSnapshot", value: function(r, s, n, e) {
    var i = this;
    return kr(this.configuration).postStationSnapshot(r, s, n, e).then(function(o) {
      return o(i.axios, i.basePath);
    });
  } }]), a;
})(Le);
var Qh = function(t) {
  return { checkStationName: function(a, r) {
    var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return v(function() {
      var n, e, i, o, u, l;
      return p(this, function(c) {
        switch (c.label) {
          case 0:
            return b("checkStationName", "name", a), n = new URL("/station-name/check", R), t && (e = t.baseOptions), i = f({ method: "GET" }, e, s), u = {}, [4, E(o = {}, t)];
          case 1:
            return c.sent(), a !== void 0 && (u.name = a), r !== void 0 && (u.stationId = r), I(n, u), l = e && e.headers ? e.headers : {}, i.headers = f({}, o, l, s.headers), [2, { url: _(n), options: i }];
        }
      });
    })();
  }, getStation: function(a) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return v(function() {
      var s, n, e, i, o, u, l;
      return p(this, function(c) {
        switch (c.label) {
          case 0:
            return b("getStation", "stationId", a), s = "/station/{stationId}".replace("{stationId}", encodeURIComponent(String(a))), n = new URL(s, R), t && (e = t.baseOptions), i = f({ method: "GET" }, e, r), u = {}, [4, E(o = {}, t)];
          case 1:
            return c.sent(), I(n, u), l = e && e.headers ? e.headers : {}, i.headers = f({}, o, l, r.headers), [2, { url: _(n), options: i }];
        }
      });
    })();
  }, getStationMachineClear: function(a) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return v(function() {
      var s, n, e, i, o, u, l;
      return p(this, function(c) {
        switch (c.label) {
          case 0:
            return b("getStationMachineClear", "stationId", a), s = "/station/{stationId}/clear-machine".replace("{stationId}", encodeURIComponent(String(a))), n = new URL(s, R), t && (e = t.baseOptions), i = f({ method: "GET" }, e, r), u = {}, [4, E(o = {}, t)];
          case 1:
            return c.sent(), I(n, u), l = e && e.headers ? e.headers : {}, i.headers = f({}, o, l, r.headers), [2, { url: _(n), options: i }];
        }
      });
    })();
  }, putStation: function(a, r) {
    var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return v(function() {
      var n, e, i, o, u, l, c;
      return p(this, function(d) {
        switch (d.label) {
          case 0:
            return b("putStation", "stationId", a), b("putStation", "putStationRequest", r), n = "/station/{stationId}".replace("{stationId}", encodeURIComponent(String(a))), e = new URL(n, R), t && (i = t.baseOptions), o = f({ method: "PUT" }, i, s), l = {}, [4, E(u = {}, t)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", I(e, l), c = i && i.headers ? i.headers : {}, o.headers = f({}, u, c, s.headers), o.data = N(r, o, t), [2, { url: _(e), options: o }];
        }
      });
    })();
  }, recordStationMachineClear: function(a, r) {
    var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return v(function() {
      var n, e, i, o, u, l, c;
      return p(this, function(d) {
        switch (d.label) {
          case 0:
            return b("recordStationMachineClear", "stationId", a), b("recordStationMachineClear", "recordStationMachineClearRequest", r), n = "/station/{stationId}/clear-machine/record".replace("{stationId}", encodeURIComponent(String(a))), e = new URL(n, R), t && (i = t.baseOptions), o = f({ method: "POST" }, i, s), l = {}, [4, E(u = {}, t)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", I(e, l), c = i && i.headers ? i.headers : {}, o.headers = f({}, u, c, s.headers), o.data = N(r, o, t), [2, { url: _(e), options: o }];
        }
      });
    })();
  }, renameStation: function(a, r) {
    var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return v(function() {
      var n, e, i, o, u, l, c;
      return p(this, function(d) {
        switch (d.label) {
          case 0:
            return b("renameStation", "stationId", a), b("renameStation", "renameStationRequest", r), n = "/station/{stationId}/name".replace("{stationId}", encodeURIComponent(String(a))), e = new URL(n, R), t && (i = t.baseOptions), o = f({ method: "PUT" }, i, s), l = {}, [4, E(u = {}, t)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", I(e, l), c = i && i.headers ? i.headers : {}, o.headers = f({}, u, c, s.headers), o.data = N(r, o, t), [2, { url: _(e), options: o }];
        }
      });
    })();
  }, reportStationMachineClearBlocked: function(a, r) {
    var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return v(function() {
      var n, e, i, o, u, l, c;
      return p(this, function(d) {
        switch (d.label) {
          case 0:
            return b("reportStationMachineClearBlocked", "stationId", a), b("reportStationMachineClearBlocked", "reportStationMachineClearBlockedRequest", r), n = "/station/{stationId}/clear-machine/blocked".replace("{stationId}", encodeURIComponent(String(a))), e = new URL(n, R), t && (i = t.baseOptions), o = f({ method: "POST" }, i, s), l = {}, [4, E(u = {}, t)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", I(e, l), c = i && i.headers ? i.headers : {}, o.headers = f({}, u, c, s.headers), o.data = N(r, o, t), [2, { url: _(e), options: o }];
        }
      });
    })();
  } };
}, tn = function(t) {
  var a = Qh(t);
  return { checkStationName: function(r, s, n) {
    return v(function() {
      var e, i, o, u, l, c;
      return p(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, a.checkStationName(r, s, n)];
          case 1:
            return o = d.sent(), l = (u = t == null ? void 0 : t.serverIndex) !== null && u !== void 0 ? u : 0, c = (i = y["StationsApi.checkStationName"]) === null || i === void 0 || (e = i[l]) === null || e === void 0 ? void 0 : e.url, [2, function(h, g) {
              return T(o, S.default, w, t)(h, c || g);
            }];
        }
      });
    })();
  }, getStation: function(r, s) {
    return v(function() {
      var n, e, i, o, u, l;
      return p(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, a.getStation(r, s)];
          case 1:
            return i = c.sent(), u = (o = t == null ? void 0 : t.serverIndex) !== null && o !== void 0 ? o : 0, l = (e = y["StationsApi.getStation"]) === null || e === void 0 || (n = e[u]) === null || n === void 0 ? void 0 : n.url, [2, function(d, h) {
              return T(i, S.default, w, t)(d, l || h);
            }];
        }
      });
    })();
  }, getStationMachineClear: function(r, s) {
    return v(function() {
      var n, e, i, o, u, l;
      return p(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, a.getStationMachineClear(r, s)];
          case 1:
            return i = c.sent(), u = (o = t == null ? void 0 : t.serverIndex) !== null && o !== void 0 ? o : 0, l = (e = y["StationsApi.getStationMachineClear"]) === null || e === void 0 || (n = e[u]) === null || n === void 0 ? void 0 : n.url, [2, function(d, h) {
              return T(i, S.default, w, t)(d, l || h);
            }];
        }
      });
    })();
  }, putStation: function(r, s, n) {
    return v(function() {
      var e, i, o, u, l, c;
      return p(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, a.putStation(r, s, n)];
          case 1:
            return o = d.sent(), l = (u = t == null ? void 0 : t.serverIndex) !== null && u !== void 0 ? u : 0, c = (i = y["StationsApi.putStation"]) === null || i === void 0 || (e = i[l]) === null || e === void 0 ? void 0 : e.url, [2, function(h, g) {
              return T(o, S.default, w, t)(h, c || g);
            }];
        }
      });
    })();
  }, recordStationMachineClear: function(r, s, n) {
    return v(function() {
      var e, i, o, u, l, c;
      return p(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, a.recordStationMachineClear(r, s, n)];
          case 1:
            return o = d.sent(), l = (u = t == null ? void 0 : t.serverIndex) !== null && u !== void 0 ? u : 0, c = (i = y["StationsApi.recordStationMachineClear"]) === null || i === void 0 || (e = i[l]) === null || e === void 0 ? void 0 : e.url, [2, function(h, g) {
              return T(o, S.default, w, t)(h, c || g);
            }];
        }
      });
    })();
  }, renameStation: function(r, s, n) {
    return v(function() {
      var e, i, o, u, l, c;
      return p(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, a.renameStation(r, s, n)];
          case 1:
            return o = d.sent(), l = (u = t == null ? void 0 : t.serverIndex) !== null && u !== void 0 ? u : 0, c = (i = y["StationsApi.renameStation"]) === null || i === void 0 || (e = i[l]) === null || e === void 0 ? void 0 : e.url, [2, function(h, g) {
              return T(o, S.default, w, t)(h, c || g);
            }];
        }
      });
    })();
  }, reportStationMachineClearBlocked: function(r, s, n) {
    return v(function() {
      var e, i, o, u, l, c;
      return p(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, a.reportStationMachineClearBlocked(r, s, n)];
          case 1:
            return o = d.sent(), l = (u = t == null ? void 0 : t.serverIndex) !== null && u !== void 0 ? u : 0, c = (i = y["StationsApi.reportStationMachineClearBlocked"]) === null || i === void 0 || (e = i[l]) === null || e === void 0 ? void 0 : e.url, [2, function(h, g) {
              return T(o, S.default, w, t)(h, c || g);
            }];
        }
      });
    })();
  } };
};
(function(t) {
  function a() {
    return Me(this, a), je(this, a, arguments);
  }
  return Ve(a, t), Fe(a, [{ key: "checkStationName", value: function(r, s, n) {
    var e = this;
    return tn(this.configuration).checkStationName(r, s, n).then(function(i) {
      return i(e.axios, e.basePath);
    });
  } }, { key: "getStation", value: function(r, s) {
    var n = this;
    return tn(this.configuration).getStation(r, s).then(function(e) {
      return e(n.axios, n.basePath);
    });
  } }, { key: "getStationMachineClear", value: function(r, s) {
    var n = this;
    return tn(this.configuration).getStationMachineClear(r, s).then(function(e) {
      return e(n.axios, n.basePath);
    });
  } }, { key: "putStation", value: function(r, s, n) {
    var e = this;
    return tn(this.configuration).putStation(r, s, n).then(function(i) {
      return i(e.axios, e.basePath);
    });
  } }, { key: "recordStationMachineClear", value: function(r, s, n) {
    var e = this;
    return tn(this.configuration).recordStationMachineClear(r, s, n).then(function(i) {
      return i(e.axios, e.basePath);
    });
  } }, { key: "renameStation", value: function(r, s, n) {
    var e = this;
    return tn(this.configuration).renameStation(r, s, n).then(function(i) {
      return i(e.axios, e.basePath);
    });
  } }, { key: "reportStationMachineClearBlocked", value: function(r, s, n) {
    var e = this;
    return tn(this.configuration).reportStationMachineClearBlocked(r, s, n).then(function(i) {
      return i(e.axios, e.basePath);
    });
  } }]), a;
})(Le);
var Xh = function(t) {
  return { importTabletSheetsFile: function(a) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return v(function() {
      var s, n, e, i, o, u;
      return p(this, function(l) {
        switch (l.label) {
          case 0:
            return b("importTabletSheetsFile", "importTabletSheetsFileRequest", a), s = new URL("/tablet-file/import", R), t && (n = t.baseOptions), e = f({ method: "POST" }, n, r), o = {}, [4, E(i = {}, t)];
          case 1:
            return l.sent(), i["Content-Type"] = "application/json", I(s, o), u = n && n.headers ? n.headers : {}, e.headers = f({}, i, u, r.headers), e.data = N(a, e, t), [2, { url: _(s), options: e }];
        }
      });
    })();
  } };
}, ef = function(t) {
  var a = Xh(t);
  return { importTabletSheetsFile: function(r, s) {
    return v(function() {
      var n, e, i, o, u, l;
      return p(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, a.importTabletSheetsFile(r, s)];
          case 1:
            return i = c.sent(), u = (o = t == null ? void 0 : t.serverIndex) !== null && o !== void 0 ? o : 0, l = (e = y["TabletImportApi.importTabletSheetsFile"]) === null || e === void 0 || (n = e[u]) === null || n === void 0 ? void 0 : n.url, [2, function(d, h) {
              return T(i, S.default, w, t)(d, l || h);
            }];
        }
      });
    })();
  } };
};
(function(t) {
  function a() {
    return Me(this, a), je(this, a, arguments);
  }
  return Ve(a, t), Fe(a, [{ key: "importTabletSheetsFile", value: function(r, s) {
    var n = this;
    return ef(this.configuration).importTabletSheetsFile(r, s).then(function(e) {
      return e(n.axios, n.basePath);
    });
  } }]), a;
})(Le);
var tf = function(t) {
  return { createTest: function(a) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return v(function() {
      var s, n, e, i, o, u;
      return p(this, function(l) {
        switch (l.label) {
          case 0:
            return s = new URL("/test", R), t && (n = t.baseOptions), e = f({ method: "POST" }, n, r), o = {}, [4, E(i = {}, t)];
          case 1:
            return l.sent(), i["Content-Type"] = "application/json", I(s, o), u = n && n.headers ? n.headers : {}, e.headers = f({}, i, u, r.headers), e.data = N(a, e, t), [2, { url: _(s), options: e }];
        }
      });
    })();
  }, deleteTest: function(a) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return v(function() {
      var s, n, e, i, o, u, l;
      return p(this, function(c) {
        switch (c.label) {
          case 0:
            return b("deleteTest", "id", a), s = "/test/{id}".replace("{id}", encodeURIComponent(String(a))), n = new URL(s, R), t && (e = t.baseOptions), i = f({ method: "DELETE" }, e, r), u = {}, [4, E(o = {}, t)];
          case 1:
            return c.sent(), I(n, u), l = e && e.headers ? e.headers : {}, i.headers = f({}, o, l, r.headers), [2, { url: _(n), options: i }];
        }
      });
    })();
  }, getTest: function(a) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return v(function() {
      var s, n, e, i, o, u, l;
      return p(this, function(c) {
        switch (c.label) {
          case 0:
            return b("getTest", "id", a), s = "/test/{id}".replace("{id}", encodeURIComponent(String(a))), n = new URL(s, R), t && (e = t.baseOptions), i = f({ method: "GET" }, e, r), u = {}, [4, E(o = {}, t)];
          case 1:
            return c.sent(), I(n, u), l = e && e.headers ? e.headers : {}, i.headers = f({}, o, l, r.headers), [2, { url: _(n), options: i }];
        }
      });
    })();
  }, listTests: function(a) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return v(function() {
      var s, n, e, i, o, u;
      return p(this, function(l) {
        switch (l.label) {
          case 0:
            return s = new URL("/test", R), t && (n = t.baseOptions), e = f({ method: "GET" }, n, r), o = {}, [4, E(i = {}, t)];
          case 1:
            return l.sent(), a !== void 0 && (o.showId = a), I(s, o), u = n && n.headers ? n.headers : {}, e.headers = f({}, i, u, r.headers), [2, { url: _(s), options: e }];
        }
      });
    })();
  }, updateTest: function(a, r) {
    var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return v(function() {
      var n, e, i, o, u, l, c;
      return p(this, function(d) {
        switch (d.label) {
          case 0:
            return b("updateTest", "id", a), n = "/test/{id}".replace("{id}", encodeURIComponent(String(a))), e = new URL(n, R), t && (i = t.baseOptions), o = f({ method: "PUT" }, i, s), l = {}, [4, E(u = {}, t)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", I(e, l), c = i && i.headers ? i.headers : {}, o.headers = f({}, u, c, s.headers), o.data = N(r, o, t), [2, { url: _(e), options: o }];
        }
      });
    })();
  } };
}, $n = function(t) {
  var a = tf(t);
  return { createTest: function(r, s) {
    return v(function() {
      var n, e, i, o, u, l;
      return p(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, a.createTest(r, s)];
          case 1:
            return i = c.sent(), u = (o = t == null ? void 0 : t.serverIndex) !== null && o !== void 0 ? o : 0, l = (e = y["TestsApi.createTest"]) === null || e === void 0 || (n = e[u]) === null || n === void 0 ? void 0 : n.url, [2, function(d, h) {
              return T(i, S.default, w, t)(d, l || h);
            }];
        }
      });
    })();
  }, deleteTest: function(r, s) {
    return v(function() {
      var n, e, i, o, u, l;
      return p(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, a.deleteTest(r, s)];
          case 1:
            return i = c.sent(), u = (o = t == null ? void 0 : t.serverIndex) !== null && o !== void 0 ? o : 0, l = (e = y["TestsApi.deleteTest"]) === null || e === void 0 || (n = e[u]) === null || n === void 0 ? void 0 : n.url, [2, function(d, h) {
              return T(i, S.default, w, t)(d, l || h);
            }];
        }
      });
    })();
  }, getTest: function(r, s) {
    return v(function() {
      var n, e, i, o, u, l;
      return p(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, a.getTest(r, s)];
          case 1:
            return i = c.sent(), u = (o = t == null ? void 0 : t.serverIndex) !== null && o !== void 0 ? o : 0, l = (e = y["TestsApi.getTest"]) === null || e === void 0 || (n = e[u]) === null || n === void 0 ? void 0 : n.url, [2, function(d, h) {
              return T(i, S.default, w, t)(d, l || h);
            }];
        }
      });
    })();
  }, listTests: function(r, s) {
    return v(function() {
      var n, e, i, o, u, l;
      return p(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, a.listTests(r, s)];
          case 1:
            return i = c.sent(), u = (o = t == null ? void 0 : t.serverIndex) !== null && o !== void 0 ? o : 0, l = (e = y["TestsApi.listTests"]) === null || e === void 0 || (n = e[u]) === null || n === void 0 ? void 0 : n.url, [2, function(d, h) {
              return T(i, S.default, w, t)(d, l || h);
            }];
        }
      });
    })();
  }, updateTest: function(r, s, n) {
    return v(function() {
      var e, i, o, u, l, c;
      return p(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, a.updateTest(r, s, n)];
          case 1:
            return o = d.sent(), l = (u = t == null ? void 0 : t.serverIndex) !== null && u !== void 0 ? u : 0, c = (i = y["TestsApi.updateTest"]) === null || i === void 0 || (e = i[l]) === null || e === void 0 ? void 0 : e.url, [2, function(h, g) {
              return T(o, S.default, w, t)(h, c || g);
            }];
        }
      });
    })();
  } };
};
(function(t) {
  function a() {
    return Me(this, a), je(this, a, arguments);
  }
  return Ve(a, t), Fe(a, [{ key: "createTest", value: function(r, s) {
    var n = this;
    return $n(this.configuration).createTest(r, s).then(function(e) {
      return e(n.axios, n.basePath);
    });
  } }, { key: "deleteTest", value: function(r, s) {
    var n = this;
    return $n(this.configuration).deleteTest(r, s).then(function(e) {
      return e(n.axios, n.basePath);
    });
  } }, { key: "getTest", value: function(r, s) {
    var n = this;
    return $n(this.configuration).getTest(r, s).then(function(e) {
      return e(n.axios, n.basePath);
    });
  } }, { key: "listTests", value: function(r, s) {
    var n = this;
    return $n(this.configuration).listTests(r, s).then(function(e) {
      return e(n.axios, n.basePath);
    });
  } }, { key: "updateTest", value: function(r, s, n) {
    var e = this;
    return $n(this.configuration).updateTest(r, s, n).then(function(i) {
      return i(e.axios, e.basePath);
    });
  } }]), a;
})(Le);
var nf = function(t) {
  return { createVenue: function(a) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return v(function() {
      var s, n, e, i, o, u;
      return p(this, function(l) {
        switch (l.label) {
          case 0:
            return s = new URL("/venues", R), t && (n = t.baseOptions), e = f({ method: "POST" }, n, r), o = {}, [4, E(i = {}, t)];
          case 1:
            return l.sent(), i["Content-Type"] = "application/json", I(s, o), u = n && n.headers ? n.headers : {}, e.headers = f({}, i, u, r.headers), e.data = N(a, e, t), [2, { url: _(s), options: e }];
        }
      });
    })();
  }, deleteVenue: function(a) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return v(function() {
      var s, n, e, i, o, u, l;
      return p(this, function(c) {
        switch (c.label) {
          case 0:
            return b("deleteVenue", "id", a), s = "/venues/{id}".replace("{id}", encodeURIComponent(String(a))), n = new URL(s, R), t && (e = t.baseOptions), i = f({ method: "DELETE" }, e, r), u = {}, [4, E(o = {}, t)];
          case 1:
            return c.sent(), I(n, u), l = e && e.headers ? e.headers : {}, i.headers = f({}, o, l, r.headers), [2, { url: _(n), options: i }];
        }
      });
    })();
  }, getVenue: function(a) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return v(function() {
      var s, n, e, i, o, u, l;
      return p(this, function(c) {
        switch (c.label) {
          case 0:
            return b("getVenue", "id", a), s = "/venues/{id}".replace("{id}", encodeURIComponent(String(a))), n = new URL(s, R), t && (e = t.baseOptions), i = f({ method: "GET" }, e, r), u = {}, [4, E(o = {}, t)];
          case 1:
            return c.sent(), I(n, u), l = e && e.headers ? e.headers : {}, i.headers = f({}, o, l, r.headers), [2, { url: _(n), options: i }];
        }
      });
    })();
  }, getVenueUsage: function(a) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return v(function() {
      var s, n, e, i, o, u, l;
      return p(this, function(c) {
        switch (c.label) {
          case 0:
            return b("getVenueUsage", "id", a), s = "/venues/{id}/usage".replace("{id}", encodeURIComponent(String(a))), n = new URL(s, R), t && (e = t.baseOptions), i = f({ method: "GET" }, e, r), u = {}, [4, E(o = {}, t)];
          case 1:
            return c.sent(), I(n, u), l = e && e.headers ? e.headers : {}, i.headers = f({}, o, l, r.headers), [2, { url: _(n), options: i }];
        }
      });
    })();
  }, listVenues: function() {
    var a = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return v(function() {
      var r, s, n, e, i, o;
      return p(this, function(u) {
        switch (u.label) {
          case 0:
            return r = new URL("/venues", R), t && (s = t.baseOptions), n = f({ method: "GET" }, s, a), i = {}, [4, E(e = {}, t)];
          case 1:
            return u.sent(), I(r, i), o = s && s.headers ? s.headers : {}, n.headers = f({}, e, o, a.headers), [2, { url: _(r), options: n }];
        }
      });
    })();
  }, updateVenue: function(a, r) {
    var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return v(function() {
      var n, e, i, o, u, l, c;
      return p(this, function(d) {
        switch (d.label) {
          case 0:
            return b("updateVenue", "id", a), n = "/venues/{id}".replace("{id}", encodeURIComponent(String(a))), e = new URL(n, R), t && (i = t.baseOptions), o = f({ method: "PATCH" }, i, s), l = {}, [4, E(u = {}, t)];
          case 1:
            return d.sent(), u["Content-Type"] = "application/json", I(e, l), c = i && i.headers ? i.headers : {}, o.headers = f({}, u, c, s.headers), o.data = N(r, o, t), [2, { url: _(e), options: o }];
        }
      });
    })();
  } };
}, pn = function(t) {
  var a = nf(t);
  return { createVenue: function(r, s) {
    return v(function() {
      var n, e, i, o, u, l;
      return p(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, a.createVenue(r, s)];
          case 1:
            return i = c.sent(), u = (o = t == null ? void 0 : t.serverIndex) !== null && o !== void 0 ? o : 0, l = (e = y["VenuesApi.createVenue"]) === null || e === void 0 || (n = e[u]) === null || n === void 0 ? void 0 : n.url, [2, function(d, h) {
              return T(i, S.default, w, t)(d, l || h);
            }];
        }
      });
    })();
  }, deleteVenue: function(r, s) {
    return v(function() {
      var n, e, i, o, u, l;
      return p(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, a.deleteVenue(r, s)];
          case 1:
            return i = c.sent(), u = (o = t == null ? void 0 : t.serverIndex) !== null && o !== void 0 ? o : 0, l = (e = y["VenuesApi.deleteVenue"]) === null || e === void 0 || (n = e[u]) === null || n === void 0 ? void 0 : n.url, [2, function(d, h) {
              return T(i, S.default, w, t)(d, l || h);
            }];
        }
      });
    })();
  }, getVenue: function(r, s) {
    return v(function() {
      var n, e, i, o, u, l;
      return p(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, a.getVenue(r, s)];
          case 1:
            return i = c.sent(), u = (o = t == null ? void 0 : t.serverIndex) !== null && o !== void 0 ? o : 0, l = (e = y["VenuesApi.getVenue"]) === null || e === void 0 || (n = e[u]) === null || n === void 0 ? void 0 : n.url, [2, function(d, h) {
              return T(i, S.default, w, t)(d, l || h);
            }];
        }
      });
    })();
  }, getVenueUsage: function(r, s) {
    return v(function() {
      var n, e, i, o, u, l;
      return p(this, function(c) {
        switch (c.label) {
          case 0:
            return [4, a.getVenueUsage(r, s)];
          case 1:
            return i = c.sent(), u = (o = t == null ? void 0 : t.serverIndex) !== null && o !== void 0 ? o : 0, l = (e = y["VenuesApi.getVenueUsage"]) === null || e === void 0 || (n = e[u]) === null || n === void 0 ? void 0 : n.url, [2, function(d, h) {
              return T(i, S.default, w, t)(d, l || h);
            }];
        }
      });
    })();
  }, listVenues: function(r) {
    return v(function() {
      var s, n, e, i, o, u;
      return p(this, function(l) {
        switch (l.label) {
          case 0:
            return [4, a.listVenues(r)];
          case 1:
            return e = l.sent(), o = (i = t == null ? void 0 : t.serverIndex) !== null && i !== void 0 ? i : 0, u = (n = y["VenuesApi.listVenues"]) === null || n === void 0 || (s = n[o]) === null || s === void 0 ? void 0 : s.url, [2, function(c, d) {
              return T(e, S.default, w, t)(c, u || d);
            }];
        }
      });
    })();
  }, updateVenue: function(r, s, n) {
    return v(function() {
      var e, i, o, u, l, c;
      return p(this, function(d) {
        switch (d.label) {
          case 0:
            return [4, a.updateVenue(r, s, n)];
          case 1:
            return o = d.sent(), l = (u = t == null ? void 0 : t.serverIndex) !== null && u !== void 0 ? u : 0, c = (i = y["VenuesApi.updateVenue"]) === null || i === void 0 || (e = i[l]) === null || e === void 0 ? void 0 : e.url, [2, function(h, g) {
              return T(o, S.default, w, t)(h, c || g);
            }];
        }
      });
    })();
  } };
};
(function(t) {
  function a() {
    return Me(this, a), je(this, a, arguments);
  }
  return Ve(a, t), Fe(a, [{ key: "createVenue", value: function(r, s) {
    var n = this;
    return pn(this.configuration).createVenue(r, s).then(function(e) {
      return e(n.axios, n.basePath);
    });
  } }, { key: "deleteVenue", value: function(r, s) {
    var n = this;
    return pn(this.configuration).deleteVenue(r, s).then(function(e) {
      return e(n.axios, n.basePath);
    });
  } }, { key: "getVenue", value: function(r, s) {
    var n = this;
    return pn(this.configuration).getVenue(r, s).then(function(e) {
      return e(n.axios, n.basePath);
    });
  } }, { key: "getVenueUsage", value: function(r, s) {
    var n = this;
    return pn(this.configuration).getVenueUsage(r, s).then(function(e) {
      return e(n.axios, n.basePath);
    });
  } }, { key: "listVenues", value: function(r) {
    var s = this;
    return pn(this.configuration).listVenues(r).then(function(n) {
      return n(s.axios, s.basePath);
    });
  } }, { key: "updateVenue", value: function(r, s, n) {
    var e = this;
    return pn(this.configuration).updateVenue(r, s, n).then(function(i) {
      return i(e.axios, e.basePath);
    });
  } }]), a;
})(Le);
function rf(t, a) {
  for (var r = 0; r < a.length; r++) {
    var s = a[r];
    s.enumerable = s.enumerable || !1, s.configurable = !0, "value" in s && (s.writable = !0), Object.defineProperty(t, s.key, s);
  }
}
function Lt(t, a, r) {
  return a in t ? Object.defineProperty(t, a, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : t[a] = r, t;
}
function Ea(t) {
  for (var a = 1; a < arguments.length; a++) {
    var r = arguments[a] != null ? arguments[a] : {}, s = Object.keys(r);
    typeof Object.getOwnPropertySymbols == "function" && (s = s.concat(Object.getOwnPropertySymbols(r).filter(function(n) {
      return Object.getOwnPropertyDescriptor(r, n).enumerable;
    }))), s.forEach(function(n) {
      Lt(t, n, r[n]);
    });
  }
  return t;
}
(function() {
  function t() {
    var s, n, e, i = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    (function(o, u) {
      if (!(o instanceof u)) throw new TypeError("Cannot call a class as a function");
    })(this, t), Lt(this, "apiKey", void 0), Lt(this, "username", void 0), Lt(this, "password", void 0), Lt(this, "accessToken", void 0), Lt(this, "basePath", void 0), Lt(this, "serverIndex", void 0), Lt(this, "baseOptions", void 0), Lt(this, "formDataCtor", void 0), this.apiKey = i.apiKey, this.username = i.username, this.password = i.password, this.accessToken = i.accessToken, this.basePath = i.basePath, this.serverIndex = i.serverIndex, this.baseOptions = (n = Ea({}, i.baseOptions), e = (e = { headers: Ea({}, (s = i.baseOptions) === null || s === void 0 ? void 0 : s.headers) }) != null ? e : {}, Object.getOwnPropertyDescriptors ? Object.defineProperties(n, Object.getOwnPropertyDescriptors(e)) : function(o) {
      var u = Object.keys(o);
      if (Object.getOwnPropertySymbols) {
        var l = Object.getOwnPropertySymbols(o);
        u.push.apply(u, l);
      }
      return u;
    }(Object(e)).forEach(function(o) {
      Object.defineProperty(n, o, Object.getOwnPropertyDescriptor(e, o));
    }), n), this.formDataCtor = i.formDataCtor;
  }
  var a, r;
  return a = t, (r = [{ key: "isJsonMime", value: function(s) {
    var n = new RegExp("^(application/json|[^;/ 	]+/[^;/ 	]+[+]json)[ 	]*(;.*)?$", "i");
    return s !== null && (n.test(s) || s.toLowerCase() === "application/json-patch+json");
  } }]) && rf(a.prototype, r), t;
})();
const sf = {
  [Ut.PENDING]: { color: "default", label: "Scheduled" },
  // #768 — stored pre-sheet, C's "Bell" press (#767). Same "info" color
  // family as IN_PROGRESS (both mean "the horse is at the ring"); the label
  // is what tells entering from actually in progress.
  [Ut.ENTERING_RING]: { color: "info", label: "Entering ring" },
  [Ut.IN_PROGRESS]: { color: "info", label: "In ring" },
  // #696 — score confirmed/frozen and released to the announcer + FVD, judge
  // may still be writing comments. Green like FINAL ("score ready"); the label
  // is what tells the two apart.
  [Ut.CONFIRMED]: { color: "success", label: "Confirmed" },
  [Ut.COMPLETED]: { color: "warning", label: "Scored" },
  [Ut.FINAL]: { color: "success", label: "Final" },
  [Ut.SCRATCHED]: { color: "error", label: "Scratched" },
  // #3088 - a scribe sent the ride to the scoreadmin review queue. Replaces
  // the scoring badge on every surface until an admin resolves the item.
  [Ut.IN_REVIEW]: { color: "secondary", label: "In Review" },
  // #3099 - ridden and superseded in the ring, marks entered but never signed.
  // Warning (amber) so it reads as an outstanding to-do, not live "In ring".
  [Ut.NEEDS_SIGNING]: { color: "warning", label: "Needs signing" }
}, Wo = {
  [gn.SCRATCHED]: { color: "error", label: "Scratched" },
  [gn.ELIMINATED]: { color: "error", label: "Eliminated" },
  [gn.EXCUSED]: { color: "error", label: "Excused" },
  [gn.NO_SHOW]: { color: "error", label: "No Show" },
  [gn.WITHDRAWN]: { color: "error", label: "Withdrawn" }
}, af = { color: "default", label: "—" };
function tp({
  status: t,
  labels: a,
  termReason: r,
  termLabels: s,
  size: n = "small",
  ...e
}) {
  const i = Wo[r];
  if (i)
    return /* @__PURE__ */ m.jsx(Zn, { size: n, color: i.color, label: (s == null ? void 0 : s[r]) ?? i.label, ...e });
  const o = sf[t] ?? af, u = (a == null ? void 0 : a[t]) ?? o.label;
  return /* @__PURE__ */ m.jsx(Zn, { size: n, color: o.color, label: u, ...e });
}
function np({ termReason: t, termLabels: a, size: r = "small", ...s }) {
  const n = Wo[t];
  return n ? /* @__PURE__ */ m.jsx(
    Zn,
    {
      size: r,
      color: n.color,
      label: (a == null ? void 0 : a[t]) ?? n.label,
      ...s
    }
  ) : null;
}
function rp(t, a, { intervalMs: r, enabled: s = !0 } = {}) {
  const [n, e] = H({}), [i, o] = H({}), [u, l] = H({}), [c, d] = H(!1), [h, g] = H(null), [U, P] = H(null), D = Array.from(new Set((t ?? []).filter(Boolean))), j = D.join(","), F = ut(a);
  F.current = a;
  const V = ut(D);
  V.current = D;
  const te = ut(j), ge = s && D.length > 0 && typeof a == "function", he = gt(async () => {
    const G = V.current;
    if (!(!G.length || typeof F.current != "function")) {
      d(!0);
      try {
        const re = await F.current(G), K = {}, ze = {}, at = {};
        for (const He of re ?? [])
          K[He.rideId] = He.status, He.termReason && (ze[He.rideId] = He.termReason), typeof He.composite == "number" && Number.isFinite(He.composite) && (at[He.rideId] = He.composite);
        e(K), o(ze), l(at), g(null), P(/* @__PURE__ */ new Date());
      } catch (re) {
        g(re);
      } finally {
        d(!1);
      }
    }
  }, []);
  return ke(() => {
    if (te.current !== j && (te.current = j, P(null)), !D.length) {
      e({}), o({}), l({});
      return;
    }
    if (!ge)
      return;
    if (!r) {
      he();
      return;
    }
    document.visibilityState !== "hidden" && he();
    let G = null;
    const re = () => {
      document.visibilityState !== "hidden" && G == null && (G = setInterval(he, r));
    }, K = () => {
      G != null && (clearInterval(G), G = null);
    }, ze = () => {
      document.visibilityState === "hidden" ? K() : (he(), re());
    };
    return re(), document.addEventListener("visibilitychange", ze), () => {
      K(), document.removeEventListener("visibilitychange", ze);
    };
  }, [j, ge, r, he]), { statuses: n, termReasons: i, composites: u, loading: c, error: h, refresh: he, lastUpdated: U };
}
function ip({
  judgeName: t,
  url: a,
  loading: r = !1,
  label: s = "Judge signature",
  ...n
}) {
  return r ? /* @__PURE__ */ m.jsxs(Vr, { spacing: 1, alignItems: "center", sx: { mt: 3 }, ...n, children: [
    /* @__PURE__ */ m.jsx(Fr, { variant: "rounded", width: 240, height: 90 }),
    /* @__PURE__ */ m.jsx(Fr, { variant: "text", width: 140 })
  ] }) : a ? /* @__PURE__ */ m.jsxs(
    Vr,
    {
      spacing: 1,
      alignItems: "center",
      "data-testid": "signature-box",
      sx: { mt: 3, pt: 2, borderTop: 1, borderColor: "divider" },
      ...n,
      children: [
        /* @__PURE__ */ m.jsx(Mt, { variant: "caption", color: "text.secondary", children: s }),
        /* @__PURE__ */ m.jsx(
          De,
          {
            sx: {
              border: 1,
              borderColor: "divider",
              borderRadius: 1,
              bgcolor: "#ffffff",
              p: 1,
              display: "flex",
              justifyContent: "center"
            },
            children: /* @__PURE__ */ m.jsx(
              De,
              {
                component: "img",
                src: a,
                alt: t || s,
                "data-testid": "signature-box-image",
                sx: { maxWidth: 240, maxHeight: 90, objectFit: "contain" }
              }
            )
          }
        ),
        t && /* @__PURE__ */ m.jsx(
          Mt,
          {
            variant: "body2",
            color: "text.primary",
            fontWeight: 600,
            "data-testid": "signature-box-name",
            children: t
          }
        )
      ]
    }
  ) : null;
}
function sp(t, a, { enabled: r = !0 } = {}) {
  const [s, n] = H(null), [e, i] = H(!1), [o, u] = H(null), l = ut(a);
  l.current = a;
  const c = r && !!t && typeof a == "function";
  return ke(() => {
    if (!c) {
      n(null);
      return;
    }
    let d = !1;
    return i(!0), u(null), (async () => {
      try {
        const h = await l.current(t);
        d || n(h ?? null);
      } catch (h) {
        d || u(h);
      } finally {
        d || i(!1);
      }
    })(), () => {
      d = !0;
    };
  }, [c, t]), { signature: s, loading: e, error: o };
}
const of = '[data-grid-cell="true"]', uf = { "data-grid-cell": "true" };
function ap(t, { selector: a = of, getOrderedCells: r } = {}) {
  const s = t.key === "Enter", n = t.key === "Tab";
  if (!s && !n || n && !r) return;
  const e = (r ? r() : Array.from(document.querySelectorAll(a))).filter((l) => l && !l.disabled), i = e.indexOf(t.target);
  if (s && t.preventDefault(), i === -1) return;
  const o = t.shiftKey ? -1 : 1, u = e[i + o];
  u && (n && t.preventDefault(), u.focus());
}
const ts = 64, lf = 50, cf = 2;
function df(t) {
  return (t.match(/[0-9]/g) || []).length;
}
function hf(t) {
  return /^[0-9]*\.?[0-9]*$/.test(t) ? df(t) <= cf : !1;
}
function ff(t) {
  return t.endsWith(".") ? t.slice(0, -1) : t;
}
function Ca({
  value: t,
  onChange: a,
  disabled: r,
  width: s = ts,
  borderless: n = !1,
  inputRef: e,
  onKeyDown: i,
  // #698 — true once this sheet's marks are confirmed (server-side, one-
  // way freeze). Renders the SAME success/green token RideStatusBadge uses
  // for its CONFIRMED status, so a locked-in mark reads as "confirmed", not
  // "broken/disabled".
  locked: o = !1,
  // #712 — granularity this field snaps to on blur (score-common
  // SCORE_STEP/ARTISTIC_SCORE_STEP/TENTH_SCORE_STEP, resolved per mark via
  // scoreStepFor). Defaults to the standard half-point step.
  step: u = ei,
  // #1755 — see the strict-mode doc above.
  strict: l = !1,
  // #1755 — static, already-translated tooltip text shown when `strict`
  // rejects the typed value. Required for `strict` to have
  // any visible effect; harmless (unused) otherwise.
  invalidLabel: c,
  // #1755 — fires with the current invalid boolean whenever it changes.
  // ScoreEntry's coefficient box uses this to turn its OWN border red too,
  // since the box's border replaces this field's outline (borderless) and
  // wouldn't otherwise reflect a rejected value.
  onValidityChange: d,
  // #2623 — stamps GRID_CELL_DATA_ATTR (data-grid-cell="true") on the native
  // input so a caller's Enter-as-Tab handler (common-fe's focusNextGridCell)
  // can find this field by DOM query, matching scribe-fe's class grid.
  // Purely a marker; it has no effect unless the caller also wires
  // `onKeyDown={focusNextGridCell}`. Uses the shared constant rather than a
  // second hardcoded copy of the literal, so the attribute name can't drift
  // from what focusNextGridCell's own GRID_CELL_SELECTOR looks for.
  gridCell: h = !1
}) {
  const [g, U] = H(!1), [P, D] = H(""), [j, F] = H(!1);
  ke(() => {
    d == null || d(j);
  }, [j]);
  const V = g || j ? P : typeof t == "number" ? t.toFixed(1) : "", te = /* @__PURE__ */ m.jsx(
    Rn,
    {
      size: "small",
      value: V,
      type: "text",
      inputRef: e,
      error: j,
      onKeyDown: i,
      inputProps: {
        inputMode: "decimal",
        autoComplete: "off",
        pattern: "[0-9.]*",
        // #2656 — deliberately NO maxLength here. A native maxLength sits
        // in FRONT of the onChange gate below and TRUNCATES pasted text to
        // fit instead of rejecting it (browsers, and @testing-library/
        // user-event v14, both do this) — with maxLength: 3, pasting
        // "10.5" truncated to "10." (passes the digit gate, silently
        // stores 10.0) and "78.5" truncated to "78." (silently stores
        // 7.8/8.0). That is exactly the silent coercion this card exists
        // to prevent. Without it, a paste arrives whole at onChange, hits
        // isTypeableScoreDraft's real digit-count check, and is refused
        // cleanly instead of mangled. The onChange gate is the single
        // source of truth for what this field accepts.
        // #2623 — see the `gridCell` doc above.
        ...h && uf,
        // #221 — all number entry uses the same monospace typography as
        // the coefficient box (700, 0.875rem, centered) so every score
        // field reads consistently. The borderless in-box variant just
        // tightens its padding.
        style: {
          textAlign: "center",
          fontFamily: "monospace",
          fontWeight: 700,
          fontSize: "0.875rem",
          ...n && { padding: "4px 2px" }
        }
      },
      sx: (ge) => ({
        width: s,
        // #221 — borderless variant sits inside the coefficient box, so
        // it drops its own outline (the box provides the border).
        ...n && {
          "& .MuiOutlinedInput-notchedOutline": { border: "none" }
        },
        // #698 — locked (confirmed) numeric entry renders green, not the
        // washed-out default disabled grey.
        ...o && {
          "& .MuiOutlinedInput-notchedOutline": {
            borderColor: ge.palette.success.main
          },
          "& .MuiInputBase-input.Mui-disabled": {
            WebkitTextFillColor: ge.palette.success.main,
            color: ge.palette.success.main
          }
        }
      }),
      disabled: r,
      onFocus: (ge) => {
        D(typeof t == "number" ? String(t) : ""), F(!1), U(!0), ge.target.select();
      },
      onBlur: () => {
        const ge = ff(P);
        if (l) {
          if (ge === "") {
            if (P === "") {
              F(!1), U(!1), t !== void 0 && a(void 0);
              return;
            }
            F(!1), U(!1);
            return;
          }
          const G = Do(ge);
          if (G === null || G < Vd || G > _n) {
            F(!0), U(!1);
            return;
          }
          F(!1);
          const K = No(G, u);
          K !== t && a(K), U(!1);
          return;
        }
        const he = Gd(ge, u);
        he === null ? P === "" && t !== void 0 && a(void 0) : he !== t && a(he), U(!1);
      },
      onChange: (ge) => {
        const he = ge.target.value;
        hf(he) && (D(he), j && F(!1));
      }
    }
  );
  return /* @__PURE__ */ m.jsx(
    Mu,
    {
      title: j ? c ?? "" : "",
      open: !!(j && c),
      arrow: !0,
      placement: "top",
      children: te
    }
  );
}
function op({
  value: t,
  onChange: a,
  disabled: r,
  coefficient: s = 1,
  inputRef: n,
  onKeyDown: e,
  // #698 — see ScoreInput's `locked` doc above; threaded through unchanged.
  locked: i = !1,
  // #712 — see ScoreInput's `step` doc above; threaded through unchanged.
  step: o = ei,
  // #1755 — see ScoreInput's `strict`/`invalidLabel` doc above; threaded
  // through unchanged.
  strict: u = !1,
  invalidLabel: l,
  // #1755 continuation — save-gating (driver decision, card comment):
  // fires with the current invalid boolean whenever it changes, so
  // RideEditor can disable Save/Commit while any score cell is in error
  // instead of silently committing the last-known-good value under a
  // visibly-errored field.
  onValidityChange: c,
  // #2623 — see ScoreInput's `gridCell` doc above; threaded through unchanged.
  gridCell: d = !1
}) {
  const [h, g] = H(!1), U = (P) => {
    g(P), c == null || c(P);
  };
  return s && s !== 1 ? /* @__PURE__ */ m.jsxs(
    pe,
    {
      "data-testid": "coefficient-entry",
      onClick: r ? void 0 : (P) => {
        var D;
        return (D = P.currentTarget.querySelector("input")) == null ? void 0 : D.focus();
      },
      sx: (P) => ({
        position: "relative",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: ts,
        height: 40,
        px: 0.75,
        borderRadius: 1,
        border: 1,
        cursor: r ? "default" : "text",
        // Match MUI's outlined-input border in both themes. #1755 — a
        // strict-mode rejected value wins over everything (the borderless
        // inner field's own red outline is suppressed, so this box is the
        // only place a coefficient row can show the error visibly). #698 —
        // locked (confirmed) otherwise wins over the plain-disabled divider
        // color so a coefficient row visibly freezes green too.
        borderColor: h ? P.palette.error.main : i ? P.palette.success.main : r ? P.palette.divider : P.palette.mode === "dark" ? "rgba(255, 255, 255, 0.23)" : "rgba(0, 0, 0, 0.23)"
      }),
      children: [
        /* @__PURE__ */ m.jsx(
          Ca,
          {
            value: t,
            onChange: a,
            disabled: r,
            width: lf,
            borderless: !0,
            inputRef: n,
            onKeyDown: e,
            locked: i,
            step: o,
            strict: u,
            invalidLabel: l,
            onValidityChange: U,
            gridCell: d
          }
        ),
        /* @__PURE__ */ m.jsxs(
          Ze,
          {
            component: "span",
            "data-testid": "coefficient-segment",
            "aria-label": `Coefficient ×${s}`,
            sx: {
              position: "absolute",
              right: 4,
              bottom: 1,
              fontFamily: "monospace",
              fontWeight: 700,
              fontSize: "0.7rem",
              lineHeight: 1,
              color: "warning.main"
            },
            children: [
              "×",
              s
            ]
          }
        )
      ]
    }
  ) : /* @__PURE__ */ m.jsx(
    Ca,
    {
      value: t,
      onChange: a,
      disabled: r,
      width: ts,
      inputRef: n,
      onKeyDown: e,
      locked: i,
      step: o,
      strict: u,
      invalidLabel: l,
      onValidityChange: c,
      gridCell: d
    }
  );
}
function up({ buildId: t, testId: a = "build-badge" }) {
  const r = to(t);
  return r ? /* @__PURE__ */ m.jsx(
    pe,
    {
      "data-testid": a,
      "aria-hidden": "true",
      sx: {
        position: "fixed",
        bottom: 2,
        left: 86,
        // Above AppBar/NavRail (both 1300/1200 in common-fe) so it's never
        // hidden by app chrome, but below modals/dialogs so it doesn't cover
        // interactive overlays. It's pointer-events:none anyway.
        zIndex: 1250,
        pointerEvents: "none",
        userSelect: "none",
        // A subtle themed pill so the text reads on top of any content —
        // proven legible in both light and dark (mirrors PinLock's approach).
        px: 0.5,
        py: "1px",
        borderRadius: 0.5,
        bgcolor: "background.paper",
        opacity: 0.75,
        // text.secondary reads on both light and dark backgrounds; never MUI
        // `primary` (dark-grey, vanishes on dark).
        color: "text.secondary",
        fontFamily: "monospace",
        fontSize: "9px",
        lineHeight: 1.2,
        letterSpacing: 0,
        whiteSpace: "nowrap"
      },
      children: r
    }
  ) : null;
}
function vf({ testId: t = "usa-badge", variant: a = "fixed" }) {
  const r = a === "static";
  return /* @__PURE__ */ m.jsxs(
    pe,
    {
      "data-testid": t,
      "aria-hidden": "true",
      sx: {
        position: r ? "static" : "fixed",
        ...r ? {} : { bottom: 2, left: 2, zIndex: 1250 },
        width: 80,
        pointerEvents: "none",
        userSelect: "none",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        opacity: 0.75
      },
      children: [
        /* @__PURE__ */ m.jsx(
          pe,
          {
            component: "svg",
            viewBox: "0 0 1200 1200",
            "aria-label": "Made in the USA",
            sx: {
              width: 28,
              height: 28,
              // text.secondary reads on both light and dark backgrounds; never
              // MUI `primary` (dark-grey, vanishes on dark) — same rule as
              // BuildBadge.
              color: "text.secondary",
              fill: "currentColor"
            },
            children: /* @__PURE__ */ m.jsx("path", { d: "m60.84 823.92h1078.4v-49.801h-1078.4zm0-99.48h1078.4v-49.801h-1078.4zm1078.3-398.16v-49.801h-1078.3v348.61h1078.4v-49.801l-647.16-0.003906v-49.801h647.04v-49.801h-647.04v-49.801h647.04v-49.801h-647.04v-49.801zm-718.92 0.95703 6.1211 12.48 13.801 2.0391-9.9609 9.7188 2.3984 13.68-12.359-6.4805-12.238 6.3633 2.3984-13.68-9.9609-9.7188 13.801-2.0391zm12.363 107.52-12.359-6.4805-12.242 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188zm0 69.719-12.359-6.4805-12.242 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188zm-36 34.801-12.359-6.4805-12.242 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188zm-35.883-34.801-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188zm-36 34.801-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188zm-35.879-34.801-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188zm-36 34.801-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188zm-36-34.801-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188zm-35.879 34.801-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188zm-36-34.801-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.8398-9.7227 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188zm-32.16-93.121 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188 2.3984 13.68-12.359-6.4805-12.359 6.4805 2.3984-13.68zm283.8-11.398-12.359-6.4805-12.242 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188zm0 69.598-12.359-6.4805-12.242 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188zm-28.32-58.199-9.9609 9.7188 2.3984 13.68-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48zm-43.562 58.199-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188zm-2.2773-83.277 2.3984 13.68-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391zm-26.043 25.078-9.9609 9.7188 2.3984 13.68-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48zm-43.559 58.199-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188zm-2.3984-83.277 2.3984 13.68-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391zm-25.922 25.078-9.9609 9.7188 2.3984 13.68-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48zm-43.559 58.199-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188zm-2.4023-83.277 2.3984 13.68-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391zm199.56-81.48 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188 2.3984 13.68-12.359-6.4805-12.242 6.4805 2.3984-13.68-9.9609-9.7188zm-29.762 22.438 6.1211 12.48 13.801 2.0391-9.9609 9.7188 2.3984 13.68-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391zm-42.121-22.438 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188 2.3984 13.68-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188zm-29.758 22.438 6.1211 12.48 13.801 2.0391-9.9609 9.7188 2.3984 13.68-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391zm-42.121-22.438 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188 2.3984 13.68-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188zm-29.758 22.438 6.1211 12.48 13.801 2.0391-9.9609 9.7188 2.3984 13.68-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391zm-42.121-22.438 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188 2.3984 13.68-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188zm-29.762 22.438 6.1211 12.48 13.801 2.0391-9.9609 9.7188 2.3984 13.68-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.957-9.8359 13.801-2.0391zm-42.117-22.438 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188 2.3984 13.68-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188zm0 69.719 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188 2.3984 13.68-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188zm0 69.719 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188 2.3984 13.68-12.363-6.4766-12.359 6.4805 2.3984-13.68-9.957-9.8398zm0 69.602 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9648 9.7227 2.3984 13.68-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.957-9.7227zm18.477 95.16-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.957-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188zm23.641-41.281-12.359 6.4805 2.3984-13.68-9.957-9.8398 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188 2.3984 13.68zm48.242 41.281-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188zm23.641-41.281-12.359 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188 2.3984 13.68zm48.238 41.281-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188zm23.641-41.281-12.359 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188 2.3984 13.68zm48.238 41.281-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188zm23.641-41.281-12.359 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188 2.3984 13.68zm48.242 41.281-12.359-6.4805-12.242 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188zm23.637-41.281-12.238 6.3594 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188 2.3984 13.68zm48.242 41.281-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391-9.9609 9.7188zm-2.2812-83.398 2.3984 13.68-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391zm0-69.723 2.3984 13.68-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391zm0-69.598 2.3984 13.68-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391zm0-69.723 2.3984 13.68-12.359-6.4805-12.359 6.4805 2.3984-13.68-9.9609-9.7188 13.801-2.0391 6.1211-12.48 6.1211 12.48 13.801 2.0391zm-405.36 606.96h1078.4v-49.801h-1078.4z" })
          }
        ),
        /* @__PURE__ */ m.jsx(
          pe,
          {
            sx: {
              mt: "1px",
              fontSize: "12px",
              fontWeight: 600,
              lineHeight: 1.15,
              letterSpacing: "0.2px",
              textAlign: "center",
              textTransform: "uppercase",
              whiteSpace: "normal",
              // text.secondary reads on both light and dark backgrounds; never
              // MUI `primary` (dark-grey, vanishes on dark).
              color: "text.secondary"
            },
            children: "Made in the USA"
          }
        )
      ]
    }
  );
}
function lp({ testId: t = "badge-footer" }) {
  return /* @__PURE__ */ m.jsx(
    pe,
    {
      component: "footer",
      "data-testid": t,
      sx: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        py: 2
      },
      children: /* @__PURE__ */ m.jsx(vf, { variant: "static" })
    }
  );
}
const pf = "5432";
function cp({
  pin: t = pf,
  onUnlock: a,
  testId: r = "pin-lock",
  ariaLabel: s = "Unlock",
  unlocked: n = !1,
  panel: e,
  panelTitle: i = "Tools",
  panelAriaLabel: o = "Open tools",
  panelCloseLabel: u = "Close"
}) {
  const [l, c] = H(!1), [d, h] = H(!1), g = n && e != null, [U, P] = H(""), [D, j] = H(!1), F = ut(null);
  return ke(() => {
    l || (P(""), j(!1));
  }, [l]), ke(() => {
    if (!l || U.length !== t.length) return;
    const V = setTimeout(() => {
      U === t ? (c(!1), a == null || a()) : (j(!0), setTimeout(() => {
        var te;
        P(""), j(!1), (te = F.current) == null || te.focus();
      }, 600));
    }, 80);
    return () => clearTimeout(V);
  }, [U, l, t, a]), /* @__PURE__ */ m.jsxs(m.Fragment, { children: [
    /* @__PURE__ */ m.jsx(
      Ri,
      {
        onClick: () => g ? h(!0) : c(!0),
        "aria-label": g ? o : s,
        "data-testid": r,
        sx: {
          position: "fixed",
          bottom: 12,
          right: 12,
          zIndex: 1300,
          // #628 — discreet, but actually findable and tappable: a scribe has to
          // hit it on a tablet when an admin walks over, so it can't be a 16px
          // ghost. Themed text color reads on both light and dark backgrounds.
          color: "text.secondary",
          bgcolor: "background.paper",
          border: 1,
          borderColor: "divider",
          width: 40,
          height: 40,
          "&:hover": { bgcolor: "action.hover" }
        },
        children: g ? /* @__PURE__ */ m.jsx(ll, { sx: { fontSize: 20 } }) : /* @__PURE__ */ m.jsx(ul, { sx: { fontSize: 20 } })
      }
    ),
    g && /* @__PURE__ */ m.jsxs(
      Ii,
      {
        open: d,
        onClose: () => h(!1),
        maxWidth: "xs",
        fullWidth: !0,
        "data-testid": `${r}-panel`,
        children: [
          /* @__PURE__ */ m.jsx(Aa, { children: i }),
          /* @__PURE__ */ m.jsx(_i, { children: typeof e == "function" ? e({ close: () => h(!1) }) : e }),
          /* @__PURE__ */ m.jsx(Ti, { children: /* @__PURE__ */ m.jsx(ht, { color: "inherit", onClick: () => h(!1), children: u }) })
        ]
      }
    ),
    /* @__PURE__ */ m.jsxs(
      Ii,
      {
        open: l,
        onClose: () => c(!1),
        maxWidth: "xs",
        fullWidth: !0,
        children: [
          /* @__PURE__ */ m.jsx(_i, { children: /* @__PURE__ */ m.jsx(pe, { sx: { pt: 1 }, children: /* @__PURE__ */ m.jsx(
            Rn,
            {
              autoComplete: "off",
              inputRef: F,
              autoFocus: !0,
              fullWidth: !0,
              type: "password",
              value: U,
              onChange: (V) => (
                // Strip non-digits + cap to PIN length so paste-overflow
                // doesn't sneak past the auto-submit threshold.
                P(
                  V.target.value.replace(/\D/g, "").slice(0, t.length)
                )
              ),
              inputProps: {
                inputMode: "numeric",
                pattern: "[0-9]*",
                maxLength: t.length,
                style: {
                  textAlign: "center",
                  fontFamily: "monospace",
                  fontSize: 24,
                  letterSpacing: 8
                }
              },
              error: D,
              helperText: D ? "Wrong PIN" : " "
            }
          ) }) }),
          /* @__PURE__ */ m.jsx(Ti, { children: /* @__PURE__ */ m.jsx(ht, { color: "inherit", onClick: () => c(!1), children: "Cancel" }) })
        ]
      }
    )
  ] });
}
const Yn = /* @__PURE__ */ new Map();
function dp() {
  Yn.clear();
}
const xa = (t) => t != null ? Yn.get(t) : null;
function gf(t, a) {
  if (t.length !== a.length) return !1;
  for (let r = 0; r < a.length; r++)
    if (!Object.is(t[r], a[r])) return !1;
  return !0;
}
function hp(t, a, r = [], s = !0, n = null, e = null) {
  const [i, o] = H(() => {
    const D = xa(n);
    return D ? { data: D.data, loading: !1, error: null, settled: !0 } : { data: void 0, loading: !0, error: null, settled: !1 };
  }), [u, l] = H(!1), [c, d] = H(0), h = [...r, s], [g, U] = H(h);
  if (!gf(g, h)) {
    U(h);
    const D = xa(n);
    D ? o({ data: D.data, loading: !1, error: null, settled: !0 }) : i.settled && o((j) => ({ ...j, settled: !1 }));
  }
  ke(() => {
    if (e != null && n != null && c === 0) {
      const F = Yn.get(n);
      if (F && Date.now() - F.at < e) {
        o({ data: F.data, loading: !1, error: null, settled: !0 });
        return;
      }
    }
    let D = !1;
    const j = new AbortController();
    return (async () => {
      let F;
      try {
        F = await t();
      } catch {
        F = void 0;
      }
      const V = F != null;
      if (!D && V && (o({ data: F, loading: !1, error: null, settled: !0 }), n != null && Yn.set(n, { data: F, at: -1 / 0 })), s)
        try {
          const te = await a(j.signal);
          D || (o({ data: te, loading: !1, error: null, settled: !0 }), n != null && Yn.set(n, { data: te, at: Date.now() }));
        } catch (te) {
          if (j.signal.aborted) return;
          !D && !V && o({ data: null, loading: !1, error: te, settled: !0 });
        } finally {
          D || l(!1);
        }
      else
        !D && !V && o({ data: null, loading: !1, error: null, settled: !0 }), D || l(!1);
    })(), () => {
      D = !0, j.abort();
    };
  }, [...r, s, c]);
  const P = gt(() => {
    l(!0), d((D) => D + 1);
  }, []);
  return { ...i, refetch: P, refreshing: u };
}
function fp(t, a = []) {
  const [r, s] = H({ data: null, loading: !0, error: null });
  return ke(() => {
    let n = !1;
    return s({ data: null, loading: !0, error: null }), t().then((e) => {
      n || s({ data: e, loading: !1, error: null });
    }).catch((e) => {
      n || s({ data: null, loading: !1, error: e });
    }), () => {
      n = !0;
    };
  }, a), r;
}
function mf({ clientId: t, cognitoDomain: a, logoutUri: r }) {
  if (t && a && r) {
    const s = `https://${a}/logout?client_id=${t}&logout_uri=${encodeURIComponent(r)}`;
    window.location.replace(s);
  }
}
function vp() {
  const { mode: t, setMode: a } = Na();
  return { mode: t, toggleTheme: () => {
    a(t === "dark" ? "light" : "dark");
  } };
}
function pp({ t, mode: a, toggleTheme: r, navigate: s, cognitoConfig: n, settingsLink: e = "/settings" }) {
  return [
    {
      icon: /* @__PURE__ */ m.jsx(La, {}),
      text: t("navigation.homeLink"),
      onClick: () => s("/")
    },
    {
      icon: /* @__PURE__ */ m.jsx(ja, {}),
      text: t("navigation.settingsLink"),
      onClick: () => window.location.href = e
    },
    {
      icon: a === "dark" ? /* @__PURE__ */ m.jsx(qa, { fontSize: "small" }) : /* @__PURE__ */ m.jsx(Wa, { fontSize: "small" }),
      text: t(a === "dark" ? "navigation.theme.switchToLightMode" : "navigation.theme.switchToDarkMode"),
      onClick: r
    },
    {
      icon: /* @__PURE__ */ m.jsx(Ja, {}),
      text: t("navigation.logoutLink"),
      onClick: () => mf(n)
    }
  ];
}
export {
  zc as ANNOUNCER_ROLES,
  So as APPS,
  hl as AccountMenu,
  jv as ActiveOrgProvider,
  Vv as ActiveShowProvider,
  vl as AppBar,
  wv as AppFooter,
  yv as AppLayout,
  lp as BadgeFooter,
  up as BuildBadge,
  Iv as CallbackPage,
  Tv as CognitoAuthProvider,
  Ev as ConfirmButton,
  lr as DEFAULT_VENUE_TIMEZONE,
  Ci as FullScreenLoader,
  uf as GRID_CELL_DATA_ATTR,
  of as GRID_CELL_SELECTOR,
  Zc as GateHeader,
  Lv as ItemCard,
  xv as LoggedOutPage,
  Ov as LogoutPage,
  gl as MainContent,
  qv as MockAuthProvider,
  Yv as MockLoginPage,
  Jv as MockProtectedRoute,
  kv as MuiThemeProvider,
  Pv as NavRail,
  Dv as NewItemCard,
  Wv as NoAccessScreen,
  Dc as OrgSwitcher,
  Uv as PageLayout,
  Bv as PermissionProvider,
  cp as PinLock,
  Av as ProtectedRoute,
  sf as RIDE_STATUS_DISPLAY,
  Wo as RIDE_TERM_REASON_DISPLAY,
  Id as ReportList,
  Dd as ReportParamsForm,
  ep as ReportViewer,
  Xv as Reports,
  tp as RideStatusBadge,
  Bc as SCOREBOARD_ADMIN_ROLES,
  Vc as SCORE_ADMIN_ROLES,
  ts as SCORE_ENTRY_WIDTH,
  lf as SCORE_FIELD_WIDTH,
  md as SERVER_ERROR_MESSAGE,
  wo as SWITCHER_APP_KEYS,
  $v as SWITCHER_ENV_VARS,
  op as ScoreEntry,
  Ca as ScoreInput,
  jc as ScoreboardIcon,
  zv as ShowSwitcher,
  ip as SignatureBox,
  Nv as StyledBreadcrumb,
  Cv as TableSkeleton,
  np as TermReasonChip,
  pf as UNLOCK_PIN,
  vf as UsaBadge,
  Nc as UserDisplayName,
  lo as VENUE_TIME_UNSET_TEXT,
  dp as _resetWarmCacheForTests,
  Mc as appUrl,
  Rv as basenameFromRedirectUri,
  _v as beginSignOut,
  Jc as buildAppSwitcherItems,
  qc as canUseApp,
  lc as defaultOrgIdFromAccessToken,
  Hc as entitlementsFor,
  ap as focusNextGridCell,
  Fv as formatVenueDateTimeOrUnset,
  mc as formatVenueTime,
  Mv as formatVenueTimeOrUnset,
  pp as getDefaultAccountMenuItems,
  Kv as installServerErrorInterceptor,
  El as isCypressTestMode,
  yc as isShowInActiveWindow,
  Sr as isSigningOut,
  uo as isVenueTimezoneConfigured,
  mf as logoutCognito,
  Zv as readServerFailure,
  to as resolveBuildId,
  Qr as resolveVenueTimeZone,
  $c as rolesFor,
  rn as unwrapReport,
  ur as useActiveOrg,
  vo as useActiveShow,
  wd as useApiConfig,
  fp as useApiResource,
  Yc as useAppSwitcherItems,
  hp as useCachedResource,
  To as useMockAuth,
  Qa as useNavRailState,
  Pl as useOfflineSession,
  Gv as usePermission,
  Oo as useReportApi,
  Qv as useReportRunner,
  rp as useRideStatuses,
  sp as useSheetSignature,
  vp as useThemeSwitcher,
  Ac as userDisplayName,
  Hv as userFirstName,
  co as venueDayKey,
  bc as venueZoneLabel
};
//# sourceMappingURL=common-fe.js.map
